algoliaShopify.externals = (function (e) {
  function t(r) {
    if (n[r]) return n[r].exports;
    var i = (n[r] = { i: r, l: !1, exports: {} });
    return e[r].call(i.exports, i, i.exports, t), (i.l = !0), i.exports;
  }
  var n = {};
  return (
    (t.m = e),
    (t.c = n),
    (t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: r });
    }),
    (t.n = function (e) {
      var n =
        e && e.__esModule
          ? function () {
              return e.default;
            }
          : function () {
              return e;
            };
      return t.d(n, 'a', n), n;
    }),
    (t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (t.p = ''),
    t((t.s = 62))
  );
})([
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e && e.__esModule ? e : { default: e };
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 });
    var i = {
      capitalize: !0,
      defer: !0,
      isDomElement: !0,
      getContainerNode: !0,
      isSpecialClick: !0,
      prepareTemplateProps: !0,
      renderTemplate: !0,
      getRefinements: !0,
      clearRefinements: !0,
      escapeRefinement: !0,
      unescapeRefinement: !0,
      checkRendering: !0,
      checkIndexUiState: !0,
      getPropertyByPath: !0,
      getObjectType: !0,
      noop: !0,
      isFiniteNumber: !0,
      isPlainObject: !0,
      uniq: !0,
      range: !0,
      isEqual: !0,
      escape: !0,
      find: !0,
      findIndex: !0,
      mergeSearchParameters: !0,
      resolveSearchParameters: !0,
      toArray: !0,
      warning: !0,
      deprecate: !0,
      createDocumentationLink: !0,
      createDocumentationMessageGenerator: !0,
      aroundLatLngToPosition: !0,
      insideBoundingBoxToBoundingBox: !0,
      addAbsolutePosition: !0,
      addQueryID: !0,
      isFacetRefined: !0,
      getAppIdAndApiKey: !0,
      convertNumericRefinementsToFilters: !0,
    };
    Object.defineProperty(t, 'capitalize', {
      enumerable: !0,
      get: function () {
        return o.default;
      },
    }),
      Object.defineProperty(t, 'defer', {
        enumerable: !0,
        get: function () {
          return a.default;
        },
      }),
      Object.defineProperty(t, 'isDomElement', {
        enumerable: !0,
        get: function () {
          return s.default;
        },
      }),
      Object.defineProperty(t, 'getContainerNode', {
        enumerable: !0,
        get: function () {
          return c.default;
        },
      }),
      Object.defineProperty(t, 'isSpecialClick', {
        enumerable: !0,
        get: function () {
          return u.default;
        },
      }),
      Object.defineProperty(t, 'prepareTemplateProps', {
        enumerable: !0,
        get: function () {
          return l.default;
        },
      }),
      Object.defineProperty(t, 'renderTemplate', {
        enumerable: !0,
        get: function () {
          return f.default;
        },
      }),
      Object.defineProperty(t, 'getRefinements', {
        enumerable: !0,
        get: function () {
          return h.default;
        },
      }),
      Object.defineProperty(t, 'clearRefinements', {
        enumerable: !0,
        get: function () {
          return d.default;
        },
      }),
      Object.defineProperty(t, 'escapeRefinement', {
        enumerable: !0,
        get: function () {
          return p.default;
        },
      }),
      Object.defineProperty(t, 'unescapeRefinement', {
        enumerable: !0,
        get: function () {
          return m.default;
        },
      }),
      Object.defineProperty(t, 'checkRendering', {
        enumerable: !0,
        get: function () {
          return g.default;
        },
      }),
      Object.defineProperty(t, 'checkIndexUiState', {
        enumerable: !0,
        get: function () {
          return v.checkIndexUiState;
        },
      }),
      Object.defineProperty(t, 'getPropertyByPath', {
        enumerable: !0,
        get: function () {
          return y.default;
        },
      }),
      Object.defineProperty(t, 'getObjectType', {
        enumerable: !0,
        get: function () {
          return b.default;
        },
      }),
      Object.defineProperty(t, 'noop', {
        enumerable: !0,
        get: function () {
          return w.default;
        },
      }),
      Object.defineProperty(t, 'isFiniteNumber', {
        enumerable: !0,
        get: function () {
          return _.default;
        },
      }),
      Object.defineProperty(t, 'isPlainObject', {
        enumerable: !0,
        get: function () {
          return O.default;
        },
      }),
      Object.defineProperty(t, 'uniq', {
        enumerable: !0,
        get: function () {
          return P.default;
        },
      }),
      Object.defineProperty(t, 'range', {
        enumerable: !0,
        get: function () {
          return j.default;
        },
      }),
      Object.defineProperty(t, 'isEqual', {
        enumerable: !0,
        get: function () {
          return S.default;
        },
      }),
      Object.defineProperty(t, 'escape', {
        enumerable: !0,
        get: function () {
          return x.default;
        },
      }),
      Object.defineProperty(t, 'find', {
        enumerable: !0,
        get: function () {
          return R.default;
        },
      }),
      Object.defineProperty(t, 'findIndex', {
        enumerable: !0,
        get: function () {
          return E.default;
        },
      }),
      Object.defineProperty(t, 'mergeSearchParameters', {
        enumerable: !0,
        get: function () {
          return T.default;
        },
      }),
      Object.defineProperty(t, 'resolveSearchParameters', {
        enumerable: !0,
        get: function () {
          return C.default;
        },
      }),
      Object.defineProperty(t, 'toArray', {
        enumerable: !0,
        get: function () {
          return N.default;
        },
      }),
      Object.defineProperty(t, 'warning', {
        enumerable: !0,
        get: function () {
          return k.warning;
        },
      }),
      Object.defineProperty(t, 'deprecate', {
        enumerable: !0,
        get: function () {
          return k.deprecate;
        },
      }),
      Object.defineProperty(t, 'createDocumentationLink', {
        enumerable: !0,
        get: function () {
          return F.createDocumentationLink;
        },
      }),
      Object.defineProperty(t, 'createDocumentationMessageGenerator', {
        enumerable: !0,
        get: function () {
          return F.createDocumentationMessageGenerator;
        },
      }),
      Object.defineProperty(t, 'aroundLatLngToPosition', {
        enumerable: !0,
        get: function () {
          return A.aroundLatLngToPosition;
        },
      }),
      Object.defineProperty(t, 'insideBoundingBoxToBoundingBox', {
        enumerable: !0,
        get: function () {
          return A.insideBoundingBoxToBoundingBox;
        },
      }),
      Object.defineProperty(t, 'addAbsolutePosition', {
        enumerable: !0,
        get: function () {
          return I.addAbsolutePosition;
        },
      }),
      Object.defineProperty(t, 'addQueryID', {
        enumerable: !0,
        get: function () {
          return D.addQueryID;
        },
      }),
      Object.defineProperty(t, 'isFacetRefined', {
        enumerable: !0,
        get: function () {
          return M.default;
        },
      }),
      Object.defineProperty(t, 'getAppIdAndApiKey', {
        enumerable: !0,
        get: function () {
          return q.getAppIdAndApiKey;
        },
      }),
      Object.defineProperty(t, 'convertNumericRefinementsToFilters', {
        enumerable: !0,
        get: function () {
          return U.convertNumericRefinementsToFilters;
        },
      });
    var o = r(n(37)),
      a = r(n(78)),
      s = r(n(38)),
      c = r(n(79)),
      u = r(n(80)),
      l = r(n(81)),
      f = r(n(82)),
      h = r(n(83)),
      d = r(n(84)),
      p = r(n(85)),
      m = r(n(40)),
      g = r(n(86)),
      v = n(87),
      y = r(n(88)),
      b = r(n(41)),
      w = r(n(43)),
      _ = r(n(89)),
      O = r(n(90)),
      P = r(n(24)),
      j = r(n(91)),
      S = r(n(92)),
      x = r(n(93)),
      R = r(n(39)),
      E = r(n(44)),
      T = r(n(94)),
      C = r(n(95)),
      N = r(n(96)),
      k = n(42),
      F = n(97),
      A = n(98),
      I = n(99),
      D = n(100),
      M = r(n(45)),
      L = n(101);
    Object.keys(L).forEach(function (e) {
      'default' !== e &&
        '__esModule' !== e &&
        (Object.prototype.hasOwnProperty.call(i, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return L[e];
            },
          }));
    });
    var H = n(102);
    Object.keys(H).forEach(function (e) {
      'default' !== e &&
        '__esModule' !== e &&
        (Object.prototype.hasOwnProperty.call(i, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return H[e];
            },
          }));
    });
    var q = n(103),
      U = n(104);
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      '@babel/helpers - typeof';
      return (
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? (t.default = r =
              function (e) {
                return typeof e;
              })
          : (t.default = r =
              function (e) {
                return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                  ? 'symbol'
                  : typeof e;
              }),
        r(e)
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      for (var n in t) e[n] = t[n];
      return e;
    }
    function i(e) {
      var t = e.parentNode;
      t && t.removeChild(e);
    }
    function o(e, t, n) {
      var r,
        i,
        o,
        s = arguments,
        c = {};
      for (o in t) 'key' == o ? (r = t[o]) : 'ref' == o ? (i = t[o]) : (c[o] = t[o]);
      if (arguments.length > 3) for (n = [n], o = 3; o < arguments.length; o++) n.push(s[o]);
      if ((null != n && (c.children = n), 'function' == typeof e && null != e.defaultProps))
        for (o in e.defaultProps) void 0 === c[o] && (c[o] = e.defaultProps[o]);
      return a(e, c, r, i, null);
    }
    function a(e, t, n, r, i) {
      var o = {
        type: e,
        props: t,
        key: n,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: i,
      };
      return null == i && (o.__v = o), null != k.vnode && k.vnode(o), o;
    }
    function s() {
      return { current: null };
    }
    function c(e) {
      return e.children;
    }
    function u(e, t) {
      (this.props = e), (this.context = t);
    }
    function l(e, t) {
      if (null == t) return e.__ ? l(e.__, e.__.__k.indexOf(e) + 1) : null;
      for (var n; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
      return 'function' == typeof e.type ? l(e) : null;
    }
    function f(e) {
      var t, n;
      if (null != (e = e.__) && null != e.__c) {
        for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)
          if (null != (n = e.__k[t]) && null != n.__e) {
            e.__e = e.__c.base = n.__e;
            break;
          }
        return f(e);
      }
    }
    function h(e) {
      ((!e.__d && (e.__d = !0) && A.push(e) && !d.__r++) || D !== k.debounceRendering) &&
        ((D = k.debounceRendering) || I)(d);
    }
    function d() {
      for (var e; (d.__r = A.length); )
        (e = A.sort(function (e, t) {
          return e.__v.__b - t.__v.__b;
        })),
          (A = []),
          e.some(function (e) {
            var t, n, i, o, a, s, c;
            e.__d &&
              ((s = (a = (t = e).__v).__e),
              (c = t.__P) &&
                ((n = []),
                ((i = r({}, a)).__v = i),
                (o = O(c, a, i, t.__n, void 0 !== c.ownerSVGElement, null, n, null == s ? l(a) : s)),
                P(n, a),
                o != s && f(a)));
          });
    }
    function p(e, t, n, r, o, s, u, f, h, d) {
      var p,
        m,
        v,
        y,
        b,
        w,
        _,
        P = (r && r.__k) || q,
        j = P.length;
      for (h == H && (h = null != u ? u[0] : j ? l(r, 0) : null), n.__k = [], p = 0; p < t.length; p++)
        if (
          null !=
          (y = n.__k[p] =
            null == (y = t[p]) || 'boolean' == typeof y
              ? null
              : 'string' == typeof y || 'number' == typeof y
              ? a(null, y, null, null, y)
              : Array.isArray(y)
              ? a(c, { children: y }, null, null, null)
              : null != y.__e || null != y.__c
              ? a(y.type, y.props, y.key, null, y.__v)
              : y)
        ) {
          if (((y.__ = n), (y.__b = n.__b + 1), null === (v = P[p]) || (v && y.key == v.key && y.type === v.type)))
            P[p] = void 0;
          else
            for (m = 0; m < j; m++) {
              if ((v = P[m]) && y.key == v.key && y.type === v.type) {
                P[m] = void 0;
                break;
              }
              v = null;
            }
          (b = O(e, y, (v = v || H), o, s, u, f, h, d)),
            (m = y.ref) && v.ref != m && (_ || (_ = []), v.ref && _.push(v.ref, null, y), _.push(m, y.__c || b, y)),
            null != b
              ? (null == w && (w = b),
                (h = g(e, y, v, P, u, b, h)),
                d || 'option' != n.type ? 'function' == typeof n.type && (n.__d = h) : (e.value = ''))
              : h && v.__e == h && h.parentNode != e && (h = l(v));
        }
      if (((n.__e = w), null != u && 'function' != typeof n.type)) for (p = u.length; p--; ) null != u[p] && i(u[p]);
      for (p = j; p--; ) null != P[p] && x(P[p], P[p]);
      if (_) for (p = 0; p < _.length; p++) S(_[p], _[++p], _[++p]);
    }
    function m(e, t) {
      return (
        (t = t || []),
        null == e ||
          'boolean' == typeof e ||
          (Array.isArray(e)
            ? e.some(function (e) {
                m(e, t);
              })
            : t.push(e)),
        t
      );
    }
    function g(e, t, n, r, i, o, a) {
      var s, c, u;
      if (void 0 !== t.__d) (s = t.__d), (t.__d = void 0);
      else if (i == n || o != a || null == o.parentNode)
        e: if (null == a || a.parentNode !== e) e.appendChild(o), (s = null);
        else {
          for (c = a, u = 0; (c = c.nextSibling) && u < r.length; u += 2) if (c == o) break e;
          e.insertBefore(o, a), (s = a);
        }
      return void 0 !== s ? s : o.nextSibling;
    }
    function v(e, t, n, r, i) {
      var o;
      for (o in n) 'children' === o || 'key' === o || o in t || b(e, o, null, n[o], r);
      for (o in t)
        (i && 'function' != typeof t[o]) ||
          'children' === o ||
          'key' === o ||
          'value' === o ||
          'checked' === o ||
          n[o] === t[o] ||
          b(e, o, t[o], n[o], r);
    }
    function y(e, t, n) {
      '-' === t[0] ? e.setProperty(t, n) : (e[t] = null == n ? '' : 'number' != typeof n || U.test(t) ? n : n + 'px');
    }
    function b(e, t, n, r, i) {
      var o, a;
      if ((i && 'className' == t && (t = 'class'), 'style' === t))
        if ('string' == typeof n) e.style = n;
        else {
          if (('string' == typeof r && (e.style = r = ''), r)) for (t in r) (n && t in n) || y(e.style, t, '');
          if (n) for (t in n) (r && n[t] === r[t]) || y(e.style, t, n[t]);
        }
      else
        'o' === t[0] && 'n' === t[1]
          ? ((o = t !== (t = t.replace(/Capture$/, ''))),
            (a = t.toLowerCase()) in e && (t = a),
            (t = t.slice(2)),
            e.l || (e.l = {}),
            (e.l[t] = n),
            n ? r || e.addEventListener(t, w, o) : e.removeEventListener(t, w, o))
          : 'list' !== t &&
            'tagName' !== t &&
            'form' !== t &&
            'type' !== t &&
            'size' !== t &&
            'download' !== t &&
            'href' !== t &&
            !i &&
            t in e
          ? (e[t] = null == n ? '' : n)
          : 'function' != typeof n &&
            'dangerouslySetInnerHTML' !== t &&
            (t !== (t = t.replace(/xlink:?/, ''))
              ? null == n || !1 === n
                ? e.removeAttributeNS('http://www.w3.org/1999/xlink', t.toLowerCase())
                : e.setAttributeNS('http://www.w3.org/1999/xlink', t.toLowerCase(), n)
              : null == n || (!1 === n && !/^ar/.test(t))
              ? e.removeAttribute(t)
              : e.setAttribute(t, n));
    }
    function w(e) {
      this.l[e.type](k.event ? k.event(e) : e);
    }
    function _(e, t, n) {
      var r, i;
      for (r = 0; r < e.__k.length; r++)
        (i = e.__k[r]) &&
          ((i.__ = e),
          i.__e &&
            ('function' == typeof i.type && i.__k.length > 1 && _(i, t, n),
            (t = g(n, i, i, e.__k, null, i.__e, t)),
            'function' == typeof e.type && (e.__d = t)));
    }
    function O(e, t, n, i, o, a, s, l, f) {
      var h,
        d,
        m,
        g,
        v,
        y,
        b,
        w,
        O,
        P,
        S,
        x = t.type;
      if (void 0 !== t.constructor) return null;
      (h = k.__b) && h(t);
      try {
        e: if ('function' == typeof x) {
          if (
            ((w = t.props),
            (O = (h = x.contextType) && i[h.__c]),
            (P = h ? (O ? O.props.value : h.__) : i),
            n.__c
              ? (b = (d = t.__c = n.__c).__ = d.__E)
              : ('prototype' in x && x.prototype.render
                  ? (t.__c = d = new x(w, P))
                  : ((t.__c = d = new u(w, P)), (d.constructor = x), (d.render = R)),
                O && O.sub(d),
                (d.props = w),
                d.state || (d.state = {}),
                (d.context = P),
                (d.__n = i),
                (m = d.__d = !0),
                (d.__h = [])),
            null == d.__s && (d.__s = d.state),
            null != x.getDerivedStateFromProps &&
              (d.__s == d.state && (d.__s = r({}, d.__s)), r(d.__s, x.getDerivedStateFromProps(w, d.__s))),
            (g = d.props),
            (v = d.state),
            m)
          )
            null == x.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(),
              null != d.componentDidMount && d.__h.push(d.componentDidMount);
          else {
            if (
              (null == x.getDerivedStateFromProps &&
                w !== g &&
                null != d.componentWillReceiveProps &&
                d.componentWillReceiveProps(w, P),
              (!d.__e && null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(w, d.__s, P)) ||
                t.__v === n.__v)
            ) {
              (d.props = w),
                (d.state = d.__s),
                t.__v !== n.__v && (d.__d = !1),
                (d.__v = t),
                (t.__e = n.__e),
                (t.__k = n.__k),
                d.__h.length && s.push(d),
                _(t, l, e);
              break e;
            }
            null != d.componentWillUpdate && d.componentWillUpdate(w, d.__s, P),
              null != d.componentDidUpdate &&
                d.__h.push(function () {
                  d.componentDidUpdate(g, v, y);
                });
          }
          (d.context = P),
            (d.props = w),
            (d.state = d.__s),
            (h = k.__r) && h(t),
            (d.__d = !1),
            (d.__v = t),
            (d.__P = e),
            (h = d.render(d.props, d.state, d.context)),
            (d.state = d.__s),
            null != d.getChildContext && (i = r(r({}, i), d.getChildContext())),
            m || null == d.getSnapshotBeforeUpdate || (y = d.getSnapshotBeforeUpdate(g, v)),
            (S = null != h && h.type == c && null == h.key ? h.props.children : h),
            p(e, Array.isArray(S) ? S : [S], t, n, i, o, a, s, l, f),
            (d.base = t.__e),
            d.__h.length && s.push(d),
            b && (d.__E = d.__ = null),
            (d.__e = !1);
        } else
          null == a && t.__v === n.__v ? ((t.__k = n.__k), (t.__e = n.__e)) : (t.__e = j(n.__e, t, n, i, o, a, s, f));
        (h = k.diffed) && h(t);
      } catch (e) {
        (t.__v = null), k.__e(e, t, n);
      }
      return t.__e;
    }
    function P(e, t) {
      k.__c && k.__c(t, e),
        e.some(function (t) {
          try {
            (e = t.__h),
              (t.__h = []),
              e.some(function (e) {
                e.call(t);
              });
          } catch (e) {
            k.__e(e, t.__v);
          }
        });
    }
    function j(e, t, n, r, i, o, a, s) {
      var c,
        u,
        l,
        f,
        h,
        d = n.props,
        m = t.props;
      if (((i = 'svg' === t.type || i), null != o))
        for (c = 0; c < o.length; c++)
          if (null != (u = o[c]) && ((null === t.type ? 3 === u.nodeType : u.localName === t.type) || e == u)) {
            (e = u), (o[c] = null);
            break;
          }
      if (null == e) {
        if (null === t.type) return document.createTextNode(m);
        (e = i
          ? document.createElementNS('http://www.w3.org/2000/svg', t.type)
          : document.createElement(t.type, m.is && { is: m.is })),
          (o = null),
          (s = !1);
      }
      if (null === t.type) d !== m && e.data !== m && (e.data = m);
      else {
        if (
          (null != o && (o = q.slice.call(e.childNodes)),
          (l = (d = n.props || H).dangerouslySetInnerHTML),
          (f = m.dangerouslySetInnerHTML),
          !s)
        ) {
          if (null != o)
            for (d = {}, h = 0; h < e.attributes.length; h++) d[e.attributes[h].name] = e.attributes[h].value;
          (f || l) && ((f && l && f.__html == l.__html) || (e.innerHTML = (f && f.__html) || ''));
        }
        v(e, m, d, i, s),
          f
            ? (t.__k = [])
            : ((c = t.props.children),
              p(e, Array.isArray(c) ? c : [c], t, n, r, 'foreignObject' !== t.type && i, o, a, H, s)),
          s ||
            ('value' in m && void 0 !== (c = m.value) && c !== e.value && b(e, 'value', c, d.value, !1),
            'checked' in m && void 0 !== (c = m.checked) && c !== e.checked && b(e, 'checked', c, d.checked, !1));
      }
      return e;
    }
    function S(e, t, n) {
      try {
        'function' == typeof e ? e(t) : (e.current = t);
      } catch (e) {
        k.__e(e, n);
      }
    }
    function x(e, t, n) {
      var r, o, a;
      if (
        (k.unmount && k.unmount(e),
        (r = e.ref) && ((r.current && r.current !== e.__e) || S(r, null, t)),
        n || 'function' == typeof e.type || (n = null != (o = e.__e)),
        (e.__e = e.__d = void 0),
        null != (r = e.__c))
      ) {
        if (r.componentWillUnmount)
          try {
            r.componentWillUnmount();
          } catch (e) {
            k.__e(e, t);
          }
        r.base = r.__P = null;
      }
      if ((r = e.__k)) for (a = 0; a < r.length; a++) r[a] && x(r[a], t, n);
      null != o && i(o);
    }
    function R(e, t, n) {
      return this.constructor(e, n);
    }
    function E(e, t, n) {
      var r, i, a;
      k.__ && k.__(e, t),
        (i = (r = n === M) ? null : (n && n.__k) || t.__k),
        (e = o(c, null, [e])),
        (a = []),
        O(
          t,
          ((r ? t : n || t).__k = e),
          i || H,
          H,
          void 0 !== t.ownerSVGElement,
          n && !r ? [n] : i ? null : t.childNodes.length ? q.slice.call(t.childNodes) : null,
          a,
          n || H,
          r
        ),
        P(a, e);
    }
    function T(e, t) {
      E(e, t, M);
    }
    function C(e, t, n) {
      var i,
        o,
        s,
        c = arguments,
        u = r({}, e.props);
      for (s in t) 'key' == s ? (i = t[s]) : 'ref' == s ? (o = t[s]) : (u[s] = t[s]);
      if (arguments.length > 3) for (n = [n], s = 3; s < arguments.length; s++) n.push(c[s]);
      return null != n && (u.children = n), a(e.type, u, i || e.key, o || e.ref, null);
    }
    function N(e, t) {
      var n = {
        __c: (t = '__cC' + L++),
        __: e,
        Consumer: function (e, t) {
          return e.children(t);
        },
        Provider: function (e, n, r) {
          return (
            this.getChildContext ||
              ((n = []),
              ((r = {})[t] = this),
              (this.getChildContext = function () {
                return r;
              }),
              (this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && n.some(h);
              }),
              (this.sub = function (e) {
                n.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function () {
                  n.splice(n.indexOf(e), 1), t && t.call(e);
                };
              })),
            e.children
          );
        },
      };
      return (n.Provider.__ = n.Consumer.contextType = n);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.render = E),
      (t.hydrate = T),
      (t.h = t.createElement = o),
      (t.Fragment = c),
      (t.createRef = s),
      (t.Component = u),
      (t.cloneElement = C),
      (t.createContext = N),
      (t.toChildArray = m),
      (t.__u = x),
      (t.options = t.isValidElement = void 0);
    var k,
      F,
      A,
      I,
      D,
      M,
      L,
      H = {},
      q = [],
      U = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    (t.isValidElement = F),
      (t.options = k),
      (t.options = k =
        {
          __e: function (e, t) {
            for (var n, r; (t = t.__); )
              if ((n = t.__c) && !n.__)
                try {
                  if (
                    (n.constructor &&
                      null != n.constructor.getDerivedStateFromError &&
                      ((r = !0), n.setState(n.constructor.getDerivedStateFromError(e))),
                    null != n.componentDidCatch && ((r = !0), n.componentDidCatch(e)),
                    r)
                  )
                    return h((n.__E = n));
                } catch (t) {
                  e = t;
                }
            throw e;
          },
        }),
      (t.isValidElement = F =
        function (e) {
          return null != e && void 0 === e.constructor;
        }),
      (u.prototype.setState = function (e, t) {
        var n;
        (n = null != this.__s && this.__s !== this.state ? this.__s : (this.__s = r({}, this.state))),
          'function' == typeof e && (e = e(r({}, n), this.props)),
          e && r(n, e),
          null != e && this.__v && (t && this.__h.push(t), h(this));
      }),
      (u.prototype.forceUpdate = function (e) {
        this.__v && ((this.__e = !0), e && this.__h.push(e), h(this));
      }),
      (u.prototype.render = c),
      (A = []),
      (I = 'function' == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout),
      (d.__r = 0),
      (M = H),
      (L = 0);
  },
  function (e, t, n) {
    'use strict';
    var r,
      i,
      o = n(0),
      a = o(n(2));
    !(function () {
      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          if (n) {
            var r = (0, a.default)(n);
            if ('string' === r || 'number' === r) e.push(n);
            else if (Array.isArray(n) && n.length) {
              var i = o.apply(null, n);
              i && e.push(i);
            } else if ('object' === r) for (var c in n) s.call(n, c) && n[c] && e.push(c);
          }
        }
        return e.join(' ');
      }
      var s = {}.hasOwnProperty;
      void 0 !== e && e.exports
        ? ((o.default = o), (e.exports = o))
        : 'object' === (0, a.default)(n(58)) && n(58)
        ? ((r = []),
          void 0 !==
            (i = function () {
              return o;
            }.apply(t, r)) && (e.exports = i))
        : (window.classNames = o);
    })();
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.component = void 0);
    var r = function (e) {
      return function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = t.descendantName,
          r = t.modifierName,
          i = n ? '-'.concat(n) : '',
          o = r ? '--'.concat(r) : '';
        return ''.concat('ais', '-').concat(e).concat(i).concat(o);
      };
    };
    t.component = r;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    }
    var i = n(7);
    e.exports = {
      isArray: null,
      isFunction: null,
      isObject: null,
      bind: null,
      each: null,
      map: null,
      mixin: null,
      isMsie: function (e) {
        if ((void 0 === e && (e = navigator.userAgent), /(msie|trident)/i.test(e))) {
          var t = e.match(/(msie |rv:)(\d+(.\d+)?)/i);
          if (t) return t[2];
        }
        return !1;
      },
      escapeRegExChars: function (e) {
        return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
      },
      isNumber: function (e) {
        return 'number' == typeof e;
      },
      toStr: function (e) {
        return void 0 === e || null === e ? '' : e + '';
      },
      cloneDeep: function (e) {
        var t = this.mixin({}, e),
          n = this;
        return (
          this.each(t, function (e, r) {
            e && (n.isArray(e) ? (t[r] = [].concat(e)) : n.isObject(e) && (t[r] = n.cloneDeep(e)));
          }),
          t
        );
      },
      error: function (e) {
        throw new Error(e);
      },
      every: function (e, t) {
        var n = !0;
        return e
          ? (this.each(e, function (r, i) {
              n && (n = t.call(null, r, i, e) && n);
            }),
            !!n)
          : n;
      },
      any: function (e, t) {
        var n = !1;
        return e
          ? (this.each(e, function (r, i) {
              if (t.call(null, r, i, e)) return (n = !0), !1;
            }),
            n)
          : n;
      },
      getUniqueId: (function () {
        var e = 0;
        return function () {
          return e++;
        };
      })(),
      templatify: function (e) {
        if (this.isFunction(e)) return e;
        var t = i.element(e);
        return 'SCRIPT' === t.prop('tagName')
          ? function () {
              return t.text();
            }
          : function () {
              return String(e);
            };
      },
      defer: function (e) {
        setTimeout(e, 0);
      },
      noop: function () {},
      formatPrefix: function (e, t) {
        return t ? '' : e + '-';
      },
      className: function (e, t, n) {
        return (n ? '' : '.') + e + t;
      },
      escapeHighlightedString: function (e, t, n) {
        t = t || '<em>';
        var i = document.createElement('div');
        i.appendChild(document.createTextNode(t)), (n = n || '</em>');
        var o = document.createElement('div');
        o.appendChild(document.createTextNode(n));
        var a = document.createElement('div');
        return (
          a.appendChild(document.createTextNode(e)),
          a.innerHTML.replace(RegExp(r(i.innerHTML), 'g'), t).replace(RegExp(r(o.innerHTML), 'g'), n)
        );
      },
    };
  },
  function (e, t, n) {
    'use strict';
    e.exports = { element: null };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, p.default)(Symbol.iterator)
          ? function (e) {
              return (0, p.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, p.default)(e);
            })(e);
    }
    function i() {
      return (
        (i =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        i.apply(this, arguments)
      );
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function a(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function s(e, t, n) {
      return t && a(e.prototype, t), n && a(e, n), e;
    }
    function c(e, t) {
      return !t || ('object' !== r(t) && 'function' != typeof t) ? u(e) : t;
    }
    function u(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function l(e) {
      return (l = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function f(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && h(e, t);
    }
    function h(e, t) {
      return (h =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    var d = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var p = d(n(2)),
      m = n(3),
      g = n(1),
      v = (function (e) {
        function t() {
          return o(this, t), c(this, l(t).apply(this, arguments));
        }
        return (
          f(t, e),
          s(t, [
            {
              key: 'shouldComponentUpdate',
              value: function (e) {
                return (
                  !(0, g.isEqual)(this.props.data, e.data) ||
                  this.props.templateKey !== e.templateKey ||
                  !(0, g.isEqual)(this.props.rootProps, e.rootProps)
                );
              },
            },
            {
              key: 'render',
              value: function () {
                var e = this.props.rootTagName,
                  t = this.props.useCustomCompileOptions[this.props.templateKey],
                  n = t ? this.props.templatesConfig.compileOptions : {},
                  r = (0, g.renderTemplate)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: n,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                  });
                return null === r
                  ? null
                  : (0, m.h)(e, i({}, this.props.rootProps, { dangerouslySetInnerHTML: { __html: r } }));
              },
            },
          ]),
          t
        );
      })(m.Component);
    v.defaultProps = { data: {}, rootTagName: 'div', useCustomCompileOptions: {}, templates: {}, templatesConfig: {} };
    var y = v;
    t.default = y;
  },
  function (e, t, n) {
    'use strict';
    var r = Object.prototype.hasOwnProperty,
      i = Object.prototype.toString;
    e.exports = function (e, t, n) {
      if ('[object Function]' !== i.call(t)) throw new TypeError('iterator must be a function');
      var o = e.length;
      if (o === +o) for (var a = 0; a < o; a++) t.call(n, e[a], a, e);
      else for (var s in e) r.call(e, s) && t.call(n, e[s], s, e);
    };
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e) {
      return JSON.parse(JSON.stringify(e));
    };
  },
  function (e, t, n) {
    'use strict';
    var r,
      i = n(0),
      o = i(n(2));
    r = (function () {
      return this;
    })();
    try {
      r = r || Function('return this')() || (0, eval)('this');
    } catch (e) {
      'object' === ('undefined' == typeof window ? 'undefined' : (0, o.default)(window)) && (r = window);
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    function r() {
      if ('function' != typeof WeakMap) return null;
      var e = new WeakMap();
      return (
        (r = function () {
          return e;
        }),
        e
      );
    }
    function i(e) {
      if (e && e.__esModule) return e;
      if (null === e || ('object' !== o(e) && 'function' != typeof e)) return { default: e };
      var t = r();
      if (t && t.has(e)) return t.get(e);
      var n = {},
        i = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var a in e)
        if (Object.prototype.hasOwnProperty.call(e, a)) {
          var s = i ? Object.getOwnPropertyDescriptor(e, a) : null;
          s && (s.get || s.set) ? Object.defineProperty(n, a, s) : (n[a] = e[a]);
        }
      return (n.default = e), t && t.set(e, n), n;
    }
    var o = n(63);
    e.exports = i;
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e, t) {
      if (Array.isArray(e)) for (var n = 0; n < e.length; n++) if (t(e[n])) return e[n];
    };
  },
  function (e, t, n) {
    'use strict';
    function r() {
      return (
        (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        r.apply(this, arguments)
      );
    }
    function i(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(n), !0).forEach(function (t) {
              a(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function a(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function s(e) {
      return (0, f.escape)(e)
        .replace(new RegExp(h.highlightPreTag, 'g'), d.highlightPreTag)
        .replace(new RegExp(h.highlightPostTag, 'g'), d.highlightPostTag);
    }
    function c(e) {
      return (0, f.isPlainObject)(e) && 'string' != typeof e.value
        ? Object.keys(e).reduce(function (t, n) {
            return o({}, t, a({}, n, c(e[n])));
          }, {})
        : Array.isArray(e)
        ? e.map(c)
        : o({}, e, { value: s(e.value) });
    }
    function u(e) {
      return (
        void 0 === e.__escaped &&
          ((e = e.map(function (e) {
            var t = r({}, e);
            return (
              t._highlightResult && (t._highlightResult = c(t._highlightResult)),
              t._snippetResult && (t._snippetResult = c(t._snippetResult)),
              t
            );
          })),
          (e.__escaped = !0)),
        e
      );
    }
    function l(e) {
      return e.map(function (e) {
        return o({}, e, { highlighted: s(e.highlighted) });
      });
    }
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.default = u),
      (t.escapeFacets = l),
      (t.TAG_REPLACEMENT = t.TAG_PLACEHOLDER = void 0);
    var f = n(1),
      h = { highlightPreTag: '__ais-highlight__', highlightPostTag: '__/ais-highlight__' };
    t.TAG_PLACEHOLDER = h;
    var d = { highlightPreTag: '<mark>', highlightPostTag: '</mark>' };
    t.TAG_REPLACEMENT = d;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var r = n(9),
        i = this;
      'function' == typeof Error.captureStackTrace
        ? Error.captureStackTrace(this, this.constructor)
        : (i.stack = new Error().stack || 'Cannot get a stacktrace, browser is too old'),
        (this.name = 'AlgoliaSearchError'),
        (this.message = e || 'Unknown error'),
        t &&
          r(t, function (e, t) {
            i[t] = e;
          });
    }
    function i(e, t) {
      function n() {
        var n = Array.prototype.slice.call(arguments, 0);
        'string' != typeof n[0] && n.unshift(t), r.apply(this, n), (this.name = 'AlgoliaSearch' + e + 'Error');
      }
      return o(n, r), n;
    }
    var o = n(50);
    o(r, Error),
      (e.exports = {
        AlgoliaSearchError: r,
        UnparsableJSON: i('UnparsableJSON', 'Could not parse the incoming response as JSON, see err.more for details'),
        RequestTimeout: i('RequestTimeout', 'Request timed out before getting a response'),
        Network: i('Network', 'Network issue, see err.more for details'),
        JSONPScriptFail: i('JSONPScriptFail', '<script> was loaded but did not call our provided callback'),
        ValidUntilNotFound: i('ValidUntilNotFound', 'The SecuredAPIKey does not have a validUntil parameter.'),
        JSONPScriptError: i('JSONPScriptError', '<script> unable to load due to an `error` event on it'),
        ObjectNotFound: i('ObjectNotFound', 'Object not found'),
        Unknown: i('Unknown', 'Unknown error occured'),
      });
  },
  function (e, t, n) {
    'use strict';
    var r = {}.toString;
    e.exports =
      Array.isArray ||
      function (e) {
        return '[object Array]' == r.call(e);
      };
  },
  function (e, t, n) {
    'use strict';
    var r = n(9);
    e.exports = function (e, t) {
      var n = [];
      return (
        r(e, function (r, i) {
          n.push(t(r, i, e));
        }),
        n
      );
    };
  },
  function (e, t, n) {
    'use strict';
    (function (r) {
      function i() {
        return (
          !('undefined' == typeof window || !window.process || 'renderer' !== window.process.type) ||
          ('undefined' != typeof document &&
            document.documentElement &&
            document.documentElement.style &&
            document.documentElement.style.WebkitAppearance) ||
          ('undefined' != typeof window &&
            window.console &&
            (window.console.firebug || (window.console.exception && window.console.table))) ||
          ('undefined' != typeof navigator &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
            parseInt(RegExp.$1, 10) >= 31) ||
          ('undefined' != typeof navigator &&
            navigator.userAgent &&
            navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))
        );
      }
      function o(e) {
        var n = this.useColors;
        if (
          ((e[0] =
            (n ? '%c' : '') +
            this.namespace +
            (n ? ' %c' : ' ') +
            e[0] +
            (n ? '%c ' : ' ') +
            '+' +
            t.humanize(this.diff)),
          n)
        ) {
          var r = 'color: ' + this.color;
          e.splice(1, 0, r, 'color: inherit');
          var i = 0,
            o = 0;
          e[0].replace(/%[a-zA-Z%]/g, function (e) {
            '%%' !== e && (i++, '%c' === e && (o = i));
          }),
            e.splice(o, 0, r);
        }
      }
      function a() {
        return (
          'object' === ('undefined' == typeof console ? 'undefined' : (0, l.default)(console)) &&
          console.log &&
          Function.prototype.apply.call(console.log, console, arguments)
        );
      }
      function s(e) {
        try {
          null == e ? t.storage.removeItem('debug') : (t.storage.debug = e);
        } catch (e) {}
      }
      function c() {
        var e;
        try {
          e = t.storage.debug;
        } catch (e) {}
        return !e && void 0 !== r && 'env' in r && (e = Object({ NODE_ENV: 'production' }).DEBUG), e;
      }
      var u = n(0),
        l = u(n(2));
      (t = e.exports = n(128)),
        (t.log = a),
        (t.formatArgs = o),
        (t.save = s),
        (t.load = c),
        (t.useColors = i),
        (t.storage =
          'undefined' != typeof chrome && void 0 !== chrome.storage
            ? chrome.storage.local
            : (function () {
                try {
                  return window.localStorage;
                } catch (e) {}
              })()),
        (t.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson']),
        (t.formatters.j = function (e) {
          try {
            return JSON.stringify(e);
          } catch (e) {
            return '[UnexpectedJSONParseError]: ' + e.message;
          }
        }),
        t.enable(c());
    }).call(t, n(26));
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      return new i(e, t, n);
    }
    var i = n(68),
      o = n(30),
      a = n(32);
    (r.version = n(36)), (r.AlgoliaSearchHelper = i), (r.SearchParameters = o), (r.SearchResults = a), (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return 'object' === (0, c.default)(e) && null !== e ? o(Array.isArray(e) ? [] : {}, e) : e;
    }
    function i(e) {
      return 'function' == typeof e || Array.isArray(e) || '[object Object]' === Object.prototype.toString.call(e);
    }
    function o(e, t) {
      if (e === t) return e;
      for (var n in t)
        if (Object.prototype.hasOwnProperty.call(t, n)) {
          var a = t[n],
            s = e[n];
          (void 0 !== s && void 0 === a) || (i(s) && i(a) ? (e[n] = o(s, a)) : (e[n] = r(a)));
        }
      return e;
    }
    function a(e) {
      i(e) || (e = {});
      for (var t = 1, n = arguments.length; t < n; t++) {
        var r = arguments[t];
        i(r) && o(e, r);
      }
      return e;
    }
    var s = n(0),
      c = s(n(2));
    e.exports = a;
  },
  function (e, t, n) {
    'use strict';
    e.exports = function () {
      return Array.prototype.slice.call(arguments).reduceRight(function (e, t) {
        return (
          Object.keys(Object(t)).forEach(function (n) {
            void 0 !== t[n] && (void 0 !== e[n] && delete e[n], (e[n] = t[n]));
          }),
          e
        );
      }, {});
    };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e && Object.keys(e).length > 0;
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    function r() {
      (this._events = this._events || {}), (this._maxListeners = this._maxListeners || void 0);
    }
    function i(e) {
      return 'function' == typeof e;
    }
    function o(e) {
      return 'number' == typeof e;
    }
    function a(e) {
      return 'object' === (0, u.default)(e) && null !== e;
    }
    function s(e) {
      return void 0 === e;
    }
    var c = n(0),
      u = c(n(2));
    (e.exports = r),
      (r.EventEmitter = r),
      (r.prototype._events = void 0),
      (r.prototype._maxListeners = void 0),
      (r.defaultMaxListeners = 10),
      (r.prototype.setMaxListeners = function (e) {
        if (!o(e) || e < 0 || isNaN(e)) throw TypeError('n must be a positive number');
        return (this._maxListeners = e), this;
      }),
      (r.prototype.emit = function (e) {
        var t, n, r, o, c, u;
        if (
          (this._events || (this._events = {}),
          'error' === e && (!this._events.error || (a(this._events.error) && !this._events.error.length)))
        ) {
          if ((t = arguments[1]) instanceof Error) throw t;
          var l = new Error('Uncaught, unspecified "error" event. (' + t + ')');
          throw ((l.context = t), l);
        }
        if (((n = this._events[e]), s(n))) return !1;
        if (i(n))
          switch (arguments.length) {
            case 1:
              n.call(this);
              break;
            case 2:
              n.call(this, arguments[1]);
              break;
            case 3:
              n.call(this, arguments[1], arguments[2]);
              break;
            default:
              (o = Array.prototype.slice.call(arguments, 1)), n.apply(this, o);
          }
        else if (a(n))
          for (o = Array.prototype.slice.call(arguments, 1), u = n.slice(), r = u.length, c = 0; c < r; c++)
            u[c].apply(this, o);
        return !0;
      }),
      (r.prototype.addListener = function (e, t) {
        var n;
        if (!i(t)) throw TypeError('listener must be a function');
        return (
          this._events || (this._events = {}),
          this._events.newListener && this.emit('newListener', e, i(t.listener) ? t.listener : t),
          this._events[e]
            ? a(this._events[e])
              ? this._events[e].push(t)
              : (this._events[e] = [this._events[e], t])
            : (this._events[e] = t),
          a(this._events[e]) &&
            !this._events[e].warned &&
            (n = s(this._maxListeners) ? r.defaultMaxListeners : this._maxListeners) &&
            n > 0 &&
            this._events[e].length > n &&
            ((this._events[e].warned = !0),
            console.error(
              '(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.',
              this._events[e].length
            ),
            'function' == typeof console.trace && console.trace()),
          this
        );
      }),
      (r.prototype.on = r.prototype.addListener),
      (r.prototype.once = function (e, t) {
        function n() {
          this.removeListener(e, n), r || ((r = !0), t.apply(this, arguments));
        }
        if (!i(t)) throw TypeError('listener must be a function');
        var r = !1;
        return (n.listener = t), this.on(e, n), this;
      }),
      (r.prototype.removeListener = function (e, t) {
        var n, r, o, s;
        if (!i(t)) throw TypeError('listener must be a function');
        if (!this._events || !this._events[e]) return this;
        if (((n = this._events[e]), (o = n.length), (r = -1), n === t || (i(n.listener) && n.listener === t)))
          delete this._events[e], this._events.removeListener && this.emit('removeListener', e, t);
        else if (a(n)) {
          for (s = o; s-- > 0; )
            if (n[s] === t || (n[s].listener && n[s].listener === t)) {
              r = s;
              break;
            }
          if (r < 0) return this;
          1 === n.length ? ((n.length = 0), delete this._events[e]) : n.splice(r, 1),
            this._events.removeListener && this.emit('removeListener', e, t);
        }
        return this;
      }),
      (r.prototype.removeAllListeners = function (e) {
        var t, n;
        if (!this._events) return this;
        if (!this._events.removeListener)
          return 0 === arguments.length ? (this._events = {}) : this._events[e] && delete this._events[e], this;
        if (0 === arguments.length) {
          for (t in this._events) 'removeListener' !== t && this.removeAllListeners(t);
          return this.removeAllListeners('removeListener'), (this._events = {}), this;
        }
        if (((n = this._events[e]), i(n))) this.removeListener(e, n);
        else if (n) for (; n.length; ) this.removeListener(e, n[n.length - 1]);
        return delete this._events[e], this;
      }),
      (r.prototype.listeners = function (e) {
        return this._events && this._events[e]
          ? i(this._events[e])
            ? [this._events[e]]
            : this._events[e].slice()
          : [];
      }),
      (r.prototype.listenerCount = function (e) {
        if (this._events) {
          var t = this._events[e];
          if (i(t)) return 1;
          if (t) return t.length;
        }
        return 0;
      }),
      (r.listenerCount = function (e, t) {
        return e.listenerCount(t);
      });
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e.filter(function (e, t, n) {
        return n.indexOf(e) === t;
      });
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2)),
      o = Object.prototype.hasOwnProperty,
      a = Array.isArray,
      s = (function () {
        for (var e = [], t = 0; t < 256; ++t) e.push('%' + ((t < 16 ? '0' : '') + t.toString(16)).toUpperCase());
        return e;
      })(),
      c = function (e) {
        for (; e.length > 1; ) {
          var t = e.pop(),
            n = t.obj[t.prop];
          if (a(n)) {
            for (var r = [], i = 0; i < n.length; ++i) void 0 !== n[i] && r.push(n[i]);
            t.obj[t.prop] = r;
          }
        }
      },
      u = function (e, t) {
        for (var n = t && t.plainObjects ? Object.create(null) : {}, r = 0; r < e.length; ++r)
          void 0 !== e[r] && (n[r] = e[r]);
        return n;
      },
      l = function e(t, n, r) {
        if (!n) return t;
        if ('object' !== (0, i.default)(n)) {
          if (a(t)) t.push(n);
          else {
            if (!t || 'object' !== (0, i.default)(t)) return [t, n];
            ((r && (r.plainObjects || r.allowPrototypes)) || !o.call(Object.prototype, n)) && (t[n] = !0);
          }
          return t;
        }
        if (!t || 'object' !== (0, i.default)(t)) return [t].concat(n);
        var s = t;
        return (
          a(t) && !a(n) && (s = u(t, r)),
          a(t) && a(n)
            ? (n.forEach(function (n, a) {
                if (o.call(t, a)) {
                  var s = t[a];
                  s && 'object' === (0, i.default)(s) && n && 'object' === (0, i.default)(n)
                    ? (t[a] = e(s, n, r))
                    : t.push(n);
                } else t[a] = n;
              }),
              t)
            : Object.keys(n).reduce(function (t, i) {
                var a = n[i];
                return o.call(t, i) ? (t[i] = e(t[i], a, r)) : (t[i] = a), t;
              }, s)
        );
      },
      f = function (e, t) {
        return Object.keys(t).reduce(function (e, n) {
          return (e[n] = t[n]), e;
        }, e);
      },
      h = function (e, t, n) {
        var r = e.replace(/\+/g, ' ');
        if ('iso-8859-1' === n) return r.replace(/%[0-9a-f]{2}/gi, unescape);
        try {
          return decodeURIComponent(r);
        } catch (e) {
          return r;
        }
      },
      d = function (e, t, n) {
        if (0 === e.length) return e;
        var r = e;
        if (
          ('symbol' === (0, i.default)(e)
            ? (r = Symbol.prototype.toString.call(e))
            : 'string' != typeof e && (r = String(e)),
          'iso-8859-1' === n)
        )
          return escape(r).replace(/%u[0-9a-f]{4}/gi, function (e) {
            return '%26%23' + parseInt(e.slice(2), 16) + '%3B';
          });
        for (var o = '', a = 0; a < r.length; ++a) {
          var c = r.charCodeAt(a);
          45 === c ||
          46 === c ||
          95 === c ||
          126 === c ||
          (c >= 48 && c <= 57) ||
          (c >= 65 && c <= 90) ||
          (c >= 97 && c <= 122)
            ? (o += r.charAt(a))
            : c < 128
            ? (o += s[c])
            : c < 2048
            ? (o += s[192 | (c >> 6)] + s[128 | (63 & c)])
            : c < 55296 || c >= 57344
            ? (o += s[224 | (c >> 12)] + s[128 | ((c >> 6) & 63)] + s[128 | (63 & c)])
            : ((a += 1),
              (c = 65536 + (((1023 & c) << 10) | (1023 & r.charCodeAt(a)))),
              (o += s[240 | (c >> 18)] + s[128 | ((c >> 12) & 63)] + s[128 | ((c >> 6) & 63)] + s[128 | (63 & c)]));
        }
        return o;
      },
      p = function (e) {
        for (var t = [{ obj: { o: e }, prop: 'o' }], n = [], r = 0; r < t.length; ++r)
          for (var o = t[r], a = o.obj[o.prop], s = Object.keys(a), u = 0; u < s.length; ++u) {
            var l = s[u],
              f = a[l];
            'object' === (0, i.default)(f) &&
              null !== f &&
              -1 === n.indexOf(f) &&
              (t.push({ obj: a, prop: l }), n.push(f));
          }
        return c(t), e;
      },
      m = function (e) {
        return '[object RegExp]' === Object.prototype.toString.call(e);
      },
      g = function (e) {
        return !(
          !e ||
          'object' !== (0, i.default)(e) ||
          !(e.constructor && e.constructor.isBuffer && e.constructor.isBuffer(e))
        );
      },
      v = function (e, t) {
        return [].concat(e, t);
      },
      y = function (e, t) {
        if (a(e)) {
          for (var n = [], r = 0; r < e.length; r += 1) n.push(t(e[r]));
          return n;
        }
        return t(e);
      };
    e.exports = {
      arrayToObject: u,
      assign: f,
      combine: v,
      compact: p,
      decode: h,
      encode: d,
      isBuffer: g,
      isRegExp: m,
      maybeMap: y,
      merge: l,
    };
  },
  function (e, t, n) {
    'use strict';
    function r() {
      throw new Error('setTimeout has not been defined');
    }
    function i() {
      throw new Error('clearTimeout has not been defined');
    }
    function o(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === r || !f) && setTimeout) return (f = setTimeout), setTimeout(e, 0);
      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }
    function a(e) {
      if (h === clearTimeout) return clearTimeout(e);
      if ((h === i || !h) && clearTimeout) return (h = clearTimeout), clearTimeout(e);
      try {
        return h(e);
      } catch (t) {
        try {
          return h.call(null, e);
        } catch (t) {
          return h.call(this, e);
        }
      }
    }
    function s() {
      g && p && ((g = !1), p.length ? (m = p.concat(m)) : (v = -1), m.length && c());
    }
    function c() {
      if (!g) {
        var e = o(s);
        g = !0;
        for (var t = m.length; t; ) {
          for (p = m, m = []; ++v < t; ) p && p[v].run();
          (v = -1), (t = m.length);
        }
        (p = null), (g = !1), a(e);
      }
    }
    function u(e, t) {
      (this.fun = e), (this.array = t);
    }
    function l() {}
    var f,
      h,
      d = (e.exports = {});
    !(function () {
      try {
        f = 'function' == typeof setTimeout ? setTimeout : r;
      } catch (e) {
        f = r;
      }
      try {
        h = 'function' == typeof clearTimeout ? clearTimeout : i;
      } catch (e) {
        h = i;
      }
    })();
    var p,
      m = [],
      g = !1,
      v = -1;
    (d.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      m.push(new u(e, t)), 1 !== m.length || g || o(c);
    }),
      (u.prototype.run = function () {
        this.fun.apply(null, this.array);
      }),
      (d.title = 'browser'),
      (d.browser = !0),
      (d.env = {}),
      (d.argv = []),
      (d.version = ''),
      (d.versions = {}),
      (d.on = l),
      (d.addListener = l),
      (d.once = l),
      (d.off = l),
      (d.removeListener = l),
      (d.removeAllListeners = l),
      (d.emit = l),
      (d.prependListener = l),
      (d.prependOnceListener = l),
      (d.listeners = function (e) {
        return [];
      }),
      (d.binding = function (e) {
        throw new Error('process.binding is not supported');
      }),
      (d.cwd = function () {
        return '/';
      }),
      (d.chdir = function (e) {
        throw new Error('process.chdir is not supported');
      }),
      (d.umask = function () {
        return 0;
      });
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n, r) {
      var i;
      if (!n) return this;
      for (t = t.split(f), n = r ? u(n, r) : n, this._callbacks = this._callbacks || {}; (i = t.shift()); )
        (this._callbacks[i] = this._callbacks[i] || { sync: [], async: [] }), this._callbacks[i][e].push(n);
      return this;
    }
    function i(e, t, n) {
      return r.call(this, 'async', e, t, n);
    }
    function o(e, t, n) {
      return r.call(this, 'sync', e, t, n);
    }
    function a(e) {
      var t;
      if (!this._callbacks) return this;
      for (e = e.split(f); (t = e.shift()); ) delete this._callbacks[t];
      return this;
    }
    function s(e) {
      var t, n, r, i, o;
      if (!this._callbacks) return this;
      for (e = e.split(f), r = [].slice.call(arguments, 1); (t = e.shift()) && (n = this._callbacks[t]); )
        (i = c(n.sync, this, [t].concat(r))), (o = c(n.async, this, [t].concat(r))), i() && l(o);
      return this;
    }
    function c(e, t, n) {
      function r() {
        for (var r, i = 0, o = e.length; !r && i < o; i += 1) r = !1 === e[i].apply(t, n);
        return !r;
      }
      return r;
    }
    function u(e, t) {
      return e.bind
        ? e.bind(t)
        : function () {
            e.apply(t, [].slice.call(arguments, 0));
          };
    }
    var l = n(145),
      f = /\s+/;
    e.exports = { onSync: o, onAsync: i, off: a, trigger: s };
  },
  function (e, t, n) {
    'use strict';
    var r = n(6),
      i = {
        wrapper: { position: 'relative', display: 'inline-block' },
        hint: {
          position: 'absolute',
          top: '0',
          left: '0',
          borderColor: 'transparent',
          boxShadow: 'none',
          opacity: '1',
        },
        input: { position: 'relative', verticalAlign: 'top', backgroundColor: 'transparent' },
        inputWithNoHint: { position: 'relative', verticalAlign: 'top' },
        dropdown: { position: 'absolute', top: '100%', left: '0', zIndex: '100', display: 'none' },
        suggestions: { display: 'block' },
        suggestion: { whiteSpace: 'nowrap', cursor: 'pointer' },
        suggestionChild: { whiteSpace: 'normal' },
        ltr: { left: '0', right: 'auto' },
        rtl: { left: 'auto', right: '0' },
        defaultClasses: {
          root: 'algolia-autocomplete',
          prefix: 'aa',
          noPrefix: !1,
          dropdownMenu: 'dropdown-menu',
          input: 'input',
          hint: 'hint',
          suggestions: 'suggestions',
          suggestion: 'suggestion',
          cursor: 'cursor',
          dataset: 'dataset',
          empty: 'empty',
        },
        appendTo: {
          wrapper: { position: 'absolute', zIndex: '100', display: 'none' },
          input: {},
          inputWithNoHint: {},
          dropdown: { display: 'block' },
        },
      };
    r.isMsie() &&
      r.mixin(i.input, {
        backgroundImage: 'url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)',
      }),
      r.isMsie() && r.isMsie() <= 7 && r.mixin(i.input, { marginTop: '-1px' }),
      (e.exports = i);
  },
  function (e, t, n) {
    'use strict';
    var r = n(64);
    (r.Template = n(65).Template), (r.template = r.Template), (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return Array.isArray(e) && Array.isArray(t)
        ? e.length === t.length &&
            e.every(function (e, n) {
              return r(t[n], e);
            })
        : e === t;
    }
    function i(e, t) {
      return u(e, function (e) {
        return r(e, t);
      });
    }
    function o(e) {
      var t = e ? o._parseNumbers(e) : {};
      (this.facets = t.facets || []),
        (this.disjunctiveFacets = t.disjunctiveFacets || []),
        (this.hierarchicalFacets = t.hierarchicalFacets || []),
        (this.facetsRefinements = t.facetsRefinements || {}),
        (this.facetsExcludes = t.facetsExcludes || {}),
        (this.disjunctiveFacetsRefinements = t.disjunctiveFacetsRefinements || {}),
        (this.numericRefinements = t.numericRefinements || {}),
        (this.tagRefinements = t.tagRefinements || []),
        (this.hierarchicalFacetsRefinements = t.hierarchicalFacetsRefinements || {});
      var n = this;
      Object.keys(t).forEach(function (e) {
        var r = -1 !== o.PARAMETERS.indexOf(e),
          i = void 0 !== t[e];
        !r && i && (n[e] = t[e]);
      });
    }
    var a = n(20),
      s = n(21),
      c = n(69),
      u = n(13),
      l = n(70),
      f = n(31),
      h = n(22),
      d = n(71);
    (o.PARAMETERS = Object.keys(new o())),
      (o._parseNumbers = function (e) {
        if (e instanceof o) return e;
        var t = {};
        if (
          ([
            'aroundPrecision',
            'aroundRadius',
            'getRankingInfo',
            'minWordSizefor2Typos',
            'minWordSizefor1Typo',
            'page',
            'maxValuesPerFacet',
            'distinct',
            'minimumAroundRadius',
            'hitsPerPage',
            'minProximity',
          ].forEach(function (n) {
            var r = e[n];
            if ('string' == typeof r) {
              var i = parseFloat(r);
              t[n] = isNaN(i) ? r : i;
            }
          }),
          Array.isArray(e.insideBoundingBox) &&
            (t.insideBoundingBox = e.insideBoundingBox.map(function (e) {
              return Array.isArray(e)
                ? e.map(function (e) {
                    return parseFloat(e);
                  })
                : e;
            })),
          e.numericRefinements)
        ) {
          var n = {};
          Object.keys(e.numericRefinements).forEach(function (t) {
            var r = e.numericRefinements[t] || {};
            (n[t] = {}),
              Object.keys(r).forEach(function (e) {
                var i = r[e],
                  o = i.map(function (e) {
                    return Array.isArray(e)
                      ? e.map(function (e) {
                          return 'string' == typeof e ? parseFloat(e) : e;
                        })
                      : 'string' == typeof e
                      ? parseFloat(e)
                      : e;
                  });
                n[t][e] = o;
              });
          }),
            (t.numericRefinements = n);
        }
        return a({}, e, t);
      }),
      (o.make = function (e) {
        var t = new o(e);
        return (
          (e.hierarchicalFacets || []).forEach(function (e) {
            if (e.rootPath) {
              var n = t.getHierarchicalRefinement(e.name);
              n.length > 0 && 0 !== n[0].indexOf(e.rootPath) && (t = t.clearRefinements(e.name)),
                (n = t.getHierarchicalRefinement(e.name)),
                0 === n.length && (t = t.toggleHierarchicalFacetRefinement(e.name, e.rootPath));
            }
          }),
          t
        );
      }),
      (o.validate = function (e, t) {
        var n = t || {};
        return e.tagFilters && n.tagRefinements && n.tagRefinements.length > 0
          ? new Error(
              '[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.'
            )
          : e.tagRefinements.length > 0 && n.tagFilters
          ? new Error(
              '[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.'
            )
          : e.numericFilters && n.numericRefinements && h(n.numericRefinements)
          ? new Error(
              "[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
            )
          : h(e.numericRefinements) && n.numericFilters
          ? new Error(
              "[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters."
            )
          : null;
      }),
      (o.prototype = {
        constructor: o,
        clearRefinements: function (e) {
          var t = {
            numericRefinements: this._clearNumericRefinements(e),
            facetsRefinements: d.clearRefinement(this.facetsRefinements, e, 'conjunctiveFacet'),
            facetsExcludes: d.clearRefinement(this.facetsExcludes, e, 'exclude'),
            disjunctiveFacetsRefinements: d.clearRefinement(this.disjunctiveFacetsRefinements, e, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: d.clearRefinement(
              this.hierarchicalFacetsRefinements,
              e,
              'hierarchicalFacet'
            ),
          };
          return t.numericRefinements === this.numericRefinements &&
            t.facetsRefinements === this.facetsRefinements &&
            t.facetsExcludes === this.facetsExcludes &&
            t.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements &&
            t.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements
            ? this
            : this.setQueryParameters(t);
        },
        clearTags: function () {
          return void 0 === this.tagFilters && 0 === this.tagRefinements.length
            ? this
            : this.setQueryParameters({ tagFilters: void 0, tagRefinements: [] });
        },
        setIndex: function (e) {
          return e === this.index ? this : this.setQueryParameters({ index: e });
        },
        setQuery: function (e) {
          return e === this.query ? this : this.setQueryParameters({ query: e });
        },
        setPage: function (e) {
          return e === this.page ? this : this.setQueryParameters({ page: e });
        },
        setFacets: function (e) {
          return this.setQueryParameters({ facets: e });
        },
        setDisjunctiveFacets: function (e) {
          return this.setQueryParameters({ disjunctiveFacets: e });
        },
        setHitsPerPage: function (e) {
          return this.hitsPerPage === e ? this : this.setQueryParameters({ hitsPerPage: e });
        },
        setTypoTolerance: function (e) {
          return this.typoTolerance === e ? this : this.setQueryParameters({ typoTolerance: e });
        },
        addNumericRefinement: function (e, t, n) {
          var r = l(n);
          if (this.isNumericRefined(e, t, r)) return this;
          var i = a({}, this.numericRefinements);
          return (
            (i[e] = a({}, i[e])),
            i[e][t] ? ((i[e][t] = i[e][t].slice()), i[e][t].push(r)) : (i[e][t] = [r]),
            this.setQueryParameters({ numericRefinements: i })
          );
        },
        getConjunctiveRefinements: function (e) {
          return this.isConjunctiveFacet(e) ? this.facetsRefinements[e] || [] : [];
        },
        getDisjunctiveRefinements: function (e) {
          return this.isDisjunctiveFacet(e) ? this.disjunctiveFacetsRefinements[e] || [] : [];
        },
        getHierarchicalRefinement: function (e) {
          return this.hierarchicalFacetsRefinements[e] || [];
        },
        getExcludeRefinements: function (e) {
          return this.isConjunctiveFacet(e) ? this.facetsExcludes[e] || [] : [];
        },
        removeNumericRefinement: function (e, t, n) {
          return void 0 !== n
            ? this.isNumericRefined(e, t, n)
              ? this.setQueryParameters({
                  numericRefinements: this._clearNumericRefinements(function (i, o) {
                    return o === e && i.op === t && r(i.val, l(n));
                  }),
                })
              : this
            : void 0 !== t
            ? this.isNumericRefined(e, t)
              ? this.setQueryParameters({
                  numericRefinements: this._clearNumericRefinements(function (n, r) {
                    return r === e && n.op === t;
                  }),
                })
              : this
            : this.isNumericRefined(e)
            ? this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function (t, n) {
                  return n === e;
                }),
              })
            : this;
        },
        getNumericRefinements: function (e) {
          return this.numericRefinements[e] || {};
        },
        getNumericRefinement: function (e, t) {
          return this.numericRefinements[e] && this.numericRefinements[e][t];
        },
        _clearNumericRefinements: function (e) {
          if (void 0 === e) return h(this.numericRefinements) ? {} : this.numericRefinements;
          if ('string' == typeof e)
            return h(this.numericRefinements[e]) ? f(this.numericRefinements, [e]) : this.numericRefinements;
          if ('function' == typeof e) {
            var t = !1,
              n = this.numericRefinements,
              r = Object.keys(n).reduce(function (r, i) {
                var o = n[i],
                  a = {};
                return (
                  (o = o || {}),
                  Object.keys(o).forEach(function (n) {
                    var r = o[n] || [],
                      s = [];
                    r.forEach(function (t) {
                      e({ val: t, op: n }, i, 'numeric') || s.push(t);
                    }),
                      s.length !== r.length && (t = !0),
                      (a[n] = s);
                  }),
                  (r[i] = a),
                  r
                );
              }, {});
            return t ? r : this.numericRefinements;
          }
        },
        addFacet: function (e) {
          return this.isConjunctiveFacet(e) ? this : this.setQueryParameters({ facets: this.facets.concat([e]) });
        },
        addDisjunctiveFacet: function (e) {
          return this.isDisjunctiveFacet(e)
            ? this
            : this.setQueryParameters({ disjunctiveFacets: this.disjunctiveFacets.concat([e]) });
        },
        addHierarchicalFacet: function (e) {
          if (this.isHierarchicalFacet(e.name))
            throw new Error('Cannot declare two hierarchical facets with the same name: `' + e.name + '`');
          return this.setQueryParameters({ hierarchicalFacets: this.hierarchicalFacets.concat([e]) });
        },
        addFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(e + ' is not defined in the facets attribute of the helper configuration');
          return d.isRefined(this.facetsRefinements, e, t)
            ? this
            : this.setQueryParameters({ facetsRefinements: d.addRefinement(this.facetsRefinements, e, t) });
        },
        addExcludeRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(e + ' is not defined in the facets attribute of the helper configuration');
          return d.isRefined(this.facetsExcludes, e, t)
            ? this
            : this.setQueryParameters({ facetsExcludes: d.addRefinement(this.facetsExcludes, e, t) });
        },
        addDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e))
            throw new Error(e + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
          return d.isRefined(this.disjunctiveFacetsRefinements, e, t)
            ? this
            : this.setQueryParameters({
                disjunctiveFacetsRefinements: d.addRefinement(this.disjunctiveFacetsRefinements, e, t),
              });
        },
        addTagRefinement: function (e) {
          if (this.isTagRefined(e)) return this;
          var t = { tagRefinements: this.tagRefinements.concat(e) };
          return this.setQueryParameters(t);
        },
        removeFacet: function (e) {
          return this.isConjunctiveFacet(e)
            ? this.clearRefinements(e).setQueryParameters({
                facets: this.facets.filter(function (t) {
                  return t !== e;
                }),
              })
            : this;
        },
        removeDisjunctiveFacet: function (e) {
          return this.isDisjunctiveFacet(e)
            ? this.clearRefinements(e).setQueryParameters({
                disjunctiveFacets: this.disjunctiveFacets.filter(function (t) {
                  return t !== e;
                }),
              })
            : this;
        },
        removeHierarchicalFacet: function (e) {
          return this.isHierarchicalFacet(e)
            ? this.clearRefinements(e).setQueryParameters({
                hierarchicalFacets: this.hierarchicalFacets.filter(function (t) {
                  return t.name !== e;
                }),
              })
            : this;
        },
        removeFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(e + ' is not defined in the facets attribute of the helper configuration');
          return d.isRefined(this.facetsRefinements, e, t)
            ? this.setQueryParameters({ facetsRefinements: d.removeRefinement(this.facetsRefinements, e, t) })
            : this;
        },
        removeExcludeRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(e + ' is not defined in the facets attribute of the helper configuration');
          return d.isRefined(this.facetsExcludes, e, t)
            ? this.setQueryParameters({ facetsExcludes: d.removeRefinement(this.facetsExcludes, e, t) })
            : this;
        },
        removeDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e))
            throw new Error(e + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
          return d.isRefined(this.disjunctiveFacetsRefinements, e, t)
            ? this.setQueryParameters({
                disjunctiveFacetsRefinements: d.removeRefinement(this.disjunctiveFacetsRefinements, e, t),
              })
            : this;
        },
        removeTagRefinement: function (e) {
          if (!this.isTagRefined(e)) return this;
          var t = {
            tagRefinements: this.tagRefinements.filter(function (t) {
              return t !== e;
            }),
          };
          return this.setQueryParameters(t);
        },
        toggleRefinement: function (e, t) {
          return this.toggleFacetRefinement(e, t);
        },
        toggleFacetRefinement: function (e, t) {
          if (this.isHierarchicalFacet(e)) return this.toggleHierarchicalFacetRefinement(e, t);
          if (this.isConjunctiveFacet(e)) return this.toggleConjunctiveFacetRefinement(e, t);
          if (this.isDisjunctiveFacet(e)) return this.toggleDisjunctiveFacetRefinement(e, t);
          throw new Error(
            'Cannot refine the undeclared facet ' +
              e +
              '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets'
          );
        },
        toggleConjunctiveFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(e + ' is not defined in the facets attribute of the helper configuration');
          return this.setQueryParameters({ facetsRefinements: d.toggleRefinement(this.facetsRefinements, e, t) });
        },
        toggleExcludeFacetRefinement: function (e, t) {
          if (!this.isConjunctiveFacet(e))
            throw new Error(e + ' is not defined in the facets attribute of the helper configuration');
          return this.setQueryParameters({ facetsExcludes: d.toggleRefinement(this.facetsExcludes, e, t) });
        },
        toggleDisjunctiveFacetRefinement: function (e, t) {
          if (!this.isDisjunctiveFacet(e))
            throw new Error(e + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
          return this.setQueryParameters({
            disjunctiveFacetsRefinements: d.toggleRefinement(this.disjunctiveFacetsRefinements, e, t),
          });
        },
        toggleHierarchicalFacetRefinement: function (e, t) {
          if (!this.isHierarchicalFacet(e))
            throw new Error(e + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
          var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e)),
            r = {};
          return (
            void 0 !== this.hierarchicalFacetsRefinements[e] &&
            this.hierarchicalFacetsRefinements[e].length > 0 &&
            (this.hierarchicalFacetsRefinements[e][0] === t ||
              0 === this.hierarchicalFacetsRefinements[e][0].indexOf(t + n))
              ? -1 === t.indexOf(n)
                ? (r[e] = [])
                : (r[e] = [t.slice(0, t.lastIndexOf(n))])
              : (r[e] = [t]),
            this.setQueryParameters({ hierarchicalFacetsRefinements: s({}, r, this.hierarchicalFacetsRefinements) })
          );
        },
        addHierarchicalFacetRefinement: function (e, t) {
          if (this.isHierarchicalFacetRefined(e)) throw new Error(e + ' is already refined.');
          if (!this.isHierarchicalFacet(e))
            throw new Error(e + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
          var n = {};
          return (
            (n[e] = [t]),
            this.setQueryParameters({ hierarchicalFacetsRefinements: s({}, n, this.hierarchicalFacetsRefinements) })
          );
        },
        removeHierarchicalFacetRefinement: function (e) {
          if (!this.isHierarchicalFacetRefined(e)) return this;
          var t = {};
          return (
            (t[e] = []),
            this.setQueryParameters({ hierarchicalFacetsRefinements: s({}, t, this.hierarchicalFacetsRefinements) })
          );
        },
        toggleTagRefinement: function (e) {
          return this.isTagRefined(e) ? this.removeTagRefinement(e) : this.addTagRefinement(e);
        },
        isDisjunctiveFacet: function (e) {
          return this.disjunctiveFacets.indexOf(e) > -1;
        },
        isHierarchicalFacet: function (e) {
          return void 0 !== this.getHierarchicalFacetByName(e);
        },
        isConjunctiveFacet: function (e) {
          return this.facets.indexOf(e) > -1;
        },
        isFacetRefined: function (e, t) {
          return !!this.isConjunctiveFacet(e) && d.isRefined(this.facetsRefinements, e, t);
        },
        isExcludeRefined: function (e, t) {
          return !!this.isConjunctiveFacet(e) && d.isRefined(this.facetsExcludes, e, t);
        },
        isDisjunctiveFacetRefined: function (e, t) {
          return !!this.isDisjunctiveFacet(e) && d.isRefined(this.disjunctiveFacetsRefinements, e, t);
        },
        isHierarchicalFacetRefined: function (e, t) {
          if (!this.isHierarchicalFacet(e)) return !1;
          var n = this.getHierarchicalRefinement(e);
          return t ? -1 !== n.indexOf(t) : n.length > 0;
        },
        isNumericRefined: function (e, t, n) {
          if (void 0 === n && void 0 === t) return !!this.numericRefinements[e];
          var r = this.numericRefinements[e] && void 0 !== this.numericRefinements[e][t];
          if (void 0 === n || !r) return r;
          var o = l(n),
            a = void 0 !== i(this.numericRefinements[e][t], o);
          return r && a;
        },
        isTagRefined: function (e) {
          return -1 !== this.tagRefinements.indexOf(e);
        },
        getRefinedDisjunctiveFacets: function () {
          var e = this,
            t = c(
              Object.keys(this.numericRefinements).filter(function (t) {
                return Object.keys(e.numericRefinements[t]).length > 0;
              }),
              this.disjunctiveFacets
            );
          return Object.keys(this.disjunctiveFacetsRefinements)
            .filter(function (t) {
              return e.disjunctiveFacetsRefinements[t].length > 0;
            })
            .concat(t)
            .concat(this.getRefinedHierarchicalFacets());
        },
        getRefinedHierarchicalFacets: function () {
          var e = this;
          return c(
            this.hierarchicalFacets.map(function (e) {
              return e.name;
            }),
            Object.keys(this.hierarchicalFacetsRefinements).filter(function (t) {
              return e.hierarchicalFacetsRefinements[t].length > 0;
            })
          );
        },
        getUnrefinedDisjunctiveFacets: function () {
          var e = this.getRefinedDisjunctiveFacets();
          return this.disjunctiveFacets.filter(function (t) {
            return -1 === e.indexOf(t);
          });
        },
        managedParameters: [
          'index',
          'facets',
          'disjunctiveFacets',
          'facetsRefinements',
          'facetsExcludes',
          'disjunctiveFacetsRefinements',
          'numericRefinements',
          'tagRefinements',
          'hierarchicalFacets',
          'hierarchicalFacetsRefinements',
        ],
        getQueryParams: function () {
          var e = this.managedParameters,
            t = {},
            n = this;
          return (
            Object.keys(this).forEach(function (r) {
              var i = n[r];
              -1 === e.indexOf(r) && void 0 !== i && (t[r] = i);
            }),
            t
          );
        },
        setQueryParameter: function (e, t) {
          if (this[e] === t) return this;
          var n = {};
          return (n[e] = t), this.setQueryParameters(n);
        },
        setQueryParameters: function (e) {
          if (!e) return this;
          var t = o.validate(this, e);
          if (t) throw t;
          var n = this,
            r = o._parseNumbers(e),
            i = Object.keys(this).reduce(function (e, t) {
              return (e[t] = n[t]), e;
            }, {}),
            a = Object.keys(r).reduce(function (e, t) {
              var n = void 0 !== e[t],
                i = void 0 !== r[t];
              return n && !i ? f(e, [t]) : (i && (e[t] = r[t]), e);
            }, i);
          return new this.constructor(a);
        },
        resetPage: function () {
          return void 0 === this.page ? this : this.setPage(0);
        },
        _getHierarchicalFacetSortBy: function (e) {
          return e.sortBy || ['isRefined:desc', 'name:asc'];
        },
        _getHierarchicalFacetSeparator: function (e) {
          return e.separator || ' > ';
        },
        _getHierarchicalRootPath: function (e) {
          return e.rootPath || null;
        },
        _getHierarchicalShowParentLevel: function (e) {
          return 'boolean' != typeof e.showParentLevel || e.showParentLevel;
        },
        getHierarchicalFacetByName: function (e) {
          return u(this.hierarchicalFacets, function (t) {
            return t.name === e;
          });
        },
        getHierarchicalFacetBreadcrumb: function (e) {
          if (!this.isHierarchicalFacet(e)) return [];
          var t = this.getHierarchicalRefinement(e)[0];
          if (!t) return [];
          var n = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(e));
          return t.split(n).map(function (e) {
            return e.trim();
          });
        },
        toString: function () {
          return JSON.stringify(this, null, 2);
        },
      }),
      (e.exports = o);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (null === e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = {};
      return (
        e.forEach(function (e, n) {
          t[e] = n;
        }),
        t
      );
    }
    function i(e, t, n) {
      t && t[n] && (e.stats = t[n]);
    }
    function o(e, t) {
      return v(e, function (e) {
        return (e.attributes || []).indexOf(t) > -1;
      });
    }
    function a(e, t) {
      var n = t[0];
      this._rawResults = t;
      var a = this;
      Object.keys(n).forEach(function (e) {
        a[e] = n[e];
      }),
        (this.processingTimeMS = t.reduce(function (e, t) {
          return void 0 === t.processingTimeMS ? e : e + t.processingTimeMS;
        }, 0)),
        (this.disjunctiveFacets = []),
        (this.hierarchicalFacets = e.hierarchicalFacets.map(function () {
          return [];
        })),
        (this.facets = []);
      var s = e.getRefinedDisjunctiveFacets(),
        c = r(e.facets),
        u = r(e.disjunctiveFacets),
        l = 1,
        f = n.facets || {};
      Object.keys(f).forEach(function (t) {
        var r = f[t],
          s = o(e.hierarchicalFacets, t);
        if (s) {
          var l = s.attributes.indexOf(t),
            h = y(e.hierarchicalFacets, function (e) {
              return e.name === s.name;
            });
          a.hierarchicalFacets[h][l] = { attribute: t, data: r, exhaustive: n.exhaustiveFacetsCount };
        } else {
          var d,
            p = -1 !== e.disjunctiveFacets.indexOf(t),
            m = -1 !== e.facets.indexOf(t);
          p &&
            ((d = u[t]),
            (a.disjunctiveFacets[d] = { name: t, data: r, exhaustive: n.exhaustiveFacetsCount }),
            i(a.disjunctiveFacets[d], n.facets_stats, t)),
            m &&
              ((d = c[t]),
              (a.facets[d] = { name: t, data: r, exhaustive: n.exhaustiveFacetsCount }),
              i(a.facets[d], n.facets_stats, t));
        }
      }),
        (this.hierarchicalFacets = g(this.hierarchicalFacets)),
        s.forEach(function (r) {
          var o = t[l],
            s = o && o.facets ? o.facets : {},
            c = e.getHierarchicalFacetByName(r);
          Object.keys(s).forEach(function (t) {
            var r,
              l = s[t];
            if (c) {
              r = y(e.hierarchicalFacets, function (e) {
                return e.name === c.name;
              });
              var f = y(a.hierarchicalFacets[r], function (e) {
                return e.attribute === t;
              });
              if (-1 === f) return;
              a.hierarchicalFacets[r][f].data = d({}, a.hierarchicalFacets[r][f].data, l);
            } else {
              r = u[t];
              var h = (n.facets && n.facets[t]) || {};
              (a.disjunctiveFacets[r] = { name: t, data: p({}, l, h), exhaustive: o.exhaustiveFacetsCount }),
                i(a.disjunctiveFacets[r], o.facets_stats, t),
                e.disjunctiveFacetsRefinements[t] &&
                  e.disjunctiveFacetsRefinements[t].forEach(function (n) {
                    !a.disjunctiveFacets[r].data[n] &&
                      e.disjunctiveFacetsRefinements[t].indexOf(n) > -1 &&
                      (a.disjunctiveFacets[r].data[n] = 0);
                  });
            }
          }),
            l++;
        }),
        e.getRefinedHierarchicalFacets().forEach(function (n) {
          var r = e.getHierarchicalFacetByName(n),
            i = e._getHierarchicalFacetSeparator(r),
            o = e.getHierarchicalRefinement(n);
          if (!(0 === o.length || o[0].split(i).length < 2)) {
            var s = t[l],
              c = s && s.facets ? s.facets : {};
            Object.keys(c).forEach(function (t) {
              var n = c[t],
                s = y(e.hierarchicalFacets, function (e) {
                  return e.name === r.name;
                }),
                u = y(a.hierarchicalFacets[s], function (e) {
                  return e.attribute === t;
                });
              if (-1 !== u) {
                var l = {};
                if (o.length > 0) {
                  var f = o[0].split(i)[0];
                  l[f] = a.hierarchicalFacets[s][u].data[f];
                }
                a.hierarchicalFacets[s][u].data = p(l, n, a.hierarchicalFacets[s][u].data);
              }
            }),
              l++;
          }
        }),
        Object.keys(e.facetsExcludes).forEach(function (t) {
          var r = e.facetsExcludes[t],
            i = c[t];
          (a.facets[i] = { name: t, data: n.facets[t], exhaustive: n.exhaustiveFacetsCount }),
            r.forEach(function (e) {
              (a.facets[i] = a.facets[i] || { name: t }),
                (a.facets[i].data = a.facets[i].data || {}),
                (a.facets[i].data[e] = 0);
            });
        }),
        (this.hierarchicalFacets = this.hierarchicalFacets.map(w(e))),
        (this.facets = g(this.facets)),
        (this.disjunctiveFacets = g(this.disjunctiveFacets)),
        (this._state = e);
    }
    function s(e, t) {
      function n(e) {
        return e.name === t;
      }
      if (e._state.isConjunctiveFacet(t)) {
        var r = v(e.facets, n);
        return r
          ? Object.keys(r.data).map(function (n) {
              return {
                name: n,
                count: r.data[n],
                isRefined: e._state.isFacetRefined(t, n),
                isExcluded: e._state.isExcludeRefined(t, n),
              };
            })
          : [];
      }
      if (e._state.isDisjunctiveFacet(t)) {
        var i = v(e.disjunctiveFacets, n);
        return i
          ? Object.keys(i.data).map(function (n) {
              return { name: n, count: i.data[n], isRefined: e._state.isDisjunctiveFacetRefined(t, n) };
            })
          : [];
      }
      if (e._state.isHierarchicalFacet(t)) return v(e.hierarchicalFacets, n);
    }
    function c(e, t) {
      if (!t.data || 0 === t.data.length) return t;
      var n = t.data.map(function (t) {
          return c(e, t);
        }),
        r = e(n);
      return d({}, t, { data: r });
    }
    function u(e, t) {
      return t.sort(e);
    }
    function l(e, t) {
      var n = v(e, function (e) {
        return e.name === t;
      });
      return n && n.stats;
    }
    function f(e, t, n, r, i) {
      var o = v(i, function (e) {
          return e.name === n;
        }),
        a = o && o.data && o.data[r] ? o.data[r] : 0,
        s = (o && o.exhaustive) || !1;
      return { type: t, attributeName: n, name: r, count: a, exhaustive: s };
    }
    function h(e, t, n, r) {
      var i = e.getHierarchicalFacetByName(t),
        o = e._getHierarchicalFacetSeparator(i),
        a = n.split(o),
        s = v(r, function (e) {
          return e.name === t;
        }),
        c = a.reduce(function (e, t) {
          var n =
            e &&
            v(e.data, function (e) {
              return e.name === t;
            });
          return void 0 !== n ? n : e;
        }, s),
        u = (c && c.count) || 0,
        l = (c && c.exhaustive) || !1,
        f = (c && c.path) || '';
      return { type: 'hierarchical', attributeName: t, name: f, count: u, exhaustive: l };
    }
    var d = n(20),
      p = n(21),
      m = n(33),
      g = n(72),
      v = n(13),
      y = n(73),
      b = n(34),
      w = n(74);
    (a.prototype.getFacetByName = function (e) {
      function t(t) {
        return t.name === e;
      }
      return v(this.facets, t) || v(this.disjunctiveFacets, t) || v(this.hierarchicalFacets, t);
    }),
      (a.DEFAULT_SORT = ['isRefined:desc', 'count:desc', 'name:asc']),
      (a.prototype.getFacetValues = function (e, t) {
        var n = s(this, e);
        if (n) {
          var r = p({}, t, { sortBy: a.DEFAULT_SORT });
          if (Array.isArray(r.sortBy)) {
            var i = b(r.sortBy, a.DEFAULT_SORT);
            return Array.isArray(n)
              ? m(n, i[0], i[1])
              : c(function (e) {
                  return m(e, i[0], i[1]);
                }, n);
          }
          if ('function' == typeof r.sortBy)
            return Array.isArray(n)
              ? n.sort(r.sortBy)
              : c(function (e) {
                  return u(r.sortBy, e);
                }, n);
          throw new Error(
            'options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function'
          );
        }
      }),
      (a.prototype.getFacetStats = function (e) {
        return this._state.isConjunctiveFacet(e)
          ? l(this.facets, e)
          : this._state.isDisjunctiveFacet(e)
          ? l(this.disjunctiveFacets, e)
          : void 0;
      }),
      (a.prototype.getRefinements = function () {
        var e = this._state,
          t = this,
          n = [];
        return (
          Object.keys(e.facetsRefinements).forEach(function (r) {
            e.facetsRefinements[r].forEach(function (i) {
              n.push(f(e, 'facet', r, i, t.facets));
            });
          }),
          Object.keys(e.facetsExcludes).forEach(function (r) {
            e.facetsExcludes[r].forEach(function (i) {
              n.push(f(e, 'exclude', r, i, t.facets));
            });
          }),
          Object.keys(e.disjunctiveFacetsRefinements).forEach(function (r) {
            e.disjunctiveFacetsRefinements[r].forEach(function (i) {
              n.push(f(e, 'disjunctive', r, i, t.disjunctiveFacets));
            });
          }),
          Object.keys(e.hierarchicalFacetsRefinements).forEach(function (r) {
            e.hierarchicalFacetsRefinements[r].forEach(function (i) {
              n.push(h(e, r, i, t.hierarchicalFacets));
            });
          }),
          Object.keys(e.numericRefinements).forEach(function (t) {
            var r = e.numericRefinements[t];
            Object.keys(r).forEach(function (e) {
              r[e].forEach(function (r) {
                n.push({ type: 'numeric', attributeName: t, name: r, numericValue: r, operator: e });
              });
            });
          }),
          e.tagRefinements.forEach(function (e) {
            n.push({ type: 'tag', attributeName: '_tags', name: e });
          }),
          n
        );
      }),
      (e.exports = a);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (e !== t) {
        var n = void 0 !== e,
          r = null === e,
          i = void 0 !== t,
          o = null === t;
        if ((!o && e > t) || (r && i) || !n) return 1;
        if ((!r && e < t) || (o && n) || !i) return -1;
      }
      return 0;
    }
    function i(e, t, n) {
      if (!Array.isArray(e)) return [];
      Array.isArray(n) || (n = []);
      var i = e.map(function (e, n) {
        return {
          criteria: t.map(function (t) {
            return e[t];
          }),
          index: n,
          value: e,
        };
      });
      return (
        i.sort(function (e, t) {
          for (var i = -1; ++i < e.criteria.length; ) {
            var o = r(e.criteria[i], t.criteria[i]);
            if (o) return i >= n.length ? o : 'desc' === n[i] ? -o : o;
          }
          return e.index - t.index;
        }),
        i.map(function (e) {
          return e.value;
        })
      );
    }
    e.exports = i;
  },
  function (e, t, n) {
    'use strict';
    var r = n(13);
    e.exports = function (e, t) {
      var n = (t || []).map(function (e) {
        return e.split(':');
      });
      return e.reduce(
        function (e, t) {
          var i = t.split(':'),
            o = r(n, function (e) {
              return e[0] === i[0];
            });
          return i.length > 1 || !o ? (e[0].push(i[0]), e[1].push(i[1]), e) : (e[0].push(o[0]), e[1].push(o[1]), e);
        },
        [[], []]
      );
    };
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      e.prototype = Object.create(t.prototype, {
        constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 },
      });
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    e.exports = '3.2.2';
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e.toString().charAt(0).toUpperCase() + e.toString().slice(1);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e instanceof HTMLElement || (Boolean(e) && e.nodeType > 0);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      return Array.prototype.find ? e.find(t, n) : e.filter(t, n)[0];
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return String(e).replace(/^\\-/, '-');
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return Object.prototype.toString.call(e).slice(8, -1);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.warning = t.deprecate = t.warn = void 0);
    var i = r(n(43)),
      o = function (e) {
        return e;
      };
    t.deprecate = o;
    var a = i.default;
    t.warn = a;
    var s = i.default;
    t.warning = s;
  },
  function (e, t, n) {
    'use strict';
    function r() {}
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (!Array.isArray(e)) return -1;
      for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
      return -1;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      return e.state.isHierarchicalFacet(t)
        ? e.state.isHierarchicalFacetRefined(t, n)
        : e.state.isConjunctiveFacet(t)
        ? e.state.isFacetRefined(t, n)
        : e.state.isDisjunctiveFacetRefined(t, n);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0), (t.default = '4.8.1');
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = n(12);
    Object.defineProperty(t, '__esModule', { value: !0 });
    var o = { highlight: !0, snippet: !0, insights: !0, getInsightsAnonymousUserToken: !0 };
    Object.defineProperty(t, 'highlight', {
      enumerable: !0,
      get: function () {
        return a.default;
      },
    }),
      Object.defineProperty(t, 'snippet', {
        enumerable: !0,
        get: function () {
          return s.default;
        },
      }),
      Object.defineProperty(t, 'insights', {
        enumerable: !0,
        get: function () {
          return c.default;
        },
      }),
      Object.defineProperty(t, 'getInsightsAnonymousUserToken', {
        enumerable: !0,
        get: function () {
          return u.default;
        },
      });
    var a = i(n(106));
    Object.keys(a).forEach(function (e) {
      'default' !== e &&
        '__esModule' !== e &&
        (Object.prototype.hasOwnProperty.call(o, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return a[e];
            },
          }));
    });
    var s = i(n(107));
    Object.keys(s).forEach(function (e) {
      'default' !== e &&
        '__esModule' !== e &&
        (Object.prototype.hasOwnProperty.call(o, e) ||
          Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return s[e];
            },
          }));
    });
    var c = r(n(48)),
      u = r(n(108));
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, u.default)(Symbol.iterator)
          ? function (e) {
              return (0, u.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, u.default)(e);
            })(e);
    }
    function i(e) {
      var t = e.getAttribute('data-insights-method'),
        n = e.getAttribute('data-insights-payload');
      if ('string' != typeof n)
        throw new Error('The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.');
      try {
        return { method: t, payload: JSON.parse(atob(n)) };
      } catch (e) {
        throw new Error('The insights helper was unable to parse `data-insights-payload`.');
      }
    }
    function o(e) {
      return e.hasAttribute('data-insights-method');
    }
    function a(e) {
      var t = e.method,
        n = e.payload;
      if ('object' !== r(n)) throw new Error('The insights helper expects the payload to be an object.');
      var i;
      try {
        i = btoa(JSON.stringify(n));
      } catch (e) {
        throw new Error('Could not JSON serialize the payload object.');
      }
      return 'data-insights-method="'.concat(t, '" data-insights-payload="').concat(i, '"');
    }
    function s(e, t) {
      return a({ method: e, payload: t });
    }
    var c = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.readDataAttributes = i),
      (t.hasDataAttributes = o),
      (t.writeDataAttributes = a),
      (t.default = s);
    var u = c(n(2));
  },
  function (e, t, n) {
    'use strict';
    var r = String.prototype.replace,
      i = /%20/g,
      o = n(25),
      a = { RFC1738: 'RFC1738', RFC3986: 'RFC3986' };
    e.exports = o.assign(
      {
        default: a.RFC3986,
        formatters: {
          RFC1738: function (e) {
            return r.call(e, i, '+');
          },
          RFC3986: function (e) {
            return String(e);
          },
        },
      },
      a
    );
  },
  function (e, t, n) {
    'use strict';
    'function' == typeof Object.create
      ? (e.exports = function (e, t) {
          (e.super_ = t),
            (e.prototype = Object.create(t.prototype, {
              constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 },
            }));
        })
      : (e.exports = function (e, t) {
          e.super_ = t;
          var n = function () {};
          (n.prototype = t.prototype), (e.prototype = new n()), (e.prototype.constructor = e);
        });
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return function (n, r, i) {
        if (('function' == typeof n && 'object' === (0, o.default)(r)) || 'object' === (0, o.default)(i))
          throw new a.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
        0 === arguments.length || 'function' == typeof n
          ? ((i = n), (n = ''))
          : (1 !== arguments.length && 'function' != typeof r) || ((i = r), (r = void 0)),
          'object' === (0, o.default)(n) && null !== n
            ? ((r = n), (n = void 0))
            : (void 0 !== n && null !== n) || (n = '');
        var s = '';
        void 0 !== n && (s += e + '=' + encodeURIComponent(n));
        var c;
        return (
          void 0 !== r &&
            (r.additionalUA && ((c = r.additionalUA), delete r.additionalUA), (s = this.as._getSearchParams(r, s))),
          this._search(s, t, i, c)
        );
      };
    }
    var i = n(0),
      o = i(n(2));
    e.exports = r;
    var a = n(15);
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e, t) {
      var r = n(125),
        i = n(9),
        o = {};
      return (
        i(r(e), function (n) {
          !0 !== t(n) && (o[n] = e[n]);
        }),
        o
      );
    };
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (e.map) return e.map(t);
      for (var n = [], r = 0; r < e.length; r++) n.push(t(e[r], r));
      return n;
    }
    var i = n(0),
      o = i(n(2)),
      a = function (e) {
        switch ((0, o.default)(e)) {
          case 'string':
            return e;
          case 'boolean':
            return e ? 'true' : 'false';
          case 'number':
            return isFinite(e) ? e : '';
          default:
            return '';
        }
      };
    e.exports = function (e, t, n, i) {
      return (
        (t = t || '&'),
        (n = n || '='),
        null === e && (e = void 0),
        'object' === (0, o.default)(e)
          ? r(c(e), function (i) {
              var o = encodeURIComponent(a(i)) + n;
              return s(e[i])
                ? r(e[i], function (e) {
                    return o + encodeURIComponent(a(e));
                  }).join(t)
                : o + encodeURIComponent(a(e[i]));
            }).join(t)
          : i
          ? encodeURIComponent(a(i)) + n + encodeURIComponent(a(e))
          : ''
      );
    };
    var s =
        Array.isArray ||
        function (e) {
          return '[object Array]' === Object.prototype.toString.call(e);
        },
      c =
        Object.keys ||
        function (e) {
          var t = [];
          for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
          return t;
        };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      (e && e.el) || i.error('EventBus initialized without el'), (this.$el = o.element(e.el));
    }
    var i = n(6),
      o = n(7);
    i.mixin(r.prototype, {
      trigger: function (e, t, n, r) {
        var o = i.Event('autocomplete:' + e);
        return this.$el.trigger(o, [t, n, r]), o;
      },
    }),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    e.exports = {
      wrapper: '<span class="%ROOT%"></span>',
      dropdown: '<span class="%PREFIX%%DROPDOWN_MENU%"></span>',
      dataset: '<div class="%PREFIX%%DATASET%-%CLASS%"></div>',
      suggestions: '<span class="%PREFIX%%SUGGESTIONS%"></span>',
      suggestion: '<div class="%PREFIX%%SUGGESTION%"></div>',
    };
  },
  function (e, t, n) {
    'use strict';
    e.exports = '0.37.0';
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e) {
      var t = e.match(/Algolia for vanilla JavaScript (\d+\.)(\d+\.)(\d+)/);
      if (t) return [t[1], t[2], t[3]];
    };
  },
  function (e, t) {
    (function (t) {
      e.exports = t;
    }).call(t, {});
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, b.default)(Symbol.iterator)
          ? function (e) {
              return (0, b.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, b.default)(e);
            })(e);
    }
    function i(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(n), !0).forEach(function (t) {
              a(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function a(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function s() {
      return (
        (s =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        s.apply(this, arguments)
      );
    }
    function c(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = u(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++)
          (n = o[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
      }
      return i;
    }
    function u(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function l(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function f(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function h(e, t, n) {
      return t && f(e.prototype, t), n && f(e, n), e;
    }
    function d(e, t) {
      return !t || ('object' !== r(t) && 'function' != typeof t) ? m(e) : t;
    }
    function p(e) {
      return (p = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function m(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function g(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && v(e, t);
    }
    function v(e, t) {
      return (v =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    var y = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var b = y(n(2)),
      w = n(3),
      _ = y(n(4)),
      O = n(1),
      P = y(n(8)),
      j = y(n(163)),
      S = y(n(60)),
      x = (function (e) {
        function t(e) {
          var n;
          return l(this, t), (n = d(this, p(t).call(this, e))), (n.handleItemClick = n.handleItemClick.bind(m(n))), n;
        }
        return (
          g(t, e),
          h(t, [
            {
              key: 'shouldComponentUpdate',
              value: function (e, t) {
                var n = this.state !== t,
                  r = !(0, O.isEqual)(this.props.facetValues, e.facetValues);
                return n || r;
              },
            },
            {
              key: 'refine',
              value: function (e, t) {
                this.props.toggleRefinement(e, t);
              },
            },
            {
              key: '_generateFacetItem',
              value: function (e) {
                var n,
                  r,
                  i = e.data && e.data.length > 0;
                if (i) {
                  var u = this.props.cssClasses,
                    l = (u.root, c(u, ['root']));
                  r = (0, w.h)(
                    t,
                    s({}, this.props, {
                      cssClasses: l,
                      depth: this.props.depth + 1,
                      facetValues: e.data,
                      showMore: !1,
                      className: this.props.cssClasses.childList,
                    })
                  );
                }
                var f = this.props.createURL(e.value),
                  h = o({}, e, {
                    url: f,
                    attribute: this.props.attribute,
                    cssClasses: this.props.cssClasses,
                    isFromSearch: this.props.isFromSearch,
                  }),
                  d = e.value;
                return (
                  void 0 !== e.isRefined && (d += '/'.concat(e.isRefined)),
                  void 0 !== e.count && (d += '/'.concat(e.count)),
                  (0, w.h)(j.default, {
                    templateKey: 'item',
                    key: d,
                    facetValueToRefine: e.value,
                    handleClick: this.handleItemClick,
                    isRefined: e.isRefined,
                    className: (0, _.default)(
                      this.props.cssClasses.item,
                      ((n = {}),
                      a(n, this.props.cssClasses.selectedItem, e.isRefined),
                      a(n, this.props.cssClasses.disabledItem, !e.count),
                      a(n, this.props.cssClasses.parentItem, i),
                      n)
                    ),
                    subItems: r,
                    templateData: h,
                    templateProps: this.props.templateProps,
                  })
                );
              },
            },
            {
              key: 'handleItemClick',
              value: function (e) {
                var t = e.facetValueToRefine,
                  n = e.originalEvent,
                  r = e.isRefined;
                if (
                  !((0, O.isSpecialClick)(n) || (r && n.target.parentNode.querySelector('input[type="radio"]:checked')))
                ) {
                  if ('INPUT' === n.target.tagName) return void this.refine(t, r);
                  for (var i = n.target; i !== n.currentTarget; ) {
                    if (
                      'LABEL' === i.tagName &&
                      (i.querySelector('input[type="checkbox"]') || i.querySelector('input[type="radio"]'))
                    )
                      return;
                    'A' === i.tagName && i.href && n.preventDefault(), (i = i.parentNode);
                  }
                  n.stopPropagation(), this.refine(t, r);
                }
              },
            },
            {
              key: 'componentWillReceiveProps',
              value: function (e) {
                this.searchBox && !e.isFromSearch && this.searchBox.resetInput();
              },
            },
            {
              key: 'refineFirstValue',
              value: function () {
                var e = this.props.facetValues[0];
                if (e) {
                  var t = e.value;
                  this.props.toggleRefinement(t);
                }
              },
            },
            {
              key: 'render',
              value: function () {
                var e = this,
                  t = (0, _.default)(
                    this.props.cssClasses.list,
                    a({}, ''.concat(this.props.cssClasses.depth).concat(this.props.depth), this.props.cssClasses.depth)
                  ),
                  n = (0, _.default)(
                    this.props.cssClasses.showMore,
                    a(
                      {},
                      this.props.cssClasses.disabledShowMore,
                      !(!0 === this.props.showMore && this.props.canToggleShowMore)
                    )
                  ),
                  r =
                    !0 === this.props.showMore &&
                    (0, w.h)(
                      P.default,
                      s({}, this.props.templateProps, {
                        templateKey: 'showMoreText',
                        rootTagName: 'button',
                        rootProps: {
                          className: n,
                          disabled: !this.props.canToggleShowMore,
                          onClick: this.props.toggleShowMore,
                        },
                        data: { isShowingMore: this.props.isShowingMore },
                      })
                    ),
                  i =
                    !0 !== this.props.searchIsAlwaysActive &&
                    !(this.props.isFromSearch || !this.props.hasExhaustiveItems),
                  o =
                    this.props.searchFacetValues &&
                    (0, w.h)(
                      'div',
                      { className: this.props.cssClasses.searchBox },
                      (0, w.h)(S.default, {
                        ref: function (t) {
                          return (e.searchBox = t);
                        },
                        placeholder: this.props.searchPlaceholder,
                        disabled: i,
                        cssClasses: this.props.cssClasses.searchable,
                        templates: this.props.templateProps.templates,
                        onChange: function (t) {
                          return e.props.searchFacetValues(t.target.value);
                        },
                        onReset: function () {
                          return e.props.searchFacetValues('');
                        },
                        onSubmit: function () {
                          return e.refineFirstValue();
                        },
                        searchAsYouType: !1,
                      })
                    ),
                  c =
                    this.props.facetValues &&
                    this.props.facetValues.length > 0 &&
                    (0, w.h)('ul', { className: t }, this.props.facetValues.map(this._generateFacetItem, this)),
                  u =
                    this.props.searchFacetValues &&
                    this.props.isFromSearch &&
                    0 === this.props.facetValues.length &&
                    (0, w.h)(
                      P.default,
                      s({}, this.props.templateProps, {
                        templateKey: 'searchableNoResults',
                        rootProps: { className: this.props.cssClasses.noResults },
                      })
                    );
                return (0, w.h)(
                  'div',
                  {
                    className: (0, _.default)(
                      this.props.cssClasses.root,
                      a(
                        {},
                        this.props.cssClasses.noRefinementRoot,
                        !this.props.facetValues || 0 === this.props.facetValues.length
                      ),
                      this.props.className
                    ),
                  },
                  this.props.children,
                  o,
                  c,
                  u,
                  r
                );
              },
            },
          ]),
          t
        );
      })(w.Component);
    x.defaultProps = { cssClasses: {}, depth: 0 };
    var R = x;
    t.default = R;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, p.default)(Symbol.iterator)
          ? function (e) {
              return (0, p.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, p.default)(e);
            })(e);
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function a(e, t, n) {
      return t && o(e.prototype, t), n && o(e, n), e;
    }
    function s(e, t) {
      return !t || ('object' !== r(t) && 'function' != typeof t) ? u(e) : t;
    }
    function c(e) {
      return (c = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function u(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function l(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && f(e, t);
    }
    function f(e, t) {
      return (f =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function h(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var d = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var p = d(n(2)),
      m = n(3),
      g = n(1),
      v = d(n(8)),
      y = (function (e) {
        function t() {
          var e, n;
          i(this, t);
          for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
          return (
            (n = s(this, (e = c(t)).call.apply(e, [this].concat(o)))),
            h(u(n), 'state', { query: n.props.query, focused: !1 }),
            h(u(n), 'onInput', function (e) {
              var t = n.props,
                r = t.searchAsYouType,
                i = t.refine,
                o = t.onChange,
                a = e.target.value;
              r && i(a), n.setState({ query: a }), o(e);
            }),
            h(u(n), 'onSubmit', function (e) {
              var t = n.props,
                r = t.searchAsYouType,
                i = t.refine,
                o = t.onSubmit;
              return e.preventDefault(), e.stopPropagation(), n.input.blur(), r || i(n.state.query), o(e), !1;
            }),
            h(u(n), 'onReset', function (e) {
              var t = n.props,
                r = t.refine,
                i = t.onReset;
              n.input.focus(), r(''), n.setState({ query: '' }), i(e);
            }),
            h(u(n), 'onBlur', function () {
              n.setState({ focused: !1 });
            }),
            h(u(n), 'onFocus', function () {
              n.setState({ focused: !0 });
            }),
            n
          );
        }
        return (
          l(t, e),
          a(t, [
            {
              key: 'resetInput',
              value: function () {
                this.setState({ query: '' });
              },
            },
            {
              key: 'componentWillReceiveProps',
              value: function (e) {
                this.state.focused || e.query === this.state.query || this.setState({ query: e.query });
              },
            },
            {
              key: 'render',
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.cssClasses,
                  r = t.placeholder,
                  i = t.autofocus,
                  o = t.showSubmit,
                  a = t.showReset,
                  s = t.showLoadingIndicator,
                  c = t.templates,
                  u = t.isSearchStalled;
                return (0, m.h)(
                  'div',
                  { className: n.root },
                  (0, m.h)(
                    'form',
                    {
                      action: '',
                      role: 'search',
                      className: n.form,
                      noValidate: !0,
                      onSubmit: this.onSubmit,
                      onReset: this.onReset,
                    },
                    (0, m.h)('input', {
                      ref: function (t) {
                        return (e.input = t);
                      },
                      value: this.state.query,
                      disabled: this.props.disabled,
                      className: n.input,
                      type: 'search',
                      placeholder: r,
                      autoFocus: i,
                      autoComplete: 'off',
                      autoCorrect: 'off',
                      autoCapitalize: 'off',
                      spellCheck: 'false',
                      maxLength: 512,
                      onInput: this.onInput,
                      onBlur: this.onBlur,
                      onFocus: this.onFocus,
                    }),
                    (0, m.h)(v.default, {
                      templateKey: 'submit',
                      rootTagName: 'button',
                      rootProps: { className: n.submit, type: 'submit', title: 'Submit the search query.', hidden: !o },
                      templates: c,
                      data: { cssClasses: n },
                    }),
                    (0, m.h)(v.default, {
                      templateKey: 'reset',
                      rootTagName: 'button',
                      rootProps: {
                        className: n.reset,
                        type: 'reset',
                        title: 'Clear the search query.',
                        hidden: !(a && this.state.query.trim() && !u),
                      },
                      templates: c,
                      data: { cssClasses: n },
                    }),
                    s &&
                      (0, m.h)(v.default, {
                        templateKey: 'loadingIndicator',
                        rootTagName: 'span',
                        rootProps: { className: n.loadingIndicator, hidden: !u },
                        templates: c,
                        data: { cssClasses: n },
                      })
                  )
                );
              },
            },
          ]),
          t
        );
      })(m.Component);
    h(y, 'defaultProps', {
      query: '',
      showSubmit: !0,
      showReset: !0,
      showLoadingIndicator: !0,
      autofocus: !1,
      searchAsYouType: !0,
      isSearchStalled: !1,
      disabled: !1,
      onChange: g.noop,
      onSubmit: g.noop,
      onReset: g.noop,
      refine: g.noop,
    });
    var b = y;
    t.default = b;
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = {
      reset:
        '\n<svg class="{{cssClasses.resetIcon}}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="10" height="10">\n  <path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"></path>\n</svg>\n  ',
      submit:
        '\n<svg class="{{cssClasses.submitIcon}}" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 40 40">\n  <path d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"></path>\n</svg>\n  ',
      loadingIndicator:
        '\n<svg class="{{cssClasses.loadingIcon}}" width="16" height="16" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#444">\n  <g fill="none" fillRule="evenodd">\n    <g transform="translate(1 1)" strokeWidth="2">\n      <circle strokeOpacity=".5" cx="18" cy="18" r="18" />\n      <path d="M36 18c0-9.94-8.06-18-18-18">\n        <animateTransform\n          attributeName="transform"\n          type="rotate"\n          from="0 18 18"\n          to="360 18 18"\n          dur="1s"\n          repeatCount="indefinite"\n        />\n      </path>\n    </g>\n  </g>\n</svg>\n  ',
    };
    t.default = r;
  },
  function (e, t, n) {
    'use strict';
    var r = n(12),
      i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }),
      Object.defineProperty(t, 'Hogan', {
        enumerable: !0,
        get: function () {
          return o.default;
        },
      }),
      Object.defineProperty(t, 'instantsearch', {
        enumerable: !0,
        get: function () {
          return a.default;
        },
      }),
      Object.defineProperty(t, 'algoliasearch', {
        enumerable: !0,
        get: function () {
          return s.default;
        },
      }),
      Object.defineProperty(t, 'autocomplete', {
        enumerable: !0,
        get: function () {
          return c.default;
        },
      }),
      Object.defineProperty(t, 'getAlgoliaResults', {
        enumerable: !0,
        get: function () {
          return c.getAlgoliaResults;
        },
      }),
      Object.defineProperty(t, 'getAlgoliaHits', {
        enumerable: !0,
        get: function () {
          return c.getAlgoliaHits;
        },
      }),
      Object.defineProperty(t, 'highlightAlgoliaHit', {
        enumerable: !0,
        get: function () {
          return c.highlightAlgoliaHit;
        },
      }),
      Object.defineProperty(t, 'aa', {
        enumerable: !0,
        get: function () {
          return u.default;
        },
      }),
      (t.connectors = t.widgets = void 0);
    var o = i(n(29)),
      a = i(n(66)),
      s = i(n(118)),
      c = r(n(140)),
      u = i(n(156)),
      l = i(n(157)),
      f = i(n(162)),
      h = i(n(166)),
      d = i(n(169)),
      p = i(n(171)),
      m = i(n(175)),
      g = i(n(178)),
      v = i(n(182)),
      y = i(n(185)),
      b = i(n(192)),
      w = i(n(197)),
      _ = i(n(199)),
      O = {
        rangeSlider: l.default,
        menu: f.default,
        refinementList: h.default,
        searchBox: d.default,
        stats: p.default,
        sortBy: m.default,
        clearRefinements: g.default,
        panel: v.default,
        hits: y.default,
        pagination: b.default,
        configure: w.default,
      };
    t.widgets = O;
    var P = { connectCurrentRefinements: _.default };
    t.connectors = P;
  },
  function (e, t, n) {
    'use strict';
    function r(t) {
      '@babel/helpers - typeof';
      return (
        'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
          ? (e.exports = r =
              function (e) {
                return typeof e;
              })
          : (e.exports = r =
              function (e) {
                return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                  ? 'symbol'
                  : typeof e;
              }),
        r(t)
      );
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    !(function (e) {
      function t(e) {
        '}' === e.n.substr(e.n.length - 1) && (e.n = e.n.substring(0, e.n.length - 1));
      }
      function n(e) {
        return e.trim ? e.trim() : e.replace(/^\s*|\s*$/g, '');
      }
      function r(e, t, n) {
        if (t.charAt(n) != e.charAt(0)) return !1;
        for (var r = 1, i = e.length; r < i; r++) if (t.charAt(n + r) != e.charAt(r)) return !1;
        return !0;
      }
      function i(t, n, r, s) {
        var c = [],
          u = null,
          l = null,
          f = null;
        for (l = r[r.length - 1]; t.length > 0; ) {
          if (((f = t.shift()), l && '<' == l.tag && !(f.tag in _))) throw new Error('Illegal content in < super tag.');
          if (e.tags[f.tag] <= e.tags.$ || o(f, s)) r.push(f), (f.nodes = i(t, f.tag, r, s));
          else {
            if ('/' == f.tag) {
              if (0 === r.length) throw new Error('Closing tag without opener: /' + f.n);
              if (((u = r.pop()), f.n != u.n && !a(f.n, u.n, s)))
                throw new Error('Nesting error: ' + u.n + ' vs. ' + f.n);
              return (u.end = f.i), c;
            }
            '\n' == f.tag && (f.last = 0 == t.length || '\n' == t[0].tag);
          }
          c.push(f);
        }
        if (r.length > 0) throw new Error('missing closing tag: ' + r.pop().n);
        return c;
      }
      function o(e, t) {
        for (var n = 0, r = t.length; n < r; n++) if (t[n].o == e.n) return (e.tag = '#'), !0;
      }
      function a(e, t, n) {
        for (var r = 0, i = n.length; r < i; r++) if (n[r].c == e && n[r].o == t) return !0;
      }
      function s(e) {
        var t = [];
        for (var n in e) t.push('"' + u(n) + '": function(c,p,t,i) {' + e[n] + '}');
        return '{ ' + t.join(',') + ' }';
      }
      function c(e) {
        var t = [];
        for (var n in e.partials)
          t.push('"' + u(n) + '":{name:"' + u(e.partials[n].name) + '", ' + c(e.partials[n]) + '}');
        return 'partials: {' + t.join(',') + '}, subs: ' + s(e.subs);
      }
      function u(e) {
        return e
          .replace(y, '\\\\')
          .replace(m, '\\"')
          .replace(g, '\\n')
          .replace(v, '\\r')
          .replace(b, '\\u2028')
          .replace(w, '\\u2029');
      }
      function l(e) {
        return ~e.indexOf('.') ? 'd' : 'f';
      }
      function f(e, t) {
        var n = '<' + (t.prefix || ''),
          r = n + e.n + O++;
        return (
          (t.partials[r] = { name: e.n, partials: {} }),
          (t.code += 't.b(t.rp("' + u(r) + '",c,p,"' + (e.indent || '') + '"));'),
          r
        );
      }
      function h(e, t) {
        t.code += 't.b(t.t(t.' + l(e.n) + '("' + u(e.n) + '",c,p,0)));';
      }
      function d(e) {
        return 't.b(' + e + ');';
      }
      var p = /\S/,
        m = /\"/g,
        g = /\n/g,
        v = /\r/g,
        y = /\\/g,
        b = /\u2028/,
        w = /\u2029/;
      (e.tags = { '#': 1, '^': 2, '<': 3, $: 4, '/': 5, '!': 6, '>': 7, '=': 8, _v: 9, '{': 10, '&': 11, _t: 12 }),
        (e.scan = function (i, o) {
          function a() {
            d.length > 0 && (m.push({ tag: '_t', text: new String(d) }), (d = ''));
          }
          function s() {
            for (var t = !0, n = y; n < m.length; n++)
              if (!(t = e.tags[m[n].tag] < e.tags._v || ('_t' == m[n].tag && null === m[n].text.match(p)))) return !1;
            return t;
          }
          function c(e, t) {
            if ((a(), e && s()))
              for (var n, r = y; r < m.length; r++)
                m[r].text && ((n = m[r + 1]) && '>' == n.tag && (n.indent = m[r].text.toString()), m.splice(r, 1));
            else t || m.push({ tag: '\n' });
            (g = !1), (y = m.length);
          }
          var u = i.length,
            l = 0,
            f = null,
            h = null,
            d = '',
            m = [],
            g = !1,
            v = 0,
            y = 0,
            b = '{{',
            w = '}}';
          for (o && ((o = o.split(' ')), (b = o[0]), (w = o[1])), v = 0; v < u; v++)
            0 == l
              ? r(b, i, v)
                ? (--v, a(), (l = 1))
                : '\n' == i.charAt(v)
                ? c(g)
                : (d += i.charAt(v))
              : 1 == l
              ? ((v += b.length - 1),
                (h = e.tags[i.charAt(v + 1)]),
                (f = h ? i.charAt(v + 1) : '_v'),
                '=' == f
                  ? ((v = (function (e, t) {
                      var r = '=' + w,
                        i = e.indexOf(r, t),
                        o = n(e.substring(e.indexOf('=', t) + 1, i)).split(' ');
                      return (b = o[0]), (w = o[o.length - 1]), i + r.length - 1;
                    })(i, v)),
                    (l = 0))
                  : (h && v++, (l = 2)),
                (g = v))
              : r(w, i, v)
              ? (m.push({ tag: f, n: n(d), otag: b, ctag: w, i: '/' == f ? g - b.length : v + w.length }),
                (d = ''),
                (v += w.length - 1),
                (l = 0),
                '{' == f && ('}}' == w ? v++ : t(m[m.length - 1])))
              : (d += i.charAt(v));
          return c(g, !0), m;
        });
      var _ = { _t: !0, '\n': !0, $: !0, '/': !0 };
      e.stringify = function (t, n, r) {
        return '{code: function (c,p,i) { ' + e.wrapMain(t.code) + ' },' + c(t) + '}';
      };
      var O = 0;
      (e.generate = function (t, n, r) {
        O = 0;
        var i = { code: '', subs: {}, partials: {} };
        return e.walk(t, i), r.asString ? this.stringify(i, n, r) : this.makeTemplate(i, n, r);
      }),
        (e.wrapMain = function (e) {
          return 'var t=this;t.b(i=i||"");' + e + 'return t.fl();';
        }),
        (e.template = e.Template),
        (e.makeTemplate = function (e, t, n) {
          var r = this.makePartials(e);
          return (r.code = new Function('c', 'p', 'i', this.wrapMain(e.code))), new this.template(r, t, this, n);
        }),
        (e.makePartials = function (e) {
          var t,
            n = { subs: {}, partials: e.partials, name: e.name };
          for (t in n.partials) n.partials[t] = this.makePartials(n.partials[t]);
          for (t in e.subs) n.subs[t] = new Function('c', 'p', 't', 'i', e.subs[t]);
          return n;
        }),
        (e.codegen = {
          '#': function (t, n) {
            (n.code +=
              'if(t.s(t.' +
              l(t.n) +
              '("' +
              u(t.n) +
              '",c,p,1),c,p,0,' +
              t.i +
              ',' +
              t.end +
              ',"' +
              t.otag +
              ' ' +
              t.ctag +
              '")){t.rs(c,p,function(c,p,t){'),
              e.walk(t.nodes, n),
              (n.code += '});c.pop();}');
          },
          '^': function (t, n) {
            (n.code += 'if(!t.s(t.' + l(t.n) + '("' + u(t.n) + '",c,p,1),c,p,1,0,0,"")){'),
              e.walk(t.nodes, n),
              (n.code += '};');
          },
          '>': f,
          '<': function (t, n) {
            var r = { partials: {}, code: '', subs: {}, inPartial: !0 };
            e.walk(t.nodes, r);
            var i = n.partials[f(t, n)];
            (i.subs = r.subs), (i.partials = r.partials);
          },
          $: function (t, n) {
            var r = { subs: {}, code: '', partials: n.partials, prefix: t.n };
            e.walk(t.nodes, r), (n.subs[t.n] = r.code), n.inPartial || (n.code += 't.sub("' + u(t.n) + '",c,p,i);');
          },
          '\n': function (e, t) {
            t.code += d('"\\n"' + (e.last ? '' : ' + i'));
          },
          _v: function (e, t) {
            t.code += 't.b(t.v(t.' + l(e.n) + '("' + u(e.n) + '",c,p,0)));';
          },
          _t: function (e, t) {
            t.code += d('"' + u(e.text) + '"');
          },
          '{': h,
          '&': h,
        }),
        (e.walk = function (t, n) {
          for (var r, i = 0, o = t.length; i < o; i++) (r = e.codegen[t[i].tag]) && r(t[i], n);
          return n;
        }),
        (e.parse = function (e, t, n) {
          return (n = n || {}), i(e, '', [], n.sectionTags || []);
        }),
        (e.cache = {}),
        (e.cacheKey = function (e, t) {
          return [e, !!t.asString, !!t.disableLambda, t.delimiters, !!t.modelGet].join('||');
        }),
        (e.compile = function (t, n) {
          n = n || {};
          var r = e.cacheKey(t, n),
            i = this.cache[r];
          if (i) {
            var o = i.partials;
            for (var a in o) delete o[a].instance;
            return i;
          }
          return (i = this.generate(this.parse(this.scan(t, n.delimiters), t, n), t, n)), (this.cache[r] = i);
        });
    })(t);
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2));
    !(function (e) {
      function t(e, t, n) {
        var r;
        return (
          t &&
            'object' == (0, i.default)(t) &&
            (void 0 !== t[e] ? (r = t[e]) : n && t.get && 'function' == typeof t.get && (r = t.get(e))),
          r
        );
      }
      function n(e, t, n, r, i, o) {
        function a() {}
        function s() {}
        (a.prototype = e), (s.prototype = e.subs);
        var c,
          u = new a();
        (u.subs = new s()), (u.subsText = {}), (u.buf = ''), (r = r || {}), (u.stackSubs = r), (u.subsText = o);
        for (c in t) r[c] || (r[c] = t[c]);
        for (c in r) u.subs[c] = r[c];
        (i = i || {}), (u.stackPartials = i);
        for (c in n) i[c] || (i[c] = n[c]);
        for (c in i) u.partials[c] = i[c];
        return u;
      }
      function r(e) {
        return String(null === e || void 0 === e ? '' : e);
      }
      function o(e) {
        return (
          (e = r(e)),
          f.test(e)
            ? e.replace(a, '&amp;').replace(s, '&lt;').replace(c, '&gt;').replace(u, '&#39;').replace(l, '&quot;')
            : e
        );
      }
      (e.Template = function (e, t, n, r) {
        (e = e || {}),
          (this.r = e.code || this.r),
          (this.c = n),
          (this.options = r || {}),
          (this.text = t || ''),
          (this.partials = e.partials || {}),
          (this.subs = e.subs || {}),
          (this.buf = '');
      }),
        (e.Template.prototype = {
          r: function (e, t, n) {
            return '';
          },
          v: o,
          t: r,
          render: function (e, t, n) {
            return this.ri([e], t || {}, n);
          },
          ri: function (e, t, n) {
            return this.r(e, t, n);
          },
          ep: function (e, t) {
            var r = this.partials[e],
              i = t[r.name];
            if (r.instance && r.base == i) return r.instance;
            if ('string' == typeof i) {
              if (!this.c) throw new Error('No compiler available.');
              i = this.c.compile(i, this.options);
            }
            if (!i) return null;
            if (((this.partials[e].base = i), r.subs)) {
              t.stackText || (t.stackText = {});
              for (key in r.subs)
                t.stackText[key] ||
                  (t.stackText[key] =
                    void 0 !== this.activeSub && t.stackText[this.activeSub] ? t.stackText[this.activeSub] : this.text);
              i = n(i, r.subs, r.partials, this.stackSubs, this.stackPartials, t.stackText);
            }
            return (this.partials[e].instance = i), i;
          },
          rp: function (e, t, n, r) {
            var i = this.ep(e, n);
            return i ? i.ri(t, n, r) : '';
          },
          rs: function (e, t, n) {
            var r = e[e.length - 1];
            if (!h(r)) return void n(e, t, this);
            for (var i = 0; i < r.length; i++) e.push(r[i]), n(e, t, this), e.pop();
          },
          s: function (e, t, n, r, o, a, s) {
            var c;
            return (
              (!h(e) || 0 !== e.length) &&
              ('function' == typeof e && (e = this.ms(e, t, n, r, o, a, s)),
              (c = !!e),
              !r && c && t && t.push('object' == (0, i.default)(e) ? e : t[t.length - 1]),
              c)
            );
          },
          d: function (e, n, r, i) {
            var o,
              a = e.split('.'),
              s = this.f(a[0], n, r, i),
              c = this.options.modelGet,
              u = null;
            if ('.' === e && h(n[n.length - 2])) s = n[n.length - 1];
            else for (var l = 1; l < a.length; l++) (o = t(a[l], s, c)), void 0 !== o ? ((u = s), (s = o)) : (s = '');
            return !(i && !s) && (i || 'function' != typeof s || (n.push(u), (s = this.mv(s, n, r)), n.pop()), s);
          },
          f: function (e, n, r, i) {
            for (var o = !1, a = null, s = !1, c = this.options.modelGet, u = n.length - 1; u >= 0; u--)
              if (((a = n[u]), void 0 !== (o = t(e, a, c)))) {
                s = !0;
                break;
              }
            return s ? (i || 'function' != typeof o || (o = this.mv(o, n, r)), o) : !i && '';
          },
          ls: function (e, t, n, i, o) {
            var a = this.options.delimiters;
            return (
              (this.options.delimiters = o), this.b(this.ct(r(e.call(t, i)), t, n)), (this.options.delimiters = a), !1
            );
          },
          ct: function (e, t, n) {
            if (this.options.disableLambda) throw new Error('Lambda features disabled.');
            return this.c.compile(e, this.options).render(t, n);
          },
          b: function (e) {
            this.buf += e;
          },
          fl: function () {
            var e = this.buf;
            return (this.buf = ''), e;
          },
          ms: function (e, t, n, r, i, o, a) {
            var s,
              c = t[t.length - 1],
              u = e.call(c);
            return 'function' == typeof u
              ? !!r ||
                  ((s =
                    this.activeSub && this.subsText && this.subsText[this.activeSub]
                      ? this.subsText[this.activeSub]
                      : this.text),
                  this.ls(u, c, n, s.substring(i, o), a))
              : u;
          },
          mv: function (e, t, n) {
            var i = t[t.length - 1],
              o = e.call(i);
            return 'function' == typeof o ? this.ct(r(o.call(i)), i, n) : o;
          },
          sub: function (e, t, n, r) {
            var i = this.subs[e];
            i && ((this.activeSub = e), i(t, n, this, r), (this.activeSub = !1));
          },
        });
      var a = /&/g,
        s = /</g,
        c = />/g,
        u = /\'/g,
        l = /\"/g,
        f = /[&<>\"\']/,
        h =
          Array.isArray ||
          function (e) {
            return '[object Array]' === Object.prototype.toString.call(e);
          };
    })(t);
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r(n(67)),
      o = r(n(46)),
      a = n(47),
      s = n(116),
      c = function (e) {
        return new i.default(e);
      };
    (c.version = o.default),
      (c.snippet = a.snippet),
      (c.highlight = a.highlight),
      (c.insights = a.insights),
      (c.getInsightsAnonymousUserToken = a.getInsightsAnonymousUserToken),
      (c.createInfiniteHitsSessionStorageCache = s.createInfiniteHitsSessionStorageCache),
      Object.defineProperty(c, 'widgets', {
        get: function () {
          throw new ReferenceError(
            '"instantsearch.widgets" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from \'instantsearch.js/es/widgets\''
          );
        },
      }),
      Object.defineProperty(c, 'connectors', {
        get: function () {
          throw new ReferenceError(
            '"instantsearch.connectors" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from \'instantsearch.js/es/connectors\''
          );
        },
      });
    var u = c;
    t.default = u;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, g.default)(Symbol.iterator)
          ? function (e) {
              return (0, g.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, g.default)(e);
            })(e);
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function a(e, t, n) {
      return t && o(e.prototype, t), n && o(e, n), e;
    }
    function s(e, t) {
      return !t || ('object' !== r(t) && 'function' != typeof t) ? u(e) : t;
    }
    function c(e) {
      return (c = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function u(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function l(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && f(e, t);
    }
    function f(e, t) {
      return (f =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function h(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function d() {
      return '#';
    }
    var p = n(12),
      m = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var g = m(n(2)),
      v = m(n(19)),
      y = m(n(23)),
      b = p(n(77)),
      w = m(n(46)),
      _ = m(n(105)),
      O = n(1),
      P = (m(n(109)), n(110)),
      j = (0, O.createDocumentationMessageGenerator)({ name: 'instantsearch' }),
      S = (function (e) {
        function t(e) {
          var n;
          i(this, t),
            (n = s(this, c(t).call(this))),
            h(u(n), 'client', void 0),
            h(u(n), 'indexName', void 0),
            h(u(n), 'insightsClient', void 0),
            h(u(n), 'onStateChange', null),
            h(u(n), 'helper', void 0),
            h(u(n), 'mainHelper', void 0),
            h(u(n), 'mainIndex', void 0),
            h(u(n), 'started', void 0),
            h(u(n), 'templatesConfig', void 0),
            h(u(n), '_stalledSearchDelay', void 0),
            h(u(n), '_searchStalledTimer', void 0),
            h(u(n), '_isSearchStalled', void 0),
            h(u(n), '_initialUiState', void 0),
            h(u(n), '_createURL', void 0),
            h(u(n), '_searchFunction', void 0),
            h(u(n), '_mainHelperSearch', void 0),
            h(u(n), 'middleware', []),
            h(u(n), 'sendEventToInsights', void 0),
            h(
              u(n),
              'scheduleSearch',
              (0, O.defer)(function () {
                n.started && n.mainHelper.search();
              })
            ),
            h(
              u(n),
              'scheduleRender',
              (0, O.defer)(function () {
                n.mainHelper.hasPendingRequests() ||
                  (clearTimeout(n._searchStalledTimer), (n._searchStalledTimer = null), (n._isSearchStalled = !1)),
                  n.mainIndex.render({ instantSearchInstance: u(n) }),
                  n.emit('render');
              })
            ),
            h(u(n), 'setUiState', function (e) {
              if (!n.mainHelper) throw new Error(j('The `start` method needs to be called before `setUiState`.'));
              n.mainIndex.refreshUiState();
              var t = 'function' == typeof e ? e(n.mainIndex.getWidgetState({})) : e;
              !(function e(n) {
                n
                  .getHelper()
                  .overrideStateWithoutTriggeringChangeEvent(
                    n.getWidgetSearchParameters(n.getHelper().state, { uiState: t[n.getIndexId()] })
                  ),
                  n.getWidgets().filter(b.isIndexWidget).forEach(e);
              })(n.mainIndex),
                n.scheduleSearch(),
                n.onInternalStateChange();
            }),
            h(u(n), 'onInternalStateChange', function () {
              var e = n.mainIndex.getWidgetState({});
              n.middleware.forEach(function (t) {
                t.onStateChange({ uiState: e });
              });
            });
          var r = e.indexName,
            o = void 0 === r ? null : r,
            a = e.numberLocale,
            l = e.initialUiState,
            f = void 0 === l ? {} : l,
            p = e.routing,
            m = void 0 === p ? null : p,
            g = e.searchFunction,
            v = e.stalledSearchDelay,
            y = void 0 === v ? 200 : v,
            S = e.searchClient,
            x = void 0 === S ? null : S,
            R = e.insightsClient,
            E = void 0 === R ? null : R,
            T = e.onStateChange,
            C = void 0 === T ? null : T;
          if (null === o) throw new Error(j('The `indexName` option is required.'));
          if (null === x) throw new Error(j('The `searchClient` option is required.'));
          if ('function' != typeof x.search)
            throw new Error(
              'The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/'
            );
          if (
            ('function' == typeof x.addAlgoliaAgent && x.addAlgoliaAgent('instantsearch.js ('.concat(w.default, ')')),
            E && 'function' != typeof E)
          )
            throw new Error(j('The `insightsClient` option should be a function.'));
          if (
            ((n.client = x),
            (n.insightsClient = E),
            (n.indexName = o),
            (n.helper = null),
            (n.mainHelper = null),
            (n.mainIndex = (0, b.default)({ indexName: o })),
            (n.onStateChange = C),
            (n.started = !1),
            (n.templatesConfig = { helpers: (0, _.default)({ numberLocale: a }), compileOptions: {} }),
            (n._stalledSearchDelay = y),
            (n._searchStalledTimer = null),
            (n._isSearchStalled = !1),
            (n._createURL = d),
            (n._initialUiState = f),
            g && (n._searchFunction = g),
            (n.sendEventToInsights = O.noop),
            m)
          ) {
            var N = 'boolean' == typeof m ? void 0 : m;
            n.EXPERIMENTAL_use((0, P.createRouterMiddleware)(N));
          }
          return n;
        }
        return (
          l(t, e),
          a(t, [
            {
              key: 'EXPERIMENTAL_use',
              value: function () {
                for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                var i = n.map(function (t) {
                  var n = t({ instantSearchInstance: e });
                  return e.middleware.push(n), n;
                });
                return (
                  this.started &&
                    i.forEach(function (e) {
                      e.subscribe();
                    }),
                  this
                );
              },
            },
            {
              key: 'addWidget',
              value: function (e) {
                return this.addWidgets([e]);
              },
            },
            {
              key: 'addWidgets',
              value: function (e) {
                if (!Array.isArray(e))
                  throw new Error(j('The `addWidgets` method expects an array of widgets. Please use `addWidget`.'));
                if (
                  e.some(function (e) {
                    return 'function' != typeof e.init && 'function' != typeof e.render;
                  })
                )
                  throw new Error(j('The widget definition expects a `render` and/or an `init` method.'));
                return this.mainIndex.addWidgets(e), this;
              },
            },
            {
              key: 'removeWidget',
              value: function (e) {
                return this.removeWidgets([e]);
              },
            },
            {
              key: 'removeWidgets',
              value: function (e) {
                if (!Array.isArray(e))
                  throw new Error(
                    j('The `removeWidgets` method expects an array of widgets. Please use `removeWidget`.')
                  );
                if (
                  e.some(function (e) {
                    return 'function' != typeof e.dispose;
                  })
                )
                  throw new Error(j('The widget definition expects a `dispose` method.'));
                return this.mainIndex.removeWidgets(e), this;
              },
            },
            {
              key: 'start',
              value: function () {
                var e = this;
                if (this.started) throw new Error(j('The `start` method has already been called once.'));
                var t = (0, v.default)(this.client, this.indexName);
                if (
                  ((t.search = function () {
                    return t.searchOnlyWithDerivedHelpers();
                  }),
                  this._searchFunction)
                ) {
                  var n = {
                    search: function () {
                      return new Promise(O.noop);
                    },
                  };
                  (this._mainHelperSearch = t.search.bind(t)),
                    (t.search = function () {
                      var r = e.mainIndex.getHelper(),
                        i = (0, v.default)(n, r.state.index, r.state);
                      return (
                        i.once('search', function (t) {
                          var n = t.state;
                          r.overrideStateWithoutTriggeringChangeEvent(n), e._mainHelperSearch();
                        }),
                        i.on('change', function (e) {
                          var t = e.state;
                          r.setState(t);
                        }),
                        e._searchFunction(i),
                        t
                      );
                    });
                }
                t.on('error', function (t) {
                  var n = t.error;
                  e.emit('error', { error: n });
                }),
                  (this.mainHelper = t),
                  this.mainIndex.init({ instantSearchInstance: this, parent: null, uiState: this._initialUiState }),
                  this.middleware.forEach(function (e) {
                    e.subscribe();
                  }),
                  t.search(),
                  (this.helper = this.mainIndex.getHelper()),
                  (this.started = !0);
              },
            },
            {
              key: 'dispose',
              value: function () {
                this.scheduleSearch.cancel(),
                  this.scheduleRender.cancel(),
                  clearTimeout(this._searchStalledTimer),
                  this.removeWidgets(this.mainIndex.getWidgets()),
                  this.mainIndex.dispose(),
                  (this.started = !1),
                  this.removeAllListeners(),
                  this.mainHelper.removeAllListeners(),
                  (this.mainHelper = null),
                  (this.helper = null),
                  this.middleware.forEach(function (e) {
                    e.unsubscribe();
                  });
              },
            },
            {
              key: 'scheduleStalledRender',
              value: function () {
                var e = this;
                this._searchStalledTimer ||
                  (this._searchStalledTimer = setTimeout(function () {
                    (e._isSearchStalled = !0), e.scheduleRender();
                  }, this._stalledSearchDelay));
              },
            },
            {
              key: 'createURL',
              value: function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (!this.started) throw new Error(j('The `start` method needs to be called before `createURL`.'));
                return this._createURL(e);
              },
            },
            {
              key: 'refresh',
              value: function () {
                if (!this.mainHelper) throw new Error(j('The `start` method needs to be called before `refresh`.'));
                this.mainHelper.clearCache().search();
              },
            },
          ]),
          t
        );
      })(y.default),
      x = S;
    t.default = x;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      'function' == typeof e.addAlgoliaAgent && e.addAlgoliaAgent('JS Helper (' + d + ')'), this.setClient(e);
      var r = n || {};
      (r.index = t),
        (this.state = a.make(r)),
        (this.lastResults = null),
        (this._queryId = 0),
        (this._lastQueryIdReceived = -1),
        (this.derivedHelpers = []),
        (this._currentNbQueries = 0);
    }
    function i(e) {
      if (e < 0) throw new Error('Page requested below 0.');
      return this._change({ state: this.state.setPage(e), isPageReset: !1 }), this;
    }
    function o() {
      return this.state.page;
    }
    var a = n(30),
      s = n(32),
      c = n(75),
      u = n(76),
      l = n(23),
      f = n(35),
      h = n(22),
      d = n(36);
    f(r, l.EventEmitter),
      (r.prototype.search = function () {
        return this._search({ onlyWithDerivedHelpers: !1 }), this;
      }),
      (r.prototype.searchOnlyWithDerivedHelpers = function () {
        return this._search({ onlyWithDerivedHelpers: !0 }), this;
      }),
      (r.prototype.getQuery = function () {
        var e = this.state;
        return u._getHitsSearchParams(e);
      }),
      (r.prototype.searchOnce = function (e, t) {
        var n = e ? this.state.setQueryParameters(e) : this.state,
          r = u._getQueries(n.index, n),
          i = this;
        return (
          this._currentNbQueries++,
          this.emit('searchOnce', { state: n }),
          t
            ? void this.client
                .search(r)
                .then(function (e) {
                  i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit('searchQueueEmpty'),
                    t(null, new s(n, e.results), n);
                })
                .catch(function (e) {
                  i._currentNbQueries--, 0 === i._currentNbQueries && i.emit('searchQueueEmpty'), t(e, null, n);
                })
            : this.client.search(r).then(
                function (e) {
                  return (
                    i._currentNbQueries--,
                    0 === i._currentNbQueries && i.emit('searchQueueEmpty'),
                    { content: new s(n, e.results), state: n, _originalResponse: e }
                  );
                },
                function (e) {
                  throw (i._currentNbQueries--, 0 === i._currentNbQueries && i.emit('searchQueueEmpty'), e);
                }
              )
        );
      }),
      (r.prototype.searchForFacetValues = function (e, t, n, r) {
        var i = 'function' == typeof this.client.searchForFacetValues;
        if (!i && 'function' != typeof this.client.initIndex)
          throw new Error(
            'search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues'
          );
        var o = this.state.setQueryParameters(r || {}),
          a = o.isDisjunctiveFacet(e),
          s = u.getSearchForFacetQuery(e, t, n, o);
        this._currentNbQueries++;
        var c = this;
        return (
          this.emit('searchForFacetValues', { state: o, facet: e, query: t }),
          (i
            ? this.client.searchForFacetValues([{ indexName: o.index, params: s }])
            : this.client.initIndex(o.index).searchForFacetValues(s)
          ).then(
            function (t) {
              return (
                c._currentNbQueries--,
                0 === c._currentNbQueries && c.emit('searchQueueEmpty'),
                (t = Array.isArray(t) ? t[0] : t),
                t.facetHits.forEach(function (t) {
                  t.isRefined = a ? o.isDisjunctiveFacetRefined(e, t.value) : o.isFacetRefined(e, t.value);
                }),
                t
              );
            },
            function (e) {
              throw (c._currentNbQueries--, 0 === c._currentNbQueries && c.emit('searchQueueEmpty'), e);
            }
          )
        );
      }),
      (r.prototype.setQuery = function (e) {
        return this._change({ state: this.state.resetPage().setQuery(e), isPageReset: !0 }), this;
      }),
      (r.prototype.clearRefinements = function (e) {
        return this._change({ state: this.state.resetPage().clearRefinements(e), isPageReset: !0 }), this;
      }),
      (r.prototype.clearTags = function () {
        return this._change({ state: this.state.resetPage().clearTags(), isPageReset: !0 }), this;
      }),
      (r.prototype.addDisjunctiveFacetRefinement = function (e, t) {
        return (
          this._change({ state: this.state.resetPage().addDisjunctiveFacetRefinement(e, t), isPageReset: !0 }), this
        );
      }),
      (r.prototype.addDisjunctiveRefine = function () {
        return this.addDisjunctiveFacetRefinement.apply(this, arguments);
      }),
      (r.prototype.addHierarchicalFacetRefinement = function (e, t) {
        return (
          this._change({ state: this.state.resetPage().addHierarchicalFacetRefinement(e, t), isPageReset: !0 }), this
        );
      }),
      (r.prototype.addNumericRefinement = function (e, t, n) {
        return this._change({ state: this.state.resetPage().addNumericRefinement(e, t, n), isPageReset: !0 }), this;
      }),
      (r.prototype.addFacetRefinement = function (e, t) {
        return this._change({ state: this.state.resetPage().addFacetRefinement(e, t), isPageReset: !0 }), this;
      }),
      (r.prototype.addRefine = function () {
        return this.addFacetRefinement.apply(this, arguments);
      }),
      (r.prototype.addFacetExclusion = function (e, t) {
        return this._change({ state: this.state.resetPage().addExcludeRefinement(e, t), isPageReset: !0 }), this;
      }),
      (r.prototype.addExclude = function () {
        return this.addFacetExclusion.apply(this, arguments);
      }),
      (r.prototype.addTag = function (e) {
        return this._change({ state: this.state.resetPage().addTagRefinement(e), isPageReset: !0 }), this;
      }),
      (r.prototype.removeNumericRefinement = function (e, t, n) {
        return this._change({ state: this.state.resetPage().removeNumericRefinement(e, t, n), isPageReset: !0 }), this;
      }),
      (r.prototype.removeDisjunctiveFacetRefinement = function (e, t) {
        return (
          this._change({ state: this.state.resetPage().removeDisjunctiveFacetRefinement(e, t), isPageReset: !0 }), this
        );
      }),
      (r.prototype.removeDisjunctiveRefine = function () {
        return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
      }),
      (r.prototype.removeHierarchicalFacetRefinement = function (e) {
        return (
          this._change({ state: this.state.resetPage().removeHierarchicalFacetRefinement(e), isPageReset: !0 }), this
        );
      }),
      (r.prototype.removeFacetRefinement = function (e, t) {
        return this._change({ state: this.state.resetPage().removeFacetRefinement(e, t), isPageReset: !0 }), this;
      }),
      (r.prototype.removeRefine = function () {
        return this.removeFacetRefinement.apply(this, arguments);
      }),
      (r.prototype.removeFacetExclusion = function (e, t) {
        return this._change({ state: this.state.resetPage().removeExcludeRefinement(e, t), isPageReset: !0 }), this;
      }),
      (r.prototype.removeExclude = function () {
        return this.removeFacetExclusion.apply(this, arguments);
      }),
      (r.prototype.removeTag = function (e) {
        return this._change({ state: this.state.resetPage().removeTagRefinement(e), isPageReset: !0 }), this;
      }),
      (r.prototype.toggleFacetExclusion = function (e, t) {
        return (
          this._change({ state: this.state.resetPage().toggleExcludeFacetRefinement(e, t), isPageReset: !0 }), this
        );
      }),
      (r.prototype.toggleExclude = function () {
        return this.toggleFacetExclusion.apply(this, arguments);
      }),
      (r.prototype.toggleRefinement = function (e, t) {
        return this.toggleFacetRefinement(e, t);
      }),
      (r.prototype.toggleFacetRefinement = function (e, t) {
        return this._change({ state: this.state.resetPage().toggleFacetRefinement(e, t), isPageReset: !0 }), this;
      }),
      (r.prototype.toggleRefine = function () {
        return this.toggleFacetRefinement.apply(this, arguments);
      }),
      (r.prototype.toggleTag = function (e) {
        return this._change({ state: this.state.resetPage().toggleTagRefinement(e), isPageReset: !0 }), this;
      }),
      (r.prototype.nextPage = function () {
        var e = this.state.page || 0;
        return this.setPage(e + 1);
      }),
      (r.prototype.previousPage = function () {
        var e = this.state.page || 0;
        return this.setPage(e - 1);
      }),
      (r.prototype.setCurrentPage = i),
      (r.prototype.setPage = i),
      (r.prototype.setIndex = function (e) {
        return this._change({ state: this.state.resetPage().setIndex(e), isPageReset: !0 }), this;
      }),
      (r.prototype.setQueryParameter = function (e, t) {
        return this._change({ state: this.state.resetPage().setQueryParameter(e, t), isPageReset: !0 }), this;
      }),
      (r.prototype.setState = function (e) {
        return this._change({ state: a.make(e), isPageReset: !1 }), this;
      }),
      (r.prototype.overrideStateWithoutTriggeringChangeEvent = function (e) {
        return (this.state = new a(e)), this;
      }),
      (r.prototype.hasRefinements = function (e) {
        return (
          !!h(this.state.getNumericRefinements(e)) ||
          (this.state.isConjunctiveFacet(e)
            ? this.state.isFacetRefined(e)
            : this.state.isDisjunctiveFacet(e)
            ? this.state.isDisjunctiveFacetRefined(e)
            : !!this.state.isHierarchicalFacet(e) && this.state.isHierarchicalFacetRefined(e))
        );
      }),
      (r.prototype.isExcluded = function (e, t) {
        return this.state.isExcludeRefined(e, t);
      }),
      (r.prototype.isDisjunctiveRefined = function (e, t) {
        return this.state.isDisjunctiveFacetRefined(e, t);
      }),
      (r.prototype.hasTag = function (e) {
        return this.state.isTagRefined(e);
      }),
      (r.prototype.isTagRefined = function () {
        return this.hasTagRefinements.apply(this, arguments);
      }),
      (r.prototype.getIndex = function () {
        return this.state.index;
      }),
      (r.prototype.getCurrentPage = o),
      (r.prototype.getPage = o),
      (r.prototype.getTags = function () {
        return this.state.tagRefinements;
      }),
      (r.prototype.getRefinements = function (e) {
        var t = [];
        if (this.state.isConjunctiveFacet(e))
          this.state.getConjunctiveRefinements(e).forEach(function (e) {
            t.push({ value: e, type: 'conjunctive' });
          }),
            this.state.getExcludeRefinements(e).forEach(function (e) {
              t.push({ value: e, type: 'exclude' });
            });
        else if (this.state.isDisjunctiveFacet(e)) {
          var n = this.state.getDisjunctiveRefinements(e);
          n.forEach(function (e) {
            t.push({ value: e, type: 'disjunctive' });
          });
        }
        var r = this.state.getNumericRefinements(e);
        return (
          Object.keys(r).forEach(function (e) {
            var n = r[e];
            t.push({ value: n, operator: e, type: 'numeric' });
          }),
          t
        );
      }),
      (r.prototype.getNumericRefinement = function (e, t) {
        return this.state.getNumericRefinement(e, t);
      }),
      (r.prototype.getHierarchicalFacetBreadcrumb = function (e) {
        return this.state.getHierarchicalFacetBreadcrumb(e);
      }),
      (r.prototype._search = function (e) {
        var t = this.state,
          n = [],
          r = [];
        e.onlyWithDerivedHelpers ||
          ((r = u._getQueries(t.index, t)),
          n.push({ state: t, queriesCount: r.length, helper: this }),
          this.emit('search', { state: t, results: this.lastResults }));
        var i = this.derivedHelpers.map(function (e) {
            var r = e.getModifiedState(t),
              i = u._getQueries(r.index, r);
            return (
              n.push({ state: r, queriesCount: i.length, helper: e }),
              e.emit('search', { state: r, results: e.lastResults }),
              i
            );
          }),
          o = Array.prototype.concat.apply(r, i),
          a = this._queryId++;
        this._currentNbQueries++;
        try {
          this.client
            .search(o)
            .then(this._dispatchAlgoliaResponse.bind(this, n, a))
            .catch(this._dispatchAlgoliaError.bind(this, a));
        } catch (e) {
          this.emit('error', { error: e });
        }
      }),
      (r.prototype._dispatchAlgoliaResponse = function (e, t, n) {
        if (!(t < this._lastQueryIdReceived)) {
          (this._currentNbQueries -= t - this._lastQueryIdReceived),
            (this._lastQueryIdReceived = t),
            0 === this._currentNbQueries && this.emit('searchQueueEmpty');
          var r = n.results.slice();
          e.forEach(function (e) {
            var t = e.state,
              n = e.queriesCount,
              i = e.helper,
              o = r.splice(0, n),
              a = (i.lastResults = new s(t, o));
            i.emit('result', { results: a, state: t });
          });
        }
      }),
      (r.prototype._dispatchAlgoliaError = function (e, t) {
        e < this._lastQueryIdReceived ||
          ((this._currentNbQueries -= e - this._lastQueryIdReceived),
          (this._lastQueryIdReceived = e),
          this.emit('error', { error: t }),
          0 === this._currentNbQueries && this.emit('searchQueueEmpty'));
      }),
      (r.prototype.containsRefinement = function (e, t, n, r) {
        return e || 0 !== t.length || 0 !== n.length || 0 !== r.length;
      }),
      (r.prototype._hasDisjunctiveRefinements = function (e) {
        return this.state.disjunctiveRefinements[e] && this.state.disjunctiveRefinements[e].length > 0;
      }),
      (r.prototype._change = function (e) {
        var t = e.state,
          n = e.isPageReset;
        t !== this.state &&
          ((this.state = t), this.emit('change', { state: this.state, results: this.lastResults, isPageReset: n }));
      }),
      (r.prototype.clearCache = function () {
        return this.client.clearCache && this.client.clearCache(), this;
      }),
      (r.prototype.setClient = function (e) {
        return this.client === e
          ? this
          : ('function' == typeof e.addAlgoliaAgent && e.addAlgoliaAgent('JS Helper (' + d + ')'),
            (this.client = e),
            this);
      }),
      (r.prototype.getClient = function () {
        return this.client;
      }),
      (r.prototype.derive = function (e) {
        var t = new c(this, e);
        return this.derivedHelpers.push(t), t;
      }),
      (r.prototype.detachDerivedHelper = function (e) {
        var t = this.derivedHelpers.indexOf(e);
        if (-1 === t) throw new Error('Derived helper already detached');
        this.derivedHelpers.splice(t, 1);
      }),
      (r.prototype.hasPendingRequests = function () {
        return this._currentNbQueries > 0;
      }),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return e.filter(function (n, r) {
        return t.indexOf(n) > -1 && e.indexOf(n) === r;
      });
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      if ('number' == typeof e) return e;
      if ('string' == typeof e) return parseFloat(e);
      if (Array.isArray(e)) return e.map(r);
      throw new Error('The value should be a number, a parsable string or an array of those.');
    }
    e.exports = r;
  },
  function (e, t, n) {
    'use strict';
    var r = n(21),
      i = n(31),
      o = n(22),
      a = {
        addRefinement: function (e, t, n) {
          if (a.isRefined(e, t, n)) return e;
          var i = '' + n,
            o = e[t] ? e[t].concat(i) : [i],
            s = {};
          return (s[t] = o), r({}, s, e);
        },
        removeRefinement: function (e, t, n) {
          if (void 0 === n)
            return a.clearRefinement(e, function (e, n) {
              return t === n;
            });
          var r = '' + n;
          return a.clearRefinement(e, function (e, n) {
            return t === n && r === e;
          });
        },
        toggleRefinement: function (e, t, n) {
          if (void 0 === n) throw new Error('toggleRefinement should be used with a value');
          return a.isRefined(e, t, n) ? a.removeRefinement(e, t, n) : a.addRefinement(e, t, n);
        },
        clearRefinement: function (e, t, n) {
          if (void 0 === t) return o(e) ? {} : e;
          if ('string' == typeof t) return i(e, [t]);
          if ('function' == typeof t) {
            var r = !1,
              a = Object.keys(e).reduce(function (i, o) {
                var a = e[o] || [],
                  s = a.filter(function (e) {
                    return !t(e, o, n);
                  });
                return s.length !== a.length && (r = !0), (i[o] = s), i;
              }, {});
            return r ? a : e;
          }
        },
        isRefined: function (e, t, n) {
          var r = !!e[t] && e[t].length > 0;
          if (void 0 === n || !r) return r;
          var i = '' + n;
          return -1 !== e[t].indexOf(i);
        },
      };
    e.exports = a;
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e) {
      return Array.isArray(e) ? e.filter(Boolean) : [];
    };
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e, t) {
      if (!Array.isArray(e)) return -1;
      for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
      return -1;
    };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return function (t, n) {
        var r = e.hierarchicalFacets[n],
          o = (e.hierarchicalFacetsRefinements[r.name] && e.hierarchicalFacetsRefinements[r.name][0]) || '',
          a = e._getHierarchicalFacetSeparator(r),
          s = e._getHierarchicalRootPath(r),
          c = e._getHierarchicalShowParentLevel(r),
          l = u(e._getHierarchicalFacetSortBy(r)),
          f = t.every(function (e) {
            return e.exhaustive;
          }),
          h = i(l, a, s, c, o),
          d = t;
        return (
          s && (d = t.slice(s.split(a).length)),
          d.reduce(h, {
            name: e.hierarchicalFacets[n].name,
            count: null,
            isRefined: !0,
            path: null,
            exhaustive: f,
            data: null,
          })
        );
      };
    }
    function i(e, t, n, r, i) {
      return function (u, l, f) {
        var h = u;
        if (f > 0) {
          var d = 0;
          for (h = u; d < f; ) {
            var p = h && Array.isArray(h.data) ? h.data : [];
            (h = c(p, function (e) {
              return e.isRefined;
            })),
              d++;
          }
        }
        if (h) {
          var m = Object.keys(l.data)
            .map(function (e) {
              return [e, l.data[e]];
            })
            .filter(function (e) {
              return o(e[0], h.path || n, i, t, n, r);
            });
          h.data = s(
            m.map(function (e) {
              var n = e[0];
              return a(e[1], n, t, i, l.exhaustive);
            }),
            e[0],
            e[1]
          );
        }
        return u;
      };
    }
    function o(e, t, n, r, i, o) {
      return (
        (!i || (0 === e.indexOf(i) && i !== e)) &&
        ((!i && -1 === e.indexOf(r)) ||
          (i && e.split(r).length - i.split(r).length == 1) ||
          (-1 === e.indexOf(r) && -1 === n.indexOf(r)) ||
          0 === n.indexOf(e) ||
          (0 === e.indexOf(t + r) && (o || 0 === e.indexOf(n))))
      );
    }
    function a(e, t, n, r, i) {
      var o = t.split(n);
      return {
        name: o[o.length - 1].trim(),
        path: t,
        count: e,
        isRefined: r === t || 0 === r.indexOf(t + n),
        exhaustive: i,
        data: null,
      };
    }
    e.exports = r;
    var s = n(33),
      c = n(13),
      u = n(34);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      (this.main = e), (this.fn = t), (this.lastResults = null);
    }
    var i = n(23);
    n(35)(r, i.EventEmitter),
      (r.prototype.detach = function () {
        this.removeAllListeners(), this.main.detachDerivedHelper(this);
      }),
      (r.prototype.getModifiedState = function (e) {
        return this.fn(e);
      }),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    var r = n(20),
      i = {
        _getQueries: function (e, t) {
          var n = [];
          return (
            n.push({ indexName: e, params: i._getHitsSearchParams(t) }),
            t.getRefinedDisjunctiveFacets().forEach(function (r) {
              n.push({ indexName: e, params: i._getDisjunctiveFacetSearchParams(t, r) });
            }),
            t.getRefinedHierarchicalFacets().forEach(function (r) {
              var o = t.getHierarchicalFacetByName(r),
                a = t.getHierarchicalRefinement(r),
                s = t._getHierarchicalFacetSeparator(o);
              a.length > 0 &&
                a[0].split(s).length > 1 &&
                n.push({ indexName: e, params: i._getDisjunctiveFacetSearchParams(t, r, !0) });
            }),
            n
          );
        },
        _getHitsSearchParams: function (e) {
          var t = e.facets.concat(e.disjunctiveFacets).concat(i._getHitsHierarchicalFacetsAttributes(e)),
            n = i._getFacetFilters(e),
            o = i._getNumericFilters(e),
            a = i._getTagFilters(e),
            s = { facets: t, tagFilters: a };
          return (
            n.length > 0 && (s.facetFilters = n), o.length > 0 && (s.numericFilters = o), r({}, e.getQueryParams(), s)
          );
        },
        _getDisjunctiveFacetSearchParams: function (e, t, n) {
          var o = i._getFacetFilters(e, t, n),
            a = i._getNumericFilters(e, t),
            s = i._getTagFilters(e),
            c = {
              hitsPerPage: 1,
              page: 0,
              attributesToRetrieve: [],
              attributesToHighlight: [],
              attributesToSnippet: [],
              tagFilters: s,
              analytics: !1,
              clickAnalytics: !1,
            },
            u = e.getHierarchicalFacetByName(t);
          return (
            (c.facets = u ? i._getDisjunctiveHierarchicalFacetAttribute(e, u, n) : t),
            a.length > 0 && (c.numericFilters = a),
            o.length > 0 && (c.facetFilters = o),
            r({}, e.getQueryParams(), c)
          );
        },
        _getNumericFilters: function (e, t) {
          if (e.numericFilters) return e.numericFilters;
          var n = [];
          return (
            Object.keys(e.numericRefinements).forEach(function (r) {
              var i = e.numericRefinements[r] || {};
              Object.keys(i).forEach(function (e) {
                var o = i[e] || [];
                t !== r &&
                  o.forEach(function (t) {
                    if (Array.isArray(t)) {
                      var i = t.map(function (t) {
                        return r + e + t;
                      });
                      n.push(i);
                    } else n.push(r + e + t);
                  });
              });
            }),
            n
          );
        },
        _getTagFilters: function (e) {
          return e.tagFilters ? e.tagFilters : e.tagRefinements.join(',');
        },
        _getFacetFilters: function (e, t, n) {
          var r = [],
            i = e.facetsRefinements || {};
          Object.keys(i).forEach(function (e) {
            (i[e] || []).forEach(function (t) {
              r.push(e + ':' + t);
            });
          });
          var o = e.facetsExcludes || {};
          Object.keys(o).forEach(function (e) {
            (o[e] || []).forEach(function (t) {
              r.push(e + ':-' + t);
            });
          });
          var a = e.disjunctiveFacetsRefinements || {};
          Object.keys(a).forEach(function (e) {
            var n = a[e] || [];
            if (e !== t && n && 0 !== n.length) {
              var i = [];
              n.forEach(function (t) {
                i.push(e + ':' + t);
              }),
                r.push(i);
            }
          });
          var s = e.hierarchicalFacetsRefinements || {};
          return (
            Object.keys(s).forEach(function (i) {
              var o = s[i] || [],
                a = o[0];
              if (void 0 !== a) {
                var c,
                  u,
                  l = e.getHierarchicalFacetByName(i),
                  f = e._getHierarchicalFacetSeparator(l),
                  h = e._getHierarchicalRootPath(l);
                if (t === i) {
                  if (-1 === a.indexOf(f) || (!h && !0 === n) || (h && h.split(f).length === a.split(f).length)) return;
                  h
                    ? ((u = h.split(f).length - 1), (a = h))
                    : ((u = a.split(f).length - 2), (a = a.slice(0, a.lastIndexOf(f)))),
                    (c = l.attributes[u]);
                } else (u = a.split(f).length - 1), (c = l.attributes[u]);
                c && r.push([c + ':' + a]);
              }
            }),
            r
          );
        },
        _getHitsHierarchicalFacetsAttributes: function (e) {
          var t = [];
          return e.hierarchicalFacets.reduce(function (t, n) {
            var r = e.getHierarchicalRefinement(n.name)[0];
            if (!r) return t.push(n.attributes[0]), t;
            var i = e._getHierarchicalFacetSeparator(n),
              o = r.split(i).length,
              a = n.attributes.slice(0, o + 1);
            return t.concat(a);
          }, t);
        },
        _getDisjunctiveHierarchicalFacetAttribute: function (e, t, n) {
          var r = e._getHierarchicalFacetSeparator(t);
          if (!0 === n) {
            var i = e._getHierarchicalRootPath(t),
              o = 0;
            return i && (o = i.split(r).length), [t.attributes[o]];
          }
          var a = e.getHierarchicalRefinement(t.name)[0] || '',
            s = a.split(r).length - 1;
          return t.attributes.slice(0, s + 1);
        },
        getSearchForFacetQuery: function (e, t, n, o) {
          var a = o.isDisjunctiveFacet(e) ? o.clearRefinements(e) : o,
            s = { facetQuery: t, facetName: e };
          return 'number' == typeof n && (s.maxFacetHits = n), r({}, i._getHitsSearchParams(a), s);
        },
      };
    e.exports = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      return u(e) || c(e) || s();
    }
    function s() {
      throw new TypeError('Invalid attempt to spread non-iterable instance');
    }
    function c(e) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
    }
    function u(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
    }
    function l(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = f(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++)
          (n = o[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
      }
      return i;
    }
    function f(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function h(e) {
      return 'ais.index' === e.$$type;
    }
    function d(e, t) {
      var n = t.state,
        r = t.isPageReset,
        i = t._uiState;
      n !== e.state &&
        ((e.state = n), e.emit('change', { state: e.state, results: e.lastResults, isPageReset: r, _uiState: i }));
    }
    function p(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return e
        .filter(function (e) {
          return !h(e);
        })
        .reduce(function (e, n) {
          return n.getWidgetState ? n.getWidgetState(e, t) : e;
        }, n);
    }
    function m(e, t) {
      var n = t.initialSearchParameters,
        r = l(t, ['initialSearchParameters']);
      return e
        .filter(function (e) {
          return !h(e);
        })
        .reduce(function (e, t) {
          return t.getWidgetSearchParameters ? t.getWidgetSearchParameters(e, r) : e;
        }, n);
    }
    function g(e) {
      var t = e.filter(h);
      0 !== t.length &&
        t.forEach(function (e) {
          var t = e.getHelper();
          d(t, { state: t.state.resetPage(), isPageReset: !0 }), g(e.getWidgets());
        });
    }
    function v(e) {
      return e.filter(h).reduce(function (e, t) {
        return e.concat.apply(
          e,
          [{ indexId: t.getIndexId(), results: t.getResults(), helper: t.getHelper() }].concat(a(v(t.getWidgets())))
        );
      }, []);
    }
    function y(e) {
      var t = e.getParent();
      return v(t ? t.getWidgets() : [e]);
    }
    var b = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.isIndexWidget = h), (t.default = void 0);
    var w = b(n(19)),
      _ = n(1),
      O = (0, _.createDocumentationMessageGenerator)({ name: 'index-widget' }),
      P = function (e) {
        if (void 0 === e || void 0 === e.indexName) throw new Error(O('The `indexName` option is required.'));
        var t = e.indexName,
          n = e.indexId,
          r = void 0 === n ? t : n,
          s = [],
          c = {},
          u = null,
          l = null,
          f = null,
          v = null,
          b = function (e) {
            return u._createURL(o({}, r, p(s, { searchParameters: e, helper: f })));
          };
        return {
          $$type: 'ais.index',
          getIndexName: function () {
            return t;
          },
          getIndexId: function () {
            return r;
          },
          getHelper: function () {
            return f;
          },
          getResults: function () {
            return v && v.lastResults;
          },
          getParent: function () {
            return l;
          },
          getWidgets: function () {
            return s;
          },
          addWidgets: function (e) {
            var t = this;
            if (!Array.isArray(e)) throw new Error(O('The `addWidgets` method expects an array of widgets.'));
            if (
              e.some(function (e) {
                return 'function' != typeof e.init && 'function' != typeof e.render;
              })
            )
              throw new Error(O('The widget definition expects a `render` and/or an `init` method.'));
            return (
              (s = s.concat(e)),
              u &&
                Boolean(e.length) &&
                (d(f, { state: m(s, { uiState: c, initialSearchParameters: f.state }), _uiState: c }),
                e.forEach(function (e) {
                  u &&
                    e.init &&
                    e.init({
                      helper: f,
                      parent: t,
                      uiState: u._initialUiState,
                      instantSearchInstance: u,
                      state: f.state,
                      templatesConfig: u.templatesConfig,
                      createURL: b,
                    });
                }),
                u.scheduleSearch()),
              this
            );
          },
          removeWidgets: function (e) {
            if (!Array.isArray(e)) throw new Error(O('The `removeWidgets` method expects an array of widgets.'));
            if (
              e.some(function (e) {
                return 'function' != typeof e.dispose;
              })
            )
              throw new Error(O('The widget definition expects a `dispose` method.'));
            if (
              ((s = s.filter(function (t) {
                return -1 === e.indexOf(t);
              })),
              u && Boolean(e.length))
            ) {
              var t = e.reduce(function (e, t) {
                return t.dispose({ helper: f, state: e }) || e;
              }, f.state);
              (c = p(s, { searchParameters: t, helper: f })),
                f.setState(m(s, { uiState: c, initialSearchParameters: t })),
                s.length && u.scheduleSearch();
            }
            return this;
          },
          init: function (e) {
            var n = this,
              i = e.instantSearchInstance,
              o = e.parent,
              h = e.uiState;
            (u = i), (l = o), (c = h[r] || {});
            var d = i.mainHelper,
              y = m(s, { uiState: c, initialSearchParameters: new w.default.SearchParameters({ index: t }) });
            (f = (0, w.default)({}, y.index, y)),
              (f.search = function () {
                return i.onStateChange
                  ? (i.onStateChange({ uiState: i.mainIndex.getWidgetState({}), setUiState: i.setUiState.bind(i) }), d)
                  : d.search();
              }),
              (f.searchWithoutTriggeringOnStateChange = function () {
                return d.search();
              }),
              (f.searchForFacetValues = function (e, t, n, r) {
                var i = f.state.setQueryParameters(r);
                return d.searchForFacetValues(e, t, n, i);
              }),
              (v = d.derive(function () {
                return _.mergeSearchParameters.apply(void 0, a((0, _.resolveSearchParameters)(n)));
              })),
              f.on('change', function (e) {
                e.isPageReset && g(s);
              }),
              v.on('search', function () {
                i.scheduleStalledRender();
              }),
              v.on('result', function (e) {
                var t = e.results;
                i.scheduleRender(), (f.lastResults = t);
              }),
              s.forEach(function (e) {
                e.init &&
                  e.init({
                    uiState: h,
                    helper: f,
                    parent: n,
                    instantSearchInstance: i,
                    state: f.state,
                    templatesConfig: i.templatesConfig,
                    createURL: b,
                  });
              }),
              f.on('change', function (e) {
                var t = e.state,
                  n = e._uiState;
                (c = p(s, { searchParameters: t, helper: f }, n || {})), i.onStateChange || i.onInternalStateChange();
              });
          },
          render: function (e) {
            var t = this,
              n = e.instantSearchInstance;
            s.forEach(function (e) {
              e.render &&
                v.lastResults &&
                e.render({
                  helper: f,
                  instantSearchInstance: n,
                  results: v.lastResults,
                  scopedResults: y(t),
                  state: v.lastResults._state,
                  templatesConfig: n.templatesConfig,
                  createURL: b,
                  searchMetadata: { isSearchStalled: n._isSearchStalled },
                });
            });
          },
          dispose: function () {
            s.forEach(function (e) {
              e.dispose && e.dispose({ helper: f, state: f.state });
            }),
              (u = null),
              (l = null),
              f.removeAllListeners(),
              (f = null),
              v.detach(),
              (v = null);
          },
          getWidgetState: function (e) {
            return s.filter(h).reduce(function (e, t) {
              return t.getWidgetState(e);
            }, i({}, e, o({}, this.getIndexId(), c)));
          },
          getWidgetSearchParameters: function (e, t) {
            var n = t.uiState;
            return m(s, { uiState: n, initialSearchParameters: e });
          },
          refreshUiState: function () {
            c = p(s, { searchParameters: this.getHelper().state, helper: this.getHelper() });
          },
        };
      },
      j = P;
    t.default = j;
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = Promise.resolve(),
      i = function (e) {
        var t = null,
          n = !1,
          i = function () {
            for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) o[a] = arguments[a];
            null === t &&
              (t = r.then(function () {
                if (((t = null), n)) return void (n = !1);
                e.apply(void 0, o);
              }));
          };
        return (
          (i.wait = function () {
            if (null === t) throw new Error('The deferred function should be called before calling `wait()`');
            return t;
          }),
          (i.cancel = function () {
            null !== t && (n = !0);
          }),
          i
        );
      },
      o = i;
    t.default = o;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = 'string' == typeof e,
        n = t ? document.querySelector(e) : e;
      if (!(0, o.default)(n)) {
        var r = 'Container must be `string` or `HTMLElement`.';
        throw (t && (r += ' Unable to find '.concat(e)), new Error(r));
      }
      return n;
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var o = i(n(38)),
      a = r;
    t.default = a;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return 1 === e.button || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      return u(e) || c(e) || s();
    }
    function s() {
      throw new TypeError('Invalid attempt to spread non-iterable instance');
    }
    function c(e) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
    }
    function u(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
    }
    function l() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return (0, d.default)([].concat(a(Object.keys(e)), a(Object.keys(t)))).reduce(
        function (n, r) {
          var i = e[r],
            o = t[r],
            a = void 0 !== o && o !== i;
          return (n.templates[r] = a ? o : i), (n.useCustomCompileOptions[r] = a), n;
        },
        { templates: {}, useCustomCompileOptions: {} }
      );
    }
    function f(e) {
      var t = e.defaultTemplates,
        n = e.templates;
      return i({ templatesConfig: e.templatesConfig }, l(t, n));
    }
    var h = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var d = h(n(24)),
      p = f;
    t.default = p;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, l.default)(Symbol.iterator)
          ? function (e) {
              return (0, l.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, l.default)(e);
            })(e);
    }
    function i(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function o(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? i(Object(n), !0).forEach(function (t) {
              a(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function a(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function s() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments.length > 1 ? arguments[1] : void 0,
        n = arguments.length > 2 ? arguments[2] : void 0;
      return Object.keys(e).reduce(function (r, i) {
        return o(
          {},
          r,
          a({}, i, function () {
            var r = this;
            return function (o) {
              var a = function (e) {
                return f.default.compile(e, t).render(r);
              };
              return e[i].call(n, o, a);
            };
          })
        );
      }, {});
    }
    function c(e) {
      var t = e.templates,
        n = e.templateKey,
        i = e.compileOptions,
        a = e.helpers,
        c = e.data,
        u = e.bindEvent,
        l = t[n],
        h = r(l),
        d = 'string' === h,
        p = 'function' === h;
      if (!d && !p)
        throw new Error("Template must be 'string' or 'function', was '".concat(h, "' (key: ").concat(n, ')'));
      if (p) return l(c, u);
      var m = s(a, i, c);
      return f.default
        .compile(l, i)
        .render(o({}, c, { helpers: m }))
        .replace(/[ \n\r\t\f\xA0]+/g, function (e) {
          return e.replace(/(^|\xA0+)[^\xA0]+/g, '$1 ');
        })
        .trim();
    }
    var u = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var l = u(n(2)),
      f = u(n(29)),
      h = c;
    t.default = h;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n, r) {
      var i,
        o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [],
        s = { type: t, attribute: n, name: r },
        c = (0, a.default)(o, function (e) {
          return e.name === n;
        });
      'hierarchical' === t
        ? (function () {
            for (
              var t = e.getHierarchicalFacetByName(n),
                o = r.split(t.separator),
                s = function (e) {
                  return function (t) {
                    return e[t];
                  };
                },
                u = 0;
              void 0 !== c && u < o.length;
              ++u
            )
              !(function (e) {
                c =
                  c &&
                  c.data &&
                  (0, a.default)(Object.keys(c.data).map(s(c.data)), function (t) {
                    return t.name === o[e];
                  });
              })(u);
            i = c && c.count;
          })()
        : (i = c && c.data && c.data[s.name]);
      var u = c && c.exhaustive;
      return void 0 !== i && (s.count = i), void 0 !== u && (s.exhaustive = u), s;
    }
    function i(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
        i = [],
        o = t.facetsRefinements,
        a = void 0 === o ? {} : o,
        c = t.facetsExcludes,
        u = void 0 === c ? {} : c,
        l = t.disjunctiveFacetsRefinements,
        f = void 0 === l ? {} : l,
        h = t.hierarchicalFacetsRefinements,
        d = void 0 === h ? {} : h,
        p = t.numericRefinements,
        m = void 0 === p ? {} : p,
        g = t.tagRefinements,
        v = void 0 === g ? [] : g;
      return (
        Object.keys(a).forEach(function (n) {
          a[n].forEach(function (o) {
            i.push(r(t, 'facet', n, o, e.facets));
          });
        }),
        Object.keys(u).forEach(function (e) {
          u[e].forEach(function (t) {
            i.push({ type: 'exclude', attribute: e, name: t, exclude: !0 });
          });
        }),
        Object.keys(f).forEach(function (n) {
          f[n].forEach(function (o) {
            i.push(r(t, 'disjunctive', n, (0, s.default)(o), e.disjunctiveFacets));
          });
        }),
        Object.keys(d).forEach(function (n) {
          d[n].forEach(function (o) {
            i.push(r(t, 'hierarchical', n, o, e.hierarchicalFacets));
          });
        }),
        Object.keys(m).forEach(function (e) {
          var t = m[e];
          Object.keys(t).forEach(function (n) {
            var r = n,
              o = t[r];
            (Array.isArray(o) ? o : [o]).forEach(function (t) {
              i.push({ type: 'numeric', attribute: e, name: ''.concat(t), numericValue: t, operator: r });
            });
          });
        }),
        v.forEach(function (e) {
          i.push({ type: 'tag', attribute: '_tags', name: e });
        }),
        n && t.query && t.query.trim() && i.push({ attribute: 'query', type: 'query', name: t.query, query: t.query }),
        i
      );
    }
    var o = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var a = o(n(39)),
      s = o(n(40)),
      c = i;
    t.default = c;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = e.helper,
        n = e.attributesToClear,
        r = void 0 === n ? [] : n,
        i = t.state.setPage(0);
      return (
        (i = r.reduce(function (e, t) {
          return i.isNumericRefined(t)
            ? e.removeNumericRefinement(t)
            : i.isHierarchicalFacet(t)
            ? e.removeHierarchicalFacetRefinement(t)
            : i.isDisjunctiveFacet(t)
            ? e.removeDisjunctiveFacetRefinement(t)
            : i.isConjunctiveFacet(t)
            ? e.removeFacetRefinement(t)
            : e;
        }, i)),
        -1 !== r.indexOf('query') && (i = i.setQuery('')),
        i
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return 'number' == typeof e && e < 0 && (e = String(e).replace(/^-/, '\\-')), e;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (void 0 === e || 'function' != typeof e)
        throw new Error(
          'The render function is not valid (received type '.concat((0, o.default)(e), ').\n\n').concat(t)
        );
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var o = i(n(41)),
      a = r;
    t.default = a;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = e.index,
        n = e.indexUiState,
        r = t
          .getWidgets()
          .map(function (e) {
            return e.$$type;
          })
          .filter(Boolean);
      Object.keys(n).reduce(function (e, t) {
        var n = o[t] && o[t].widgets;
        return (
          n &&
            !n.some(function (e) {
              return r.includes(e);
            }) &&
            e.push([
              t,
              {
                connectors: o[t].connectors,
                widgets: o[t].widgets.map(function (e) {
                  return e.split('ais.')[1];
                }),
              },
            ]),
          e
        );
      }, []);
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.checkIndexUiState = r);
    var o =
      (i(n(37)),
      n(42),
      {
        query: { connectors: ['connectSearchBox'], widgets: ['ais.searchBox', 'ais.autocomplete', 'ais.voiceSearch'] },
        refinementList: { connectors: ['connectRefinementList'], widgets: ['ais.refinementList'] },
        menu: { connectors: ['connectMenu'], widgets: ['ais.menu'] },
        hierarchicalMenu: { connectors: ['connectHierarchicalMenu'], widgets: ['ais.hierarchicalMenu'] },
        numericMenu: { connectors: ['connectNumericMenu'], widgets: ['ais.numericMenu'] },
        ratingMenu: { connectors: ['connectRatingMenu'], widgets: ['ais.ratingMenu'] },
        range: { connectors: ['connectRange'], widgets: ['ais.rangeInput', 'ais.rangeSlider', 'ais.range'] },
        toggle: { connectors: ['connectToggleRefinement'], widgets: ['ais.toggleRefinement'] },
        geoSearch: { connectors: ['connectGeoSearch'], widgets: ['ais.geoSearch'] },
        sortBy: { connectors: ['connectSortBy'], widgets: ['ais.sortBy'] },
        page: { connectors: ['connectPagination'], widgets: ['ais.pagination', 'ais.infiniteHits'] },
        hitsPerPage: { connectors: ['connectHitsPerPage'], widgets: ['ais.hitsPerPage'] },
        configure: { connectors: ['connectConfigure'], widgets: ['ais.configure'] },
        places: { connectors: [], widgets: ['ais.places'] },
      });
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return t.split('.').reduce(function (e, t) {
        return e && e[t];
      }, e);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return 'number' == typeof e && isFinite(e);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, c.default)(Symbol.iterator)
          ? function (e) {
              return (0, c.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, c.default)(e);
            })(e);
    }
    function i(e) {
      return null === e ? (void 0 === e ? '[object Undefined]' : '[object Null]') : Object.prototype.toString.call(e);
    }
    function o(e) {
      return 'object' === r(e) && null !== e;
    }
    function a(e) {
      if (!o(e) || '[object Object]' !== i(e)) return !1;
      if (null === Object.getPrototypeOf(e)) return !0;
      for (var t = e; null !== Object.getPrototypeOf(t); ) t = Object.getPrototypeOf(t);
      return Object.getPrototypeOf(e) === t;
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var c = s(n(2)),
      u = a;
    t.default = u;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError('Invalid attempt to spread non-iterable instance');
    }
    function o(e) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
    }
    function a(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
    }
    function s(e) {
      var t = e.start,
        n = void 0 === t ? 0 : t,
        i = e.end,
        o = e.step,
        a = void 0 === o ? 1 : o,
        s = 0 === a ? 1 : a,
        c = Math.round((i - n) / s);
      return r(Array(c)).map(function (e, t) {
        return n + t * s;
      });
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var c = s;
    t.default = c;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e !== Object(e);
    }
    function i(e, t) {
      if (e === t) return !0;
      if (r(e) || r(t) || 'function' == typeof e || 'function' == typeof t) return e === t;
      if (Object.keys(e).length !== Object.keys(t).length) return !1;
      for (var n = 0, o = Object.keys(e); n < o.length; n++) {
        var a = o[n];
        if (!(a in t)) return !1;
        if (!i(e[a], t[a])) return !1;
      }
      return !0;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var o = i;
    t.default = o;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return e && a.test(e)
        ? e.replace(o, function (e) {
            return i[e];
          })
        : e;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' },
      o = /[&<>"']/g,
      a = RegExp(o.source),
      s = r;
    t.default = s;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++)
          (n = o[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    var c = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var u = c(n(44)),
      l = c(n(24)),
      f = function (e, t) {
        var n =
          (t.facets,
          t.disjunctiveFacets,
          t.facetsRefinements,
          t.facetsExcludes,
          t.disjunctiveFacetsRefinements,
          t.numericRefinements,
          t.tagRefinements,
          t.hierarchicalFacets,
          t.hierarchicalFacetsRefinements,
          t.ruleContexts,
          a(t, [
            'facets',
            'disjunctiveFacets',
            'facetsRefinements',
            'facetsExcludes',
            'disjunctiveFacetsRefinements',
            'numericRefinements',
            'tagRefinements',
            'hierarchicalFacets',
            'hierarchicalFacetsRefinements',
            'ruleContexts',
          ]));
        return e.setQueryParameters(n);
      },
      h = function (e, t) {
        return t.facets.reduce(function (e, t) {
          return e.addFacet(t);
        }, e);
      },
      d = function (e, t) {
        return t.disjunctiveFacets.reduce(function (e, t) {
          return e.addDisjunctiveFacet(t);
        }, e);
      },
      p = function (e, t) {
        return e.setQueryParameters({
          hierarchicalFacets: t.hierarchicalFacets.reduce(function (e, t) {
            var n = (0, u.default)(e, function (e) {
              return e.name === t.name;
            });
            if (-1 === n) return e.concat(t);
            var r = e.slice();
            return r.splice(n, 1, t), r;
          }, e.hierarchicalFacets),
        });
      },
      m = function (e, t) {
        return t.tagRefinements.reduce(function (e, t) {
          return e.addTagRefinement(t);
        }, e);
      },
      g = function (e, t) {
        return e.setQueryParameters({ facetsRefinements: i({}, e.facetsRefinements, {}, t.facetsRefinements) });
      },
      v = function (e, t) {
        return e.setQueryParameters({ facetsExcludes: i({}, e.facetsExcludes, {}, t.facetsExcludes) });
      },
      y = function (e, t) {
        return e.setQueryParameters({
          disjunctiveFacetsRefinements: i({}, e.disjunctiveFacetsRefinements, {}, t.disjunctiveFacetsRefinements),
        });
      },
      b = function (e, t) {
        return e.setQueryParameters({ numericRefinements: i({}, e.numericRefinements, {}, t.numericRefinements) });
      },
      w = function (e, t) {
        return e.setQueryParameters({
          hierarchicalFacetsRefinements: i({}, e.hierarchicalFacetsRefinements, {}, t.hierarchicalFacetsRefinements),
        });
      },
      _ = function (e, t) {
        var n = (0, l.default)([].concat(e.ruleContexts).concat(t.ruleContexts).filter(Boolean));
        return n.length > 0 ? e.setQueryParameters({ ruleContexts: n }) : e;
      },
      O = function () {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return t.reduce(function (e, t) {
          var n = w(e, t),
            r = p(n, t),
            i = m(r, t),
            o = b(i, t),
            a = y(o, t),
            s = v(a, t),
            c = g(s, t),
            u = d(c, t),
            l = _(u, t),
            O = h(l, t);
          return f(O, t);
        });
      },
      P = O;
    t.default = P;
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = function (e) {
        for (var t = e.getParent(), n = [e.getHelper().state]; null !== t; )
          (n = [t.getHelper().state].concat(n)), (t = t.getParent());
        return n;
      },
      i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return Array.isArray(e) ? e : [e];
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r;
    t.default = i;
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.createDocumentationMessageGenerator = t.createDocumentationLink = void 0);
    var r = function (e) {
      var t = e.name,
        n = e.connector;
      return [
        'https://www.algolia.com/doc/api-reference/widgets/',
        t,
        '/js/',
        void 0 !== n && n ? '#connector' : '',
      ].join('');
    };
    t.createDocumentationLink = r;
    var i = function () {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
      var i = t
        .map(function (e) {
          return r(e);
        })
        .join(', ');
      return function (e) {
        return [e, 'See documentation: '.concat(i)].filter(Boolean).join('\n\n');
      };
    };
    t.createDocumentationMessageGenerator = i;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return a(e) || o(e, t) || i();
    }
    function i() {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
    function o(e, t) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e)) {
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t);
            r = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }
    }
    function a(e) {
      if (Array.isArray(e)) return e;
    }
    function s(e) {
      var t = e.match(f);
      if (!t) throw new Error('Invalid value for "aroundLatLng" parameter: "'.concat(e, '"'));
      return { lat: parseFloat(t[1]), lng: parseFloat(t[2]) };
    }
    function c(e) {
      var t = r(e, 1),
        n = t[0];
      n = void 0 === n ? [void 0, void 0, void 0, void 0] : n;
      var i = r(n, 4),
        o = i[0],
        a = i[1],
        s = i[2],
        c = i[3];
      if (!(o && a && s && c)) throw new Error('Invalid value for "insideBoundingBox" parameter: ['.concat(e, ']'));
      return { northEast: { lat: o, lng: a }, southWest: { lat: s, lng: c } };
    }
    function u(e) {
      var t = e.split(',').map(parseFloat),
        n = r(t, 4),
        i = n[0],
        o = n[1],
        a = n[2],
        s = n[3];
      if (!(i && o && a && s)) throw new Error('Invalid value for "insideBoundingBox" parameter: "'.concat(e, '"'));
      return { northEast: { lat: i, lng: o }, southWest: { lat: a, lng: s } };
    }
    function l(e) {
      return Array.isArray(e) ? c(e) : u(e);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.aroundLatLngToPosition = s),
      (t.insideBoundingBoxArrayToBoundingBox = c),
      (t.insideBoundingBoxStringToBoundingBox = u),
      (t.insideBoundingBoxToBoundingBox = l);
    var f = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.addAbsolutePosition = void 0);
    var a = function (e, t, n) {
      return e.map(function (e, r) {
        return i({}, e, { __position: n * t + r + 1 });
      });
    };
    t.addAbsolutePosition = a;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.addQueryID = void 0);
    var a = function (e, t) {
      return t
        ? e.map(function (e) {
            return i({}, e, { __queryID: t });
          })
        : e;
    };
    t.addQueryID = a;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, a.default)(Symbol.iterator)
          ? function (e) {
              return (0, a.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, a.default)(e);
            })(e);
    }
    function i(e) {
      var t = e.instantSearchInstance,
        n = e.helper,
        i = e.attribute,
        o = e.widgetType;
      return function () {
        for (var e = arguments.length, a = new Array(e), c = 0; c < e; c++) a[c] = arguments[c];
        var u = a[0],
          l = a[1],
          f = a[2],
          h = void 0 === f ? 'Filter Applied' : f;
        1 === a.length && 'object' === r(a[0])
          ? t.sendEventToInsights(a[0])
          : 'click' !== u ||
            (2 !== a.length && 3 !== a.length) ||
            (0, s.default)(n, i, l) ||
            t.sendEventToInsights({
              insightsMethod: 'clickedFilters',
              widgetType: o,
              eventType: u,
              payload: { eventName: h, index: n.getIndex(), filters: [''.concat(i, ':').concat(JSON.stringify(l))] },
            });
      };
    }
    var o = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.createSendEventForFacet = i);
    var a = o(n(2)),
      s = o(n(45));
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, s.default)(Symbol.iterator)
          ? function (e) {
              return (0, s.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, s.default)(e);
            })(e);
    }
    function i(e) {
      var t = e.instantSearchInstance,
        n = e.index,
        r = e.widgetType;
      return function () {
        for (var e = arguments.length, i = new Array(e), o = 0; o < e; o++) i[o] = arguments[o];
        var a = c({ widgetType: r, index: n, methodName: 'sendEvent', args: i });
        a && t.sendEventToInsights(a);
      };
    }
    function o(e) {
      var t = e.index,
        n = e.widgetType;
      return function () {
        for (var e = arguments.length, r = new Array(e), i = 0; i < e; i++) r[i] = arguments[i];
        var o = c({ widgetType: n, index: t, methodName: 'bindEvent', args: r });
        return o ? 'data-insights-event='.concat(btoa(JSON.stringify(o))) : '';
      };
    }
    var a = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.createSendEventForHits = i),
      (t.createBindEventForHits = o);
    var s = a(n(2)),
      c = function (e) {
        var t = e.index,
          n = e.widgetType,
          i = (e.methodName, e.args);
        if (1 === i.length && 'object' === r(i[0])) return i[0];
        var o = i[0],
          a = i[1],
          s = i[2];
        if (!a) return null;
        if (('click' === o || 'conversion' === o) && !s) return null;
        var c = Array.isArray(a) ? a : [a];
        if (0 === c.length) return null;
        var u = c[0].__queryID,
          l = c.map(function (e) {
            return e.objectID;
          }),
          f = c.map(function (e) {
            return e.__position;
          });
        return 'view' === o
          ? {
              insightsMethod: 'viewedObjectIDs',
              widgetType: n,
              eventType: o,
              payload: { eventName: s || 'Hits Viewed', index: t, objectIDs: l },
            }
          : 'click' === o
          ? {
              insightsMethod: 'clickedObjectIDsAfterSearch',
              widgetType: n,
              eventType: o,
              payload: { eventName: s, index: t, queryID: u, objectIDs: l, positions: f },
            }
          : 'conversion' === o
          ? {
              insightsMethod: 'convertedObjectIDsAfterSearch',
              widgetType: n,
              eventType: o,
              payload: { eventName: s, index: t, queryID: u, objectIDs: l },
            }
          : null;
      };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      if (e.transporter) {
        var t = e.transporter,
          n = t.headers,
          r = t.queryParameters,
          i = 'x-algolia-application-id';
        return [n[i] || r[i], n['x-algolia-api-key'] || r['x-algolia-api-key']];
      }
      return [e.applicationID, e.apiKey];
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.getAppIdAndApiKey = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (!e) return null;
      var n = e.numericRefinements[t],
        r = [];
      return (
        Object.keys(n)
          .filter(function (e) {
            return Array.isArray(n[e]) && n[e].length > 0;
          })
          .forEach(function (e) {
            n[e].forEach(function (n) {
              r.push(''.concat(t).concat(e).concat(n));
            });
          }),
        r
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.convertNumericRefinementsToFilters = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      var t = e.numberLocale;
      return {
        formatNumber: function (e, n) {
          return Number(n(e)).toLocaleString(t);
        },
        highlight: function (e, t) {
          try {
            var n = JSON.parse(e);
            return t((0, s.highlight)(i({}, n, { hit: this })));
          } catch (e) {
            throw new Error(
              '\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }'
            );
          }
        },
        snippet: function (e, t) {
          try {
            var n = JSON.parse(e);
            return t((0, s.snippet)(i({}, n, { hit: this })));
          } catch (e) {
            throw new Error(
              '\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }'
            );
          }
        },
        insights: function (e, t) {
          try {
            var n = JSON.parse(e),
              r = n.method,
              o = n.payload;
            return t((0, s.insights)(r, i({ objectIDs: [this.objectID] }, o)));
          } catch (e) {
            throw new Error(
              '\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }'
            );
          }
        },
      };
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var s = n(47);
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = e.attribute,
        n = e.highlightedTagName,
        r = void 0 === n ? 'mark' : n,
        a = e.hit,
        c = e.cssClasses,
        u = void 0 === c ? {} : c,
        l = (0, i.getPropertyByPath)(a, '_highlightResult.'.concat(t, '.value')) || '',
        f = s({ descendantName: 'highlighted' }) + (u.highlighted ? ' '.concat(u.highlighted) : '');
      return l
        .replace(new RegExp(o.TAG_REPLACEMENT.highlightPreTag, 'g'), '<'.concat(r, ' class="').concat(f, '">'))
        .replace(new RegExp(o.TAG_REPLACEMENT.highlightPostTag, 'g'), '</'.concat(r, '>'));
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
    var i = n(1),
      o = n(14),
      a = n(5),
      s = (0, a.component)('Highlight');
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = e.attribute,
        n = e.highlightedTagName,
        r = void 0 === n ? 'mark' : n,
        a = e.hit,
        c = e.cssClasses,
        u = void 0 === c ? {} : c,
        l = (0, i.getPropertyByPath)(a, '_snippetResult.'.concat(t, '.value')) || '',
        f = s({ descendantName: 'highlighted' }) + (u.highlighted ? ' '.concat(u.highlighted) : '');
      return l
        .replace(new RegExp(o.TAG_REPLACEMENT.highlightPreTag, 'g'), '<'.concat(r, ' class="').concat(f, '">'))
        .replace(new RegExp(o.TAG_REPLACEMENT.highlightPostTag, 'g'), '</'.concat(r, '>'));
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
    var i = n(1),
      o = n(14),
      a = n(5),
      s = (0, a.component)('Snippet');
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      for (var t = ''.concat(e, '='), n = document.cookie.split(';'), r = 0; r < n.length; r++) {
        for (var i = n[r]; ' ' === i.charAt(0); ) i = i.substring(1);
        if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
      }
    }
    function i() {
      return r(o);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = i), (t.ANONYMOUS_TOKEN_COOKIE_KEY = void 0);
    var o = '_ALGOLIA';
    t.ANONYMOUS_TOKEN_COOKIE_KEY = o;
  },
  function (e, t, n) {
    'use strict';
    function r() {
      return 'undefined' != typeof window && Boolean(window.AlgoliaAnalyticsObject);
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var a = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.createRouterMiddleware = void 0);
    var s = a(n(111)),
      c = a(n(112)),
      u = n(1),
      l = function e(t, n) {
        n(t),
          t
            .getWidgets()
            .filter(function (e) {
              return 'ais.index' === e.$$type;
            })
            .forEach(function (t) {
              e(t, n);
            });
      },
      f = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.router,
          n = void 0 === t ? (0, c.default)() : t,
          r = e.stateMapping,
          a = void 0 === r ? (0, s.default)() : r;
        return function (e) {
          function t(e) {
            var t = Object.keys(e).reduce(function (t, n) {
                return i({}, t, o({}, n, e[n]));
              }, r.mainIndex.getWidgetState({})),
              s = a.stateToRoute(t);
            return n.createURL(s);
          }
          var r = e.instantSearchInstance;
          (r._createURL = t), (r._initialUiState = i({}, r._initialUiState, {}, a.routeToState(n.read())));
          var s = void 0;
          return {
            onStateChange: function (e) {
              var t = e.uiState,
                r = a.stateToRoute(t);
              (void 0 !== s && (0, u.isEqual)(s, r)) || (n.write(r), (s = r));
            },
            subscribe: function () {
              n.onUpdate(function (e) {
                var t = a.routeToState(e);
                l(r.mainIndex, function (e) {
                  var n = e.getWidgets(),
                    i = t[e.getIndexId()] || {},
                    o = n.reduce(function (e, t) {
                      return t.getWidgetSearchParameters ? t.getWidgetSearchParameters(e, { uiState: i }) : e;
                    }, e.getHelper().state);
                  e.getHelper().overrideStateWithoutTriggeringChangeEvent(o), r.scheduleSearch();
                });
              });
            },
            unsubscribe: function () {
              n.dispose();
            },
          };
        };
      };
    t.createRouterMiddleware = f;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++)
          (n = o[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function c(e) {
      return e.configure, a(e, ['configure']);
    }
    function u() {
      return {
        stateToRoute: function (e) {
          return Object.keys(e).reduce(function (t, n) {
            return i({}, t, o({}, n, c(e[n])));
          }, {});
        },
        routeToState: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return Object.keys(e).reduce(function (t, n) {
            return i({}, t, o({}, n, c(e[n])));
          }, {});
        },
      };
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = u);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function o(e, t, n) {
      return t && i(e.prototype, t), n && i(e, n), e;
    }
    function a(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function s(e) {
      return new d(e);
    }
    var c = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = s);
    var u = c(n(113)),
      l = function (e) {
        var t = e.qsModule,
          n = e.routeState,
          r = e.location,
          i = r.protocol,
          o = r.hostname,
          a = r.port,
          s = void 0 === a ? '' : a,
          c = r.pathname,
          u = r.hash,
          l = t.stringify(n),
          f = '' === s ? '' : ':'.concat(s);
        return l
          ? ''.concat(i, '//').concat(o).concat(f).concat(c, '?').concat(l).concat(u)
          : ''.concat(i, '//').concat(o).concat(f).concat(c).concat(u);
      },
      f = function (e) {
        var t = e.qsModule,
          n = e.location;
        return t.parse(n.search.slice(1), { arrayLimit: 99 });
      },
      h = function (e) {
        e && (window.document.title = e);
      },
      d = (function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.windowTitle,
            i = t.writeDelay,
            o = void 0 === i ? 400 : i,
            s = t.createURL,
            c = void 0 === s ? l : s,
            u = t.parseURL,
            d = void 0 === u ? f : u;
          r(this, e),
            a(this, 'windowTitle', void 0),
            a(this, 'writeDelay', void 0),
            a(this, '_createURL', void 0),
            a(this, 'parseURL', void 0),
            a(this, 'writeTimer', void 0),
            (this.windowTitle = n),
            (this.writeTimer = void 0),
            (this.writeDelay = o),
            (this._createURL = c),
            (this.parseURL = d);
          var p = this.windowTitle && this.windowTitle(this.read());
          h(p);
        }
        return (
          o(e, [
            {
              key: 'read',
              value: function () {
                return this.parseURL({ qsModule: u.default, location: window.location });
              },
            },
            {
              key: 'write',
              value: function (e) {
                var t = this,
                  n = this.createURL(e),
                  r = this.windowTitle && this.windowTitle(e);
                this.writeTimer && window.clearTimeout(this.writeTimer),
                  (this.writeTimer = window.setTimeout(function () {
                    h(r), window.history.pushState(e, r || '', n), (t.writeTimer = void 0);
                  }, this.writeDelay));
              },
            },
            {
              key: 'onUpdate',
              value: function (e) {
                var t = this;
                (this._onPopState = function (n) {
                  t.writeTimer && (window.clearTimeout(t.writeTimer), (t.writeTimer = void 0));
                  var r = n.state;
                  e(r || t.read());
                }),
                  window.addEventListener('popstate', this._onPopState);
              },
            },
            {
              key: 'createURL',
              value: function (e) {
                return this._createURL({ qsModule: u.default, routeState: e, location: window.location });
              },
            },
            {
              key: 'dispose',
              value: function () {
                this._onPopState && window.removeEventListener('popstate', this._onPopState),
                  this.writeTimer && window.clearTimeout(this.writeTimer),
                  this.write({});
              },
            },
          ]),
          e
        );
      })();
  },
  function (e, t, n) {
    'use strict';
    var r = n(114),
      i = n(115),
      o = n(49);
    e.exports = { formats: o, parse: i, stringify: r };
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2)),
      o = n(25),
      a = n(49),
      s = Object.prototype.hasOwnProperty,
      c = {
        brackets: function (e) {
          return e + '[]';
        },
        comma: 'comma',
        indices: function (e, t) {
          return e + '[' + t + ']';
        },
        repeat: function (e) {
          return e;
        },
      },
      u = Array.isArray,
      l = Array.prototype.push,
      f = function (e, t) {
        l.apply(e, u(t) ? t : [t]);
      },
      h = Date.prototype.toISOString,
      d = a.default,
      p = {
        addQueryPrefix: !1,
        allowDots: !1,
        charset: 'utf-8',
        charsetSentinel: !1,
        delimiter: '&',
        encode: !0,
        encoder: o.encode,
        encodeValuesOnly: !1,
        format: d,
        formatter: a.formatters[d],
        indices: !1,
        serializeDate: function (e) {
          return h.call(e);
        },
        skipNulls: !1,
        strictNullHandling: !1,
      },
      m = function (e) {
        return (
          'string' == typeof e ||
          'number' == typeof e ||
          'boolean' == typeof e ||
          'symbol' === (0, i.default)(e) ||
          'bigint' == typeof e
        );
      },
      g = function e(t, n, r, i, a, s, c, l, h, d, g, v, y) {
        var b = t;
        if (
          ('function' == typeof c
            ? (b = c(n, b))
            : b instanceof Date
            ? (b = d(b))
            : 'comma' === r &&
              u(b) &&
              (b = o
                .maybeMap(b, function (e) {
                  return e instanceof Date ? d(e) : e;
                })
                .join(',')),
          null === b)
        ) {
          if (i) return s && !v ? s(n, p.encoder, y, 'key') : n;
          b = '';
        }
        if (m(b) || o.isBuffer(b))
          return s
            ? [g(v ? n : s(n, p.encoder, y, 'key')) + '=' + g(s(b, p.encoder, y, 'value'))]
            : [g(n) + '=' + g(String(b))];
        var w = [];
        if (void 0 === b) return w;
        var _;
        if (u(c)) _ = c;
        else {
          var O = Object.keys(b);
          _ = l ? O.sort(l) : O;
        }
        for (var P = 0; P < _.length; ++P) {
          var j = _[P],
            S = b[j];
          if (!a || null !== S) {
            var x = u(b) ? ('function' == typeof r ? r(n, j) : n) : n + (h ? '.' + j : '[' + j + ']');
            f(w, e(S, x, r, i, a, s, c, l, h, d, g, v, y));
          }
        }
        return w;
      },
      v = function (e) {
        if (!e) return p;
        if (null !== e.encoder && void 0 !== e.encoder && 'function' != typeof e.encoder)
          throw new TypeError('Encoder has to be a function.');
        var t = e.charset || p.charset;
        if (void 0 !== e.charset && 'utf-8' !== e.charset && 'iso-8859-1' !== e.charset)
          throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
        var n = a.default;
        if (void 0 !== e.format) {
          if (!s.call(a.formatters, e.format)) throw new TypeError('Unknown format option provided.');
          n = e.format;
        }
        var r = a.formatters[n],
          i = p.filter;
        return (
          ('function' == typeof e.filter || u(e.filter)) && (i = e.filter),
          {
            addQueryPrefix: 'boolean' == typeof e.addQueryPrefix ? e.addQueryPrefix : p.addQueryPrefix,
            allowDots: void 0 === e.allowDots ? p.allowDots : !!e.allowDots,
            charset: t,
            charsetSentinel: 'boolean' == typeof e.charsetSentinel ? e.charsetSentinel : p.charsetSentinel,
            delimiter: void 0 === e.delimiter ? p.delimiter : e.delimiter,
            encode: 'boolean' == typeof e.encode ? e.encode : p.encode,
            encoder: 'function' == typeof e.encoder ? e.encoder : p.encoder,
            encodeValuesOnly: 'boolean' == typeof e.encodeValuesOnly ? e.encodeValuesOnly : p.encodeValuesOnly,
            filter: i,
            formatter: r,
            serializeDate: 'function' == typeof e.serializeDate ? e.serializeDate : p.serializeDate,
            skipNulls: 'boolean' == typeof e.skipNulls ? e.skipNulls : p.skipNulls,
            sort: 'function' == typeof e.sort ? e.sort : null,
            strictNullHandling: 'boolean' == typeof e.strictNullHandling ? e.strictNullHandling : p.strictNullHandling,
          }
        );
      };
    e.exports = function (e, t) {
      var n,
        r,
        o = e,
        a = v(t);
      'function' == typeof a.filter ? ((r = a.filter), (o = r('', o))) : u(a.filter) && ((r = a.filter), (n = r));
      var s = [];
      if ('object' !== (0, i.default)(o) || null === o) return '';
      var l;
      l =
        t && t.arrayFormat in c ? t.arrayFormat : t && 'indices' in t ? (t.indices ? 'indices' : 'repeat') : 'indices';
      var h = c[l];
      n || (n = Object.keys(o)), a.sort && n.sort(a.sort);
      for (var d = 0; d < n.length; ++d) {
        var p = n[d];
        (a.skipNulls && null === o[p]) ||
          f(
            s,
            g(
              o[p],
              p,
              h,
              a.strictNullHandling,
              a.skipNulls,
              a.encode ? a.encoder : null,
              a.filter,
              a.sort,
              a.allowDots,
              a.serializeDate,
              a.formatter,
              a.encodeValuesOnly,
              a.charset
            )
          );
      }
      var m = s.join(a.delimiter),
        y = !0 === a.addQueryPrefix ? '?' : '';
      return (
        a.charsetSentinel && ('iso-8859-1' === a.charset ? (y += 'utf8=%26%2310003%3B&') : (y += 'utf8=%E2%9C%93&')),
        m.length > 0 ? y + m : ''
      );
    };
  },
  function (e, t, n) {
    'use strict';
    var r = n(25),
      i = Object.prototype.hasOwnProperty,
      o = Array.isArray,
      a = {
        allowDots: !1,
        allowPrototypes: !1,
        arrayLimit: 20,
        charset: 'utf-8',
        charsetSentinel: !1,
        comma: !1,
        decoder: r.decode,
        delimiter: '&',
        depth: 5,
        ignoreQueryPrefix: !1,
        interpretNumericEntities: !1,
        parameterLimit: 1e3,
        parseArrays: !0,
        plainObjects: !1,
        strictNullHandling: !1,
      },
      s = function (e) {
        return e.replace(/&#(\d+);/g, function (e, t) {
          return String.fromCharCode(parseInt(t, 10));
        });
      },
      c = function (e, t) {
        return e && 'string' == typeof e && t.comma && e.indexOf(',') > -1 ? e.split(',') : e;
      },
      u = function (e, t) {
        var n,
          u = {},
          l = t.ignoreQueryPrefix ? e.replace(/^\?/, '') : e,
          f = t.parameterLimit === 1 / 0 ? void 0 : t.parameterLimit,
          h = l.split(t.delimiter, f),
          d = -1,
          p = t.charset;
        if (t.charsetSentinel)
          for (n = 0; n < h.length; ++n)
            0 === h[n].indexOf('utf8=') &&
              ('utf8=%E2%9C%93' === h[n] ? (p = 'utf-8') : 'utf8=%26%2310003%3B' === h[n] && (p = 'iso-8859-1'),
              (d = n),
              (n = h.length));
        for (n = 0; n < h.length; ++n)
          if (n !== d) {
            var m,
              g,
              v = h[n],
              y = v.indexOf(']='),
              b = -1 === y ? v.indexOf('=') : y + 1;
            -1 === b
              ? ((m = t.decoder(v, a.decoder, p, 'key')), (g = t.strictNullHandling ? null : ''))
              : ((m = t.decoder(v.slice(0, b), a.decoder, p, 'key')),
                (g = r.maybeMap(c(v.slice(b + 1), t), function (e) {
                  return t.decoder(e, a.decoder, p, 'value');
                }))),
              g && t.interpretNumericEntities && 'iso-8859-1' === p && (g = s(g)),
              v.indexOf('[]=') > -1 && (g = o(g) ? [g] : g),
              i.call(u, m) ? (u[m] = r.combine(u[m], g)) : (u[m] = g);
          }
        return u;
      },
      l = function (e, t, n, r) {
        for (var i = r ? t : c(t, n), o = e.length - 1; o >= 0; --o) {
          var a,
            s = e[o];
          if ('[]' === s && n.parseArrays) a = [].concat(i);
          else {
            a = n.plainObjects ? Object.create(null) : {};
            var u = '[' === s.charAt(0) && ']' === s.charAt(s.length - 1) ? s.slice(1, -1) : s,
              l = parseInt(u, 10);
            n.parseArrays || '' !== u
              ? !isNaN(l) && s !== u && String(l) === u && l >= 0 && n.parseArrays && l <= n.arrayLimit
                ? ((a = []), (a[l] = i))
                : (a[u] = i)
              : (a = { 0: i });
          }
          i = a;
        }
        return i;
      },
      f = function (e, t, n, r) {
        if (e) {
          var o = n.allowDots ? e.replace(/\.([^.[]+)/g, '[$1]') : e,
            a = /(\[[^[\]]*])/,
            s = /(\[[^[\]]*])/g,
            c = n.depth > 0 && a.exec(o),
            u = c ? o.slice(0, c.index) : o,
            f = [];
          if (u) {
            if (!n.plainObjects && i.call(Object.prototype, u) && !n.allowPrototypes) return;
            f.push(u);
          }
          for (var h = 0; n.depth > 0 && null !== (c = s.exec(o)) && h < n.depth; ) {
            if (((h += 1), !n.plainObjects && i.call(Object.prototype, c[1].slice(1, -1)) && !n.allowPrototypes))
              return;
            f.push(c[1]);
          }
          return c && f.push('[' + o.slice(c.index) + ']'), l(f, t, n, r);
        }
      },
      h = function (e) {
        if (!e) return a;
        if (null !== e.decoder && void 0 !== e.decoder && 'function' != typeof e.decoder)
          throw new TypeError('Decoder has to be a function.');
        if (void 0 !== e.charset && 'utf-8' !== e.charset && 'iso-8859-1' !== e.charset)
          throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
        var t = void 0 === e.charset ? a.charset : e.charset;
        return {
          allowDots: void 0 === e.allowDots ? a.allowDots : !!e.allowDots,
          allowPrototypes: 'boolean' == typeof e.allowPrototypes ? e.allowPrototypes : a.allowPrototypes,
          arrayLimit: 'number' == typeof e.arrayLimit ? e.arrayLimit : a.arrayLimit,
          charset: t,
          charsetSentinel: 'boolean' == typeof e.charsetSentinel ? e.charsetSentinel : a.charsetSentinel,
          comma: 'boolean' == typeof e.comma ? e.comma : a.comma,
          decoder: 'function' == typeof e.decoder ? e.decoder : a.decoder,
          delimiter: 'string' == typeof e.delimiter || r.isRegExp(e.delimiter) ? e.delimiter : a.delimiter,
          depth: 'number' == typeof e.depth || !1 === e.depth ? +e.depth : a.depth,
          ignoreQueryPrefix: !0 === e.ignoreQueryPrefix,
          interpretNumericEntities:
            'boolean' == typeof e.interpretNumericEntities ? e.interpretNumericEntities : a.interpretNumericEntities,
          parameterLimit: 'number' == typeof e.parameterLimit ? e.parameterLimit : a.parameterLimit,
          parseArrays: !1 !== e.parseArrays,
          plainObjects: 'boolean' == typeof e.plainObjects ? e.plainObjects : a.plainObjects,
          strictNullHandling: 'boolean' == typeof e.strictNullHandling ? e.strictNullHandling : a.strictNullHandling,
        };
      };
    e.exports = function (e, t) {
      var n = h(t);
      if ('' === e || null === e || void 0 === e) return n.plainObjects ? Object.create(null) : {};
      for (
        var i = 'string' == typeof e ? u(e, n) : e,
          o = n.plainObjects ? Object.create(null) : {},
          a = Object.keys(i),
          s = 0;
        s < a.length;
        ++s
      ) {
        var c = a[s],
          l = f(c, i[c], n, 'string' == typeof e);
        o = r.merge(o, l, n);
      }
      return r.compact(o);
    };
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }),
      Object.defineProperty(t, 'createInfiniteHitsSessionStorageCache', {
        enumerable: !0,
        get: function () {
          return i.default;
        },
      });
    var i = r(n(117));
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (null == e) return {};
      var n,
        r,
        o = i(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (r = 0; r < a.length; r++)
          (n = a[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]));
      }
      return o;
    }
    function i(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function o(e) {
      return r(e || {}, ['page']);
    }
    function a() {
      return 'undefined' != typeof window && void 0 !== window.sessionStorage;
    }
    function s() {
      return {
        read: function (e) {
          var t = e.state;
          if (!a()) return null;
          try {
            var n = JSON.parse(window.sessionStorage.getItem(u));
            return n && (0, c.isEqual)(n.state, o(t)) ? n.hits : null;
          } catch (e) {
            if (e instanceof SyntaxError)
              try {
                window.sessionStorage.removeItem(u);
              } catch (e) {}
            return null;
          }
        },
        write: function (e) {
          var t = e.state,
            n = e.hits;
          if (a())
            try {
              window.sessionStorage.setItem(u, JSON.stringify({ state: o(t), hits: n }));
            } catch (e) {}
        },
      };
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = s);
    var c = n(1),
      u = 'ais.infiniteHits';
  },
  function (e, t, n) {
    'use strict';
    var r = n(119),
      i = n(130);
    e.exports = i(r, 'Browser (lite)');
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, r) {
      var o = n(18)('algoliasearch'),
        a = n(10),
        s = n(16),
        u = n(17),
        l = 'Usage: algoliasearch(applicationID, apiKey, opts)';
      if (!0 !== r._allowEmptyCredentials && !e)
        throw new c.AlgoliaSearchError('Please provide an application ID. ' + l);
      if (!0 !== r._allowEmptyCredentials && !t) throw new c.AlgoliaSearchError('Please provide an API key. ' + l);
      (this.applicationID = e),
        (this.apiKey = t),
        (this.hosts = { read: [], write: [] }),
        (r = r || {}),
        (this._timeouts = r.timeouts || { connect: 1e3, read: 2e3, write: 3e4 }),
        r.timeout && (this._timeouts.connect = this._timeouts.read = this._timeouts.write = r.timeout);
      var f = r.protocol || 'https:';
      if ((/:$/.test(f) || (f += ':'), 'http:' !== f && 'https:' !== f))
        throw new c.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + r.protocol + '`)');
      if ((this._checkAppIdData(), r.hosts))
        s(r.hosts)
          ? ((this.hosts.read = a(r.hosts)), (this.hosts.write = a(r.hosts)))
          : ((this.hosts.read = a(r.hosts.read)), (this.hosts.write = a(r.hosts.write)));
      else {
        var h = u(this._shuffleResult, function (t) {
            return e + '-' + t + '.algolianet.com';
          }),
          d = (!1 === r.dsn ? '' : '-dsn') + '.algolia.net';
        (this.hosts.read = [this.applicationID + d].concat(h)),
          (this.hosts.write = [this.applicationID + '.algolia.net'].concat(h));
      }
      (this.hosts.read = u(this.hosts.read, i(f))),
        (this.hosts.write = u(this.hosts.write, i(f))),
        (this.extraHeaders = {}),
        (this.cache = r._cache || {}),
        (this._ua = r._ua),
        (this._useCache = !(void 0 !== r._useCache && !r._cache) || r._useCache),
        (this._useRequestCache = this._useCache && r._useRequestCache),
        (this._useFallback = void 0 === r.useFallback || r.useFallback),
        (this._setTimeout = r._setTimeout),
        o('init done, %j', this);
    }
    function i(e) {
      return function (t) {
        return e + '//' + t.toLowerCase();
      };
    }
    function o(e) {
      if (void 0 === Array.prototype.toJSON) return JSON.stringify(e);
      var t = Array.prototype.toJSON;
      delete Array.prototype.toJSON;
      var n = JSON.stringify(e);
      return (Array.prototype.toJSON = t), n;
    }
    function a(e) {
      for (var t, n, r = e.length; 0 !== r; )
        (n = Math.floor(Math.random() * r)), (r -= 1), (t = e[r]), (e[r] = e[n]), (e[n] = t);
      return e;
    }
    function s(e) {
      var t = {};
      for (var n in e)
        if (Object.prototype.hasOwnProperty.call(e, n)) {
          var r;
          (r =
            'x-algolia-api-key' === n || 'x-algolia-application-id' === n ? '**hidden for security purposes**' : e[n]),
            (t[n] = r);
        }
      return t;
    }
    e.exports = r;
    var c = n(15),
      u = n(120),
      l = n(121),
      f = n(127),
      h =
        (Object({ NODE_ENV: 'production' }).RESET_APP_DATA_TIMER &&
          parseInt(Object({ NODE_ENV: 'production' }).RESET_APP_DATA_TIMER, 10)) ||
        12e4;
    (r.prototype.initIndex = function (e) {
      return new l(this, e);
    }),
      (r.prototype.setExtraHeader = function (e, t) {
        this.extraHeaders[e.toLowerCase()] = t;
      }),
      (r.prototype.getExtraHeader = function (e) {
        return this.extraHeaders[e.toLowerCase()];
      }),
      (r.prototype.unsetExtraHeader = function (e) {
        delete this.extraHeaders[e.toLowerCase()];
      }),
      (r.prototype.addAlgoliaAgent = function (e) {
        var t = '; ' + e;
        -1 === this._ua.indexOf(t) && (this._ua += t);
      }),
      (r.prototype._jsonRequest = function (e) {
        function t(n, i) {
          function u(e) {
            var t = (e && e.body && e.body.message && e.body.status) || e.statusCode || (e && e.body && 200);
            h('received response: statusCode: %s, computed statusCode: %d, headers: %j', e.statusCode, t, e.headers);
            var n = 2 === Math.floor(t / 100),
              r = new Date();
            if (
              (b.push({
                currentHost: S,
                headers: s(f),
                content: a || null,
                contentLength: void 0 !== a ? a.length : null,
                method: i.method,
                timeouts: i.timeouts,
                url: i.url,
                startTime: P,
                endTime: r,
                duration: r - P,
                statusCode: t,
              }),
              n)
            )
              return (
                m._useCache && !m._useRequestCache && p && (p[l] = e.responseText),
                { responseText: e.responseText, body: e.body }
              );
            if (4 !== Math.floor(t / 100)) return (g += 1), _();
            h('unrecoverable error');
            var o = new c.AlgoliaSearchError(e.body && e.body.message, { debugData: b, statusCode: t });
            return m._promise.reject(o);
          }
          function w(t) {
            h('error: %s, stack: %s', t.message, t.stack);
            var n = new Date();
            return (
              b.push({
                currentHost: S,
                headers: s(f),
                content: a || null,
                contentLength: void 0 !== a ? a.length : null,
                method: i.method,
                timeouts: i.timeouts,
                url: i.url,
                startTime: P,
                endTime: n,
                duration: n - P,
              }),
              t instanceof c.AlgoliaSearchError || (t = new c.Unknown(t && t.message, t)),
              (g += 1),
              t instanceof c.Unknown || t instanceof c.UnparsableJSON || (g >= m.hosts[e.hostType].length && (v || !y))
                ? ((t.debugData = b), m._promise.reject(t))
                : t instanceof c.RequestTimeout
                ? O()
                : _()
            );
          }
          function _() {
            return h('retrying request'), m._incrementHostIndex(e.hostType), t(n, i);
          }
          function O() {
            return (
              h('retrying request with higher timeout'),
              m._incrementHostIndex(e.hostType),
              m._incrementTimeoutMultipler(),
              (i.timeouts = m._getTimeoutsForRequest(e.hostType)),
              t(n, i)
            );
          }
          m._checkAppIdData();
          var P = new Date();
          if (
            (m._useCache && !m._useRequestCache && (l = e.url),
            m._useCache && !m._useRequestCache && a && (l += '_body_' + i.body),
            r(!m._useRequestCache, p, l))
          ) {
            h('serving response from cache');
            var j = p[l];
            return m._promise.resolve({ body: JSON.parse(j), responseText: j });
          }
          if (g >= m.hosts[e.hostType].length)
            return !y || v
              ? (h('could not get any response'),
                m._promise.reject(
                  new c.AlgoliaSearchError(
                    'Cannot connect to the AlgoliaSearch API. Send an email to support@algolia.com to report and resolve the issue. Application id was: ' +
                      m.applicationID,
                    { debugData: b }
                  )
                ))
              : (h('switching to fallback'),
                (g = 0),
                (i.method = e.fallback.method),
                (i.url = e.fallback.url),
                (i.jsonBody = e.fallback.body),
                i.jsonBody && (i.body = o(i.jsonBody)),
                (f = m._computeRequestHeaders({ additionalUA: d, headers: e.headers })),
                (i.timeouts = m._getTimeoutsForRequest(e.hostType)),
                m._setHostIndexByType(0, e.hostType),
                (v = !0),
                t(m._request.fallback, i));
          var S = m._getHostByType(e.hostType),
            x = S + i.url,
            R = {
              body: i.body,
              jsonBody: i.jsonBody,
              method: i.method,
              headers: f,
              timeouts: i.timeouts,
              debug: h,
              forceAuthHeaders: i.forceAuthHeaders,
            };
          return (
            h('method: %s, url: %s, headers: %j, timeouts: %d', R.method, x, R.headers, R.timeouts),
            n === m._request.fallback && h('using fallback'),
            n.call(m, x, R).then(u, w)
          );
        }
        function r(e, t, n) {
          return m._useCache && e && t && void 0 !== t[n];
        }
        function i(t, n) {
          if (
            (r(m._useRequestCache, p, l) &&
              t.catch(function () {
                delete p[l];
              }),
            'function' != typeof e.callback)
          )
            return t.then(n);
          t.then(
            function (t) {
              u(function () {
                e.callback(null, n(t));
              }, m._setTimeout || setTimeout);
            },
            function (t) {
              u(function () {
                e.callback(t);
              }, m._setTimeout || setTimeout);
            }
          );
        }
        this._checkAppIdData();
        var a,
          l,
          f,
          h = n(18)('algoliasearch:' + e.url),
          d = e.additionalUA || '',
          p = e.cache,
          m = this,
          g = 0,
          v = !1,
          y = m._useFallback && m._request.fallback && e.fallback;
        this.apiKey.length > 500 && void 0 !== e.body && (void 0 !== e.body.params || void 0 !== e.body.requests)
          ? ((e.body.apiKey = this.apiKey),
            (f = this._computeRequestHeaders({ additionalUA: d, withApiKey: !1, headers: e.headers })))
          : (f = this._computeRequestHeaders({ additionalUA: d, headers: e.headers })),
          void 0 !== e.body && (a = o(e.body)),
          h('request start');
        var b = [];
        if (
          (m._useCache && m._useRequestCache && (l = e.url),
          m._useCache && m._useRequestCache && a && (l += '_body_' + a),
          r(m._useRequestCache, p, l))
        ) {
          h('serving request from cache');
          var w = p[l];
          return i('function' != typeof w.then ? m._promise.resolve({ responseText: w }) : w, function (e) {
            return JSON.parse(e.responseText);
          });
        }
        var _ = t(m._request, {
          url: e.url,
          method: e.method,
          body: a,
          jsonBody: e.body,
          timeouts: m._getTimeoutsForRequest(e.hostType),
          forceAuthHeaders: e.forceAuthHeaders,
        });
        return (
          m._useCache && m._useRequestCache && p && (p[l] = _),
          i(_, function (e) {
            return e.body;
          })
        );
      }),
      (r.prototype._getSearchParams = function (e, t) {
        if (void 0 === e || null === e) return t;
        for (var n in e)
          null !== n &&
            void 0 !== e[n] &&
            e.hasOwnProperty(n) &&
            ((t += '' === t ? '' : '&'),
            (t +=
              n +
              '=' +
              encodeURIComponent('[object Array]' === Object.prototype.toString.call(e[n]) ? o(e[n]) : e[n])));
        return t;
      }),
      (r.prototype._computeRequestHeaders = function (e) {
        var t = n(9),
          r = e.additionalUA ? this._ua + '; ' + e.additionalUA : this._ua,
          i = { 'x-algolia-agent': r, 'x-algolia-application-id': this.applicationID };
        return (
          !1 !== e.withApiKey && (i['x-algolia-api-key'] = this.apiKey),
          this.userToken && (i['x-algolia-usertoken'] = this.userToken),
          this.securityTags && (i['x-algolia-tagfilters'] = this.securityTags),
          t(this.extraHeaders, function (e, t) {
            i[t] = e;
          }),
          e.headers &&
            t(e.headers, function (e, t) {
              i[t] = e;
            }),
          i
        );
      }),
      (r.prototype.search = function (e, t, r) {
        var i = n(16),
          o = n(17);
        if (!i(e)) throw new Error('Usage: client.search(arrayOfQueries[, callback])');
        'function' == typeof t ? ((r = t), (t = {})) : void 0 === t && (t = {});
        var a = this,
          s = {
            requests: o(e, function (e) {
              var t = '';
              return (
                void 0 !== e.query && (t += 'query=' + encodeURIComponent(e.query)),
                { indexName: e.indexName, params: a._getSearchParams(e.params, t) }
              );
            }),
          },
          c = o(s.requests, function (e, t) {
            return t + '=' + encodeURIComponent('/1/indexes/' + encodeURIComponent(e.indexName) + '?' + e.params);
          }).join('&');
        return (
          void 0 !== t.strategy && (s.strategy = t.strategy),
          this._jsonRequest({
            cache: this.cache,
            method: 'POST',
            url: '/1/indexes/*/queries',
            body: s,
            hostType: 'read',
            fallback: { method: 'GET', url: '/1/indexes/*', body: { params: c } },
            callback: r,
          })
        );
      }),
      (r.prototype.searchForFacetValues = function (e) {
        var t = n(16),
          r = n(17),
          i =
            'Usage: client.searchForFacetValues([{indexName, params: {facetName, facetQuery, ...params}}, ...queries])';
        if (!t(e)) throw new Error(i);
        var o = this;
        return o._promise.all(
          r(e, function (e) {
            if (!e || void 0 === e.indexName || void 0 === e.params.facetName || void 0 === e.params.facetQuery)
              throw new Error(i);
            var t = n(10),
              r = n(52),
              a = e.indexName,
              s = e.params,
              c = s.facetName,
              u = r(t(s), function (e) {
                return 'facetName' === e;
              }),
              l = o._getSearchParams(u, '');
            return o._jsonRequest({
              cache: o.cache,
              method: 'POST',
              url: '/1/indexes/' + encodeURIComponent(a) + '/facets/' + encodeURIComponent(c) + '/query',
              hostType: 'read',
              body: { params: l },
            });
          })
        );
      }),
      (r.prototype.setSecurityTags = function (e) {
        if ('[object Array]' === Object.prototype.toString.call(e)) {
          for (var t = [], n = 0; n < e.length; ++n)
            if ('[object Array]' === Object.prototype.toString.call(e[n])) {
              for (var r = [], i = 0; i < e[n].length; ++i) r.push(e[n][i]);
              t.push('(' + r.join(',') + ')');
            } else t.push(e[n]);
          e = t.join(',');
        }
        this.securityTags = e;
      }),
      (r.prototype.setUserToken = function (e) {
        this.userToken = e;
      }),
      (r.prototype.clearCache = function () {
        this.cache = {};
      }),
      (r.prototype.setRequestTimeout = function (e) {
        e && (this._timeouts.connect = this._timeouts.read = this._timeouts.write = e);
      }),
      (r.prototype.setTimeouts = function (e) {
        this._timeouts = e;
      }),
      (r.prototype.getTimeouts = function () {
        return this._timeouts;
      }),
      (r.prototype._getAppIdData = function () {
        var e = f.get(this.applicationID);
        return null !== e && this._cacheAppIdData(e), e;
      }),
      (r.prototype._setAppIdData = function (e) {
        return (e.lastChange = new Date().getTime()), this._cacheAppIdData(e), f.set(this.applicationID, e);
      }),
      (r.prototype._checkAppIdData = function () {
        var e = this._getAppIdData(),
          t = new Date().getTime();
        return null === e || t - e.lastChange > h ? this._resetInitialAppIdData(e) : e;
      }),
      (r.prototype._resetInitialAppIdData = function (e) {
        var t = e || {};
        return (
          (t.hostIndexes = { read: 0, write: 0 }),
          (t.timeoutMultiplier = 1),
          (t.shuffleResult = t.shuffleResult || a([1, 2, 3])),
          this._setAppIdData(t)
        );
      }),
      (r.prototype._cacheAppIdData = function (e) {
        (this._hostIndexes = e.hostIndexes),
          (this._timeoutMultiplier = e.timeoutMultiplier),
          (this._shuffleResult = e.shuffleResult);
      }),
      (r.prototype._partialAppIdDataUpdate = function (e) {
        var t = n(9),
          r = this._getAppIdData();
        return (
          t(e, function (e, t) {
            r[t] = e;
          }),
          this._setAppIdData(r)
        );
      }),
      (r.prototype._getHostByType = function (e) {
        return this.hosts[e][this._getHostIndexByType(e)];
      }),
      (r.prototype._getTimeoutMultiplier = function () {
        return this._timeoutMultiplier;
      }),
      (r.prototype._getHostIndexByType = function (e) {
        return this._hostIndexes[e];
      }),
      (r.prototype._setHostIndexByType = function (e, t) {
        var r = n(10),
          i = r(this._hostIndexes);
        return (i[t] = e), this._partialAppIdDataUpdate({ hostIndexes: i }), e;
      }),
      (r.prototype._incrementHostIndex = function (e) {
        return this._setHostIndexByType((this._getHostIndexByType(e) + 1) % this.hosts[e].length, e);
      }),
      (r.prototype._incrementTimeoutMultipler = function () {
        var e = Math.max(this._timeoutMultiplier + 1, 4);
        return this._partialAppIdDataUpdate({ timeoutMultiplier: e });
      }),
      (r.prototype._getTimeoutsForRequest = function (e) {
        return {
          connect: this._timeouts.connect * this._timeoutMultiplier,
          complete: this._timeouts[e] * this._timeoutMultiplier,
        };
      });
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e, t) {
      t(e, 0);
    };
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      (this.indexName = t),
        (this.as = e),
        (this.typeAheadArgs = null),
        (this.typeAheadValueOption = null),
        (this.cache = {});
    }
    var i = n(0),
      o = i(n(2)),
      a = n(51),
      s = n(122),
      c = n(123);
    (e.exports = r),
      (r.prototype.clearCache = function () {
        this.cache = {};
      }),
      (r.prototype.search = a('query')),
      (r.prototype.similarSearch = s(
        a('similarQuery'),
        c('index.similarSearch(query[, callback])', 'index.search({ similarQuery: query }[, callback])')
      )),
      (r.prototype.browse = function (e, t, r) {
        var i,
          a,
          s = n(124),
          c = this;
        0 === arguments.length || (1 === arguments.length && 'function' == typeof arguments[0])
          ? ((i = 0), (r = arguments[0]), (e = void 0))
          : 'number' == typeof arguments[0]
          ? ((i = arguments[0]),
            'number' == typeof arguments[1]
              ? (a = arguments[1])
              : 'function' == typeof arguments[1] && ((r = arguments[1]), (a = void 0)),
            (e = void 0),
            (t = void 0))
          : 'object' === (0, o.default)(arguments[0])
          ? ('function' == typeof arguments[1] && (r = arguments[1]), (t = arguments[0]), (e = void 0))
          : 'string' == typeof arguments[0] && 'function' == typeof arguments[1] && ((r = arguments[1]), (t = void 0)),
          (t = s({}, t || {}, { page: i, hitsPerPage: a, query: e }));
        var u = this.as._getSearchParams(t, '');
        return this.as._jsonRequest({
          method: 'POST',
          url: '/1/indexes/' + encodeURIComponent(c.indexName) + '/browse',
          body: { params: u },
          hostType: 'read',
          callback: r,
        });
      }),
      (r.prototype.browseFrom = function (e, t) {
        return this.as._jsonRequest({
          method: 'POST',
          url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse',
          body: { cursor: e },
          hostType: 'read',
          callback: t,
        });
      }),
      (r.prototype.searchForFacetValues = function (e, t) {
        var r = n(10),
          i = n(52);
        if (void 0 === e.facetName || void 0 === e.facetQuery)
          throw new Error('Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])');
        var o = e.facetName,
          a = i(r(e), function (e) {
            return 'facetName' === e;
          }),
          s = this.as._getSearchParams(a, '');
        return this.as._jsonRequest({
          method: 'POST',
          url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(o) + '/query',
          hostType: 'read',
          body: { params: s },
          callback: t,
        });
      }),
      (r.prototype.searchFacet = s(function (e, t) {
        return this.searchForFacetValues(e, t);
      }, c('index.searchFacet(params[, callback])', 'index.searchForFacetValues(params[, callback])'))),
      (r.prototype._search = function (e, t, n, r) {
        return this.as._jsonRequest({
          cache: this.cache,
          method: 'POST',
          url: t || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
          body: { params: e },
          hostType: 'read',
          fallback: { method: 'GET', url: '/1/indexes/' + encodeURIComponent(this.indexName), body: { params: e } },
          callback: n,
          additionalUA: r,
        });
      }),
      (r.prototype.getObject = function (e, t, n) {
        var r = this;
        (1 !== arguments.length && 'function' != typeof t) || ((n = t), (t = void 0));
        var i = '';
        if (void 0 !== t) {
          i = '?attributes=';
          for (var o = 0; o < t.length; ++o) 0 !== o && (i += ','), (i += t[o]);
        }
        return this.as._jsonRequest({
          method: 'GET',
          url: '/1/indexes/' + encodeURIComponent(r.indexName) + '/' + encodeURIComponent(e) + i,
          hostType: 'read',
          callback: n,
        });
      }),
      (r.prototype.getObjects = function (e, t, r) {
        var i = n(16),
          o = n(17);
        if (!i(e)) throw new Error('Usage: index.getObjects(arrayOfObjectIDs[, callback])');
        var a = this;
        (1 !== arguments.length && 'function' != typeof t) || ((r = t), (t = void 0));
        var s = {
          requests: o(e, function (e) {
            var n = { indexName: a.indexName, objectID: e };
            return t && (n.attributesToRetrieve = t.join(',')), n;
          }),
        };
        return this.as._jsonRequest({
          method: 'POST',
          url: '/1/indexes/*/objects',
          hostType: 'read',
          body: s,
          callback: r,
        });
      }),
      (r.prototype.as = null),
      (r.prototype.indexName = null),
      (r.prototype.typeAheadArgs = null),
      (r.prototype.typeAheadValueOption = null);
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e, t) {
      function n() {
        return r || (console.warn(t), (r = !0)), e.apply(this, arguments);
      }
      var r = !1;
      return n;
    };
  },
  function (e, t, n) {
    'use strict';
    e.exports = function (e, t) {
      return (
        'algoliasearch: `' +
        e +
        '` was replaced by `' +
        t +
        '`. Please see https://github.com/algolia/algoliasearch-client-javascript/wiki/Deprecated#' +
        e.toLowerCase().replace(/[\.\(\)]/g, '')
      );
    };
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2)),
      o = n(9);
    e.exports = function e(t) {
      var n = Array.prototype.slice.call(arguments);
      return (
        o(n, function (n) {
          for (var r in n)
            n.hasOwnProperty(r) &&
              ('object' === (0, i.default)(t[r]) && 'object' === (0, i.default)(n[r])
                ? (t[r] = e({}, t[r], n[r]))
                : void 0 !== n[r] && (t[r] = n[r]));
        }),
        t
      );
    };
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2)),
      o = Object.prototype.hasOwnProperty,
      a = Object.prototype.toString,
      s = Array.prototype.slice,
      c = n(126),
      u = Object.prototype.propertyIsEnumerable,
      l = !u.call({ toString: null }, 'toString'),
      f = u.call(function () {}, 'prototype'),
      h = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor',
      ],
      d = function (e) {
        var t = e.constructor;
        return t && t.prototype === e;
      },
      p = {
        $console: !0,
        $external: !0,
        $frame: !0,
        $frameElement: !0,
        $frames: !0,
        $innerHeight: !0,
        $innerWidth: !0,
        $outerHeight: !0,
        $outerWidth: !0,
        $pageXOffset: !0,
        $pageYOffset: !0,
        $parent: !0,
        $scrollLeft: !0,
        $scrollTop: !0,
        $scrollX: !0,
        $scrollY: !0,
        $self: !0,
        $webkitIndexedDB: !0,
        $webkitStorageInfo: !0,
        $window: !0,
      },
      m = (function () {
        if ('undefined' == typeof window) return !1;
        for (var e in window)
          try {
            if (!p['$' + e] && o.call(window, e) && null !== window[e] && 'object' === (0, i.default)(window[e]))
              try {
                d(window[e]);
              } catch (e) {
                return !0;
              }
          } catch (e) {
            return !0;
          }
        return !1;
      })(),
      g = function (e) {
        if ('undefined' == typeof window || !m) return d(e);
        try {
          return d(e);
        } catch (e) {
          return !1;
        }
      },
      v = function (e) {
        var t = null !== e && 'object' === (0, i.default)(e),
          n = '[object Function]' === a.call(e),
          r = c(e),
          s = t && '[object String]' === a.call(e),
          u = [];
        if (!t && !n && !r) throw new TypeError('Object.keys called on a non-object');
        var d = f && n;
        if (s && e.length > 0 && !o.call(e, 0)) for (var p = 0; p < e.length; ++p) u.push(String(p));
        if (r && e.length > 0) for (var m = 0; m < e.length; ++m) u.push(String(m));
        else for (var v in e) (d && 'prototype' === v) || !o.call(e, v) || u.push(String(v));
        if (l)
          for (var y = g(e), b = 0; b < h.length; ++b)
            (y && 'constructor' === h[b]) || !o.call(e, h[b]) || u.push(h[b]);
        return u;
      };
    (v.shim = function () {
      if (Object.keys) {
        if (
          !(function () {
            return 2 === (Object.keys(arguments) || '').length;
          })(1, 2)
        ) {
          var e = Object.keys;
          Object.keys = function (t) {
            return e(c(t) ? s.call(t) : t);
          };
        }
      } else Object.keys = v;
      return Object.keys || v;
    }),
      (e.exports = v);
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2)),
      o = Object.prototype.toString;
    e.exports = function (e) {
      var t = o.call(e),
        n = '[object Arguments]' === t;
      return (
        n ||
          (n =
            '[object Array]' !== t &&
            null !== e &&
            'object' === (0, i.default)(e) &&
            'number' == typeof e.length &&
            e.length >= 0 &&
            '[object Function]' === o.call(e.callee)),
        n
      );
    };
  },
  function (e, t, n) {
    'use strict';
    (function (t) {
      function r(e, t) {
        return c('localStorage failed with', t), a(), (s = l), s.get(e);
      }
      function i(e, t) {
        return 1 === arguments.length ? s.get(e) : s.set(e, t);
      }
      function o() {
        try {
          return (
            'localStorage' in t &&
            null !== t.localStorage &&
            (t.localStorage[u] || t.localStorage.setItem(u, JSON.stringify({})), !0)
          );
        } catch (e) {
          return !1;
        }
      }
      function a() {
        try {
          t.localStorage.removeItem(u);
        } catch (e) {}
      }
      var s,
        c = n(18)('algoliasearch:src/hostIndexState.js'),
        u = 'algoliasearch-client-js',
        l = {
          state: {},
          set: function (e, t) {
            return (this.state[e] = t), this.state[e];
          },
          get: function (e) {
            return this.state[e] || null;
          },
        },
        f = {
          set: function (e, n) {
            l.set(e, n);
            try {
              var i = JSON.parse(t.localStorage[u]);
              return (i[e] = n), (t.localStorage[u] = JSON.stringify(i)), i[e];
            } catch (t) {
              return r(e, t);
            }
          },
          get: function (e) {
            try {
              return JSON.parse(t.localStorage[u])[e] || null;
            } catch (t) {
              return r(e, t);
            }
          },
        };
      (s = o() ? f : l), (e.exports = { get: i, set: i, supportsLocalStorage: o });
    }).call(t, n(11));
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var n,
        r = 0;
      for (n in e) (r = (r << 5) - r + e.charCodeAt(n)), (r |= 0);
      return t.colors[Math.abs(r) % t.colors.length];
    }
    function i(e) {
      function n() {
        if (n.enabled) {
          var e = n,
            r = +new Date(),
            i = r - (u || r);
          (e.diff = i), (e.prev = u), (e.curr = r), (u = r);
          for (var o = new Array(arguments.length), a = 0; a < o.length; a++) o[a] = arguments[a];
          (o[0] = t.coerce(o[0])), 'string' != typeof o[0] && o.unshift('%O');
          var s = 0;
          (o[0] = o[0].replace(/%([a-zA-Z%])/g, function (n, r) {
            if ('%%' === n) return n;
            s++;
            var i = t.formatters[r];
            if ('function' == typeof i) {
              var a = o[s];
              (n = i.call(e, a)), o.splice(s, 1), s--;
            }
            return n;
          })),
            t.formatArgs.call(e, o),
            (n.log || t.log || console.log.bind(console)).apply(e, o);
        }
      }
      return (
        (n.namespace = e),
        (n.enabled = t.enabled(e)),
        (n.useColors = t.useColors()),
        (n.color = r(e)),
        'function' == typeof t.init && t.init(n),
        n
      );
    }
    function o(e) {
      t.save(e), (t.names = []), (t.skips = []);
      for (var n = ('string' == typeof e ? e : '').split(/[\s,]+/), r = n.length, i = 0; i < r; i++)
        n[i] &&
          ((e = n[i].replace(/\*/g, '.*?')),
          '-' === e[0] ? t.skips.push(new RegExp('^' + e.substr(1) + '$')) : t.names.push(new RegExp('^' + e + '$')));
    }
    function a() {
      t.enable('');
    }
    function s(e) {
      var n, r;
      for (n = 0, r = t.skips.length; n < r; n++) if (t.skips[n].test(e)) return !1;
      for (n = 0, r = t.names.length; n < r; n++) if (t.names[n].test(e)) return !0;
      return !1;
    }
    function c(e) {
      return e instanceof Error ? e.stack || e.message : e;
    }
    (t = e.exports = i.debug = i.default = i),
      (t.coerce = c),
      (t.disable = a),
      (t.enable = o),
      (t.enabled = s),
      (t.humanize = n(129)),
      (t.names = []),
      (t.skips = []),
      (t.formatters = {});
    var u;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      if (((e = String(e)), !(e.length > 100))) {
        var t =
          /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
            e
          );
        if (t) {
          var n = parseFloat(t[1]);
          switch ((t[2] || 'ms').toLowerCase()) {
            case 'years':
            case 'year':
            case 'yrs':
            case 'yr':
            case 'y':
              return n * d;
            case 'days':
            case 'day':
            case 'd':
              return n * h;
            case 'hours':
            case 'hour':
            case 'hrs':
            case 'hr':
            case 'h':
              return n * f;
            case 'minutes':
            case 'minute':
            case 'mins':
            case 'min':
            case 'm':
              return n * l;
            case 'seconds':
            case 'second':
            case 'secs':
            case 'sec':
            case 's':
              return n * u;
            case 'milliseconds':
            case 'millisecond':
            case 'msecs':
            case 'msec':
            case 'ms':
              return n;
            default:
              return;
          }
        }
      }
    }
    function i(e) {
      return e >= h
        ? Math.round(e / h) + 'd'
        : e >= f
        ? Math.round(e / f) + 'h'
        : e >= l
        ? Math.round(e / l) + 'm'
        : e >= u
        ? Math.round(e / u) + 's'
        : e + 'ms';
    }
    function o(e) {
      return a(e, h, 'day') || a(e, f, 'hour') || a(e, l, 'minute') || a(e, u, 'second') || e + ' ms';
    }
    function a(e, t, n) {
      if (!(e < t)) return e < 1.5 * t ? Math.floor(e / t) + ' ' + n : Math.ceil(e / t) + ' ' + n + 's';
    }
    var s = n(0),
      c = s(n(2)),
      u = 1e3,
      l = 60 * u,
      f = 60 * l,
      h = 24 * f,
      d = 365.25 * h;
    e.exports = function (e, t) {
      t = t || {};
      var n = (0, c.default)(e);
      if ('string' === n && e.length > 0) return r(e);
      if ('number' === n && !1 === isNaN(e)) return t.long ? o(e) : i(e);
      throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(e));
    };
  },
  function (e, t, n) {
    'use strict';
    var r = n(131),
      i = r.Promise || n(132).Promise;
    e.exports = function (e, t) {
      function o(e, t, r) {
        return (r = n(10)(r || {})), (r._ua = r._ua || o.ua), new a(e, t, r);
      }
      function a() {
        e.apply(this, arguments);
      }
      var s = n(50),
        c = n(15),
        u = n(134),
        l = n(135),
        f = n(136);
      (t = t || ''),
        (o.version = n(139)),
        (o.ua = 'Algolia for JavaScript (' + o.version + '); ' + t),
        (o.initPlaces = f(o)),
        (r.__algolia = { debug: n(18), algoliasearch: o });
      var h = { hasXMLHttpRequest: 'XMLHttpRequest' in r, hasXDomainRequest: 'XDomainRequest' in r };
      return (
        h.hasXMLHttpRequest && (h.cors = 'withCredentials' in new XMLHttpRequest()),
        s(a, e),
        (a.prototype._request = function (e, t) {
          return new i(function (n, r) {
            function i() {
              if (!p) {
                clearTimeout(d);
                var e;
                try {
                  e = {
                    body: JSON.parse(g.responseText),
                    responseText: g.responseText,
                    statusCode: g.status,
                    headers: (g.getAllResponseHeaders && g.getAllResponseHeaders()) || {},
                  };
                } catch (t) {
                  e = new c.UnparsableJSON({ more: g.responseText });
                }
                e instanceof c.UnparsableJSON ? r(e) : n(e);
              }
            }
            function o(e) {
              p || (clearTimeout(d), r(new c.Network({ more: e })));
            }
            function a() {
              (p = !0), g.abort(), r(new c.RequestTimeout());
            }
            function s() {
              (v = !0), clearTimeout(d), (d = setTimeout(a, t.timeouts.complete));
            }
            function l() {
              v || s();
            }
            function f() {
              !v && g.readyState > 1 && s();
            }
            if (!h.cors && !h.hasXDomainRequest) return void r(new c.Network('CORS not supported'));
            e = u(e, t.headers);
            var d,
              p,
              m = t.body,
              g = h.cors ? new XMLHttpRequest() : new XDomainRequest(),
              v = !1;
            (d = setTimeout(a, t.timeouts.connect)),
              (g.onprogress = l),
              'onreadystatechange' in g && (g.onreadystatechange = f),
              (g.onload = i),
              (g.onerror = o),
              g instanceof XMLHttpRequest
                ? (g.open(t.method, e, !0),
                  t.forceAuthHeaders &&
                    (g.setRequestHeader('x-algolia-application-id', t.headers['x-algolia-application-id']),
                    g.setRequestHeader('x-algolia-api-key', t.headers['x-algolia-api-key'])))
                : g.open(t.method, e),
              h.cors &&
                (m &&
                  ('POST' === t.method
                    ? g.setRequestHeader('content-type', 'application/x-www-form-urlencoded')
                    : g.setRequestHeader('content-type', 'application/json')),
                g.setRequestHeader('accept', 'application/json')),
              m ? g.send(m) : g.send();
          });
        }),
        (a.prototype._request.fallback = function (e, t) {
          return (
            (e = u(e, t.headers)),
            new i(function (n, r) {
              l(e, t, function (e, t) {
                if (e) return void r(e);
                n(t);
              });
            })
          );
        }),
        (a.prototype._promise = {
          reject: function (e) {
            return i.reject(e);
          },
          resolve: function (e) {
            return i.resolve(e);
          },
          delay: function (e) {
            return new i(function (t) {
              setTimeout(t, e);
            });
          },
          all: function (e) {
            return i.all(e);
          },
        }),
        o
      );
    };
  },
  function (e, t, n) {
    'use strict';
    (function (t) {
      var n;
      (n = 'undefined' != typeof window ? window : void 0 !== t ? t : 'undefined' != typeof self ? self : {}),
        (e.exports = n);
    }).call(t, n(11));
  },
  function (e, t, n) {
    'use strict';
    (function (r, i) {
      var o,
        a,
        s = n(0),
        c = s(n(2));
      !(function (r, i) {
        'object' === (0, c.default)(t) && void 0 !== e
          ? (e.exports = i())
          : ((o = i), void 0 !== (a = 'function' == typeof o ? o.call(t, n, t, e) : o) && (e.exports = a));
      })(0, function () {
        function e(e) {
          var t = (0, c.default)(e);
          return null !== e && ('object' === t || 'function' === t);
        }
        function t(e) {
          return 'function' == typeof e;
        }
        function o(e) {
          W = e;
        }
        function a(e) {
          K = e;
        }
        function s() {
          return void 0 !== V
            ? function () {
                V(l);
              }
            : u();
        }
        function u() {
          var e = setTimeout;
          return function () {
            return e(l, 1);
          };
        }
        function l() {
          for (var e = 0; e < Q; e += 2) (0, Z[e])(Z[e + 1]), (Z[e] = void 0), (Z[e + 1] = void 0);
          Q = 0;
        }
        function f(e, t) {
          var n = arguments,
            r = this,
            i = new this.constructor(d);
          void 0 === i[te] && k(i);
          var o = r._state;
          return (
            o
              ? (function () {
                  var e = n[o - 1];
                  K(function () {
                    return T(o, i, e, r._result);
                  });
                })()
              : S(r, i, e, t),
            i
          );
        }
        function h(e) {
          var t = this;
          if (e && 'object' === (0, c.default)(e) && e.constructor === t) return e;
          var n = new t(d);
          return _(n, e), n;
        }
        function d() {}
        function p() {
          return new TypeError('You cannot resolve a promise with itself');
        }
        function m() {
          return new TypeError('A promises callback cannot return that same promise.');
        }
        function g(e) {
          try {
            return e.then;
          } catch (e) {
            return (oe.error = e), oe;
          }
        }
        function v(e, t, n, r) {
          try {
            e.call(t, n, r);
          } catch (e) {
            return e;
          }
        }
        function y(e, t, n) {
          K(function (e) {
            var r = !1,
              i = v(
                n,
                t,
                function (n) {
                  r || ((r = !0), t !== n ? _(e, n) : P(e, n));
                },
                function (t) {
                  r || ((r = !0), j(e, t));
                },
                'Settle: ' + (e._label || ' unknown promise')
              );
            !r && i && ((r = !0), j(e, i));
          }, e);
        }
        function b(e, t) {
          t._state === re
            ? P(e, t._result)
            : t._state === ie
            ? j(e, t._result)
            : S(
                t,
                void 0,
                function (t) {
                  return _(e, t);
                },
                function (t) {
                  return j(e, t);
                }
              );
        }
        function w(e, n, r) {
          n.constructor === e.constructor && r === f && n.constructor.resolve === h
            ? b(e, n)
            : r === oe
            ? (j(e, oe.error), (oe.error = null))
            : void 0 === r
            ? P(e, n)
            : t(r)
            ? y(e, n, r)
            : P(e, n);
        }
        function _(t, n) {
          t === n ? j(t, p()) : e(n) ? w(t, n, g(n)) : P(t, n);
        }
        function O(e) {
          e._onerror && e._onerror(e._result), x(e);
        }
        function P(e, t) {
          e._state === ne && ((e._result = t), (e._state = re), 0 !== e._subscribers.length && K(x, e));
        }
        function j(e, t) {
          e._state === ne && ((e._state = ie), (e._result = t), K(O, e));
        }
        function S(e, t, n, r) {
          var i = e._subscribers,
            o = i.length;
          (e._onerror = null), (i[o] = t), (i[o + re] = n), (i[o + ie] = r), 0 === o && e._state && K(x, e);
        }
        function x(e) {
          var t = e._subscribers,
            n = e._state;
          if (0 !== t.length) {
            for (var r = void 0, i = void 0, o = e._result, a = 0; a < t.length; a += 3)
              (r = t[a]), (i = t[a + n]), r ? T(n, r, i, o) : i(o);
            e._subscribers.length = 0;
          }
        }
        function R() {
          this.error = null;
        }
        function E(e, t) {
          try {
            return e(t);
          } catch (e) {
            return (ae.error = e), ae;
          }
        }
        function T(e, n, r, i) {
          var o = t(r),
            a = void 0,
            s = void 0,
            c = void 0,
            u = void 0;
          if (o) {
            if (((a = E(r, i)), a === ae ? ((u = !0), (s = a.error), (a.error = null)) : (c = !0), n === a))
              return void j(n, m());
          } else (a = i), (c = !0);
          n._state !== ne || (o && c ? _(n, a) : u ? j(n, s) : e === re ? P(n, a) : e === ie && j(n, a));
        }
        function C(e, t) {
          try {
            t(
              function (t) {
                _(e, t);
              },
              function (t) {
                j(e, t);
              }
            );
          } catch (t) {
            j(e, t);
          }
        }
        function N() {
          return se++;
        }
        function k(e) {
          (e[te] = se++), (e._state = void 0), (e._result = void 0), (e._subscribers = []);
        }
        function F(e, t) {
          (this._instanceConstructor = e),
            (this.promise = new e(d)),
            this.promise[te] || k(this.promise),
            $(t)
              ? ((this.length = t.length),
                (this._remaining = t.length),
                (this._result = new Array(this.length)),
                0 === this.length
                  ? P(this.promise, this._result)
                  : ((this.length = this.length || 0),
                    this._enumerate(t),
                    0 === this._remaining && P(this.promise, this._result)))
              : j(this.promise, A());
        }
        function A() {
          return new Error('Array Methods must be provided an Array');
        }
        function I(e) {
          return new F(this, e).promise;
        }
        function D(e) {
          var t = this;
          return new t(
            $(e)
              ? function (n, r) {
                  for (var i = e.length, o = 0; o < i; o++) t.resolve(e[o]).then(n, r);
                }
              : function (e, t) {
                  return t(new TypeError('You must pass an array to race.'));
                }
          );
        }
        function M(e) {
          var t = this,
            n = new t(d);
          return j(n, e), n;
        }
        function L() {
          throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
        }
        function H() {
          throw new TypeError(
            "Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function."
          );
        }
        function q(e) {
          (this[te] = N()),
            (this._result = this._state = void 0),
            (this._subscribers = []),
            d !== e && ('function' != typeof e && L(), this instanceof q ? C(this, e) : H());
        }
        function U() {
          var e = void 0;
          if (void 0 !== i) e = i;
          else if ('undefined' != typeof self) e = self;
          else
            try {
              e = Function('return this')();
            } catch (e) {
              throw new Error('polyfill failed because global object is unavailable in this environment');
            }
          var t = e.Promise;
          if (t) {
            var n = null;
            try {
              n = Object.prototype.toString.call(t.resolve());
            } catch (e) {}
            if ('[object Promise]' === n && !t.cast) return;
          }
          e.Promise = q;
        }
        var B = void 0;
        B = Array.isArray
          ? Array.isArray
          : function (e) {
              return '[object Array]' === Object.prototype.toString.call(e);
            };
        var $ = B,
          Q = 0,
          V = void 0,
          W = void 0,
          K = function (e, t) {
            (Z[Q] = e), (Z[Q + 1] = t), 2 === (Q += 2) && (W ? W(l) : ee());
          },
          G = 'undefined' != typeof window ? window : void 0,
          J = G || {},
          z = J.MutationObserver || J.WebKitMutationObserver,
          X = 'undefined' == typeof self && void 0 !== r && '[object process]' === {}.toString.call(r),
          Y =
            'undefined' != typeof Uint8ClampedArray &&
            'undefined' != typeof importScripts &&
            'undefined' != typeof MessageChannel,
          Z = new Array(1e3),
          ee = void 0;
        ee = X
          ? (function () {
              return function () {
                return r.nextTick(l);
              };
            })()
          : z
          ? (function () {
              var e = 0,
                t = new z(l),
                n = document.createTextNode('');
              return (
                t.observe(n, { characterData: !0 }),
                function () {
                  n.data = e = ++e % 2;
                }
              );
            })()
          : Y
          ? (function () {
              var e = new MessageChannel();
              return (
                (e.port1.onmessage = l),
                function () {
                  return e.port2.postMessage(0);
                }
              );
            })()
          : void 0 === G
          ? (function () {
              try {
                var e = n(133);
                return (V = e.runOnLoop || e.runOnContext), s();
              } catch (e) {
                return u();
              }
            })()
          : u();
        var te = Math.random().toString(36).substring(16),
          ne = void 0,
          re = 1,
          ie = 2,
          oe = new R(),
          ae = new R(),
          se = 0;
        return (
          (F.prototype._enumerate = function (e) {
            for (var t = 0; this._state === ne && t < e.length; t++) this._eachEntry(e[t], t);
          }),
          (F.prototype._eachEntry = function (e, t) {
            var n = this._instanceConstructor,
              r = n.resolve;
            if (r === h) {
              var i = g(e);
              if (i === f && e._state !== ne) this._settledAt(e._state, t, e._result);
              else if ('function' != typeof i) this._remaining--, (this._result[t] = e);
              else if (n === q) {
                var o = new n(d);
                w(o, e, i), this._willSettleAt(o, t);
              } else
                this._willSettleAt(
                  new n(function (t) {
                    return t(e);
                  }),
                  t
                );
            } else this._willSettleAt(r(e), t);
          }),
          (F.prototype._settledAt = function (e, t, n) {
            var r = this.promise;
            r._state === ne && (this._remaining--, e === ie ? j(r, n) : (this._result[t] = n)),
              0 === this._remaining && P(r, this._result);
          }),
          (F.prototype._willSettleAt = function (e, t) {
            var n = this;
            S(
              e,
              void 0,
              function (e) {
                return n._settledAt(re, t, e);
              },
              function (e) {
                return n._settledAt(ie, t, e);
              }
            );
          }),
          (q.all = I),
          (q.race = D),
          (q.resolve = h),
          (q.reject = M),
          (q._setScheduler = o),
          (q._setAsap = a),
          (q._asap = K),
          (q.prototype = {
            constructor: q,
            then: f,
            catch: function (e) {
              return this.then(null, e);
            },
          }),
          (q.polyfill = U),
          (q.Promise = q),
          q
        );
      });
    }).call(t, n(26), n(11));
  },
  function (e, t) {},
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return /\?/.test(e) ? (e += '&') : (e += '?'), e + i(t);
    }
    e.exports = r;
    var i = n(53);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      function r() {
        t.debug('JSONP: success'),
          g ||
            h ||
            ((g = !0),
            f ||
              (t.debug('JSONP: Fail. Script loaded but did not call the callback'), s(), n(new i.JSONPScriptFail())));
      }
      function a() {
        ('loaded' !== this.readyState && 'complete' !== this.readyState) || r();
      }
      function s() {
        clearTimeout(v), (p.onload = null), (p.onreadystatechange = null), (p.onerror = null), d.removeChild(p);
      }
      function c() {
        try {
          delete window[m], delete window[m + '_loaded'];
        } catch (e) {
          window[m] = window[m + '_loaded'] = void 0;
        }
      }
      function u() {
        t.debug('JSONP: Script timeout'), (h = !0), s(), n(new i.RequestTimeout());
      }
      function l() {
        t.debug('JSONP: Script error'), g || h || (s(), n(new i.JSONPScriptError()));
      }
      if ('GET' !== t.method) return void n(new Error('Method ' + t.method + ' ' + e + ' is not supported by JSONP.'));
      t.debug('JSONP: start');
      var f = !1,
        h = !1;
      o += 1;
      var d = document.getElementsByTagName('head')[0],
        p = document.createElement('script'),
        m = 'algoliaJSONP_' + o,
        g = !1;
      (window[m] = function (e) {
        if ((c(), h)) return void t.debug('JSONP: Late answer, ignoring');
        (f = !0), s(), n(null, { body: e, responseText: JSON.stringify(e) });
      }),
        (e += '&callback=' + m),
        t.jsonBody && t.jsonBody.params && (e += '&' + t.jsonBody.params);
      var v = setTimeout(u, t.timeouts.complete);
      (p.onreadystatechange = a),
        (p.onload = r),
        (p.onerror = l),
        (p.async = !0),
        (p.defer = !0),
        (p.src = e),
        d.appendChild(p);
    }
    e.exports = r;
    var i = n(15),
      o = 0;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return function (t, r, i) {
        var c = n(10);
        (i = (i && c(i)) || {}),
          (i.hosts = i.hosts || [
            'places-dsn.algolia.net',
            'places-1.algolianet.com',
            'places-2.algolianet.com',
            'places-3.algolianet.com',
          ]),
          (0 !== arguments.length && 'object' !== (0, o.default)(t) && void 0 !== t) ||
            ((t = ''), (r = ''), (i._allowEmptyCredentials = !0));
        var u = e(t, r, i),
          l = u.initIndex('places');
        return (
          (l.search = s('query', '/1/places/query')),
          (l.reverse = function (e, t) {
            var n = a.encode(e);
            return this.as._jsonRequest({
              method: 'GET',
              url: '/1/places/reverse?' + n,
              hostType: 'read',
              callback: t,
            });
          }),
          (l.getObject = function (e, t) {
            return this.as._jsonRequest({
              method: 'GET',
              url: '/1/places/' + encodeURIComponent(e),
              hostType: 'read',
              callback: t,
            });
          }),
          l
        );
      };
    }
    var i = n(0),
      o = i(n(2));
    e.exports = r;
    var a = n(137),
      s = n(51);
  },
  function (e, t, n) {
    'use strict';
    (t.decode = t.parse = n(138)), (t.encode = t.stringify = n(53));
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    e.exports = function (e, t, n, o) {
      (t = t || '&'), (n = n || '=');
      var a = {};
      if ('string' != typeof e || 0 === e.length) return a;
      var s = /\+/g;
      e = e.split(t);
      var c = 1e3;
      o && 'number' == typeof o.maxKeys && (c = o.maxKeys);
      var u = e.length;
      c > 0 && u > c && (u = c);
      for (var l = 0; l < u; ++l) {
        var f,
          h,
          d,
          p,
          m = e[l].replace(s, '%20'),
          g = m.indexOf(n);
        g >= 0 ? ((f = m.substr(0, g)), (h = m.substr(g + 1))) : ((f = m), (h = '')),
          (d = decodeURIComponent(f)),
          (p = decodeURIComponent(h)),
          r(a, d) ? (i(a[d]) ? a[d].push(p) : (a[d] = [a[d], p])) : (a[d] = p);
      }
      return a;
    };
    var i =
      Array.isArray ||
      function (e) {
        return '[object Array]' === Object.prototype.toString.call(e);
      };
  },
  function (e, t, n) {
    'use strict';
    e.exports = '3.35.1';
  },
  function (e, t, n) {
    'use strict';
    e.exports = n(141);
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n, r) {
      n = o.isArray(n) ? n : [].slice.call(arguments, 2);
      var u = i(e).each(function (e, o) {
        var u = i(o),
          l = new c({ el: u }),
          f =
            r ||
            new s({
              input: u,
              eventBus: l,
              dropdownMenuContainer: t.dropdownMenuContainer,
              hint: void 0 === t.hint || !!t.hint,
              minLength: t.minLength,
              autoselect: t.autoselect,
              autoselectOnBlur: t.autoselectOnBlur,
              tabAutocomplete: t.tabAutocomplete,
              openOnFocus: t.openOnFocus,
              templates: t.templates,
              debug: t.debug,
              clearOnSelected: t.clearOnSelected,
              cssClasses: t.cssClasses,
              datasets: n,
              keyboardShortcuts: t.keyboardShortcuts,
              appendTo: t.appendTo,
              autoWidth: t.autoWidth,
              ariaLabel: t.ariaLabel || o.getAttribute('aria-label'),
            });
        u.data(a, f);
      });
      return (
        (u.autocomplete = {}),
        o.each(['open', 'close', 'getVal', 'setVal', 'destroy', 'getWrapper'], function (e) {
          u.autocomplete[e] = function () {
            var t,
              n = arguments;
            return (
              u.each(function (r, o) {
                var s = i(o).data(a);
                t = s[e].apply(s, n);
              }),
              t
            );
          };
        }),
        u
      );
    }
    var i = n(142);
    n(7).element = i;
    var o = n(6);
    (o.isArray = i.isArray),
      (o.isFunction = i.isFunction),
      (o.isObject = i.isPlainObject),
      (o.bind = i.proxy),
      (o.each = function (e, t) {
        function n(e, n) {
          return t(n, e);
        }
        i.each(e, n);
      }),
      (o.map = i.map),
      (o.mixin = i.extend),
      (o.Event = i.Event);
    var a = 'aaAutocomplete',
      s = n(143),
      c = n(54);
    (r.sources = s.sources), (r.escapeHighlightedString = o.escapeHighlightedString);
    var u = 'autocomplete' in window,
      l = window.autocomplete;
    (r.noConflict = function () {
      return u ? (window.autocomplete = l) : delete window.autocomplete, r;
    }),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = r(n(2));
    !(function (t, n) {
      e.exports = (function (e) {
        var t = (function () {
          function t(e) {
            return null == e ? String(e) : z[X.call(e)] || 'object';
          }
          function n(e) {
            return 'function' == t(e);
          }
          function r(e) {
            return null != e && e == e.window;
          }
          function o(e) {
            return null != e && e.nodeType == e.DOCUMENT_NODE;
          }
          function a(e) {
            return 'object' == t(e);
          }
          function s(e) {
            return a(e) && !r(e) && Object.getPrototypeOf(e) == Object.prototype;
          }
          function c(e) {
            var t = !!e && 'length' in e && e.length,
              n = x.type(e);
            return (
              'function' != n && !r(e) && ('array' == n || 0 === t || ('number' == typeof t && t > 0 && t - 1 in e))
            );
          }
          function u(e) {
            return k.call(e, function (e) {
              return null != e;
            });
          }
          function l(e) {
            return e.length > 0 ? x.fn.concat.apply([], e) : e;
          }
          function f(e) {
            return e
              .replace(/::/g, '/')
              .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
              .replace(/([a-z\d])([A-Z])/g, '$1_$2')
              .replace(/_/g, '-')
              .toLowerCase();
          }
          function h(e) {
            return e in D ? D[e] : (D[e] = new RegExp('(^|\\s)' + e + '(\\s|$)'));
          }
          function d(e, t) {
            return 'number' != typeof t || M[f(e)] ? t : t + 'px';
          }
          function p(e) {
            var t, n;
            return (
              I[e] ||
                ((t = A.createElement(e)),
                A.body.appendChild(t),
                (n = getComputedStyle(t, '').getPropertyValue('display')),
                t.parentNode.removeChild(t),
                'none' == n && (n = 'block'),
                (I[e] = n)),
              I[e]
            );
          }
          function m(e) {
            return 'children' in e
              ? F.call(e.children)
              : x.map(e.childNodes, function (e) {
                  if (1 == e.nodeType) return e;
                });
          }
          function g(e, t) {
            var n,
              r = e ? e.length : 0;
            for (n = 0; n < r; n++) this[n] = e[n];
            (this.length = r), (this.selector = t || '');
          }
          function v(e, t, n) {
            for (S in t)
              n && (s(t[S]) || te(t[S]))
                ? (s(t[S]) && !s(e[S]) && (e[S] = {}), te(t[S]) && !te(e[S]) && (e[S] = []), v(e[S], t[S], n))
                : t[S] !== j && (e[S] = t[S]);
          }
          function y(e, t) {
            return null == t ? x(e) : x(e).filter(t);
          }
          function b(e, t, r, i) {
            return n(t) ? t.call(e, r, i) : t;
          }
          function w(e, t, n) {
            null == n ? e.removeAttribute(t) : e.setAttribute(t, n);
          }
          function _(e, t) {
            var n = e.className || '',
              r = n && n.baseVal !== j;
            if (t === j) return r ? n.baseVal : n;
            r ? (n.baseVal = t) : (e.className = t);
          }
          function O(e) {
            try {
              return e
                ? 'true' == e ||
                    ('false' != e && ('null' == e ? null : +e + '' == e ? +e : /^[\[\{]/.test(e) ? x.parseJSON(e) : e))
                : e;
            } catch (t) {
              return e;
            }
          }
          function P(e, t) {
            t(e);
            for (var n = 0, r = e.childNodes.length; n < r; n++) P(e.childNodes[n], t);
          }
          var j,
            S,
            x,
            R,
            E,
            T,
            C = [],
            N = C.concat,
            k = C.filter,
            F = C.slice,
            A = e.document,
            I = {},
            D = {},
            M = {
              'column-count': 1,
              columns: 1,
              'font-weight': 1,
              'line-height': 1,
              opacity: 1,
              'z-index': 1,
              zoom: 1,
            },
            L = /^\s*<(\w+|!)[^>]*>/,
            H = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
            q = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
            U = /^(?:body|html)$/i,
            B = /([A-Z])/g,
            $ = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
            Q = ['after', 'prepend', 'before', 'append'],
            V = A.createElement('table'),
            W = A.createElement('tr'),
            K = {
              tr: A.createElement('tbody'),
              tbody: V,
              thead: V,
              tfoot: V,
              td: W,
              th: W,
              '*': A.createElement('div'),
            },
            G = /complete|loaded|interactive/,
            J = /^[\w-]*$/,
            z = {},
            X = z.toString,
            Y = {},
            Z = A.createElement('div'),
            ee = {
              tabindex: 'tabIndex',
              readonly: 'readOnly',
              for: 'htmlFor',
              class: 'className',
              maxlength: 'maxLength',
              cellspacing: 'cellSpacing',
              cellpadding: 'cellPadding',
              rowspan: 'rowSpan',
              colspan: 'colSpan',
              usemap: 'useMap',
              frameborder: 'frameBorder',
              contenteditable: 'contentEditable',
            },
            te =
              Array.isArray ||
              function (e) {
                return e instanceof Array;
              };
          return (
            (Y.matches = function (e, t) {
              if (!t || !e || 1 !== e.nodeType) return !1;
              var n =
                e.matches || e.webkitMatchesSelector || e.mozMatchesSelector || e.oMatchesSelector || e.matchesSelector;
              if (n) return n.call(e, t);
              var r,
                i = e.parentNode,
                o = !i;
              return o && (i = Z).appendChild(e), (r = ~Y.qsa(i, t).indexOf(e)), o && Z.removeChild(e), r;
            }),
            (E = function (e) {
              return e.replace(/-+(.)?/g, function (e, t) {
                return t ? t.toUpperCase() : '';
              });
            }),
            (T = function (e) {
              return k.call(e, function (t, n) {
                return e.indexOf(t) == n;
              });
            }),
            (Y.fragment = function (e, t, n) {
              var r, i, o;
              return (
                H.test(e) && (r = x(A.createElement(RegExp.$1))),
                r ||
                  (e.replace && (e = e.replace(q, '<$1></$2>')),
                  t === j && (t = L.test(e) && RegExp.$1),
                  t in K || (t = '*'),
                  (o = K[t]),
                  (o.innerHTML = '' + e),
                  (r = x.each(F.call(o.childNodes), function () {
                    o.removeChild(this);
                  }))),
                s(n) &&
                  ((i = x(r)),
                  x.each(n, function (e, t) {
                    $.indexOf(e) > -1 ? i[e](t) : i.attr(e, t);
                  })),
                r
              );
            }),
            (Y.Z = function (e, t) {
              return new g(e, t);
            }),
            (Y.isZ = function (e) {
              return e instanceof Y.Z;
            }),
            (Y.init = function (e, t) {
              var r;
              if (!e) return Y.Z();
              if ('string' == typeof e)
                if (((e = e.trim()), '<' == e[0] && L.test(e))) (r = Y.fragment(e, RegExp.$1, t)), (e = null);
                else {
                  if (t !== j) return x(t).find(e);
                  r = Y.qsa(A, e);
                }
              else {
                if (n(e)) return x(A).ready(e);
                if (Y.isZ(e)) return e;
                if (te(e)) r = u(e);
                else if (a(e)) (r = [e]), (e = null);
                else if (L.test(e)) (r = Y.fragment(e.trim(), RegExp.$1, t)), (e = null);
                else {
                  if (t !== j) return x(t).find(e);
                  r = Y.qsa(A, e);
                }
              }
              return Y.Z(r, e);
            }),
            (x = function (e, t) {
              return Y.init(e, t);
            }),
            (x.extend = function (e) {
              var t,
                n = F.call(arguments, 1);
              return (
                'boolean' == typeof e && ((t = e), (e = n.shift())),
                n.forEach(function (n) {
                  v(e, n, t);
                }),
                e
              );
            }),
            (Y.qsa = function (e, t) {
              var n,
                r = '#' == t[0],
                i = !r && '.' == t[0],
                o = r || i ? t.slice(1) : t,
                a = J.test(o);
              return e.getElementById && a && r
                ? (n = e.getElementById(o))
                  ? [n]
                  : []
                : 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType
                ? []
                : F.call(
                    a && !r && e.getElementsByClassName
                      ? i
                        ? e.getElementsByClassName(o)
                        : e.getElementsByTagName(t)
                      : e.querySelectorAll(t)
                  );
            }),
            (x.contains = A.documentElement.contains
              ? function (e, t) {
                  return e !== t && e.contains(t);
                }
              : function (e, t) {
                  for (; t && (t = t.parentNode); ) if (t === e) return !0;
                  return !1;
                }),
            (x.type = t),
            (x.isFunction = n),
            (x.isWindow = r),
            (x.isArray = te),
            (x.isPlainObject = s),
            (x.isEmptyObject = function (e) {
              var t;
              for (t in e) return !1;
              return !0;
            }),
            (x.isNumeric = function (e) {
              var t = Number(e),
                n = (0, i.default)(e);
              return (null != e && 'boolean' != n && ('string' != n || e.length) && !isNaN(t) && isFinite(t)) || !1;
            }),
            (x.inArray = function (e, t, n) {
              return C.indexOf.call(t, e, n);
            }),
            (x.camelCase = E),
            (x.trim = function (e) {
              return null == e ? '' : String.prototype.trim.call(e);
            }),
            (x.uuid = 0),
            (x.support = {}),
            (x.expr = {}),
            (x.noop = function () {}),
            (x.map = function (e, t) {
              var n,
                r,
                i,
                o = [];
              if (c(e)) for (r = 0; r < e.length; r++) null != (n = t(e[r], r)) && o.push(n);
              else for (i in e) null != (n = t(e[i], i)) && o.push(n);
              return l(o);
            }),
            (x.each = function (e, t) {
              var n, r;
              if (c(e)) {
                for (n = 0; n < e.length; n++) if (!1 === t.call(e[n], n, e[n])) return e;
              } else for (r in e) if (!1 === t.call(e[r], r, e[r])) return e;
              return e;
            }),
            (x.grep = function (e, t) {
              return k.call(e, t);
            }),
            e.JSON && (x.parseJSON = JSON.parse),
            x.each('Boolean Number String Function Array Date RegExp Object Error'.split(' '), function (e, t) {
              z['[object ' + t + ']'] = t.toLowerCase();
            }),
            (x.fn = {
              constructor: Y.Z,
              length: 0,
              forEach: C.forEach,
              reduce: C.reduce,
              push: C.push,
              sort: C.sort,
              splice: C.splice,
              indexOf: C.indexOf,
              concat: function () {
                var e,
                  t,
                  n = [];
                for (e = 0; e < arguments.length; e++) (t = arguments[e]), (n[e] = Y.isZ(t) ? t.toArray() : t);
                return N.apply(Y.isZ(this) ? this.toArray() : this, n);
              },
              map: function (e) {
                return x(
                  x.map(this, function (t, n) {
                    return e.call(t, n, t);
                  })
                );
              },
              slice: function () {
                return x(F.apply(this, arguments));
              },
              ready: function (e) {
                return (
                  G.test(A.readyState) && A.body
                    ? e(x)
                    : A.addEventListener(
                        'DOMContentLoaded',
                        function () {
                          e(x);
                        },
                        !1
                      ),
                  this
                );
              },
              get: function (e) {
                return e === j ? F.call(this) : this[e >= 0 ? e : e + this.length];
              },
              toArray: function () {
                return this.get();
              },
              size: function () {
                return this.length;
              },
              remove: function () {
                return this.each(function () {
                  null != this.parentNode && this.parentNode.removeChild(this);
                });
              },
              each: function (e) {
                return (
                  C.every.call(this, function (t, n) {
                    return !1 !== e.call(t, n, t);
                  }),
                  this
                );
              },
              filter: function (e) {
                return n(e)
                  ? this.not(this.not(e))
                  : x(
                      k.call(this, function (t) {
                        return Y.matches(t, e);
                      })
                    );
              },
              add: function (e, t) {
                return x(T(this.concat(x(e, t))));
              },
              is: function (e) {
                return this.length > 0 && Y.matches(this[0], e);
              },
              not: function (e) {
                var t = [];
                if (n(e) && e.call !== j)
                  this.each(function (n) {
                    e.call(this, n) || t.push(this);
                  });
                else {
                  var r = 'string' == typeof e ? this.filter(e) : c(e) && n(e.item) ? F.call(e) : x(e);
                  this.forEach(function (e) {
                    r.indexOf(e) < 0 && t.push(e);
                  });
                }
                return x(t);
              },
              has: function (e) {
                return this.filter(function () {
                  return a(e) ? x.contains(this, e) : x(this).find(e).size();
                });
              },
              eq: function (e) {
                return -1 === e ? this.slice(e) : this.slice(e, +e + 1);
              },
              first: function () {
                var e = this[0];
                return e && !a(e) ? e : x(e);
              },
              last: function () {
                var e = this[this.length - 1];
                return e && !a(e) ? e : x(e);
              },
              find: function (e) {
                var t = this;
                return e
                  ? 'object' == (0, i.default)(e)
                    ? x(e).filter(function () {
                        var e = this;
                        return C.some.call(t, function (t) {
                          return x.contains(t, e);
                        });
                      })
                    : 1 == this.length
                    ? x(Y.qsa(this[0], e))
                    : this.map(function () {
                        return Y.qsa(this, e);
                      })
                  : x();
              },
              closest: function (e, t) {
                var n = [],
                  r = 'object' == (0, i.default)(e) && x(e);
                return (
                  this.each(function (i, a) {
                    for (; a && !(r ? r.indexOf(a) >= 0 : Y.matches(a, e)); ) a = a !== t && !o(a) && a.parentNode;
                    a && n.indexOf(a) < 0 && n.push(a);
                  }),
                  x(n)
                );
              },
              parents: function (e) {
                for (var t = [], n = this; n.length > 0; )
                  n = x.map(n, function (e) {
                    if ((e = e.parentNode) && !o(e) && t.indexOf(e) < 0) return t.push(e), e;
                  });
                return y(t, e);
              },
              parent: function (e) {
                return y(T(this.pluck('parentNode')), e);
              },
              children: function (e) {
                return y(
                  this.map(function () {
                    return m(this);
                  }),
                  e
                );
              },
              contents: function () {
                return this.map(function () {
                  return this.contentDocument || F.call(this.childNodes);
                });
              },
              siblings: function (e) {
                return y(
                  this.map(function (e, t) {
                    return k.call(m(t.parentNode), function (e) {
                      return e !== t;
                    });
                  }),
                  e
                );
              },
              empty: function () {
                return this.each(function () {
                  this.innerHTML = '';
                });
              },
              pluck: function (e) {
                return x.map(this, function (t) {
                  return t[e];
                });
              },
              show: function () {
                return this.each(function () {
                  'none' == this.style.display && (this.style.display = ''),
                    'none' == getComputedStyle(this, '').getPropertyValue('display') &&
                      (this.style.display = p(this.nodeName));
                });
              },
              replaceWith: function (e) {
                return this.before(e).remove();
              },
              wrap: function (e) {
                var t = n(e);
                if (this[0] && !t)
                  var r = x(e).get(0),
                    i = r.parentNode || this.length > 1;
                return this.each(function (n) {
                  x(this).wrapAll(t ? e.call(this, n) : i ? r.cloneNode(!0) : r);
                });
              },
              wrapAll: function (e) {
                if (this[0]) {
                  x(this[0]).before((e = x(e)));
                  for (var t; (t = e.children()).length; ) e = t.first();
                  x(e).append(this);
                }
                return this;
              },
              wrapInner: function (e) {
                var t = n(e);
                return this.each(function (n) {
                  var r = x(this),
                    i = r.contents(),
                    o = t ? e.call(this, n) : e;
                  i.length ? i.wrapAll(o) : r.append(o);
                });
              },
              unwrap: function () {
                return (
                  this.parent().each(function () {
                    x(this).replaceWith(x(this).children());
                  }),
                  this
                );
              },
              clone: function () {
                return this.map(function () {
                  return this.cloneNode(!0);
                });
              },
              hide: function () {
                return this.css('display', 'none');
              },
              toggle: function (e) {
                return this.each(function () {
                  var t = x(this);
                  (e === j ? 'none' == t.css('display') : e) ? t.show() : t.hide();
                });
              },
              prev: function (e) {
                return x(this.pluck('previousElementSibling')).filter(e || '*');
              },
              next: function (e) {
                return x(this.pluck('nextElementSibling')).filter(e || '*');
              },
              html: function (e) {
                return 0 in arguments
                  ? this.each(function (t) {
                      var n = this.innerHTML;
                      x(this).empty().append(b(this, e, t, n));
                    })
                  : 0 in this
                  ? this[0].innerHTML
                  : null;
              },
              text: function (e) {
                return 0 in arguments
                  ? this.each(function (t) {
                      var n = b(this, e, t, this.textContent);
                      this.textContent = null == n ? '' : '' + n;
                    })
                  : 0 in this
                  ? this.pluck('textContent').join('')
                  : null;
              },
              attr: function (e, t) {
                var n;
                return 'string' != typeof e || 1 in arguments
                  ? this.each(function (n) {
                      if (1 === this.nodeType)
                        if (a(e)) for (S in e) w(this, S, e[S]);
                        else w(this, e, b(this, t, n, this.getAttribute(e)));
                    })
                  : 0 in this && 1 == this[0].nodeType && null != (n = this[0].getAttribute(e))
                  ? n
                  : j;
              },
              removeAttr: function (e) {
                return this.each(function () {
                  1 === this.nodeType &&
                    e.split(' ').forEach(function (e) {
                      w(this, e);
                    }, this);
                });
              },
              prop: function (e, t) {
                return (
                  (e = ee[e] || e),
                  1 in arguments
                    ? this.each(function (n) {
                        this[e] = b(this, t, n, this[e]);
                      })
                    : this[0] && this[0][e]
                );
              },
              removeProp: function (e) {
                return (
                  (e = ee[e] || e),
                  this.each(function () {
                    delete this[e];
                  })
                );
              },
              data: function (e, t) {
                var n = 'data-' + e.replace(B, '-$1').toLowerCase(),
                  r = 1 in arguments ? this.attr(n, t) : this.attr(n);
                return null !== r ? O(r) : j;
              },
              val: function (e) {
                return 0 in arguments
                  ? (null == e && (e = ''),
                    this.each(function (t) {
                      this.value = b(this, e, t, this.value);
                    }))
                  : this[0] &&
                      (this[0].multiple
                        ? x(this[0])
                            .find('option')
                            .filter(function () {
                              return this.selected;
                            })
                            .pluck('value')
                        : this[0].value);
              },
              offset: function (t) {
                if (t)
                  return this.each(function (e) {
                    var n = x(this),
                      r = b(this, t, e, n.offset()),
                      i = n.offsetParent().offset(),
                      o = { top: r.top - i.top, left: r.left - i.left };
                    'static' == n.css('position') && (o.position = 'relative'), n.css(o);
                  });
                if (!this.length) return null;
                if (A.documentElement !== this[0] && !x.contains(A.documentElement, this[0]))
                  return { top: 0, left: 0 };
                var n = this[0].getBoundingClientRect();
                return {
                  left: n.left + e.pageXOffset,
                  top: n.top + e.pageYOffset,
                  width: Math.round(n.width),
                  height: Math.round(n.height),
                };
              },
              css: function (e, n) {
                if (arguments.length < 2) {
                  var r = this[0];
                  if ('string' == typeof e) {
                    if (!r) return;
                    return r.style[E(e)] || getComputedStyle(r, '').getPropertyValue(e);
                  }
                  if (te(e)) {
                    if (!r) return;
                    var i = {},
                      o = getComputedStyle(r, '');
                    return (
                      x.each(e, function (e, t) {
                        i[t] = r.style[E(t)] || o.getPropertyValue(t);
                      }),
                      i
                    );
                  }
                }
                var a = '';
                if ('string' == t(e))
                  n || 0 === n
                    ? (a = f(e) + ':' + d(e, n))
                    : this.each(function () {
                        this.style.removeProperty(f(e));
                      });
                else
                  for (S in e)
                    e[S] || 0 === e[S]
                      ? (a += f(S) + ':' + d(S, e[S]) + ';')
                      : this.each(function () {
                          this.style.removeProperty(f(S));
                        });
                return this.each(function () {
                  this.style.cssText += ';' + a;
                });
              },
              index: function (e) {
                return e ? this.indexOf(x(e)[0]) : this.parent().children().indexOf(this[0]);
              },
              hasClass: function (e) {
                return (
                  !!e &&
                  C.some.call(
                    this,
                    function (e) {
                      return this.test(_(e));
                    },
                    h(e)
                  )
                );
              },
              addClass: function (e) {
                return e
                  ? this.each(function (t) {
                      if ('className' in this) {
                        R = [];
                        var n = _(this);
                        b(this, e, t, n)
                          .split(/\s+/g)
                          .forEach(function (e) {
                            x(this).hasClass(e) || R.push(e);
                          }, this),
                          R.length && _(this, n + (n ? ' ' : '') + R.join(' '));
                      }
                    })
                  : this;
              },
              removeClass: function (e) {
                return this.each(function (t) {
                  if ('className' in this) {
                    if (e === j) return _(this, '');
                    (R = _(this)),
                      b(this, e, t, R)
                        .split(/\s+/g)
                        .forEach(function (e) {
                          R = R.replace(h(e), ' ');
                        }),
                      _(this, R.trim());
                  }
                });
              },
              toggleClass: function (e, t) {
                return e
                  ? this.each(function (n) {
                      var r = x(this);
                      b(this, e, n, _(this))
                        .split(/\s+/g)
                        .forEach(function (e) {
                          (t === j ? !r.hasClass(e) : t) ? r.addClass(e) : r.removeClass(e);
                        });
                    })
                  : this;
              },
              scrollTop: function (e) {
                if (this.length) {
                  var t = 'scrollTop' in this[0];
                  return e === j
                    ? t
                      ? this[0].scrollTop
                      : this[0].pageYOffset
                    : this.each(
                        t
                          ? function () {
                              this.scrollTop = e;
                            }
                          : function () {
                              this.scrollTo(this.scrollX, e);
                            }
                      );
                }
              },
              scrollLeft: function (e) {
                if (this.length) {
                  var t = 'scrollLeft' in this[0];
                  return e === j
                    ? t
                      ? this[0].scrollLeft
                      : this[0].pageXOffset
                    : this.each(
                        t
                          ? function () {
                              this.scrollLeft = e;
                            }
                          : function () {
                              this.scrollTo(e, this.scrollY);
                            }
                      );
                }
              },
              position: function () {
                if (this.length) {
                  var e = this[0],
                    t = this.offsetParent(),
                    n = this.offset(),
                    r = U.test(t[0].nodeName) ? { top: 0, left: 0 } : t.offset();
                  return (
                    (n.top -= parseFloat(x(e).css('margin-top')) || 0),
                    (n.left -= parseFloat(x(e).css('margin-left')) || 0),
                    (r.top += parseFloat(x(t[0]).css('border-top-width')) || 0),
                    (r.left += parseFloat(x(t[0]).css('border-left-width')) || 0),
                    { top: n.top - r.top, left: n.left - r.left }
                  );
                }
              },
              offsetParent: function () {
                return this.map(function () {
                  for (
                    var e = this.offsetParent || A.body;
                    e && !U.test(e.nodeName) && 'static' == x(e).css('position');

                  )
                    e = e.offsetParent;
                  return e;
                });
              },
            }),
            (x.fn.detach = x.fn.remove),
            ['width', 'height'].forEach(function (e) {
              var t = e.replace(/./, function (e) {
                return e[0].toUpperCase();
              });
              x.fn[e] = function (n) {
                var i,
                  a = this[0];
                return n === j
                  ? r(a)
                    ? a['inner' + t]
                    : o(a)
                    ? a.documentElement['scroll' + t]
                    : (i = this.offset()) && i[e]
                  : this.each(function (t) {
                      (a = x(this)), a.css(e, b(this, n, t, a[e]()));
                    });
              };
            }),
            Q.forEach(function (n, r) {
              var i = r % 2;
              (x.fn[n] = function () {
                var n,
                  o,
                  a = x.map(arguments, function (e) {
                    var r = [];
                    return (
                      (n = t(e)),
                      'array' == n
                        ? (e.forEach(function (e) {
                            return e.nodeType !== j
                              ? r.push(e)
                              : x.zepto.isZ(e)
                              ? (r = r.concat(e.get()))
                              : void (r = r.concat(Y.fragment(e)));
                          }),
                          r)
                        : 'object' == n || null == e
                        ? e
                        : Y.fragment(e)
                    );
                  }),
                  s = this.length > 1;
                return a.length < 1
                  ? this
                  : this.each(function (t, n) {
                      (o = i ? n : n.parentNode),
                        (n = 0 == r ? n.nextSibling : 1 == r ? n.firstChild : 2 == r ? n : null);
                      var c = x.contains(A.documentElement, o);
                      a.forEach(function (t) {
                        if (s) t = t.cloneNode(!0);
                        else if (!o) return x(t).remove();
                        o.insertBefore(t, n),
                          c &&
                            P(t, function (t) {
                              if (
                                !(
                                  null == t.nodeName ||
                                  'SCRIPT' !== t.nodeName.toUpperCase() ||
                                  (t.type && 'text/javascript' !== t.type) ||
                                  t.src
                                )
                              ) {
                                var n = t.ownerDocument ? t.ownerDocument.defaultView : e;
                                n.eval.call(n, t.innerHTML);
                              }
                            });
                      });
                    });
              }),
                (x.fn[i ? n + 'To' : 'insert' + (r ? 'Before' : 'After')] = function (e) {
                  return x(e)[n](this), this;
                });
            }),
            (Y.Z.prototype = g.prototype = x.fn),
            (Y.uniq = T),
            (Y.deserializeValue = O),
            (x.zepto = Y),
            x
          );
        })();
        return (
          (function (t) {
            function n(e) {
              return e._zid || (e._zid = d++);
            }
            function r(e, t, r, a) {
              if (((t = i(t)), t.ns)) var s = o(t.ns);
              return (v[n(e)] || []).filter(function (e) {
                return (
                  e && (!t.e || e.e == t.e) && (!t.ns || s.test(e.ns)) && (!r || n(e.fn) === n(r)) && (!a || e.sel == a)
                );
              });
            }
            function i(e) {
              var t = ('' + e).split('.');
              return { e: t[0], ns: t.slice(1).sort().join(' ') };
            }
            function o(e) {
              return new RegExp('(?:^| )' + e.replace(' ', ' .* ?') + '(?: |$)');
            }
            function a(e, t) {
              return (e.del && !b && e.e in w) || !!t;
            }
            function s(e) {
              return _[e] || (b && w[e]) || e;
            }
            function c(e, r, o, c, u, f, d) {
              var p = n(e),
                m = v[p] || (v[p] = []);
              r.split(/\s/).forEach(function (n) {
                if ('ready' == n) return t(document).ready(o);
                var r = i(n);
                (r.fn = o),
                  (r.sel = u),
                  r.e in _ &&
                    (o = function (e) {
                      var n = e.relatedTarget;
                      if (!n || (n !== this && !t.contains(this, n))) return r.fn.apply(this, arguments);
                    }),
                  (r.del = f);
                var p = f || o;
                (r.proxy = function (t) {
                  if (((t = l(t)), !t.isImmediatePropagationStopped())) {
                    try {
                      var n = Object.getOwnPropertyDescriptor(t, 'data');
                      (n && !n.writable) || (t.data = c);
                    } catch (t) {}
                    var r = p.apply(e, t._args == h ? [t] : [t].concat(t._args));
                    return !1 === r && (t.preventDefault(), t.stopPropagation()), r;
                  }
                }),
                  (r.i = m.length),
                  m.push(r),
                  'addEventListener' in e && e.addEventListener(s(r.e), r.proxy, a(r, d));
              });
            }
            function u(e, t, i, o, c) {
              var u = n(e);
              (t || '').split(/\s/).forEach(function (t) {
                r(e, t, i, o).forEach(function (t) {
                  delete v[u][t.i], 'removeEventListener' in e && e.removeEventListener(s(t.e), t.proxy, a(t, c));
                });
              });
            }
            function l(e, n) {
              return (
                (!n && e.isDefaultPrevented) ||
                  (n || (n = e),
                  t.each(S, function (t, r) {
                    var i = n[t];
                    (e[t] = function () {
                      return (this[r] = O), i && i.apply(n, arguments);
                    }),
                      (e[r] = P);
                  }),
                  e.timeStamp || (e.timeStamp = Date.now()),
                  (n.defaultPrevented !== h
                    ? n.defaultPrevented
                    : 'returnValue' in n
                    ? !1 === n.returnValue
                    : n.getPreventDefault && n.getPreventDefault()) && (e.isDefaultPrevented = O)),
                e
              );
            }
            function f(e) {
              var t,
                n = { originalEvent: e };
              for (t in e) j.test(t) || e[t] === h || (n[t] = e[t]);
              return l(n, e);
            }
            var h,
              d = 1,
              p = Array.prototype.slice,
              m = t.isFunction,
              g = function (e) {
                return 'string' == typeof e;
              },
              v = {},
              y = {},
              b = 'onfocusin' in e,
              w = { focus: 'focusin', blur: 'focusout' },
              _ = { mouseenter: 'mouseover', mouseleave: 'mouseout' };
            (y.click = y.mousedown = y.mouseup = y.mousemove = 'MouseEvents'),
              (t.event = { add: c, remove: u }),
              (t.proxy = function (e, r) {
                var i = 2 in arguments && p.call(arguments, 2);
                if (m(e)) {
                  var o = function () {
                    return e.apply(r, i ? i.concat(p.call(arguments)) : arguments);
                  };
                  return (o._zid = n(e)), o;
                }
                if (g(r)) return i ? (i.unshift(e[r], e), t.proxy.apply(null, i)) : t.proxy(e[r], e);
                throw new TypeError('expected function');
              }),
              (t.fn.bind = function (e, t, n) {
                return this.on(e, t, n);
              }),
              (t.fn.unbind = function (e, t) {
                return this.off(e, t);
              }),
              (t.fn.one = function (e, t, n, r) {
                return this.on(e, t, n, r, 1);
              });
            var O = function () {
                return !0;
              },
              P = function () {
                return !1;
              },
              j = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
              S = {
                preventDefault: 'isDefaultPrevented',
                stopImmediatePropagation: 'isImmediatePropagationStopped',
                stopPropagation: 'isPropagationStopped',
              };
            (t.fn.delegate = function (e, t, n) {
              return this.on(t, e, n);
            }),
              (t.fn.undelegate = function (e, t, n) {
                return this.off(t, e, n);
              }),
              (t.fn.live = function (e, n) {
                return t(document.body).delegate(this.selector, e, n), this;
              }),
              (t.fn.die = function (e, n) {
                return t(document.body).undelegate(this.selector, e, n), this;
              }),
              (t.fn.on = function (e, n, r, i, o) {
                var a,
                  s,
                  l = this;
                return e && !g(e)
                  ? (t.each(e, function (e, t) {
                      l.on(e, n, r, t, o);
                    }),
                    l)
                  : (g(n) || m(i) || !1 === i || ((i = r), (r = n), (n = h)),
                    (i !== h && !1 !== r) || ((i = r), (r = h)),
                    !1 === i && (i = P),
                    l.each(function (l, h) {
                      o &&
                        (a = function (e) {
                          return u(h, e.type, i), i.apply(this, arguments);
                        }),
                        n &&
                          (s = function (e) {
                            var r,
                              o = t(e.target).closest(n, h).get(0);
                            if (o && o !== h)
                              return (
                                (r = t.extend(f(e), { currentTarget: o, liveFired: h })),
                                (a || i).apply(o, [r].concat(p.call(arguments, 1)))
                              );
                          }),
                        c(h, e, i, r, n, s || a);
                    }));
              }),
              (t.fn.off = function (e, n, r) {
                var i = this;
                return e && !g(e)
                  ? (t.each(e, function (e, t) {
                      i.off(e, n, t);
                    }),
                    i)
                  : (g(n) || m(r) || !1 === r || ((r = n), (n = h)),
                    !1 === r && (r = P),
                    i.each(function () {
                      u(this, e, r, n);
                    }));
              }),
              (t.fn.trigger = function (e, n) {
                return (
                  (e = g(e) || t.isPlainObject(e) ? t.Event(e) : l(e)),
                  (e._args = n),
                  this.each(function () {
                    e.type in w && 'function' == typeof this[e.type]
                      ? this[e.type]()
                      : 'dispatchEvent' in this
                      ? this.dispatchEvent(e)
                      : t(this).triggerHandler(e, n);
                  })
                );
              }),
              (t.fn.triggerHandler = function (e, n) {
                var i, o;
                return (
                  this.each(function (a, s) {
                    (i = f(g(e) ? t.Event(e) : e)),
                      (i._args = n),
                      (i.target = s),
                      t.each(r(s, e.type || e), function (e, t) {
                        if (((o = t.proxy(i)), i.isImmediatePropagationStopped())) return !1;
                      });
                  }),
                  o
                );
              }),
              'focusin focusout focus blur load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select keydown keypress keyup error'
                .split(' ')
                .forEach(function (e) {
                  t.fn[e] = function (t) {
                    return 0 in arguments ? this.bind(e, t) : this.trigger(e);
                  };
                }),
              (t.Event = function (e, t) {
                g(e) || ((t = e), (e = t.type));
                var n = document.createEvent(y[e] || 'Events'),
                  r = !0;
                if (t) for (var i in t) 'bubbles' == i ? (r = !!t[i]) : (n[i] = t[i]);
                return n.initEvent(e, r, !0), l(n);
              });
          })(t),
          (function (e) {
            var t,
              n = [];
            e.fn.remove = function () {
              return this.each(function () {
                this.parentNode &&
                  ('IMG' === this.tagName &&
                    (n.push(this),
                    (this.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='),
                    t && clearTimeout(t),
                    (t = setTimeout(function () {
                      n = [];
                    }, 6e4))),
                  this.parentNode.removeChild(this));
              });
            };
          })(t),
          (function (e) {
            function t(t, r) {
              var c = t[s],
                u = c && i[c];
              if (void 0 === r) return u || n(t);
              if (u) {
                if (r in u) return u[r];
                var l = a(r);
                if (l in u) return u[l];
              }
              return o.call(e(t), r);
            }
            function n(t, n, o) {
              var c = t[s] || (t[s] = ++e.uuid),
                u = i[c] || (i[c] = r(t));
              return void 0 !== n && (u[a(n)] = o), u;
            }
            function r(t) {
              var n = {};
              return (
                e.each(t.attributes || c, function (t, r) {
                  0 == r.name.indexOf('data-') &&
                    (n[a(r.name.replace('data-', ''))] = e.zepto.deserializeValue(r.value));
                }),
                n
              );
            }
            var i = {},
              o = e.fn.data,
              a = e.camelCase,
              s = (e.expando = 'Zepto' + +new Date()),
              c = [];
            (e.fn.data = function (r, i) {
              return void 0 === i
                ? e.isPlainObject(r)
                  ? this.each(function (t, i) {
                      e.each(r, function (e, t) {
                        n(i, e, t);
                      });
                    })
                  : 0 in this
                  ? t(this[0], r)
                  : void 0
                : this.each(function () {
                    n(this, r, i);
                  });
            }),
              (e.data = function (t, n, r) {
                return e(t).data(n, r);
              }),
              (e.hasData = function (t) {
                var n = t[s],
                  r = n && i[n];
                return !!r && !e.isEmptyObject(r);
              }),
              (e.fn.removeData = function (t) {
                return (
                  'string' == typeof t && (t = t.split(/\s+/)),
                  this.each(function () {
                    var n = this[s],
                      r = n && i[n];
                    r &&
                      e.each(t || r, function (e) {
                        delete r[t ? a(this) : e];
                      });
                  })
                );
              }),
              ['remove', 'empty'].forEach(function (t) {
                var n = e.fn[t];
                e.fn[t] = function () {
                  var e = this.find('*');
                  return 'remove' === t && (e = e.add(this)), e.removeData(), n.call(this);
                };
              });
          })(t),
          t
        );
      })(t);
    })(window);
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t, n;
      if (
        ((e = e || {}),
        e.input || c.error('missing input'),
        (this.isActivated = !1),
        (this.debug = !!e.debug),
        (this.autoselect = !!e.autoselect),
        (this.autoselectOnBlur = !!e.autoselectOnBlur),
        (this.openOnFocus = !!e.openOnFocus),
        (this.minLength = c.isNumber(e.minLength) ? e.minLength : 1),
        (this.autoWidth = void 0 === e.autoWidth || !!e.autoWidth),
        (this.clearOnSelected = !!e.clearOnSelected),
        (this.tabAutocomplete = void 0 === e.tabAutocomplete || !!e.tabAutocomplete),
        (e.hint = !!e.hint),
        e.hint && e.appendTo)
      )
        throw new Error("[autocomplete.js] hint and appendTo options can't be used at the same time");
      (this.css = e.css = c.mixin({}, p, e.appendTo ? p.appendTo : {})),
        (this.cssClasses = e.cssClasses = c.mixin({}, p.defaultClasses, e.cssClasses || {})),
        (this.cssClasses.prefix = e.cssClasses.formattedPrefix =
          c.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix)),
        (this.listboxId = e.listboxId = [this.cssClasses.root, 'listbox', c.getUniqueId()].join('-'));
      var o = i(e);
      this.$node = o.wrapper;
      var a = (this.$input = o.input);
      (t = o.menu),
        (n = o.hint),
        e.dropdownMenuContainer &&
          u.element(e.dropdownMenuContainer).css('position', 'relative').append(t.css('top', '0')),
        a.on('blur.aa', function (e) {
          var n = document.activeElement;
          c.isMsie() &&
            (t[0] === n || t[0].contains(n)) &&
            (e.preventDefault(),
            e.stopImmediatePropagation(),
            c.defer(function () {
              a.focus();
            }));
        }),
        t.on('mousedown.aa', function (e) {
          e.preventDefault();
        }),
        (this.eventBus = e.eventBus || new l({ el: a })),
        (this.dropdown = new r.Dropdown({
          appendTo: e.appendTo,
          wrapper: this.$node,
          menu: t,
          datasets: e.datasets,
          templates: e.templates,
          cssClasses: e.cssClasses,
          minLength: this.minLength,
        })
          .onSync('suggestionClicked', this._onSuggestionClicked, this)
          .onSync('cursorMoved', this._onCursorMoved, this)
          .onSync('cursorRemoved', this._onCursorRemoved, this)
          .onSync('opened', this._onOpened, this)
          .onSync('closed', this._onClosed, this)
          .onSync('shown', this._onShown, this)
          .onSync('empty', this._onEmpty, this)
          .onSync('redrawn', this._onRedrawn, this)
          .onAsync('datasetRendered', this._onDatasetRendered, this)),
        (this.input = new r.Input({ input: a, hint: n })
          .onSync('focused', this._onFocused, this)
          .onSync('blurred', this._onBlurred, this)
          .onSync('enterKeyed', this._onEnterKeyed, this)
          .onSync('tabKeyed', this._onTabKeyed, this)
          .onSync('escKeyed', this._onEscKeyed, this)
          .onSync('upKeyed', this._onUpKeyed, this)
          .onSync('downKeyed', this._onDownKeyed, this)
          .onSync('leftKeyed', this._onLeftKeyed, this)
          .onSync('rightKeyed', this._onRightKeyed, this)
          .onSync('queryChanged', this._onQueryChanged, this)
          .onSync('whitespaceChanged', this._onWhitespaceChanged, this)),
        this._bindKeyboardShortcuts(e),
        this._setLanguageDirection();
    }
    function i(e) {
      var t, n, r, i;
      (t = u.element(e.input)),
        (n = u.element(d.wrapper.replace('%ROOT%', e.cssClasses.root)).css(e.css.wrapper)),
        e.appendTo ||
          'block' !== t.css('display') ||
          'table' !== t.parent().css('display') ||
          n.css('display', 'table-cell');
      var a = d.dropdown.replace('%PREFIX%', e.cssClasses.prefix).replace('%DROPDOWN_MENU%', e.cssClasses.dropdownMenu);
      (r = u.element(a).css(e.css.dropdown).attr({ role: 'listbox', id: e.listboxId })),
        e.templates && e.templates.dropdownMenu && r.html(c.templatify(e.templates.dropdownMenu)()),
        (i = t.clone().css(e.css.hint).css(o(t))),
        i
          .val('')
          .addClass(c.className(e.cssClasses.prefix, e.cssClasses.hint, !0))
          .removeAttr('id name placeholder required')
          .prop('readonly', !0)
          .attr({ 'aria-hidden': 'true', autocomplete: 'off', spellcheck: 'false', tabindex: -1 }),
        i.removeData && i.removeData(),
        t.data(s, {
          'aria-autocomplete': t.attr('aria-autocomplete'),
          'aria-expanded': t.attr('aria-expanded'),
          'aria-owns': t.attr('aria-owns'),
          autocomplete: t.attr('autocomplete'),
          dir: t.attr('dir'),
          role: t.attr('role'),
          spellcheck: t.attr('spellcheck'),
          style: t.attr('style'),
          type: t.attr('type'),
        }),
        t
          .addClass(c.className(e.cssClasses.prefix, e.cssClasses.input, !0))
          .attr({
            autocomplete: 'off',
            spellcheck: !1,
            role: 'combobox',
            'aria-autocomplete': e.datasets && e.datasets[0] && e.datasets[0].displayKey ? 'both' : 'list',
            'aria-expanded': 'false',
            'aria-label': e.ariaLabel,
            'aria-owns': e.listboxId,
          })
          .css(e.hint ? e.css.input : e.css.inputWithNoHint);
      try {
        t.attr('dir') || t.attr('dir', 'auto');
      } catch (e) {}
      return (
        (n = e.appendTo ? n.appendTo(u.element(e.appendTo).eq(0)).eq(0) : t.wrap(n).parent()),
        n.prepend(e.hint ? i : null).append(r),
        { wrapper: n, input: t, hint: i, menu: r }
      );
    }
    function o(e) {
      return {
        backgroundAttachment: e.css('background-attachment'),
        backgroundClip: e.css('background-clip'),
        backgroundColor: e.css('background-color'),
        backgroundImage: e.css('background-image'),
        backgroundOrigin: e.css('background-origin'),
        backgroundPosition: e.css('background-position'),
        backgroundRepeat: e.css('background-repeat'),
        backgroundSize: e.css('background-size'),
      };
    }
    function a(e, t) {
      var n = e.find(c.className(t.prefix, t.input));
      c.each(n.data(s), function (e, t) {
        void 0 === e ? n.removeAttr(t) : n.attr(t, e);
      }),
        n.detach().removeClass(c.className(t.prefix, t.input, !0)).insertAfter(e),
        n.removeData && n.removeData(s),
        e.remove();
    }
    var s = 'aaAttrs',
      c = n(6),
      u = n(7),
      l = n(54),
      f = n(144),
      h = n(151),
      d = n(55),
      p = n(28);
    c.mixin(r.prototype, {
      _bindKeyboardShortcuts: function (e) {
        if (e.keyboardShortcuts) {
          var t = this.$input,
            n = [];
          c.each(e.keyboardShortcuts, function (e) {
            'string' == typeof e && (e = e.toUpperCase().charCodeAt(0)), n.push(e);
          }),
            u.element(document).keydown(function (e) {
              var r = e.target || e.srcElement,
                i = r.tagName;
              if (!r.isContentEditable && 'INPUT' !== i && 'SELECT' !== i && 'TEXTAREA' !== i) {
                var o = e.which || e.keyCode;
                -1 !== n.indexOf(o) && (t.focus(), e.stopPropagation(), e.preventDefault());
              }
            });
        }
      },
      _onSuggestionClicked: function (e, t) {
        var n,
          r = { selectionMethod: 'click' };
        (n = this.dropdown.getDatumForSuggestion(t)) && this._select(n, r);
      },
      _onCursorMoved: function (e, t) {
        var n = this.dropdown.getDatumForCursor(),
          r = this.dropdown.getCurrentCursor().attr('id');
        this.input.setActiveDescendant(r),
          n &&
            (t && this.input.setInputValue(n.value, !0), this.eventBus.trigger('cursorchanged', n.raw, n.datasetName));
      },
      _onCursorRemoved: function () {
        this.input.resetInputValue(), this._updateHint(), this.eventBus.trigger('cursorremoved');
      },
      _onDatasetRendered: function () {
        this._updateHint(), this.eventBus.trigger('updated');
      },
      _onOpened: function () {
        this._updateHint(), this.input.expand(), this.eventBus.trigger('opened');
      },
      _onEmpty: function () {
        this.eventBus.trigger('empty');
      },
      _onRedrawn: function () {
        this.$node.css('top', '0px'), this.$node.css('left', '0px');
        var e = this.$input[0].getBoundingClientRect();
        this.autoWidth && this.$node.css('width', e.width + 'px');
        var t = this.$node[0].getBoundingClientRect(),
          n = e.bottom - t.top;
        this.$node.css('top', n + 'px');
        var r = e.left - t.left;
        this.$node.css('left', r + 'px'), this.eventBus.trigger('redrawn');
      },
      _onShown: function () {
        this.eventBus.trigger('shown'), this.autoselect && this.dropdown.cursorTopSuggestion();
      },
      _onClosed: function () {
        this.input.clearHint(),
          this.input.removeActiveDescendant(),
          this.input.collapse(),
          this.eventBus.trigger('closed');
      },
      _onFocused: function () {
        if (((this.isActivated = !0), this.openOnFocus)) {
          var e = this.input.getQuery();
          e.length >= this.minLength ? this.dropdown.update(e) : this.dropdown.empty(), this.dropdown.open();
        }
      },
      _onBlurred: function () {
        var e, t;
        (e = this.dropdown.getDatumForCursor()), (t = this.dropdown.getDatumForTopSuggestion());
        var n = { selectionMethod: 'blur' };
        this.debug ||
          (this.autoselectOnBlur && e
            ? this._select(e, n)
            : this.autoselectOnBlur && t
            ? this._select(t, n)
            : ((this.isActivated = !1), this.dropdown.empty(), this.dropdown.close()));
      },
      _onEnterKeyed: function (e, t) {
        var n, r;
        (n = this.dropdown.getDatumForCursor()), (r = this.dropdown.getDatumForTopSuggestion());
        var i = { selectionMethod: 'enterKey' };
        n ? (this._select(n, i), t.preventDefault()) : this.autoselect && r && (this._select(r, i), t.preventDefault());
      },
      _onTabKeyed: function (e, t) {
        if (!this.tabAutocomplete) return void this.dropdown.close();
        var n,
          r = { selectionMethod: 'tabKey' };
        (n = this.dropdown.getDatumForCursor()) ? (this._select(n, r), t.preventDefault()) : this._autocomplete(!0);
      },
      _onEscKeyed: function () {
        this.dropdown.close(), this.input.resetInputValue();
      },
      _onUpKeyed: function () {
        var e = this.input.getQuery();
        this.dropdown.isEmpty && e.length >= this.minLength ? this.dropdown.update(e) : this.dropdown.moveCursorUp(),
          this.dropdown.open();
      },
      _onDownKeyed: function () {
        var e = this.input.getQuery();
        this.dropdown.isEmpty && e.length >= this.minLength ? this.dropdown.update(e) : this.dropdown.moveCursorDown(),
          this.dropdown.open();
      },
      _onLeftKeyed: function () {
        'rtl' === this.dir && this._autocomplete();
      },
      _onRightKeyed: function () {
        'ltr' === this.dir && this._autocomplete();
      },
      _onQueryChanged: function (e, t) {
        this.input.clearHintIfInvalid(),
          t.length >= this.minLength ? this.dropdown.update(t) : this.dropdown.empty(),
          this.dropdown.open(),
          this._setLanguageDirection();
      },
      _onWhitespaceChanged: function () {
        this._updateHint(), this.dropdown.open();
      },
      _setLanguageDirection: function () {
        var e = this.input.getLanguageDirection();
        this.dir !== e && ((this.dir = e), this.$node.css('direction', e), this.dropdown.setLanguageDirection(e));
      },
      _updateHint: function () {
        var e, t, n, r, i, o;
        (e = this.dropdown.getDatumForTopSuggestion()),
          e && this.dropdown.isVisible() && !this.input.hasOverflow()
            ? ((t = this.input.getInputValue()),
              (n = f.normalizeQuery(t)),
              (r = c.escapeRegExChars(n)),
              (i = new RegExp('^(?:' + r + ')(.+$)', 'i')),
              (o = i.exec(e.value)),
              o ? this.input.setHint(t + o[1]) : this.input.clearHint())
            : this.input.clearHint();
      },
      _autocomplete: function (e) {
        var t, n, r, i;
        (t = this.input.getHint()),
          (n = this.input.getQuery()),
          (r = e || this.input.isCursorAtEnd()),
          t &&
            n !== t &&
            r &&
            ((i = this.dropdown.getDatumForTopSuggestion()),
            i && this.input.setInputValue(i.value),
            this.eventBus.trigger('autocompleted', i.raw, i.datasetName));
      },
      _select: function (e, t) {
        void 0 !== e.value && this.input.setQuery(e.value),
          this.clearOnSelected ? this.setVal('') : this.input.setInputValue(e.value, !0),
          this._setLanguageDirection(),
          !1 === this.eventBus.trigger('selected', e.raw, e.datasetName, t).isDefaultPrevented() &&
            (this.dropdown.close(), c.defer(c.bind(this.dropdown.empty, this.dropdown)));
      },
      open: function () {
        if (!this.isActivated) {
          var e = this.input.getInputValue();
          e.length >= this.minLength ? this.dropdown.update(e) : this.dropdown.empty();
        }
        this.dropdown.open();
      },
      close: function () {
        this.dropdown.close();
      },
      setVal: function (e) {
        (e = c.toStr(e)),
          this.isActivated ? this.input.setInputValue(e) : (this.input.setQuery(e), this.input.setInputValue(e, !0)),
          this._setLanguageDirection();
      },
      getVal: function () {
        return this.input.getQuery();
      },
      destroy: function () {
        this.input.destroy(), this.dropdown.destroy(), a(this.$node, this.cssClasses), (this.$node = null);
      },
      getWrapper: function () {
        return this.dropdown.$container[0];
      },
    }),
      (r.Dropdown = h),
      (r.Input = f),
      (r.sources = n(153)),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t,
        n,
        r,
        o,
        a = this;
      (e = e || {}),
        e.input || c.error('input is missing'),
        (t = c.bind(this._onBlur, this)),
        (n = c.bind(this._onFocus, this)),
        (r = c.bind(this._onKeydown, this)),
        (o = c.bind(this._onInput, this)),
        (this.$hint = u.element(e.hint)),
        (this.$input = u.element(e.input).on('blur.aa', t).on('focus.aa', n).on('keydown.aa', r)),
        0 === this.$hint.length && (this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = c.noop),
        c.isMsie()
          ? this.$input.on('keydown.aa keypress.aa cut.aa paste.aa', function (e) {
              s[e.which || e.keyCode] || c.defer(c.bind(a._onInput, a, e));
            })
          : this.$input.on('input.aa', o),
        (this.query = this.$input.val()),
        (this.$overflowHelper = i(this.$input));
    }
    function i(e) {
      return u
        .element('<pre aria-hidden="true"></pre>')
        .css({
          position: 'absolute',
          visibility: 'hidden',
          whiteSpace: 'pre',
          fontFamily: e.css('font-family'),
          fontSize: e.css('font-size'),
          fontStyle: e.css('font-style'),
          fontVariant: e.css('font-variant'),
          fontWeight: e.css('font-weight'),
          wordSpacing: e.css('word-spacing'),
          letterSpacing: e.css('letter-spacing'),
          textIndent: e.css('text-indent'),
          textRendering: e.css('text-rendering'),
          textTransform: e.css('text-transform'),
        })
        .insertAfter(e);
    }
    function o(e, t) {
      return r.normalizeQuery(e) === r.normalizeQuery(t);
    }
    function a(e) {
      return e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
    }
    var s;
    s = { 9: 'tab', 27: 'esc', 37: 'left', 39: 'right', 13: 'enter', 38: 'up', 40: 'down' };
    var c = n(6),
      u = n(7),
      l = n(27);
    (r.normalizeQuery = function (e) {
      return (e || '').replace(/^\s*/g, '').replace(/\s{2,}/g, ' ');
    }),
      c.mixin(r.prototype, l, {
        _onBlur: function () {
          this.resetInputValue(), this.$input.removeAttr('aria-activedescendant'), this.trigger('blurred');
        },
        _onFocus: function () {
          this.trigger('focused');
        },
        _onKeydown: function (e) {
          var t = s[e.which || e.keyCode];
          this._managePreventDefault(t, e), t && this._shouldTrigger(t, e) && this.trigger(t + 'Keyed', e);
        },
        _onInput: function () {
          this._checkInputValue();
        },
        _managePreventDefault: function (e, t) {
          var n, r, i;
          switch (e) {
            case 'tab':
              (r = this.getHint()), (i = this.getInputValue()), (n = r && r !== i && !a(t));
              break;
            case 'up':
            case 'down':
              n = !a(t);
              break;
            default:
              n = !1;
          }
          n && t.preventDefault();
        },
        _shouldTrigger: function (e, t) {
          var n;
          switch (e) {
            case 'tab':
              n = !a(t);
              break;
            default:
              n = !0;
          }
          return n;
        },
        _checkInputValue: function () {
          var e, t, n;
          (e = this.getInputValue()),
            (t = o(e, this.query)),
            (n = !(!t || !this.query) && this.query.length !== e.length),
            (this.query = e),
            t ? n && this.trigger('whitespaceChanged', this.query) : this.trigger('queryChanged', this.query);
        },
        focus: function () {
          this.$input.focus();
        },
        blur: function () {
          this.$input.blur();
        },
        getQuery: function () {
          return this.query;
        },
        setQuery: function (e) {
          this.query = e;
        },
        getInputValue: function () {
          return this.$input.val();
        },
        setInputValue: function (e, t) {
          void 0 === e && (e = this.query), this.$input.val(e), t ? this.clearHint() : this._checkInputValue();
        },
        expand: function () {
          this.$input.attr('aria-expanded', 'true');
        },
        collapse: function () {
          this.$input.attr('aria-expanded', 'false');
        },
        setActiveDescendant: function (e) {
          this.$input.attr('aria-activedescendant', e);
        },
        removeActiveDescendant: function () {
          this.$input.removeAttr('aria-activedescendant');
        },
        resetInputValue: function () {
          this.setInputValue(this.query, !0);
        },
        getHint: function () {
          return this.$hint.val();
        },
        setHint: function (e) {
          this.$hint.val(e);
        },
        clearHint: function () {
          this.setHint('');
        },
        clearHintIfInvalid: function () {
          var e, t, n;
          (e = this.getInputValue()),
            (t = this.getHint()),
            (n = e !== t && 0 === t.indexOf(e)),
            ('' !== e && n && !this.hasOverflow()) || this.clearHint();
        },
        getLanguageDirection: function () {
          return (this.$input.css('direction') || 'ltr').toLowerCase();
        },
        hasOverflow: function () {
          var e = this.$input.width() - 2;
          return this.$overflowHelper.text(this.getInputValue()), this.$overflowHelper.width() >= e;
        },
        isCursorAtEnd: function () {
          var e, t, n;
          return (
            (e = this.$input.val().length),
            (t = this.$input[0].selectionStart),
            c.isNumber(t)
              ? t === e
              : !document.selection ||
                ((n = document.selection.createRange()), n.moveStart('character', -e), e === n.text.length)
          );
        },
        destroy: function () {
          this.$hint.off('.aa'), this.$input.off('.aa'), (this.$hint = this.$input = this.$overflowHelper = null);
        },
      }),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    function r() {
      s && c && ((s = !1), c.length ? (h = c.concat(h)) : (f = -1), h.length && i());
    }
    function i() {
      if (!s) {
        (d = !1), (s = !0);
        for (var e = h.length, t = setTimeout(r); e; ) {
          for (c = h, h = []; c && ++f < e; ) c[f].run();
          (f = -1), (e = h.length);
        }
        (c = null), (f = -1), (s = !1), clearTimeout(t);
      }
    }
    function o(e, t) {
      (this.fun = e), (this.array = t);
    }
    function a(e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      h.push(new o(e, t)), d || s || ((d = !0), u());
    }
    for (
      var s, c, u, l = [n(146), n(147), n(148), n(149), n(150)], f = -1, h = [], d = !1, p = -1, m = l.length;
      ++p < m;

    )
      if (l[p] && l[p].test && l[p].test()) {
        u = l[p].install(i);
        break;
      }
    (o.prototype.run = function () {
      var e = this.fun,
        t = this.array;
      switch (t.length) {
        case 0:
          return e();
        case 1:
          return e(t[0]);
        case 2:
          return e(t[0], t[1]);
        case 3:
          return e(t[0], t[1], t[2]);
        default:
          return e.apply(null, t);
      }
    }),
      (e.exports = a);
  },
  function (e, t, n) {
    'use strict';
    (function (e) {
      (t.test = function () {
        return void 0 !== e && !e.browser;
      }),
        (t.install = function (t) {
          return function () {
            e.nextTick(t);
          };
        });
    }).call(t, n(26));
  },
  function (e, t, n) {
    'use strict';
    (function (e) {
      var n = e.MutationObserver || e.WebKitMutationObserver;
      (t.test = function () {
        return n;
      }),
        (t.install = function (t) {
          var r = 0,
            i = new n(t),
            o = e.document.createTextNode('');
          return (
            i.observe(o, { characterData: !0 }),
            function () {
              o.data = r = ++r % 2;
            }
          );
        });
    }).call(t, n(11));
  },
  function (e, t, n) {
    'use strict';
    (function (e) {
      (t.test = function () {
        return !e.setImmediate && void 0 !== e.MessageChannel;
      }),
        (t.install = function (t) {
          var n = new e.MessageChannel();
          return (
            (n.port1.onmessage = t),
            function () {
              n.port2.postMessage(0);
            }
          );
        });
    }).call(t, n(11));
  },
  function (e, t, n) {
    'use strict';
    (function (e) {
      (t.test = function () {
        return 'document' in e && 'onreadystatechange' in e.document.createElement('script');
      }),
        (t.install = function (t) {
          return function () {
            var n = e.document.createElement('script');
            return (
              (n.onreadystatechange = function () {
                t(), (n.onreadystatechange = null), n.parentNode.removeChild(n), (n = null);
              }),
              e.document.documentElement.appendChild(n),
              t
            );
          };
        });
    }).call(t, n(11));
  },
  function (e, t, n) {
    'use strict';
    (t.test = function () {
      return !0;
    }),
      (t.install = function (e) {
        return function () {
          setTimeout(e, 0);
        };
      });
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t,
        n,
        r,
        s = this;
      (e = e || {}),
        e.menu || o.error('menu is required'),
        o.isArray(e.datasets) || o.isObject(e.datasets) || o.error('1 or more datasets required'),
        e.datasets || o.error('datasets is required'),
        (this.isOpen = !1),
        (this.isEmpty = !0),
        (this.minLength = e.minLength || 0),
        (this.templates = {}),
        (this.appendTo = e.appendTo || !1),
        (this.css = o.mixin({}, u, e.appendTo ? u.appendTo : {})),
        (this.cssClasses = e.cssClasses = o.mixin({}, u.defaultClasses, e.cssClasses || {})),
        (this.cssClasses.prefix =
          e.cssClasses.formattedPrefix || o.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix)),
        (t = o.bind(this._onSuggestionClick, this)),
        (n = o.bind(this._onSuggestionMouseEnter, this)),
        (r = o.bind(this._onSuggestionMouseLeave, this));
      var c = o.className(this.cssClasses.prefix, this.cssClasses.suggestion);
      (this.$menu = a.element(e.menu).on('mouseenter.aa', c, n).on('mouseleave.aa', c, r).on('click.aa', c, t)),
        (this.$container = e.appendTo ? e.wrapper : this.$menu),
        e.templates &&
          e.templates.header &&
          ((this.templates.header = o.templatify(e.templates.header)), this.$menu.prepend(this.templates.header())),
        e.templates &&
          e.templates.empty &&
          ((this.templates.empty = o.templatify(e.templates.empty)),
          (this.$empty = a.element(
            '<div class="' + o.className(this.cssClasses.prefix, this.cssClasses.empty, !0) + '"></div>'
          )),
          this.$menu.append(this.$empty),
          this.$empty.hide()),
        (this.datasets = o.map(e.datasets, function (t) {
          return i(s.$menu, t, e.cssClasses);
        })),
        o.each(this.datasets, function (e) {
          var t = e.getRoot();
          t && 0 === t.parent().length && s.$menu.append(t), e.onSync('rendered', s._onRendered, s);
        }),
        e.templates &&
          e.templates.footer &&
          ((this.templates.footer = o.templatify(e.templates.footer)), this.$menu.append(this.templates.footer()));
      var l = this;
      a.element(window).resize(function () {
        l._redraw();
      });
    }
    function i(e, t, n) {
      return new r.Dataset(o.mixin({ $menu: e, cssClasses: n }, t));
    }
    var o = n(6),
      a = n(7),
      s = n(27),
      c = n(152),
      u = n(28);
    o.mixin(r.prototype, s, {
      _onSuggestionClick: function (e) {
        this.trigger('suggestionClicked', a.element(e.currentTarget));
      },
      _onSuggestionMouseEnter: function (e) {
        var t = a.element(e.currentTarget);
        if (!t.hasClass(o.className(this.cssClasses.prefix, this.cssClasses.cursor, !0))) {
          this._removeCursor();
          var n = this;
          setTimeout(function () {
            n._setCursor(t, !1);
          }, 0);
        }
      },
      _onSuggestionMouseLeave: function (e) {
        (e.relatedTarget &&
          a.element(e.relatedTarget).closest('.' + o.className(this.cssClasses.prefix, this.cssClasses.cursor, !0))
            .length > 0) ||
          (this._removeCursor(), this.trigger('cursorRemoved'));
      },
      _onRendered: function (e, t) {
        function n(e) {
          return e.isEmpty();
        }
        function r(e) {
          return e.templates && e.templates.empty;
        }
        if (((this.isEmpty = o.every(this.datasets, n)), this.isEmpty))
          if ((t.length >= this.minLength && this.trigger('empty'), this.$empty))
            if (t.length < this.minLength) this._hide();
            else {
              var i = this.templates.empty({ query: this.datasets[0] && this.datasets[0].query });
              this.$empty.html(i), this.$empty.show(), this._show();
            }
          else o.any(this.datasets, r) ? (t.length < this.minLength ? this._hide() : this._show()) : this._hide();
        else
          this.isOpen &&
            (this.$empty && (this.$empty.empty(), this.$empty.hide()),
            t.length >= this.minLength ? this._show() : this._hide());
        this.trigger('datasetRendered');
      },
      _hide: function () {
        this.$container.hide();
      },
      _show: function () {
        this.$container.css('display', 'block'), this._redraw(), this.trigger('shown');
      },
      _redraw: function () {
        this.isOpen && this.appendTo && this.trigger('redrawn');
      },
      _getSuggestions: function () {
        return this.$menu.find(o.className(this.cssClasses.prefix, this.cssClasses.suggestion));
      },
      _getCursor: function () {
        return this.$menu.find(o.className(this.cssClasses.prefix, this.cssClasses.cursor)).first();
      },
      _setCursor: function (e, t) {
        e
          .first()
          .addClass(o.className(this.cssClasses.prefix, this.cssClasses.cursor, !0))
          .attr('aria-selected', 'true'),
          this.trigger('cursorMoved', t);
      },
      _removeCursor: function () {
        this._getCursor()
          .removeClass(o.className(this.cssClasses.prefix, this.cssClasses.cursor, !0))
          .removeAttr('aria-selected');
      },
      _moveCursor: function (e) {
        var t, n, r, i;
        if (this.isOpen) {
          if (
            ((n = this._getCursor()),
            (t = this._getSuggestions()),
            this._removeCursor(),
            (r = t.index(n) + e),
            -1 == (r = ((r + 1) % (t.length + 1)) - 1))
          )
            return void this.trigger('cursorRemoved');
          r < -1 && (r = t.length - 1), this._setCursor((i = t.eq(r)), !0), this._ensureVisible(i);
        }
      },
      _ensureVisible: function (e) {
        var t, n, r, i;
        (t = e.position().top),
          (n = t + e.height() + parseInt(e.css('margin-top'), 10) + parseInt(e.css('margin-bottom'), 10)),
          (r = this.$menu.scrollTop()),
          (i =
            this.$menu.height() +
            parseInt(this.$menu.css('padding-top'), 10) +
            parseInt(this.$menu.css('padding-bottom'), 10)),
          t < 0 ? this.$menu.scrollTop(r + t) : i < n && this.$menu.scrollTop(r + (n - i));
      },
      close: function () {
        this.isOpen && ((this.isOpen = !1), this._removeCursor(), this._hide(), this.trigger('closed'));
      },
      open: function () {
        this.isOpen || ((this.isOpen = !0), this.isEmpty || this._show(), this.trigger('opened'));
      },
      setLanguageDirection: function (e) {
        this.$menu.css('ltr' === e ? this.css.ltr : this.css.rtl);
      },
      moveCursorUp: function () {
        this._moveCursor(-1);
      },
      moveCursorDown: function () {
        this._moveCursor(1);
      },
      getDatumForSuggestion: function (e) {
        var t = null;
        return (
          e.length && (t = { raw: c.extractDatum(e), value: c.extractValue(e), datasetName: c.extractDatasetName(e) }),
          t
        );
      },
      getCurrentCursor: function () {
        return this._getCursor().first();
      },
      getDatumForCursor: function () {
        return this.getDatumForSuggestion(this._getCursor().first());
      },
      getDatumForTopSuggestion: function () {
        return this.getDatumForSuggestion(this._getSuggestions().first());
      },
      cursorTopSuggestion: function () {
        this._setCursor(this._getSuggestions().first(), !1);
      },
      update: function (e) {
        function t(t) {
          t.update(e);
        }
        o.each(this.datasets, t);
      },
      empty: function () {
        function e(e) {
          e.clear();
        }
        o.each(this.datasets, e), (this.isEmpty = !0);
      },
      isVisible: function () {
        return this.isOpen && !this.isEmpty;
      },
      destroy: function () {
        function e(e) {
          e.destroy();
        }
        this.$menu.off('.aa'), (this.$menu = null), o.each(this.datasets, e);
      },
    }),
      (r.Dataset = c),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      (e = e || {}),
        (e.templates = e.templates || {}),
        e.source || l.error('missing source'),
        e.name && !a(e.name) && l.error('invalid dataset name: ' + e.name),
        (this.query = null),
        (this._isEmpty = !0),
        (this.highlight = !!e.highlight),
        (this.name = void 0 === e.name || null === e.name ? l.getUniqueId() : e.name),
        (this.source = e.source),
        (this.displayFn = i(e.display || e.displayKey)),
        (this.debounce = e.debounce),
        (this.cache = !1 !== e.cache),
        (this.templates = o(e.templates, this.displayFn)),
        (this.css = l.mixin({}, d, e.appendTo ? d.appendTo : {})),
        (this.cssClasses = e.cssClasses = l.mixin({}, d.defaultClasses, e.cssClasses || {})),
        (this.cssClasses.prefix =
          e.cssClasses.formattedPrefix || l.formatPrefix(this.cssClasses.prefix, this.cssClasses.noPrefix));
      var t = l.className(this.cssClasses.prefix, this.cssClasses.dataset);
      (this.$el =
        e.$menu && e.$menu.find(t + '-' + this.name).length > 0
          ? f.element(e.$menu.find(t + '-' + this.name)[0])
          : f.element(
              h.dataset
                .replace('%CLASS%', this.name)
                .replace('%PREFIX%', this.cssClasses.prefix)
                .replace('%DATASET%', this.cssClasses.dataset)
            )),
        (this.$menu = e.$menu),
        this.clearCachedSuggestions();
    }
    function i(e) {
      function t(t) {
        return t[e];
      }
      return (e = e || 'value'), l.isFunction(e) ? e : t;
    }
    function o(e, t) {
      function n(e) {
        return '<p>' + t(e) + '</p>';
      }
      return {
        empty: e.empty && l.templatify(e.empty),
        header: e.header && l.templatify(e.header),
        footer: e.footer && l.templatify(e.footer),
        suggestion: e.suggestion || n,
      };
    }
    function a(e) {
      return /^[_a-zA-Z0-9-]+$/.test(e);
    }
    var s = 'aaDataset',
      c = 'aaValue',
      u = 'aaDatum',
      l = n(6),
      f = n(7),
      h = n(55),
      d = n(28),
      p = n(27);
    (r.extractDatasetName = function (e) {
      return f.element(e).data(s);
    }),
      (r.extractValue = function (e) {
        return f.element(e).data(c);
      }),
      (r.extractDatum = function (e) {
        var t = f.element(e).data(u);
        return 'string' == typeof t && (t = JSON.parse(t)), t;
      }),
      l.mixin(r.prototype, p, {
        _render: function (e, t) {
          function n() {
            var t = [].slice.call(arguments, 0);
            return (t = [{ query: e, isEmpty: !0 }].concat(t)), d.templates.empty.apply(this, t);
          }
          function r() {
            function e(e) {
              var t,
                n = h.suggestion
                  .replace('%PREFIX%', o.cssClasses.prefix)
                  .replace('%SUGGESTION%', o.cssClasses.suggestion);
              return (
                (t = f
                  .element(n)
                  .attr({ role: 'option', id: ['option', Math.floor(1e8 * Math.random())].join('-') })
                  .append(d.templates.suggestion.apply(this, [e].concat(i)))),
                t.data(s, d.name),
                t.data(c, d.displayFn(e) || void 0),
                t.data(u, JSON.stringify(e)),
                t.children().each(function () {
                  f.element(this).css(o.css.suggestionChild);
                }),
                t
              );
            }
            var n,
              r,
              i = [].slice.call(arguments, 0),
              o = this,
              a = h.suggestions
                .replace('%PREFIX%', this.cssClasses.prefix)
                .replace('%SUGGESTIONS%', this.cssClasses.suggestions);
            return (n = f.element(a).css(this.css.suggestions)), (r = l.map(t, e)), n.append.apply(n, r), n;
          }
          function i() {
            var t = [].slice.call(arguments, 0);
            return (t = [{ query: e, isEmpty: !a }].concat(t)), d.templates.header.apply(this, t);
          }
          function o() {
            var t = [].slice.call(arguments, 0);
            return (t = [{ query: e, isEmpty: !a }].concat(t)), d.templates.footer.apply(this, t);
          }
          if (this.$el) {
            var a,
              d = this,
              p = [].slice.call(arguments, 2);
            if ((this.$el.empty(), (a = t && t.length), (this._isEmpty = !a), !a && this.templates.empty))
              this.$el
                .html(n.apply(this, p))
                .prepend(d.templates.header ? i.apply(this, p) : null)
                .append(d.templates.footer ? o.apply(this, p) : null);
            else if (a)
              this.$el
                .html(r.apply(this, p))
                .prepend(d.templates.header ? i.apply(this, p) : null)
                .append(d.templates.footer ? o.apply(this, p) : null);
            else if (t && !Array.isArray(t)) throw new TypeError('suggestions must be an array');
            this.$menu &&
              this.$menu
                .addClass(this.cssClasses.prefix + (a ? 'with' : 'without') + '-' + this.name)
                .removeClass(this.cssClasses.prefix + (a ? 'without' : 'with') + '-' + this.name),
              this.trigger('rendered', e);
          }
        },
        getRoot: function () {
          return this.$el;
        },
        update: function (e) {
          function t(t) {
            if (!this.canceled && e === this.query) {
              var n = [].slice.call(arguments, 1);
              this.cacheSuggestions(e, t, n), this._render.apply(this, [e, t].concat(n));
            }
          }
          if (((this.query = e), (this.canceled = !1), this.shouldFetchFromCache(e)))
            t.apply(this, [this.cachedSuggestions].concat(this.cachedRenderExtraArgs));
          else {
            var n = this,
              r = function () {
                n.canceled || n.source(e, t.bind(n));
              };
            if (this.debounce) {
              var i = function () {
                (n.debounceTimeout = null), r();
              };
              clearTimeout(this.debounceTimeout), (this.debounceTimeout = setTimeout(i, this.debounce));
            } else r();
          }
        },
        cacheSuggestions: function (e, t, n) {
          (this.cachedQuery = e), (this.cachedSuggestions = t), (this.cachedRenderExtraArgs = n);
        },
        shouldFetchFromCache: function (e) {
          return this.cache && this.cachedQuery === e && this.cachedSuggestions && this.cachedSuggestions.length;
        },
        clearCachedSuggestions: function () {
          delete this.cachedQuery, delete this.cachedSuggestions, delete this.cachedRenderExtraArgs;
        },
        cancel: function () {
          this.canceled = !0;
        },
        clear: function () {
          this.$el && (this.cancel(), this.$el.empty(), this.trigger('rendered', ''));
        },
        isEmpty: function () {
          return this._isEmpty;
        },
        destroy: function () {
          this.clearCachedSuggestions(), (this.$el = null);
        },
      }),
      (e.exports = r);
  },
  function (e, t, n) {
    'use strict';
    e.exports = { hits: n(154), popularIn: n(155) };
  },
  function (e, t, n) {
    'use strict';
    var r = n(6),
      i = n(56),
      o = n(57);
    e.exports = function (e, t) {
      function n(n, i) {
        e.search(n, t, function (e, t) {
          if (e) return void r.error(e.message);
          i(t.hits, t);
        });
      }
      var a = o(e.as._ua);
      return a && a[0] >= 3 && a[1] > 20 && ((t = t || {}), (t.additionalUA = 'autocomplete.js ' + i)), n;
    };
  },
  function (e, t, n) {
    'use strict';
    var r = n(6),
      i = n(56),
      o = n(57);
    e.exports = function (e, t, n, a) {
      function s(s, c) {
        e.search(s, t, function (e, s) {
          if (e) return void r.error(e.message);
          if (s.hits.length > 0) {
            var f = s.hits[0],
              h = r.mixin({ hitsPerPage: 0 }, n);
            delete h.source, delete h.index;
            var d = o(l.as._ua);
            return (
              d && d[0] >= 3 && d[1] > 20 && (t.additionalUA = 'autocomplete.js ' + i),
              void l.search(u(f), h, function (e, t) {
                if (e) return void r.error(e.message);
                var n = [];
                if (a.includeAll) {
                  var i = a.allTitle || 'All departments';
                  n.push(r.mixin({ facet: { value: i, count: t.nbHits } }, r.cloneDeep(f)));
                }
                r.each(t.facets, function (e, t) {
                  r.each(e, function (e, i) {
                    n.push(r.mixin({ facet: { facet: t, value: i, count: e } }, r.cloneDeep(f)));
                  });
                });
                for (var o = 1; o < s.hits.length; ++o) n.push(s.hits[o]);
                c(n, s);
              })
            );
          }
          c([]);
        });
      }
      var c = o(e.as._ua);
      if ((c && c[0] >= 3 && c[1] > 20 && ((t = t || {}), (t.additionalUA = 'autocomplete.js ' + i)), !n.source))
        return r.error("Missing 'source' key");
      var u = r.isFunction(n.source)
        ? n.source
        : function (e) {
            return e[n.source];
          };
      if (!n.index) return r.error("Missing 'index' key");
      var l = n.index;
      return (a = a || {}), s;
    };
  },
  function (e, t, n) {
    'use strict';
    var r,
      i,
      o = n(0),
      a = o(n(2));
    !(function (o, s) {
      'object' == (0, a.default)(t) && void 0 !== e
        ? (e.exports = s())
        : ((r = s), void 0 !== (i = 'function' == typeof r ? r.call(t, n, t, e) : r) && (e.exports = i));
    })(0, function () {
      var e,
        t,
        n,
        r,
        i = function () {
          try {
            return Boolean(navigator.cookieEnabled);
          } catch (e) {
            return !1;
          }
        },
        o = function () {
          try {
            return Boolean(navigator.sendBeacon);
          } catch (e) {
            return !1;
          }
        },
        s = function () {
          try {
            return Boolean(XMLHttpRequest);
          } catch (e) {
            return !1;
          }
        },
        c = function (e) {
          return void 0 === e;
        },
        u = function (e) {
          return 'string' == typeof e;
        },
        l = function (e) {
          return 'number' == typeof e;
        },
        f = function (e) {
          return 'function' == typeof e;
        },
        h = 'insights-js (1.3.0)',
        d = ['de', 'us'],
        p = function () {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (e) {
            var t = (16 * Math.random()) | 0;
            return ('x' === e ? t : (3 & t) | 8).toString(16);
          });
        },
        m = '_ALGOLIA',
        g = function (e, t, n) {
          var r = new Date();
          r.setTime(r.getTime() + n);
          var i = 'expires=' + r.toUTCString();
          document.cookie = e + '=' + t + ';' + i + ';path=/';
        },
        v = function (e) {
          for (var t = e + '=', n = document.cookie.split(';'), r = 0; r < n.length; r++) {
            for (var i = n[r]; ' ' === i.charAt(0); ) i = i.substring(1);
            if (0 === i.indexOf(t)) return i.substring(t.length, i.length);
          }
          return '';
        },
        y = 'ANONYMOUS_USER_TOKEN';
      Object.keys ||
        (Object.keys =
          ((e = Object.prototype.hasOwnProperty),
          (t = !{ toString: null }.propertyIsEnumerable('toString')),
          (r = (n = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor',
          ]).length),
          function (i) {
            if ('function' != typeof i && ('object' != (0, a.default)(i) || null === i))
              throw new TypeError('Object.keys called on non-object');
            var o,
              s,
              c = [];
            for (o in i) e.call(i, o) && c.push(o);
            if (t) for (s = 0; s < r; s++) e.call(i, n[s]) && c.push(n[s]);
            return c;
          })),
        'function' != typeof Object.assign &&
          (Object.assign = function (e, t) {
            var n = arguments;
            if (null == e) throw new TypeError('Cannot convert undefined or null to object');
            for (var r = Object(e), i = 1; i < arguments.length; i++) {
              var o = n[i];
              if (null != o) for (var a in o) Object.prototype.hasOwnProperty.call(o, a) && (r[a] = o[a]);
            }
            return r;
          });
      var b = function (e, t) {
          var n = JSON.stringify(t);
          navigator.sendBeacon(e, n);
        },
        w = function (e, t) {
          var n = JSON.stringify(t),
            r = new XMLHttpRequest();
          r.open('POST', e), r.send(n);
        },
        _ = new (function (e) {
          var t = e.requestFn;
          (this._ua = ''),
            (this._uaURIEncoded = ''),
            (this.version = '1.3.0'),
            (this._hasCredentials = !1),
            (this.sendEvent = (function (e) {
              return function (t, n) {
                if (!this._userHasOptedOut) {
                  if (!this._hasCredentials)
                    throw new Error(
                      "Before calling any methods on the analytics, you first need to call the 'init' function with appId and apiKey parameters"
                    );
                  if ('' === n.userToken || '' === this._userToken)
                    throw new Error('`userToken` cannot be an empty string.');
                  var r = n.userToken || this._userToken;
                  if (c(r))
                    throw new Error(
                      "Before calling any methods on the analytics, you first need to call 'setUserToken' function or include 'userToken' in the event payload."
                    );
                  if (!u(n.index)) throw new TypeError('expected required parameter `index` to be a string');
                  if (!u(n.eventName)) throw new TypeError('expected required parameter `eventName` to be a string');
                  if (!c(n.userToken) && !u(n.userToken))
                    throw new TypeError('expected optional parameter `userToken` to be a string');
                  var i = { eventType: t, eventName: n.eventName, userToken: r, index: n.index };
                  if (!c(n.timestamp)) {
                    if (!l(n.timestamp)) throw new TypeError('expected optional parameter `timestamp` to be a number');
                    i.timestamp = n.timestamp;
                  }
                  if (!c(n.queryID)) {
                    if (!u(n.queryID)) throw new TypeError('expected optional parameter `queryID` to be a string');
                    i.queryID = n.queryID;
                  }
                  if (!c(n.objectIDs)) {
                    if (!Array.isArray(n.objectIDs))
                      throw new TypeError('expected optional parameter `objectIDs` to be an array');
                    i.objectIDs = n.objectIDs;
                  }
                  if (!c(n.positions)) {
                    if (!Array.isArray(n.positions))
                      throw new TypeError('expected optional parameter `positions` to be an array');
                    if (c(n.objectIDs)) throw new Error('cannot use `positions` without providing `objectIDs`');
                    if (n.objectIDs.length !== n.positions.length)
                      throw new Error('objectIDs and positions need to be of the same size');
                    i.positions = n.positions;
                  }
                  if (!c(n.filters)) {
                    if (!c(n.objectIDs)) throw new Error('cannot use `objectIDs` and `filters` for the same event');
                    if (!Array.isArray(n.filters))
                      throw new TypeError('expected optional parameter `filters` to be an array');
                    i.filters = n.filters;
                  }
                  if (c(n.objectIDs) && c(n.filters))
                    throw new Error('expected either `objectIDs` or `filters` to be provided');
                  !(function (e, t, n, r, i, o) {
                    e(
                      i +
                        '/1/events?X-Algolia-Application-Id=' +
                        t +
                        '&X-Algolia-API-Key=' +
                        n +
                        '&X-Algolia-Agent=' +
                        r,
                      { events: o }
                    );
                  })(e, this._appId, this._apiKey, this._uaURIEncoded, this._endpointOrigin, [i]);
                }
              };
            })(t).bind(this)),
            (this.init = function (e) {
              if (!e)
                throw new Error(
                  'Init function should be called with an object argument containing your apiKey and appId'
                );
              if (c(e.apiKey) || !u(e.apiKey))
                throw new Error('apiKey is missing, please provide it so we can authenticate the application');
              if (c(e.appId) || !u(e.appId))
                throw new Error(
                  'appId is missing, please provide it, so we can properly attribute data to your application'
                );
              if (!c(e.region) && -1 === d.indexOf(e.region))
                throw new Error('optional region is incorrect, please provide either one of: ' + d.join(', ') + '.');
              if (
                !(
                  c(e.cookieDuration) ||
                  (l(e.cookieDuration) &&
                    isFinite(e.cookieDuration) &&
                    Math.floor(e.cookieDuration) === e.cookieDuration)
                )
              )
                throw new Error('optional cookieDuration is incorrect, expected an integer.');
              (this._apiKey = e.apiKey),
                (this._appId = e.appId),
                (this._userHasOptedOut = !!e.userHasOptedOut),
                (this._region = e.region),
                (this._endpointOrigin = e.region
                  ? 'https://insights.' + e.region + '.algolia.io'
                  : 'https://insights.algolia.io'),
                (this._cookieDuration = e.cookieDuration ? e.cookieDuration : 15552e6),
                (this._hasCredentials = !0),
                (this._ua = h),
                (this._uaURIEncoded = encodeURIComponent(h)),
                i() && this.setUserToken(this.ANONYMOUS_USER_TOKEN);
            }.bind(this)),
            (this.initSearch = function (e) {
              if (!this._hasCredentials)
                throw new Error(
                  "Before calling any methods on the analytics, you first need to call the 'init' function with appId and apiKey parameters"
                );
              if (!e)
                throw new Error('initSearch function requires an argument with getQueryID and hitsContainer arguments');
              if (!e.getQueryID || 'function' != typeof e.getQueryID)
                throw new Error('getQueryID must be a function that returns the queryID of the last search operation');
              this.getQueryID = e.getQueryID;
            }.bind(this)),
            (this.addAlgoliaAgent = function (e) {
              -1 === this._ua.indexOf('; ' + e) &&
                ((this._ua += '; ' + e), (this._uaURIEncoded = encodeURIComponent(this._ua)));
            }.bind(this)),
            (this.ANONYMOUS_USER_TOKEN = y),
            (this.setUserToken = function (e) {
              if (e === y) {
                if (!i())
                  throw new Error(
                    'Tracking of anonymous users is only possible on environments which support cookies.'
                  );
                var t = v(m);
                t && '' !== t && 0 === t.indexOf('anonymous-')
                  ? (this._userToken = t)
                  : ((this._userToken = 'anonymous-' + p()), g(m, this._userToken, this._cookieDuration));
              } else this._userToken = e;
            }.bind(this)),
            (this.getUserToken = function (e, t) {
              return f(t) && t(null, this._userToken), this._userToken;
            }.bind(this)),
            (this.clickedObjectIDsAfterSearch = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to clickedObjectIDsAfterSearch function, please provide `queryID`,  `objectIDs` and `positions` to be reported'
                );
              if (!e.queryID)
                throw new Error(
                  'required queryID parameter was not sent, click event can not be properly sent without'
                );
              if (!e.objectIDs)
                throw new Error(
                  'required objectIDs parameter was not sent, click event can not be properly sent without'
                );
              if (!e.positions)
                throw new Error(
                  'required positions parameter was not sent, click event can not be properly sent without'
                );
              this.sendEvent('click', e);
            }.bind(this)),
            (this.clickedObjectIDs = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to clickedObjectIDs function, please provide `objectIDs` to be reported'
                );
              if (!e.objectIDs)
                throw new Error(
                  'required `objectIDs` parameter was not sent, click event can not be properly sent without'
                );
              this.sendEvent('click', e);
            }.bind(this)),
            (this.clickedFilters = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to clickedFilters function, please provide `filters` to be reported'
                );
              if (!e.filters)
                throw new Error(
                  'required `filters` parameter was not sent, click event can not be properly sent without'
                );
              this.sendEvent('click', e);
            }.bind(this)),
            (this.convertedObjectIDsAfterSearch = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to convertedObjectIDsAfterSearch function, please provide `queryID` and `objectIDs` to be reported'
                );
              if (!e.queryID)
                throw new Error(
                  'required queryID parameter was not sent, conversion event can not be properly sent without'
                );
              if (!e.objectIDs)
                throw new Error(
                  'required objectIDs parameter was not sent, conversion event can not be properly sent without'
                );
              this.sendEvent('conversion', e);
            }.bind(this)),
            (this.convertedObjectIDs = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to convertedObjectIDs function, please provide `objectIDs` to be reported'
                );
              if (!e.objectIDs)
                throw new Error(
                  'required objectIDs parameter was not sent, conversion event can not be properly sent without'
                );
              this.sendEvent('conversion', e);
            }.bind(this)),
            (this.convertedFilters = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to convertedFilters function, please provide `filters` to be reported'
                );
              if (!e.filters)
                throw new Error(
                  'required filters parameter was not sent, conversion event can not be properly sent without'
                );
              this.sendEvent('conversion', e);
            }.bind(this)),
            (this.viewedObjectIDs = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to viewedObjectIDs function, please provide `objectIDs` to be reported'
                );
              if (!e.objectIDs)
                throw new Error(
                  'required objectIDs parameter was not sent, view event can not be properly sent without'
                );
              this.sendEvent('view', e);
            }.bind(this)),
            (this.viewedFilters = function (e) {
              if (!e)
                throw new Error(
                  'No params were sent to viewedFilters function, please provide `filters` to be reported'
                );
              if (!e.filters)
                throw new Error('required filters parameter was not sent, view event can not be properly sent without');
              this.sendEvent('view', e);
            }.bind(this));
        })({
          requestFn: (function () {
            if (o()) return b;
            if (s()) return w;
            throw new Error('Could not find a supported HTTP request client in this environment.');
          })(),
        });
      return (
        'undefined' != typeof window &&
          function (e) {
            var t,
              n = e.AlgoliaAnalyticsObject;
            if (n) {
              var r =
                  ((t = this),
                  function (e) {
                    for (var n = [], r = arguments.length - 1; r-- > 0; ) n[r] = arguments[r + 1];
                    e && f(t[e]) && t[e].apply(t, n);
                  }),
                i = e[n];
              i.queue = i.queue || [];
              var o = i.queue;
              o.forEach(function (e) {
                var t = [].slice.call(e),
                  n = t[0],
                  i = t.slice(1);
                r.apply(void 0, [n].concat(i));
              }),
                (o.push = function (e) {
                  var t = [].slice.call(e),
                    n = t[0],
                    i = t.slice(1);
                  r.apply(void 0, [n].concat(i));
                });
            }
          }.call(_, window),
        _
      );
    });
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      return u(e) || c(e, t) || s();
    }
    function s() {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
    function c(e, t) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e)) {
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t);
            r = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }
    }
    function u(e) {
      if (Array.isArray(e)) return e;
    }
    function l() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.container,
        n = e.attribute,
        r = e.min,
        o = e.max,
        a = e.cssClasses,
        s = void 0 === a ? {} : a,
        c = e.step,
        u = e.pips,
        l = void 0 === u || u,
        f = e.precision,
        p = void 0 === f ? 0 : f,
        v = e.tooltips,
        _ = void 0 === v || v;
      if (!t) throw new Error(y('The `container` option is required.'));
      var O = (0, g.getContainerNode)(t),
        P = {
          root: (0, d.default)(b(), s.root),
          disabledRoot: (0, d.default)(b({ modifierName: 'disabled' }), s.disabledRoot),
        },
        j = w({ containerNode: O, step: c, pips: l, tooltips: _, renderState: {}, cssClasses: P });
      return i(
        {},
        (0, m.default)(j, function () {
          return (0, h.render)(null, O);
        })({ attribute: n, min: r, max: o, precision: p }),
        { $$type: 'ais.rangeSlider' }
      );
    }
    var f = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = l);
    var h = n(3),
      d = f(n(4)),
      p = f(n(158)),
      m = f(n(161)),
      g = n(1),
      v = n(5),
      y = (0, g.createDocumentationMessageGenerator)({ name: 'range-slider' }),
      b = (0, v.component)('RangeSlider'),
      w = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.pips,
          i = e.step,
          o = e.tooltips;
        return function (e, s) {
          var c = e.refine,
            u = e.range,
            l = e.start;
          if (!s) {
            var f = u.min,
              d = u.max,
              m = a(l, 2),
              g = m[0],
              v = m[1],
              y = g === -1 / 0 ? f : g,
              b = v === 1 / 0 ? d : v,
              w = [y > d ? d : y, b < f ? f : b];
            (0, h.render)(
              (0, h.h)(p.default, {
                cssClasses: n,
                refine: c,
                min: f,
                max: d,
                values: w,
                tooltips: o,
                step: i,
                pips: r,
              }),
              t
            );
          }
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, b.default)(Symbol.iterator)
          ? function (e) {
              return (0, b.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, b.default)(e);
            })(e);
    }
    function i(e) {
      return s(e) || a(e) || o();
    }
    function o() {
      throw new TypeError('Invalid attempt to spread non-iterable instance');
    }
    function a(e) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
    }
    function s(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
    }
    function c() {
      return (
        (c =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        c.apply(this, arguments)
      );
    }
    function u(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function l(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function f(e, t, n) {
      return t && l(e.prototype, t), n && l(e, n), e;
    }
    function h(e, t) {
      return !t || ('object' !== r(t) && 'function' != typeof t) ? p(e) : t;
    }
    function d(e) {
      return (d = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function p(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function m(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && g(e, t);
    }
    function g(e, t) {
      return (g =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function v(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var y = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var b = y(n(2)),
      w = n(3),
      _ = y(n(159)),
      O = y(n(4)),
      P = n(1),
      j = y(n(160)),
      S = (function (e) {
        function t() {
          var e, n;
          u(this, t);
          for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
          return (
            (n = h(this, (e = d(t)).call.apply(e, [this].concat(i)))),
            v(p(n), 'handleChange', function (e) {
              var t = e.values;
              n.isDisabled || n.props.refine(t);
            }),
            v(p(n), 'createHandleComponent', function (e) {
              return function (t) {
                var n = Math.round(100 * parseFloat(t['aria-valuenow'])) / 100,
                  r = e && e.format ? e.format(n) : n,
                  i = (0, O.default)(t.className, {
                    'rheostat-handle-lower': 0 === t['data-handle-key'],
                    'rheostat-handle-upper': 1 === t['data-handle-key'],
                  });
                return (0,
                w.h)('div', c({}, t, { className: i }), e && (0, w.h)('div', { className: 'rheostat-tooltip' }, r));
              };
            }),
            n
          );
        }
        return (
          m(t, e),
          f(t, [
            {
              key: 'computeDefaultPitPoints',
              value: function (e) {
                var t = e.min,
                  n = e.max,
                  r = n - t,
                  o = r / 34;
                return [t].concat(
                  i(
                    (0, P.range)({ end: 33 }).map(function (e) {
                      return t + o * (e + 1);
                    })
                  ),
                  [n]
                );
              },
            },
            {
              key: 'computeSnapPoints',
              value: function (e) {
                var t = e.min,
                  n = e.max,
                  r = e.step;
                if (r) return [].concat(i((0, P.range)({ start: t, end: n, step: r })), [n]);
              },
            },
            {
              key: 'render',
              value: function () {
                var e = this.props,
                  t = e.tooltips,
                  n = e.step,
                  r = e.pips,
                  i = e.values,
                  o = e.cssClasses,
                  a = this.isDisabled ? { min: this.props.min, max: this.props.max + 0.001 } : this.props,
                  s = a.min,
                  c = a.max,
                  u = this.computeSnapPoints({ min: s, max: c, step: n }),
                  l = !1 === r ? [] : this.computeDefaultPitPoints({ min: s, max: c });
                return (0, w.h)(
                  'div',
                  { className: (0, O.default)(o.root, v({}, o.disabledRoot, this.isDisabled)) },
                  (0, w.h)(_.default, {
                    handle: this.createHandleComponent(t),
                    onChange: this.handleChange,
                    min: s,
                    max: c,
                    pitComponent: j.default,
                    pitPoints: l,
                    snap: !0,
                    snapPoints: u,
                    values: this.isDisabled ? [s, c] : i,
                    disabled: this.isDisabled,
                  })
                );
              },
            },
            {
              key: 'isDisabled',
              get: function () {
                return this.props.min >= this.props.max;
              },
            },
          ]),
          t
        );
      })(w.Component),
      x = S;
    t.default = x;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function i(e) {
      return (i =
        'function' == typeof Symbol && 'symbol' === (0, w.default)(Symbol.iterator)
          ? function (e) {
              return (0, w.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, w.default)(e);
            })(e);
    }
    function o() {
      return (
        (o =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        o.apply(this, arguments)
      );
    }
    function a(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function s(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function c(e, t, n) {
      return t && s(e.prototype, t), n && s(e, n), e;
    }
    function u(e, t) {
      return !t || ('object' !== i(t) && 'function' != typeof t) ? l(e) : t;
    }
    function l(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function f(e) {
      return (f = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function h(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && d(e, t);
    }
    function d(e, t) {
      return (d =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function p(e, t, n) {
      return ((e - t) / (n - t)) * 100;
    }
    function m(e, t, n) {
      var r = e / 100;
      return 0 === e ? t : 100 === e ? n : Math.round((n - t) * r + t);
    }
    function g(e) {
      return ['rheostat', 'vertical' === e.orientation ? 'rheostat-vertical' : 'rheostat-horizontal']
        .concat(e.className.split(' '))
        .join(' ');
    }
    function v(e) {
      return Number(e.currentTarget.getAttribute('data-handle-key'));
    }
    function y(e) {
      e.stopPropagation(), e.preventDefault();
    }
    var b = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var w = b(n(2)),
      _ = n(3),
      O = { DOWN: 40, END: 35, ESC: 27, HOME: 36, LEFT: 37, PAGE_DOWN: 34, PAGE_UP: 33, RIGHT: 39, UP: 38 },
      P = (function (e) {
        function t() {
          return a(this, t), u(this, f(t).apply(this, arguments));
        }
        return (
          h(t, e),
          c(t, [
            {
              key: 'render',
              value: function () {
                return (0, _.h)('button', o({}, this.props, { type: 'button' }));
              },
            },
          ]),
          t
        );
      })(_.Component),
      j = (0, _.h)('div', { className: 'rheostat-background' }),
      S = (function (e) {
        function t(e) {
          var n;
          return (
            a(this, t),
            (n = u(this, f(t).call(this, e))),
            r(l(n), 'state', {
              className: g(n.props),
              handlePos: n.props.values.map(function (e) {
                return p(e, n.props.min, n.props.max);
              }),
              handleDimensions: 0,
              mousePos: null,
              sliderBox: {},
              slidingIndex: null,
              values: n.props.values,
            }),
            (n.getPublicState = n.getPublicState.bind(l(n))),
            (n.getSliderBoundingBox = n.getSliderBoundingBox.bind(l(n))),
            (n.getProgressStyle = n.getProgressStyle.bind(l(n))),
            (n.getMinValue = n.getMinValue.bind(l(n))),
            (n.getMaxValue = n.getMaxValue.bind(l(n))),
            (n.getHandleDimensions = n.getHandleDimensions.bind(l(n))),
            (n.getClosestSnapPoint = n.getClosestSnapPoint.bind(l(n))),
            (n.getSnapPosition = n.getSnapPosition.bind(l(n))),
            (n.getNextPositionForKey = n.getNextPositionForKey.bind(l(n))),
            (n.getNextState = n.getNextState.bind(l(n))),
            (n.handleClick = n.handleClick.bind(l(n))),
            (n.getClosestHandle = n.getClosestHandle.bind(l(n))),
            (n.setStartSlide = n.setStartSlide.bind(l(n))),
            (n.startMouseSlide = n.startMouseSlide.bind(l(n))),
            (n.startTouchSlide = n.startTouchSlide.bind(l(n))),
            (n.handleMouseSlide = n.handleMouseSlide.bind(l(n))),
            (n.handleTouchSlide = n.handleTouchSlide.bind(l(n))),
            (n.handleSlide = n.handleSlide.bind(l(n))),
            (n.endSlide = n.endSlide.bind(l(n))),
            (n.handleKeydown = n.handleKeydown.bind(l(n))),
            (n.validatePosition = n.validatePosition.bind(l(n))),
            (n.validateValues = n.validateValues.bind(l(n))),
            (n.canMove = n.canMove.bind(l(n))),
            (n.fireChangeEvent = n.fireChangeEvent.bind(l(n))),
            (n.slideTo = n.slideTo.bind(l(n))),
            (n.updateNewValues = n.updateNewValues.bind(l(n))),
            n
          );
        }
        return (
          h(t, e),
          c(t, [
            {
              key: 'componentWillReceiveProps',
              value: function (e) {
                var t = this.props,
                  n = t.className,
                  r = t.disabled,
                  i = t.min,
                  o = t.max,
                  a = t.orientation,
                  s = this.state,
                  c = s.values,
                  u = s.slidingIndex,
                  l = e.min !== i || e.max !== o,
                  f =
                    c.length !== e.values.length ||
                    c.some(function (t, n) {
                      return e.values[n] !== t;
                    }),
                  h = e.className !== n || e.orientation !== a,
                  d = e.disabled && !r;
                h && this.setState({ className: g(e) }),
                  (l || f) && this.updateNewValues(e),
                  d && null !== u && this.endSlide();
              },
            },
            {
              key: 'getPublicState',
              value: function () {
                var e = this.props,
                  t = e.min;
                return { max: e.max, min: t, values: this.state.values };
              },
            },
            {
              key: 'getSliderBoundingBox',
              value: function () {
                var e = this.rheostat.getDOMNode ? this.rheostat.getDOMNode() : this.rheostat,
                  t = e.getBoundingClientRect();
                return {
                  height: t.height || e.clientHeight,
                  left: t.left,
                  top: t.top,
                  width: t.width || e.clientWidth,
                };
              },
            },
            {
              key: 'getProgressStyle',
              value: function (e) {
                var t = this.state.handlePos,
                  n = t[e];
                if (0 === e)
                  return 'vertical' === this.props.orientation
                    ? { height: ''.concat(n, '%'), top: 0 }
                    : { left: 0, width: ''.concat(n, '%') };
                var r = t[e - 1],
                  i = n - r;
                return 'vertical' === this.props.orientation
                  ? { height: ''.concat(i, '%'), top: ''.concat(r, '%') }
                  : { left: ''.concat(r, '%'), width: ''.concat(i, '%') };
              },
            },
            {
              key: 'getMinValue',
              value: function (e) {
                return this.state.values[e - 1] ? Math.max(this.props.min, this.state.values[e - 1]) : this.props.min;
              },
            },
            {
              key: 'getMaxValue',
              value: function (e) {
                return this.state.values[e + 1] ? Math.min(this.props.max, this.state.values[e + 1]) : this.props.max;
              },
            },
            {
              key: 'getHandleDimensions',
              value: function (e, t) {
                var n = e.currentTarget || null;
                return n
                  ? 'vertical' === this.props.orientation
                    ? ((n.clientHeight / t.height) * 100) / 2
                    : ((n.clientWidth / t.width) * 100) / 2
                  : 0;
              },
            },
            {
              key: 'getClosestSnapPoint',
              value: function (e) {
                return this.props.snapPoints.length
                  ? this.props.snapPoints.reduce(function (t, n) {
                      return Math.abs(t - e) < Math.abs(n - e) ? t : n;
                    })
                  : e;
              },
            },
            {
              key: 'getSnapPosition',
              value: function (e) {
                if (!this.props.snap) return e;
                var t = this.props,
                  n = t.max,
                  r = t.min,
                  i = m(e, r, n);
                return p(this.getClosestSnapPoint(i), r, n);
              },
            },
            {
              key: 'getNextPositionForKey',
              value: function (e, t) {
                var n,
                  i = this.state,
                  o = i.handlePos,
                  a = i.values,
                  s = this.props,
                  c = s.max,
                  u = s.min,
                  l = s.snapPoints,
                  f = this.props.snap,
                  h = a[e],
                  d = o[e],
                  m = d,
                  g = 1;
                c >= 100 ? (d = Math.round(d)) : (g = 100 / (c - u));
                var v = null;
                f && (v = l.indexOf(this.getClosestSnapPoint(a[e])));
                var y =
                  ((n = {}),
                  r(n, O.LEFT, function (e) {
                    return -1 * e;
                  }),
                  r(n, O.RIGHT, function (e) {
                    return e;
                  }),
                  r(n, O.UP, function (e) {
                    return e;
                  }),
                  r(n, O.DOWN, function (e) {
                    return -1 * e;
                  }),
                  r(n, O.PAGE_DOWN, function (e) {
                    return e > 1 ? -e : -10 * e;
                  }),
                  r(n, O.PAGE_UP, function (e) {
                    return e > 1 ? e : 10 * e;
                  }),
                  n);
                if (Object.prototype.hasOwnProperty.call(y, t))
                  (d += y[t](g)), f && (d > m ? v < l.length - 1 && (h = l[v + 1]) : v > 0 && (h = l[v - 1]));
                else if (t === O.HOME) (d = 0), f && (h = l[0]);
                else {
                  if (t !== O.END) return null;
                  (d = 100), f && (h = l[l.length - 1]);
                }
                return f ? p(h, u, c) : d;
              },
            },
            {
              key: 'getNextState',
              value: function (e, t) {
                var n = this.state.handlePos,
                  r = this.props,
                  i = r.max,
                  o = r.min,
                  a = this.validatePosition(e, t),
                  s = n.map(function (t, n) {
                    return n === e ? a : t;
                  });
                return {
                  handlePos: s,
                  values: s.map(function (e) {
                    return m(e, o, i);
                  }),
                };
              },
            },
            {
              key: 'getClosestHandle',
              value: function (e) {
                var t = this.state.handlePos;
                return t.reduce(function (n, r, i) {
                  return Math.abs(t[i] - e) < Math.abs(t[n] - e) ? i : n;
                }, 0);
              },
            },
            {
              key: 'setStartSlide',
              value: function (e, t, n) {
                var r = this.getSliderBoundingBox();
                this.setState({
                  handleDimensions: this.getHandleDimensions(e, r),
                  mousePos: { x: t, y: n },
                  sliderBox: r,
                  slidingIndex: v(e),
                });
              },
            },
            {
              key: 'startMouseSlide',
              value: function (e) {
                this.setStartSlide(e, e.clientX, e.clientY),
                  'function' == typeof document.addEventListener
                    ? (document.addEventListener('mousemove', this.handleMouseSlide, !1),
                      document.addEventListener('mouseup', this.endSlide, !1))
                    : (document.attachEvent('onmousemove', this.handleMouseSlide),
                      document.attachEvent('onmouseup', this.endSlide)),
                  y(e);
              },
            },
            {
              key: 'startTouchSlide',
              value: function (e) {
                if (!(e.changedTouches.length > 1)) {
                  var t = e.changedTouches[0];
                  this.setStartSlide(e, t.clientX, t.clientY),
                    document.addEventListener('touchmove', this.handleTouchSlide, !1),
                    document.addEventListener('touchend', this.endSlide, !1),
                    this.props.onSliderDragStart && this.props.onSliderDragStart(),
                    y(e);
                }
              },
            },
            {
              key: 'handleMouseSlide',
              value: function (e) {
                null !== this.state.slidingIndex && (this.handleSlide(e.clientX, e.clientY), y(e));
              },
            },
            {
              key: 'handleTouchSlide',
              value: function (e) {
                if (null !== this.state.slidingIndex) {
                  if (e.changedTouches.length > 1) return void this.endSlide();
                  var t = e.changedTouches[0];
                  this.handleSlide(t.clientX, t.clientY), y(e);
                }
              },
            },
            {
              key: 'handleSlide',
              value: function (e, t) {
                var n = this.state,
                  r = n.slidingIndex,
                  i = n.sliderBox,
                  o =
                    'vertical' === this.props.orientation
                      ? ((t - i.top) / i.height) * 100
                      : ((e - i.left) / i.width) * 100;
                this.slideTo(r, o),
                  this.canMove(r, o) &&
                    (this.setState({ x: e, y: t }), this.props.onSliderDragMove && this.props.onSliderDragMove());
              },
            },
            {
              key: 'endSlide',
              value: function () {
                var e = this,
                  t = this.state.slidingIndex;
                if (
                  (this.setState({ slidingIndex: null }),
                  'function' == typeof document.removeEventListener
                    ? (document.removeEventListener('mouseup', this.endSlide, !1),
                      document.removeEventListener('touchend', this.endSlide, !1),
                      document.removeEventListener('touchmove', this.handleTouchSlide, !1),
                      document.removeEventListener('mousemove', this.handleMouseSlide, !1))
                    : (document.detachEvent('onmousemove', this.handleMouseSlide),
                      document.detachEvent('onmouseup', this.endSlide)),
                  this.props.onSliderDragEnd && this.props.onSliderDragEnd(),
                  this.props.snap)
                ) {
                  var n = this.getSnapPosition(this.state.handlePos[t]);
                  this.slideTo(t, n, function () {
                    return e.fireChangeEvent();
                  });
                } else this.fireChangeEvent();
              },
            },
            {
              key: 'handleClick',
              value: function (e) {
                var t = this;
                if (!e.target.getAttribute('data-handle-key')) {
                  var n = this.getSliderBoundingBox(),
                    r =
                      'vertical' === this.props.orientation
                        ? (e.clientY - n.top) / n.height
                        : (e.clientX - n.left) / n.width,
                    i = 100 * r,
                    o = this.getClosestHandle(i),
                    a = this.getSnapPosition(i);
                  this.slideTo(o, a, function () {
                    return t.fireChangeEvent();
                  }),
                    this.props.onClick && this.props.onClick();
                }
              },
            },
            {
              key: 'handleKeydown',
              value: function (e) {
                var t = this,
                  n = v(e);
                if (e.keyCode === O.ESC) return void e.currentTarget.blur();
                var r = this.getNextPositionForKey(n, e.keyCode);
                null !== r &&
                  (this.canMove(n, r) &&
                    (this.slideTo(n, r, function () {
                      return t.fireChangeEvent();
                    }),
                    this.props.onKeyPress && this.props.onKeyPress()),
                  y(e));
              },
            },
            {
              key: 'validatePosition',
              value: function (e, t) {
                var n = this.state,
                  r = n.handlePos,
                  i = n.handleDimensions;
                return Math.max(
                  Math.min(t, void 0 !== r[e + 1] ? r[e + 1] - i : 100),
                  void 0 !== r[e - 1] ? r[e - 1] + i : 0
                );
              },
            },
            {
              key: 'validateValues',
              value: function (e, t) {
                var n = t || this.props,
                  r = n.max,
                  i = n.min;
                return e.map(function (e, t, n) {
                  var o = Math.max(Math.min(e, r), i);
                  return n.length && o < n[t - 1] ? n[t - 1] : o;
                });
              },
            },
            {
              key: 'canMove',
              value: function (e, t) {
                var n = this.state,
                  r = n.handlePos,
                  i = n.handleDimensions;
                return !(
                  t < 0 ||
                  t > 100 ||
                  t > (void 0 !== r[e + 1] ? r[e + 1] - i : 1 / 0) ||
                  t < (void 0 !== r[e - 1] ? r[e - 1] + i : -1 / 0)
                );
              },
            },
            {
              key: 'fireChangeEvent',
              value: function () {
                var e = this.props.onChange;
                e && e(this.getPublicState());
              },
            },
            {
              key: 'slideTo',
              value: function (e, t, n) {
                var r = this,
                  i = this.getNextState(e, t);
                this.setState(i, function () {
                  var e = r.props.onValuesUpdated;
                  e && e(r.getPublicState()), n && n();
                });
              },
            },
            {
              key: 'updateNewValues',
              value: function (e) {
                var t = this;
                if (null === this.state.slidingIndex) {
                  var n = e.max,
                    r = e.min,
                    i = e.values,
                    o = this.validateValues(i, e);
                  this.setState(
                    {
                      handlePos: o.map(function (e) {
                        return p(e, r, n);
                      }),
                      values: o,
                    },
                    function () {
                      return t.fireChangeEvent();
                    }
                  );
                }
              },
            },
            {
              key: 'render',
              value: function () {
                var e = this,
                  t = this.props,
                  n = t.children,
                  r = t.disabled,
                  i = t.handle,
                  o = t.max,
                  a = t.min,
                  s = t.orientation,
                  c = t.pitComponent,
                  u = t.pitPoints,
                  l = t.progressBar,
                  f = this.state,
                  h = f.className,
                  d = f.handlePos,
                  m = f.values;
                return (0, _.h)(
                  'div',
                  {
                    className: h,
                    ref: function (t) {
                      e.rheostat = t;
                    },
                    onClick: !r && this.handleClick,
                    style: { position: 'relative' },
                  },
                  j,
                  d.map(function (t, n) {
                    var o =
                      'vertical' === s
                        ? { top: ''.concat(t, '%'), position: 'absolute' }
                        : { left: ''.concat(t, '%'), position: 'absolute' };
                    return (0,
                    _.h)(i, { 'aria-valuemax': e.getMaxValue(n), 'aria-valuemin': e.getMinValue(n), 'aria-valuenow': m[n], 'aria-disabled': r, 'data-handle-key': n, className: 'rheostat-handle', key: 'handle-'.concat(n), onClick: e.killEvent, onKeyDown: !r && e.handleKeydown, onMouseDown: !r && e.startMouseSlide, onTouchStart: !r && e.startTouchSlide, role: 'slider', style: o, tabIndex: 0 });
                  }),
                  d.map(function (t, n, r) {
                    return 0 === n && r.length > 1
                      ? null
                      : (0, _.h)(l, {
                          className: 'rheostat-progress',
                          key: 'progress-bar-'.concat(n),
                          style: e.getProgressStyle(n),
                        });
                  }),
                  c &&
                    u.map(function (e) {
                      var t = p(e, a, o),
                        n =
                          'vertical' === s
                            ? { top: ''.concat(t, '%'), position: 'absolute' }
                            : { left: ''.concat(t, '%'), position: 'absolute' };
                      return (0, _.h)(c, { key: 'pit-'.concat(e), style: n }, e);
                    }),
                  n
                );
              },
            },
          ]),
          t
        );
      })(_.Component);
    r(S, 'defaultProps', {
      className: '',
      children: null,
      disabled: !1,
      handle: P,
      max: 100,
      min: 0,
      onClick: null,
      onChange: null,
      onKeyPress: null,
      onSliderDragEnd: null,
      onSliderDragMove: null,
      onSliderDragStart: null,
      onValuesUpdated: null,
      orientation: 'horizontal',
      pitComponent: null,
      pitPoints: [],
      progressBar: 'div',
      snap: !1,
      snapPoints: [],
      values: [0],
    });
    var x = S;
    t.default = x;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var a = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var s = n(3),
      c = a(n(4)),
      u = function (e) {
        var t = e.style,
          n = e.children,
          r = Math.round(parseFloat(t.left)),
          o = [0, 50, 100].includes(r),
          a = Array.isArray(n) ? n[0] : n,
          u = Math.round(100 * parseInt(a, 10)) / 100;
        return (0, s.h)(
          'div',
          {
            style: i({}, t, { marginLeft: 100 === r ? '-2px' : 0 }),
            className: (0, c.default)('rheostat-marker', 'rheostat-marker-horizontal', { 'rheostat-marker-large': o }),
          },
          o && (0, s.h)('div', { className: 'rheostat-value' }, u)
        );
      },
      l = u;
    t.default = l;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      return u(e) || c(e, t) || s();
    }
    function s() {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
    function c(e, t) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e)) {
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t);
            r = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }
    }
    function u(e) {
      if (Array.isArray(e)) return e;
    }
    function l(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : f.noop;
      return (
        (0, f.checkRendering)(e, h()),
        function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.attribute,
            s = n.min,
            c = n.max,
            u = n.precision,
            l = void 0 === u ? 0 : u,
            p = (0, f.isFiniteNumber)(s),
            m = (0, f.isFiniteNumber)(c);
          if (!r) throw new Error(h('The `attribute` option is required.'));
          if (p && m && s > c) throw new Error(h("The `max` option can't be lower than `min`."));
          var g = function (e) {
              return Number(Number(e).toFixed(l));
            },
            v = {
              from: function (e) {
                return e;
              },
              to: function (e) {
                return g(e).toLocaleString();
              },
            },
            y = function (e, t, n, i) {
              var o,
                u = e.state,
                l = t.min,
                h = t.max,
                d = u.getNumericRefinement(r, '>=') || [],
                v = a(d, 1),
                y = v[0],
                b = u.getNumericRefinement(r, '<=') || [],
                w = a(b, 1),
                _ = w[0],
                O = void 0 === n || '' === n,
                P = void 0 === i || '' === i,
                j = O ? void 0 : parseFloat(n),
                S = P ? void 0 : parseFloat(i);
              o = p || l !== j ? (p && O ? s : j) : void 0;
              var x;
              x = m || h !== S ? (m && P ? c : S) : void 0;
              var R = void 0 === o,
                E = (0, f.isFiniteNumber)(o),
                T = (0, f.isFiniteNumber)(l),
                C = T && l <= o,
                N = R || (E && (!T || C)),
                k = void 0 === x,
                F = (0, f.isFiniteNumber)(x),
                A = (0, f.isFiniteNumber)(h),
                I = A && h >= x,
                D = k || (F && (!A || I)),
                M = y !== o,
                L = _ !== x;
              return (M || L) && N && D
                ? ((u = u.removeNumericRefinement(r)),
                  E && (u = u.addNumericRefinement(r, '>=', g(o))),
                  F && (u = u.addNumericRefinement(r, '<=', g(x))),
                  u)
                : null;
            },
            b = function (e, t, n) {
              var i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 'Filter Applied',
                o = (0, f.convertNumericRefinementsToFilters)(e, r);
              o &&
                o.length > 0 &&
                t.sendEventToInsights({
                  insightsMethod: 'clickedFilters',
                  widgetType: d,
                  eventType: 'click',
                  payload: { eventName: i, index: n.getIndex(), filters: o },
                });
            },
            w = function (e, t, n) {
              return function () {
                for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++) i[o] = arguments[o];
                if (1 === i.length) return void e.sendEventToInsights(i[0]);
                var s = i[0],
                  c = i[1],
                  u = i[2];
                if ('click' === s) {
                  var l = a(c, 2),
                    f = l[0],
                    h = l[1],
                    d = y(t, n, f, h);
                  b(d, e, t, u);
                }
              };
            };
          return {
            $$type: d,
            _getCurrentRange: function (e) {
              var t,
                n = Math.pow(10, l);
              t = p ? s : (0, f.isFiniteNumber)(e.min) ? e.min : 0;
              var r;
              return (
                (r = m ? c : (0, f.isFiniteNumber)(e.max) ? e.max : 0),
                { min: Math.floor(t * n) / n, max: Math.ceil(r * n) / n }
              );
            },
            _getCurrentRefinement: function (e) {
              var t = e.getNumericRefinement(r, '>=') || [],
                n = a(t, 1),
                i = n[0],
                o = e.getNumericRefinement(r, '<=') || [],
                s = a(o, 1),
                c = s[0];
              return [(0, f.isFiniteNumber)(i) ? i : -1 / 0, (0, f.isFiniteNumber)(c) ? c : 1 / 0];
            },
            _refine: function (e, t, n) {
              return function () {
                var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                  i = a(r, 2),
                  o = i[0],
                  s = i[1],
                  c = y(t, n, o, s);
                c && (b(c, e, t), t.setState(c).search());
              };
            },
            init: function (t) {
              var r = t.helper,
                o = t.instantSearchInstance,
                a = {},
                s = this._getCurrentRange(a),
                c = this._getCurrentRefinement(r);
              e(
                {
                  refine: this._refine(o, r, {}),
                  sendEvent: w(o, r, {}),
                  format: v,
                  range: s,
                  widgetParams: i({}, n, { precision: l }),
                  start: c,
                  instantSearchInstance: o,
                },
                !0
              );
            },
            render: function (t) {
              var o = t.results,
                a = t.helper,
                s = t.instantSearchInstance,
                c = o.disjunctiveFacets || [],
                u = (0, f.find)(c, function (e) {
                  return e.name === r;
                }),
                h = (u && u.stats) || {},
                d = this._getCurrentRange(h),
                p = this._getCurrentRefinement(a);
              e(
                {
                  refine: this._refine(s, a, d),
                  sendEvent: w(s, a, d),
                  format: v,
                  range: d,
                  widgetParams: i({}, n, { precision: l }),
                  start: p,
                  instantSearchInstance: s,
                },
                !1
              );
            },
            dispose: function (e) {
              var n = e.state;
              t();
              var a = n.removeDisjunctiveFacet(r);
              return (a.numericRefinements = i({}, n.numericRefinements, o({}, r, void 0))), a;
            },
            getWidgetState: function (e, t) {
              var n = t.searchParameters,
                a = n.getNumericRefinements(r),
                s = a['>='],
                c = void 0 === s ? [] : s,
                u = a['<='],
                l = void 0 === u ? [] : u;
              return 0 === c.length && 0 === l.length
                ? e
                : i({}, e, { range: i({}, e.range, o({}, r, ''.concat(c, ':').concat(l))) });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                u = e
                  .addDisjunctiveFacet(r)
                  .setQueryParameters({ numericRefinements: i({}, e.numericRefinements, o({}, r, {})) });
              p && (u = u.addNumericRefinement(r, '>=', s)), m && (u = u.addNumericRefinement(r, '<=', c));
              var l = n.range && n.range[r];
              if (!l || -1 === l.indexOf(':')) return u;
              var h = l.split(':').map(parseFloat),
                d = a(h, 2),
                g = d[0],
                v = d[1];
              return (
                (0, f.isFiniteNumber)(g) && (u = u.addNumericRefinement(r, '>=', g)),
                (0, f.isFiniteNumber)(v) && (u = u.addNumericRefinement(r, '<=', v)),
                u
              );
            },
          };
        }
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = l);
    var f = n(1),
      h = (0, f.createDocumentationMessageGenerator)(
        { name: 'range-input', connector: !0 },
        { name: 'range-slider', connector: !0 }
      ),
      d = 'ais.range';
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      var t = e.container,
        n = e.attribute,
        r = e.sortBy,
        i = e.limit,
        o = e.showMore,
        a = e.showMoreLimit,
        s = e.cssClasses,
        l = void 0 === s ? {} : s,
        p = e.templates,
        y = void 0 === p ? h.default : p,
        b = e.transformItems;
      if (!t) throw new Error(m('The `container` option is required.'));
      var w = (0, d.getContainerNode)(t),
        _ = {
          root: (0, u.default)(g(), l.root),
          noRefinementRoot: (0, u.default)(g({ modifierName: 'noRefinement' }), l.noRefinementRoot),
          list: (0, u.default)(g({ descendantName: 'list' }), l.list),
          item: (0, u.default)(g({ descendantName: 'item' }), l.item),
          selectedItem: (0, u.default)(g({ descendantName: 'item', modifierName: 'selected' }), l.selectedItem),
          link: (0, u.default)(g({ descendantName: 'link' }), l.link),
          label: (0, u.default)(g({ descendantName: 'label' }), l.label),
          count: (0, u.default)(g({ descendantName: 'count' }), l.count),
          showMore: (0, u.default)(g({ descendantName: 'showMore' }), l.showMore),
          disabledShowMore: (0, u.default)(
            g({ descendantName: 'showMore', modifierName: 'disabled' }),
            l.disabledShowMore
          ),
        },
        O = v({ containerNode: w, cssClasses: _, renderState: {}, templates: y, showMore: o });
      return (0, f.default)(O, function () {
        return (0, c.render)(null, w);
      })({ attribute: n, limit: i, showMore: o, showMoreLimit: a, sortBy: r, transformItems: b });
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var c = n(3),
      u = s(n(4)),
      l = s(n(59)),
      f = s(n(164)),
      h = s(n(165)),
      d = n(1),
      p = n(5),
      m = (0, d.createDocumentationMessageGenerator)({ name: 'menu' }),
      g = (0, p.component)('Menu'),
      v = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.renderState,
          o = e.templates,
          a = e.showMore;
        return function (e, s) {
          var u = e.refine,
            f = e.items,
            p = e.createURL,
            m = e.instantSearchInstance,
            g = e.isShowingMore,
            v = e.toggleShowMore,
            y = e.canToggleShowMore;
          if (s)
            return void (r.templateProps = (0, d.prepareTemplateProps)({
              defaultTemplates: h.default,
              templatesConfig: m.templatesConfig,
              templates: o,
            }));
          var b = f.map(function (e) {
            return i({}, e, { url: p(e.name) });
          });
          (0, c.render)(
            (0, c.h)(l.default, {
              createURL: p,
              cssClasses: n,
              facetValues: b,
              showMore: a,
              templateProps: r.templateProps,
              toggleRefinement: u,
              toggleShowMore: v,
              isShowingMore: g,
              canToggleShowMore: y,
            }),
            t
          );
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r() {
      return (
        (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        r.apply(this, arguments)
      );
    }
    function i(e) {
      var t = e.className,
        n = e.handleClick,
        i = e.facetValueToRefine,
        o = e.isRefined,
        c = e.templateProps,
        u = e.templateKey,
        l = e.templateData,
        f = e.subItems;
      return (0, a.h)(
        'li',
        {
          className: t,
          onClick: function (e) {
            n({ facetValueToRefine: i, isRefined: o, originalEvent: e });
          },
        },
        (0, a.h)(s.default, r({}, c, { templateKey: u, data: l })),
        f
      );
    }
    var o = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var a = n(3),
      s = o(n(8)),
      c = i;
    t.default = c;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++)
          (n = o[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function c(e, t) {
      return f(e) || l(e, t) || u();
    }
    function u() {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
    function l(e, t) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e)) {
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t);
            r = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }
    }
    function f(e) {
      if (Array.isArray(e)) return e;
    }
    function h(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : d.noop;
      return (
        (0, d.checkRendering)(e, p()),
        function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.attribute,
            s = n.limit,
            u = void 0 === s ? 10 : s,
            l = n.showMore,
            f = void 0 !== l && l,
            h = n.showMoreLimit,
            m = void 0 === h ? 20 : h,
            g = n.sortBy,
            v = void 0 === g ? ['isRefined', 'name:asc'] : g,
            y = n.transformItems,
            b =
              void 0 === y
                ? function (e) {
                    return e;
                  }
                : y;
          if (!r) throw new Error(p('The `attribute` option is required.'));
          if (!0 === f && m <= u) throw new Error(p('The `showMoreLimit` option must be greater than `limit`.'));
          var w;
          return {
            $$type: 'ais.menu',
            isShowingMore: !1,
            toggleShowMore: function () {},
            cachedToggleShowMore: function () {
              this.toggleShowMore();
            },
            createToggleShowMore: function (e) {
              var t = this,
                n = e.results,
                r = e.instantSearchInstance;
              return function () {
                (t.isShowingMore = !t.isShowingMore), t.render({ results: n, instantSearchInstance: r });
              };
            },
            getLimit: function () {
              return this.isShowingMore ? m : u;
            },
            refine: function (e) {
              return function (t) {
                var n = e.getHierarchicalFacetBreadcrumb(r),
                  i = c(n, 1),
                  o = i[0];
                w('click', t || o), e.toggleRefinement(r, t || o).search();
              };
            },
            init: function (t) {
              var i = t.helper,
                o = t.createURL,
                a = t.instantSearchInstance;
              (w = (0, d.createSendEventForFacet)({
                instantSearchInstance: a,
                helper: i,
                attribute: r,
                widgetType: this.$$type,
              })),
                (this.cachedToggleShowMore = this.cachedToggleShowMore.bind(this)),
                (this._createURL = function (e) {
                  return o(i.state.toggleRefinement(r, e));
                }),
                (this._refine = this.refine(i)),
                e(
                  {
                    items: [],
                    createURL: this._createURL,
                    refine: this._refine,
                    sendEvent: w,
                    instantSearchInstance: a,
                    canRefine: !1,
                    widgetParams: n,
                    isShowingMore: this.isShowingMore,
                    toggleShowMore: this.cachedToggleShowMore,
                    canToggleShowMore: !1,
                  },
                  !0
                );
            },
            render: function (t) {
              var o = t.results,
                s = t.instantSearchInstance,
                c = o.getFacetValues(r, { sortBy: v }),
                u = c && c.data ? c.data : [],
                l = b(
                  u.slice(0, this.getLimit()).map(function (e) {
                    var t = e.name,
                      n = e.path;
                    return i({}, a(e, ['name', 'path']), { label: t, value: n });
                  })
                );
              (this.toggleShowMore = this.createToggleShowMore({ results: o, instantSearchInstance: s })),
                e(
                  {
                    items: l,
                    createURL: this._createURL,
                    refine: this._refine,
                    sendEvent: w,
                    instantSearchInstance: s,
                    canRefine: l.length > 0,
                    widgetParams: n,
                    isShowingMore: this.isShowingMore,
                    toggleShowMore: this.cachedToggleShowMore,
                    canToggleShowMore: f && (this.isShowingMore || u.length > this.getLimit()),
                  },
                  !1
                );
            },
            dispose: function (e) {
              var n = e.state;
              return t(), n.removeHierarchicalFacet(r).setQueryParameter('maxValuesPerFacet', void 0);
            },
            getWidgetState: function (e, t) {
              var n = t.searchParameters,
                a = n.getHierarchicalFacetBreadcrumb(r),
                s = c(a, 1),
                u = s[0];
              return u ? i({}, e, { menu: i({}, e.menu, o({}, r, u)) }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                a = n.menu && n.menu[r],
                s = e.removeHierarchicalFacet(r).addHierarchicalFacet({ name: r, attributes: [r] }),
                c = s.maxValuesPerFacet || 0,
                l = Math.max(c, f ? m : u),
                h = s.setQueryParameter('maxValuesPerFacet', l);
              return a
                ? h.addHierarchicalFacetRefinement(r, a)
                : h.setQueryParameters({
                    hierarchicalFacetsRefinements: i({}, h.hierarchicalFacetsRefinements, o({}, r, [])),
                  });
            },
          };
        }
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = h);
    var d = n(1),
      p = (0, d.createDocumentationMessageGenerator)({ name: 'menu', connector: !0 });
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = {
      item: '<a class="{{cssClasses.link}}" href="{{url}}"><span class="{{cssClasses.label}}">{{label}}</span><span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
      showMoreText:
        '\n    {{#isShowingMore}}\n      Show less\n    {{/isShowingMore}}\n    {{^isShowingMore}}\n      Show more\n    {{/isShowingMore}}\n  ',
    };
    t.default = r;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (null == e) return {};
      var n,
        r,
        o = i(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (r = 0; r < a.length; r++)
          (n = a[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]));
      }
      return o;
    }
    function i(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function o(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function a(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? o(Object(n), !0).forEach(function (t) {
              s(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : o(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function s(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function c(e) {
      var t = a({}, e, {
        submit: e.searchableSubmit,
        reset: e.searchableReset,
        loadingIndicator: e.searchableLoadingIndicator,
      });
      return (
        t.searchableReset,
        t.searchableSubmit,
        t.searchableLoadingIndicator,
        r(t, ['searchableReset', 'searchableSubmit', 'searchableLoadingIndicator'])
      );
    }
    function u() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.container,
        n = e.attribute,
        r = e.operator,
        i = e.sortBy,
        o = e.limit,
        s = e.showMore,
        u = e.showMoreLimit,
        l = e.searchable,
        d = void 0 !== l && l,
        v = e.searchablePlaceholder,
        O = void 0 === v ? 'Search...' : v,
        P = e.searchableEscapeFacetValues,
        j = void 0 === P || P,
        S = e.searchableIsAlwaysActive,
        x = void 0 === S || S,
        R = e.cssClasses,
        E = void 0 === R ? {} : R,
        T = e.templates,
        C = void 0 === T ? m.default : T,
        N = e.transformItems;
      if (!t) throw new Error(y('The `container` option is required.'));
      var k = !!d && Boolean(j),
        F = (0, g.getContainerNode)(t),
        A = c(a({}, m.default, {}, C)),
        I = {
          root: (0, h.default)(b(), E.root),
          noRefinementRoot: (0, h.default)(b({ modifierName: 'noRefinement' }), E.noRefinementRoot),
          list: (0, h.default)(b({ descendantName: 'list' }), E.list),
          item: (0, h.default)(b({ descendantName: 'item' }), E.item),
          selectedItem: (0, h.default)(b({ descendantName: 'item', modifierName: 'selected' }), E.selectedItem),
          searchBox: (0, h.default)(b({ descendantName: 'searchBox' }), E.searchBox),
          label: (0, h.default)(b({ descendantName: 'label' }), E.label),
          checkbox: (0, h.default)(b({ descendantName: 'checkbox' }), E.checkbox),
          labelText: (0, h.default)(b({ descendantName: 'labelText' }), E.labelText),
          count: (0, h.default)(b({ descendantName: 'count' }), E.count),
          noResults: (0, h.default)(b({ descendantName: 'noResults' }), E.noResults),
          showMore: (0, h.default)(b({ descendantName: 'showMore' }), E.showMore),
          disabledShowMore: (0, h.default)(
            b({ descendantName: 'showMore', modifierName: 'disabled' }),
            E.disabledShowMore
          ),
          searchable: {
            root: (0, h.default)(w(), E.searchableRoot),
            form: (0, h.default)(w({ descendantName: 'form' }), E.searchableForm),
            input: (0, h.default)(w({ descendantName: 'input' }), E.searchableInput),
            submit: (0, h.default)(w({ descendantName: 'submit' }), E.searchableSubmit),
            submitIcon: (0, h.default)(w({ descendantName: 'submitIcon' }), E.searchableSubmitIcon),
            reset: (0, h.default)(w({ descendantName: 'reset' }), E.searchableReset),
            resetIcon: (0, h.default)(w({ descendantName: 'resetIcon' }), E.searchableResetIcon),
            loadingIndicator: (0, h.default)(w({ descendantName: 'loadingIndicator' }), E.searchableLoadingIndicator),
            loadingIcon: (0, h.default)(w({ descendantName: 'loadingIcon' }), E.searchableLoadingIcon),
          },
        },
        D = _({
          containerNode: F,
          cssClasses: I,
          templates: A,
          renderState: {},
          searchable: d,
          searchablePlaceholder: O,
          searchableIsAlwaysActive: x,
          showMore: s,
        });
      return (0, p.default)(D, function () {
        return (0, f.render)(null, F);
      })({
        attribute: n,
        operator: r,
        limit: o,
        showMore: s,
        showMoreLimit: u,
        sortBy: i,
        escapeFacetValues: k,
        transformItems: N,
      });
    }
    var l = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = u);
    var f = n(3),
      h = l(n(4)),
      d = l(n(59)),
      p = l(n(167)),
      m = l(n(168)),
      g = n(1),
      v = n(5),
      y = (0, g.createDocumentationMessageGenerator)({ name: 'refinement-list' }),
      b = (0, v.component)('RefinementList'),
      w = (0, v.component)('SearchBox'),
      _ = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.templates,
          i = e.renderState,
          o = e.showMore,
          a = e.searchable,
          s = e.searchablePlaceholder,
          c = e.searchableIsAlwaysActive;
        return function (e, u) {
          var l = e.refine,
            h = e.items,
            p = e.createURL,
            m = e.searchForItems,
            v = e.isFromSearch,
            y = e.instantSearchInstance,
            b = e.toggleShowMore,
            w = e.isShowingMore,
            _ = e.hasExhaustiveItems,
            O = e.canToggleShowMore;
          if (u)
            return void (i.templateProps = (0, g.prepareTemplateProps)({
              templatesConfig: y.templatesConfig,
              templates: r,
            }));
          (0, f.render)(
            (0, f.h)(d.default, {
              createURL: p,
              cssClasses: n,
              facetValues: h,
              templateProps: i.templateProps,
              toggleRefinement: l,
              searchFacetValues: a ? m : void 0,
              searchPlaceholder: s,
              searchIsAlwaysActive: c,
              isFromSearch: v,
              showMore: o && !v && h.length > 0,
              toggleShowMore: b,
              isShowingMore: w,
              hasExhaustiveItems: _,
              canToggleShowMore: O,
            }),
            t
          );
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = s(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (r = 0; r < o.length; r++)
          (n = o[r]), t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]));
      }
      return i;
    }
    function s(e, t) {
      if (null == e) return {};
      var n,
        r,
        i = {},
        o = Object.keys(e);
      for (r = 0; r < o.length; r++) (n = o[r]), t.indexOf(n) >= 0 || (i[n] = e[n]);
      return i;
    }
    function c(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u.noop;
      return (
        (0, u.checkRendering)(e, f()),
        function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.attribute,
            s = n.operator,
            c = void 0 === s ? 'or' : s,
            h = n.limit,
            d = void 0 === h ? 10 : h,
            p = n.showMore,
            m = void 0 !== p && p,
            g = n.showMoreLimit,
            v = void 0 === g ? 20 : g,
            y = n.sortBy,
            b = void 0 === y ? ['isRefined', 'count:desc', 'name:asc'] : y,
            w = n.escapeFacetValues,
            _ = void 0 === w || w,
            O = n.transformItems,
            P =
              void 0 === O
                ? function (e) {
                    return e;
                  }
                : O;
          if (!r) throw new Error(f('The `attribute` option is required.'));
          if (!/^(and|or)$/.test(c))
            throw new Error(f('The `operator` must one of: `"and"`, `"or"` (got "'.concat(c, '").')));
          if (!0 === m && v <= d) throw new Error(f('`showMoreLimit` should be greater than `limit`.'));
          var j,
            S,
            x,
            R = function (e) {
              var t = e.name;
              return i({}, a(e, ['name']), { label: t, value: t, highlighted: t });
            },
            E = function (e) {
              return e ? v : d;
            },
            T = [],
            C = !0,
            N = function (t) {
              var i = t.items,
                o = t.state,
                a = t.createURL,
                s = t.helperSpecializedSearchFacetValues,
                c = t.refine,
                u = t.isFromSearch,
                l = t.isFirstSearch,
                f = t.isShowingMore,
                h = t.toggleShowMore,
                p = t.instantSearchInstance,
                g = function (e) {
                  return a(o.toggleRefinement(r, e));
                },
                v = s && s(o, a, s, c, p, f),
                y = f && T.length > d,
                b = m && !u && !C,
                w = y || b;
              e(
                {
                  createURL: g,
                  items: i,
                  refine: c,
                  searchForItems: v,
                  instantSearchInstance: p,
                  isFromSearch: u,
                  canRefine: u || i.length > 0,
                  widgetParams: n,
                  isShowingMore: f,
                  canToggleShowMore: w,
                  toggleShowMore: h,
                  hasExhaustiveItems: C,
                },
                l
              );
            },
            k = function (e, t) {
              return function (n, o, s, c, u, f) {
                return function (h) {
                  if ('' === h && T)
                    N({
                      items: T,
                      state: n,
                      createURL: o,
                      helperSpecializedSearchFacetValues: s,
                      refine: c,
                      isFromSearch: !1,
                      isFirstSearch: !1,
                      instantSearchInstance: u,
                      toggleShowMore: t,
                      isShowingMore: f,
                    });
                  else {
                    var d = {
                      highlightPreTag: _ ? l.TAG_PLACEHOLDER.highlightPreTag : l.TAG_REPLACEMENT.highlightPreTag,
                      highlightPostTag: _ ? l.TAG_PLACEHOLDER.highlightPostTag : l.TAG_REPLACEMENT.highlightPostTag,
                    };
                    e.searchForFacetValues(r, h, E(f), d).then(function (e) {
                      var t = _ ? (0, l.escapeFacets)(e.facetHits) : e.facetHits,
                        r = P(
                          t.map(function (e) {
                            var t = e.value;
                            return i({}, a(e, ['value']), { value: t, label: t });
                          })
                        );
                      N({
                        items: r,
                        state: n,
                        createURL: o,
                        helperSpecializedSearchFacetValues: s,
                        refine: c,
                        isFromSearch: !0,
                        isFirstSearch: !1,
                        instantSearchInstance: u,
                        isShowingMore: f,
                      });
                    });
                  }
                };
              };
            };
          return {
            $$type: 'ais.refinementList',
            isShowingMore: !1,
            toggleShowMore: function () {},
            cachedToggleShowMore: function () {
              this.toggleShowMore();
            },
            createToggleShowMore: function (e) {
              var t = this;
              return function () {
                (t.isShowingMore = !t.isShowingMore), t.render(e);
              };
            },
            getLimit: function () {
              return E(this.isShowingMore);
            },
            init: function (e) {
              var t = e.helper,
                n = e.createURL,
                i = e.instantSearchInstance;
              (this.cachedToggleShowMore = this.cachedToggleShowMore.bind(this)),
                (x = (0, u.createSendEventForFacet)({
                  instantSearchInstance: i,
                  helper: t,
                  attribute: r,
                  widgetType: this.$$type,
                })),
                (S = function (e) {
                  x('click', e), t.toggleRefinement(r, e).search();
                }),
                (j = k(t, this.cachedToggleShowMore)),
                N({
                  items: [],
                  state: t.state,
                  createURL: n,
                  helperSpecializedSearchFacetValues: j,
                  refine: S,
                  isFromSearch: !1,
                  isFirstSearch: !0,
                  instantSearchInstance: i,
                  isShowingMore: this.isShowingMore,
                  toggleShowMore: this.cachedToggleShowMore,
                  sendEvent: x,
                });
            },
            render: function (e) {
              var t = e.results,
                n = e.state,
                i = e.createURL,
                o = e.instantSearchInstance,
                a = t.getFacetValues(r, { sortBy: b }) || [],
                s = P(a.slice(0, this.getLimit()).map(R)),
                c = n.maxValuesPerFacet,
                u = this.getLimit();
              (C = c > u ? a.length <= u : a.length < u),
                (T = s),
                (this.toggleShowMore = this.createToggleShowMore(e)),
                N({
                  items: s,
                  state: n,
                  createURL: i,
                  helperSpecializedSearchFacetValues: j,
                  refine: S,
                  isFromSearch: !1,
                  isFirstSearch: !1,
                  instantSearchInstance: o,
                  isShowingMore: this.isShowingMore,
                  toggleShowMore: this.cachedToggleShowMore,
                  sendEvent: x,
                });
            },
            dispose: function (e) {
              var n = e.state;
              t();
              var i = n.setQueryParameter('maxValuesPerFacet', void 0);
              return 'and' === c ? i.removeFacet(r) : i.removeDisjunctiveFacet(r);
            },
            getWidgetState: function (e, t) {
              var n = t.searchParameters,
                a = 'or' === c ? n.getDisjunctiveRefinements(r) : n.getConjunctiveRefinements(r);
              return a.length ? i({}, e, { refinementList: i({}, e.refinementList, o({}, r, a)) }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                a = 'or' === c,
                s = n.refinementList && n.refinementList[r],
                u = e.clearRefinements(r),
                l = a ? u.addDisjunctiveFacet(r) : u.addFacet(r),
                f = l.maxValuesPerFacet || 0,
                h = Math.max(f, m ? v : d),
                p = l.setQueryParameter('maxValuesPerFacet', h);
              if (!s) {
                var g = a ? 'disjunctiveFacetsRefinements' : 'facetsRefinements';
                return p.setQueryParameters(o({}, g, i({}, p[g], o({}, r, []))));
              }
              return s.reduce(function (e, t) {
                return a ? e.addDisjunctiveFacetRefinement(r, t) : e.addFacetRefinement(r, t);
              }, p);
            },
          };
        }
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = c);
    var u = n(1),
      l = n(14),
      f = (0, u.createDocumentationMessageGenerator)({ name: 'refinement-list', connector: !0 });
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r(n(61)),
      o = {
        item: '<label class="{{cssClasses.label}}">\n  <input type="checkbox"\n         class="{{cssClasses.checkbox}}"\n         value="{{value}}"\n         {{#isRefined}}checked{{/isRefined}} />\n  <span class="{{cssClasses.labelText}}">{{#isFromSearch}}{{{highlighted}}}{{/isFromSearch}}{{^isFromSearch}}{{highlighted}}{{/isFromSearch}}</span>\n  <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span>\n</label>',
        showMoreText:
          '\n    {{#isShowingMore}}\n      Show less\n    {{/isShowingMore}}\n    {{^isShowingMore}}\n      Show more\n    {{/isShowingMore}}\n    ',
        searchableNoResults: 'No results',
        searchableReset: i.default.reset,
        searchableSubmit: i.default.submit,
        searchableLoadingIndicator: i.default.loadingIndicator,
      };
    t.default = o;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.container,
        n = e.placeholder,
        r = void 0 === n ? '' : n,
        o = e.cssClasses,
        a = void 0 === o ? {} : o,
        s = e.autofocus,
        f = void 0 !== s && s,
        d = e.searchAsYouType,
        y = void 0 === d || d,
        b = e.showReset,
        w = void 0 === b || b,
        _ = e.showSubmit,
        O = void 0 === _ || _,
        P = e.showLoadingIndicator,
        j = void 0 === P || P,
        S = e.queryHook,
        x = e.templates;
      if (!t) throw new Error(m('The `container` option is required.'));
      var R = (0, l.getContainerNode)(t),
        E = {
          root: (0, u.default)(g(), a.root),
          form: (0, u.default)(g({ descendantName: 'form' }), a.form),
          input: (0, u.default)(g({ descendantName: 'input' }), a.input),
          submit: (0, u.default)(g({ descendantName: 'submit' }), a.submit),
          submitIcon: (0, u.default)(g({ descendantName: 'submitIcon' }), a.submitIcon),
          reset: (0, u.default)(g({ descendantName: 'reset' }), a.reset),
          resetIcon: (0, u.default)(g({ descendantName: 'resetIcon' }), a.resetIcon),
          loadingIndicator: (0, u.default)(g({ descendantName: 'loadingIndicator' }), a.loadingIndicator),
          loadingIcon: (0, u.default)(g({ descendantName: 'loadingIcon' }), a.loadingIcon),
        },
        T = v({
          containerNode: R,
          cssClasses: E,
          placeholder: r,
          templates: i({}, p.default, {}, x),
          autofocus: f,
          searchAsYouType: y,
          showReset: w,
          showSubmit: O,
          showLoadingIndicator: j,
        });
      return (0, h.default)(T, function () {
        return (0, c.render)(null, R);
      })({ queryHook: S });
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var c = n(3),
      u = s(n(4)),
      l = n(1),
      f = n(5),
      h = s(n(170)),
      d = s(n(60)),
      p = s(n(61)),
      m = (0, l.createDocumentationMessageGenerator)({ name: 'search-box' }),
      g = (0, f.component)('SearchBox'),
      v = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.placeholder,
          i = e.templates,
          o = e.autofocus,
          a = e.searchAsYouType,
          s = e.showReset,
          u = e.showSubmit,
          l = e.showLoadingIndicator;
        return function (e) {
          var f = e.refine,
            h = e.query,
            p = e.isSearchStalled;
          (0, c.render)(
            (0, c.h)(d.default, {
              query: h,
              placeholder: r,
              autofocus: o,
              refine: f,
              searchAsYouType: a,
              templates: i,
              showSubmit: u,
              showReset: s,
              showLoadingIndicator: l,
              isSearchStalled: p,
              cssClasses: n,
            }),
            t
          );
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.noop;
      return (
        (0, s.checkRendering)(e, c()),
        function () {
          function n(e) {
            return function () {
              e.setQuery(''), e.search();
            };
          }
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = r.queryHook;
          return {
            $$type: 'ais.searchBox',
            _clear: function () {},
            _cachedClear: function () {
              this._clear();
            },
            init: function (t) {
              var i = t.helper,
                a = t.instantSearchInstance;
              (this._cachedClear = this._cachedClear.bind(this)), (this._clear = n(i));
              var s = function (e) {
                e !== i.state.query && i.setQuery(e).search();
              };
              (this._refine = function (e) {
                if (o) return void o(e, s);
                s(e);
              }),
                e(
                  {
                    query: i.state.query || '',
                    refine: this._refine,
                    clear: this._cachedClear,
                    widgetParams: r,
                    instantSearchInstance: a,
                  },
                  !0
                );
            },
            render: function (t) {
              var i = t.helper,
                o = t.instantSearchInstance,
                a = t.searchMetadata;
              (this._clear = n(i)),
                e(
                  {
                    query: i.state.query || '',
                    refine: this._refine,
                    clear: this._cachedClear,
                    widgetParams: r,
                    instantSearchInstance: o,
                    isSearchStalled: a.isSearchStalled,
                  },
                  !1
                );
            },
            dispose: function (e) {
              var n = e.state;
              return t(), n.setQueryParameter('query', void 0);
            },
            getWidgetState: function (e, t) {
              var n = t.searchParameters,
                r = n.query || '';
              return '' === r || (e && e.query === r) ? e : i({}, e, { query: r });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameter('query', n.query || '');
            },
          };
        }
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var s = n(1),
      c = (0, s.createDocumentationMessageGenerator)({ name: 'search-box', connector: !0 });
  },
  function (e, t, n) {
    'use strict';
    function r() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.container,
        n = e.cssClasses,
        r = void 0 === n ? {} : n,
        i = e.templates,
        s = void 0 === i ? u.default : i;
      if (!t) throw new Error(h('The `container` option is required.'));
      var f = (0, l.getContainerNode)(t),
        m = { root: (0, a.default)(d(), r.root), text: (0, a.default)(d({ descendantName: 'text' }), r.text) },
        g = p({ containerNode: f, cssClasses: m, renderState: {}, templates: s });
      return (0, c.default)(g, function () {
        return (0, o.render)(null, f);
      })();
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
    var o = n(3),
      a = i(n(4)),
      s = i(n(172)),
      c = i(n(173)),
      u = i(n(174)),
      l = n(1),
      f = n(5),
      h = (0, l.createDocumentationMessageGenerator)({ name: 'stats' }),
      d = (0, f.component)('Stats'),
      p = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.renderState,
          i = e.templates;
        return function (e, a) {
          var c = e.hitsPerPage,
            f = e.nbHits,
            h = e.nbPages,
            d = e.page,
            p = e.processingTimeMS,
            m = e.query,
            g = e.instantSearchInstance;
          if (a)
            return void (r.templateProps = (0, l.prepareTemplateProps)({
              defaultTemplates: u.default,
              templatesConfig: g.templatesConfig,
              templates: i,
            }));
          (0, o.render)(
            (0, o.h)(s.default, {
              cssClasses: n,
              hitsPerPage: c,
              nbHits: f,
              nbPages: h,
              page: d,
              processingTimeMS: p,
              query: m,
              templateProps: r.templateProps,
            }),
            t
          );
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r() {
      return (
        (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        r.apply(this, arguments)
      );
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var o = n(3),
      a = i(n(8)),
      s = function (e) {
        var t = e.nbHits,
          n = e.hitsPerPage,
          i = e.nbPages,
          s = e.page,
          c = e.processingTimeMS,
          u = e.query,
          l = e.templateProps,
          f = e.cssClasses;
        return (0, o.h)(
          'div',
          { className: f.root },
          (0, o.h)(
            a.default,
            r({}, l, {
              templateKey: 'text',
              rootTagName: 'span',
              rootProps: { className: f.text },
              data: {
                hasManyResults: t > 1,
                hasNoResults: 0 === t,
                hasOneResult: 1 === t,
                hitsPerPage: n,
                nbHits: t,
                nbPages: i,
                page: s,
                processingTimeMS: c,
                query: u,
                cssClasses: f,
              },
            })
          )
        );
      },
      c = s;
    t.default = c;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.noop;
      return (
        (0, i.checkRendering)(e, o()),
        function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return {
            $$type: 'ais.stats',
            init: function (t) {
              var r = t.helper,
                i = t.instantSearchInstance;
              e(
                {
                  instantSearchInstance: i,
                  hitsPerPage: r.state.hitsPerPage,
                  nbHits: 0,
                  nbPages: 0,
                  page: r.state.page || 0,
                  processingTimeMS: -1,
                  query: r.state.query || '',
                  widgetParams: n,
                },
                !0
              );
            },
            render: function (t) {
              var r = t.results,
                i = t.instantSearchInstance;
              e(
                {
                  instantSearchInstance: i,
                  hitsPerPage: r.hitsPerPage,
                  nbHits: r.nbHits,
                  nbPages: r.nbPages,
                  page: r.page,
                  processingTimeMS: r.processingTimeMS,
                  query: r.query,
                  widgetParams: n,
                },
                !1
              );
            },
            dispose: function () {
              t();
            },
          };
        }
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
    var i = n(1),
      o = (0, i.createDocumentationMessageGenerator)({ name: 'stats', connector: !0 });
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = {
      text: '{{#hasNoResults}}No results{{/hasNoResults}}\n    {{#hasOneResult}}1 result{{/hasOneResult}}\n    {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} results{{/hasManyResults}} found in {{processingTimeMS}}ms',
    };
    t.default = r;
  },
  function (e, t, n) {
    'use strict';
    function r() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.container,
        n = e.items,
        r = e.cssClasses,
        i = void 0 === r ? {} : r,
        s = e.transformItems;
      if (!t) throw new Error(f('The `container` option is required.'));
      var l = (0, u.getContainerNode)(t),
        p = {
          root: (0, a.default)(h(), i.root),
          select: (0, a.default)(h({ descendantName: 'select' }), i.select),
          option: (0, a.default)(h({ descendantName: 'option' }), i.option),
        },
        m = d({ containerNode: l, cssClasses: p });
      return (0, c.default)(m, function () {
        return (0, o.render)(null, l);
      })({ items: n, transformItems: s });
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = r);
    var o = n(3),
      a = i(n(4)),
      s = i(n(176)),
      c = i(n(177)),
      u = n(1),
      l = n(5),
      f = (0, u.createDocumentationMessageGenerator)({ name: 'sort-by' }),
      h = (0, l.component)('SortBy'),
      d = function (e) {
        var t = e.containerNode,
          n = e.cssClasses;
        return function (e, r) {
          var i = e.currentRefinement,
            a = e.options,
            c = e.refine;
          r ||
            (0, o.render)(
              (0, o.h)(
                'div',
                { className: n.root },
                (0, o.h)(s.default, { cssClasses: n, currentValue: i, options: a, setValue: c })
              ),
              t
            );
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = e.currentValue,
        n = e.options,
        r = e.cssClasses,
        i = e.setValue;
      return (0, o.h)(
        'select',
        {
          className: (0, a.default)(r.select),
          onChange: function (e) {
            return i(e.target.value);
          },
          value: ''.concat(t),
        },
        n.map(function (e) {
          return (0,
          o.h)('option', { className: (0, a.default)(r.option), key: e.label + e.value, value: ''.concat(e.value) }, e.label);
        })
      );
    }
    var i = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var o = n(3),
      a = i(n(4)),
      s = r;
    t.default = s;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : s.noop;
      return (
        (0, s.checkRendering)(e, c()),
        function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.items,
            o = n.transformItems,
            a =
              void 0 === o
                ? function (e) {
                    return e;
                  }
                : o;
          if (!Array.isArray(r)) throw new Error(c('The `items` option expects an array of objects.'));
          return {
            $$type: 'ais.sortBy',
            init: function (t) {
              var i = t.helper,
                o = t.instantSearchInstance,
                c = t.parent,
                u = i.state.index;
              (0, s.find)(r, function (e) {
                return e.value === u;
              }),
                (this.initialIndex = c.getIndexName()),
                (this.setIndex = function (e) {
                  i.setIndex(e).search();
                }),
                e(
                  {
                    currentRefinement: u,
                    options: a(r),
                    refine: this.setIndex,
                    hasNoResults: !0,
                    widgetParams: n,
                    instantSearchInstance: o,
                  },
                  !0
                );
            },
            render: function (t) {
              var i = t.helper,
                o = t.results,
                s = t.instantSearchInstance;
              e(
                {
                  currentRefinement: i.state.index,
                  options: a(r),
                  refine: this.setIndex,
                  hasNoResults: 0 === o.nbHits,
                  widgetParams: n,
                  instantSearchInstance: s,
                },
                !1
              );
            },
            dispose: function (e) {
              var n = e.state;
              return t(), n.setIndex(this.initialIndex);
            },
            getWidgetState: function (e, t) {
              var n = t.searchParameters,
                r = n.index;
              return r === this.initialIndex ? e : i({}, e, { sortBy: r });
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState;
              return e.setQueryParameter('index', n.sortBy || this.initialIndex || e.index);
            },
          };
        }
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var s = n(1),
      c = (0, s.createDocumentationMessageGenerator)({ name: 'sort-by', connector: !0 });
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = n(3),
      o = r(n(179)),
      a = r(n(4)),
      s = r(n(180)),
      c = r(n(181)),
      u = n(1),
      l = n(5),
      f = (0, u.createDocumentationMessageGenerator)({ name: 'clear-refinements' }),
      h = (0, l.component)('ClearRefinements'),
      d = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.renderState,
          a = e.templates;
        return function (e, s) {
          var l = e.refine,
            f = e.hasRefinements,
            h = e.instantSearchInstance;
          if (s)
            return void (r.templateProps = (0, u.prepareTemplateProps)({
              defaultTemplates: c.default,
              templatesConfig: h.templatesConfig,
              templates: a,
            }));
          (0, i.render)(
            (0, i.h)(o.default, { refine: l, cssClasses: n, hasRefinements: f, templateProps: r.templateProps }),
            t
          );
        };
      },
      p = function (e) {
        var t = e || {},
          n = t.container,
          r = t.templates,
          o = void 0 === r ? c.default : r,
          l = t.includedAttributes,
          p = t.excludedAttributes,
          m = t.transformItems,
          g = t.cssClasses,
          v = void 0 === g ? {} : g;
        if (!n) throw new Error(f('The `container` option is required.'));
        var y = (0, u.getContainerNode)(n),
          b = {
            root: (0, a.default)(h(), v.root),
            button: (0, a.default)(h({ descendantName: 'button' }), v.button),
            disabledButton: (0, a.default)(h({ descendantName: 'button', modifierName: 'disabled' }), v.disabledButton),
          },
          w = d({ containerNode: y, cssClasses: b, renderState: {}, templates: o });
        return (0, s.default)(w, function () {
          return (0, i.render)(null, y);
        })({ includedAttributes: l, excludedAttributes: p, transformItems: m });
      },
      m = p;
    t.default = m;
  },
  function (e, t, n) {
    'use strict';
    function r() {
      return (
        (r =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        r.apply(this, arguments)
      );
    }
    function i(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var o = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var a = n(3),
      s = o(n(4)),
      c = o(n(8)),
      u = function (e) {
        var t = e.hasRefinements,
          n = e.refine,
          o = e.cssClasses,
          u = e.templateProps;
        return (0, a.h)(
          'div',
          { className: o.root },
          (0, a.h)(
            c.default,
            r({}, u, {
              templateKey: 'resetLabel',
              rootTagName: 'button',
              rootProps: { className: (0, s.default)(o.button, i({}, o.disabledButton, !t)), onClick: n, disabled: !t },
              data: { hasRefinements: t },
            })
          )
        );
      },
      l = u;
    t.default = l;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError('Invalid attempt to spread non-iterable instance');
    }
    function o(e) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
    }
    function a(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
    }
    function s(e) {
      var t = e.scopedResult,
        n = e.includedAttributes,
        r = e.excludedAttributes,
        i = e.transformItems,
        o = -1 !== n.indexOf('query') || -1 === r.indexOf('query');
      return {
        helper: t.helper,
        items: i(
          (0, c.uniq)(
            (0, c.getRefinements)(t.results, t.helper.state, o)
              .map(function (e) {
                return e.attribute;
              })
              .filter(function (e) {
                return 0 === n.length || -1 !== n.indexOf(e);
              })
              .filter(function (e) {
                return ('query' === e && o) || -1 === r.indexOf(e);
              })
          )
        ),
      };
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var c = n(1),
      u = (0, c.createDocumentationMessageGenerator)({ name: 'clear-refinements', connector: !0 }),
      l = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.noop;
        return (
          (0, c.checkRendering)(e, u()),
          function (n) {
            var i = n || {},
              o = i.includedAttributes,
              a = void 0 === o ? [] : o,
              l = i.excludedAttributes,
              f = void 0 === l ? ['query'] : l,
              h = i.transformItems,
              d =
                void 0 === h
                  ? function (e) {
                      return e;
                    }
                  : h;
            if (n.includedAttributes && n.excludedAttributes)
              throw new Error(u('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
            var p = {
                refine: c.noop,
                createURL: function () {
                  return '';
                },
              },
              m = function () {
                return p.refine();
              },
              g = function () {
                return p.createURL();
              };
            return {
              $$type: 'ais.clearRefinements',
              init: function (t) {
                var r = t.instantSearchInstance;
                e({ hasRefinements: !1, refine: m, createURL: g, instantSearchInstance: r, widgetParams: n }, !0);
              },
              render: function (t) {
                var i = t.scopedResults,
                  o = t.createURL,
                  u = t.instantSearchInstance,
                  l = i.reduce(function (e, t) {
                    return e.concat(
                      s({ scopedResult: t, includedAttributes: a, excludedAttributes: f, transformItems: d })
                    );
                  }, []);
                (p.refine = function () {
                  l.forEach(function (e) {
                    var t = e.helper,
                      n = e.items;
                    t.setState((0, c.clearRefinements)({ helper: t, attributesToClear: n })).search();
                  });
                }),
                  (p.createURL = function () {
                    return o(
                      c.mergeSearchParameters.apply(
                        void 0,
                        r(
                          l.map(function (e) {
                            var t = e.helper,
                              n = e.items;
                            return (0, c.clearRefinements)({ helper: t, attributesToClear: n });
                          })
                        )
                      )
                    );
                  }),
                  e(
                    {
                      hasRefinements: l.some(function (e) {
                        return e.items.length > 0;
                      }),
                      refine: m,
                      createURL: g,
                      instantSearchInstance: u,
                      widgetParams: n,
                    },
                    !1
                  );
              },
              dispose: function () {
                t();
              },
            };
          }
        );
      },
      f = l;
    t.default = f;
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = { resetLabel: 'Clear refinements' };
    t.default = r;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var a = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var s = n(3),
      c = a(n(4)),
      u = n(1),
      l = n(5),
      f = a(n(183)),
      h = (0, u.createDocumentationMessageGenerator)({ name: 'panel' }),
      d = (0, l.component)('Panel'),
      p = function (e) {
        var t = e.containerNode,
          n = e.bodyContainerNode,
          r = e.cssClasses,
          i = e.templates;
        return function (e) {
          var o = e.options,
            a = e.hidden,
            c = e.collapsible,
            u = e.collapsed;
          (0, s.render)(
            (0, s.h)(f.default, {
              cssClasses: r,
              hidden: a,
              collapsible: c,
              isCollapsed: u,
              templates: i,
              data: o,
              bodyElement: n,
            }),
            t
          );
        };
      },
      m = function (e) {
        var t = e || {},
          n = t.templates,
          r = void 0 === n ? {} : n,
          o = t.hidden,
          a =
            void 0 === o
              ? function () {
                  return !1;
                }
              : o,
          l = t.collapsed,
          f = t.cssClasses,
          m = void 0 === f ? {} : f,
          g = document.createElement('div'),
          v = Boolean(l),
          y =
            'function' == typeof l
              ? l
              : function () {
                  return !1;
                },
          b = {
            root: (0, c.default)(d(), m.root),
            noRefinementRoot: (0, c.default)(d({ modifierName: 'noRefinement' }), m.noRefinementRoot),
            collapsibleRoot: (0, c.default)(d({ modifierName: 'collapsible' }), m.collapsibleRoot),
            collapsedRoot: (0, c.default)(d({ modifierName: 'collapsed' }), m.collapsedRoot),
            collapseButton: (0, c.default)(d({ descendantName: 'collapseButton' }), m.collapseButton),
            collapseIcon: (0, c.default)(d({ descendantName: 'collapseIcon' }), m.collapseIcon),
            body: (0, c.default)(d({ descendantName: 'body' }), m.body),
            header: (0, c.default)(d({ descendantName: 'header' }), m.header),
            footer: (0, c.default)(d({ descendantName: 'footer' }), m.footer),
          };
        return function (e) {
          return function (t) {
            var n = t || {},
              o = n.container;
            if (!o) throw new Error(h('The `container` option is required in the widget within the panel.'));
            var c = {
                header: '',
                footer: '',
                collapseButtonText: function (e) {
                  var t = e.collapsed;
                  return '<svg\n          class="'
                    .concat(
                      b.collapseIcon,
                      '"\n          width="1em"\n          height="1em"\n          viewBox="0 0 500 500"\n        >\n        <path d="'
                    )
                    .concat(
                      t ? 'M100 250l300-150v300z' : 'M250 400l150-300H100z',
                      '" fill="currentColor" />\n        </svg>'
                    );
                },
              },
              l = p({
                containerNode: (0, u.getContainerNode)(o),
                bodyContainerNode: g,
                cssClasses: b,
                templates: i({}, c, {}, r),
              });
            l({ options: {}, hidden: !0, collapsible: v, collapsed: !1 });
            var f = e(i({}, t, { container: g }));
            return i({}, f, {
              dispose: function () {
                if (((0, s.render)(null, (0, u.getContainerNode)(o)), 'function' == typeof f.dispose)) {
                  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return (e = f.dispose).call.apply(e, [this].concat(n));
                }
              },
              render: function () {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                var r = t[0];
                if (
                  (l({ options: r, hidden: Boolean(a(r)), collapsible: v, collapsed: Boolean(y(r)) }),
                  'function' == typeof f.render)
                ) {
                  var i;
                  (i = f.render).call.apply(i, [this].concat(t));
                }
              },
            });
          };
        };
      },
      g = m;
    t.default = g;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function i(e, t) {
      return s(e) || a(e, t) || o();
    }
    function o() {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
    function a(e, t) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e)) {
        var n = [],
          r = !0,
          i = !1,
          o = void 0;
        try {
          for (
            var a, s = e[Symbol.iterator]();
            !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t);
            r = !0
          );
        } catch (e) {
          (i = !0), (o = e);
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }
        return n;
      }
    }
    function s(e) {
      if (Array.isArray(e)) return e;
    }
    function c(e) {
      var t,
        n = (0, f.useState)(e.isCollapsed),
        o = i(n, 2),
        a = o[0],
        s = o[1],
        c = (0, f.useState)(!1),
        u = i(c, 2),
        p = u[0],
        m = u[1],
        g = (0, f.useRef)(null);
      return (
        (0, f.useEffect)(
          function () {
            if (g.current)
              return (
                g.current.appendChild(e.bodyElement),
                function () {
                  g.current.removeChild(e.bodyElement);
                }
              );
          },
          [g, e.bodyElement]
        ),
        p || e.isCollapsed === a || s(e.isCollapsed),
        (0, l.h)(
          'div',
          {
            className: (0, h.default)(
              e.cssClasses.root,
              ((t = {}),
              r(t, e.cssClasses.noRefinementRoot, e.hidden),
              r(t, e.cssClasses.collapsibleRoot, e.collapsible),
              r(t, e.cssClasses.collapsedRoot, a),
              t)
            ),
            hidden: e.hidden,
          },
          e.templates.header &&
            (0, l.h)(
              'div',
              { className: e.cssClasses.header },
              (0, l.h)(d.default, { templates: e.templates, templateKey: 'header', rootTagName: 'span', data: e.data }),
              e.collapsible &&
                (0, l.h)(
                  'button',
                  {
                    className: e.cssClasses.collapseButton,
                    'aria-expanded': !a,
                    onClick: function (e) {
                      e.preventDefault(),
                        m(!0),
                        s(function (e) {
                          return !e;
                        });
                    },
                  },
                  (0, l.h)(d.default, {
                    templates: e.templates,
                    templateKey: 'collapseButtonText',
                    rootTagName: 'span',
                    data: { collapsed: a },
                  })
                )
            ),
          (0, l.h)('div', { className: e.cssClasses.body, ref: g }),
          e.templates.footer &&
            (0, l.h)(d.default, {
              templates: e.templates,
              templateKey: 'footer',
              rootProps: { className: e.cssClasses.footer },
              data: e.data,
            })
        )
      );
    }
    var u = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var l = n(3),
      f = n(184),
      h = u(n(4)),
      d = u(n(8)),
      p = c;
    t.default = p;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      P.options.__h && P.options.__h(_, e, j || t), (j = 0);
      var n = _.__H || (_.__H = { __: [], __h: [] });
      return e >= n.__.length && n.__.push({}), n.__[e];
    }
    function i(e) {
      return (j = 1), o(b, e);
    }
    function o(e, t, n) {
      var i = r(w++, 2);
      return (
        (i.t = e),
        i.__c ||
          ((i.__c = _),
          (i.__ = [
            n ? n(t) : b(void 0, t),
            function (e) {
              var t = i.t(i.__[0], e);
              i.__[0] !== t && ((i.__ = [t, i.__[1]]), i.__c.setState({}));
            },
          ])),
        i.__
      );
    }
    function a(e, t) {
      var n = r(w++, 3);
      !P.options.__s && y(n.__H, t) && ((n.__ = e), (n.__H = t), _.__H.__h.push(n));
    }
    function s(e, t) {
      var n = r(w++, 4);
      !P.options.__s && y(n.__H, t) && ((n.__ = e), (n.__H = t), _.__h.push(n));
    }
    function c(e) {
      return (
        (j = 5),
        l(function () {
          return { current: e };
        }, [])
      );
    }
    function u(e, t, n) {
      (j = 6),
        s(
          function () {
            'function' == typeof e ? e(t()) : e && (e.current = t());
          },
          null == n ? n : n.concat(e)
        );
    }
    function l(e, t) {
      var n = r(w++, 7);
      return y(n.__H, t) ? ((n.__H = t), (n.__h = e), (n.__ = e())) : n.__;
    }
    function f(e, t) {
      return (
        (j = 8),
        l(function () {
          return e;
        }, t)
      );
    }
    function h(e) {
      var t = _.context[e.__c],
        n = r(w++, 9);
      return (n.__c = e), t ? (null == n.__ && ((n.__ = !0), t.sub(_)), t.props.value) : e.__;
    }
    function d(e, t) {
      P.options.useDebugValue && P.options.useDebugValue(t ? t(e) : e);
    }
    function p(e) {
      var t = r(w++, 10),
        n = i();
      return (
        (t.__ = e),
        _.componentDidCatch ||
          (_.componentDidCatch = function (e) {
            t.__ && t.__(e), n[1](e);
          }),
        [
          n[0],
          function () {
            n[1](void 0);
          },
        ]
      );
    }
    function m() {
      S.some(function (e) {
        if (e.__P)
          try {
            e.__H.__h.forEach(g), e.__H.__h.forEach(v), (e.__H.__h = []);
          } catch (t) {
            return (e.__H.__h = []), P.options.__e(t, e.__v), !0;
          }
      }),
        (S = []);
    }
    function g(e) {
      'function' == typeof e.u && e.u();
    }
    function v(e) {
      e.u = e.__();
    }
    function y(e, t) {
      return (
        !e ||
        t.some(function (t, n) {
          return t !== e[n];
        })
      );
    }
    function b(e, t) {
      return 'function' == typeof t ? t(e) : t;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }),
      (t.useState = i),
      (t.useReducer = o),
      (t.useEffect = a),
      (t.useLayoutEffect = s),
      (t.useRef = c),
      (t.useImperativeHandle = u),
      (t.useMemo = l),
      (t.useCallback = f),
      (t.useContext = h),
      (t.useDebugValue = d),
      (t.useErrorBoundary = p);
    var w,
      _,
      O,
      P = n(3),
      j = 0,
      S = [],
      x = P.options.__r,
      R = P.options.diffed,
      E = P.options.__c,
      T = P.options.unmount;
    (P.options.__r = function (e) {
      x && x(e), (w = 0);
      var t = (_ = e.__c).__H;
      t && (t.__h.forEach(g), t.__h.forEach(v), (t.__h = []));
    }),
      (P.options.diffed = function (e) {
        R && R(e);
        var t = e.__c;
        t &&
          t.__H &&
          t.__H.__h.length &&
          ((1 !== S.push(t) && O === P.options.requestAnimationFrame) ||
            (
              (O = P.options.requestAnimationFrame) ||
              function (e) {
                var t,
                  n = function () {
                    clearTimeout(r), C && cancelAnimationFrame(t), setTimeout(e);
                  },
                  r = setTimeout(n, 100);
                C && (t = requestAnimationFrame(n));
              }
            )(m));
      }),
      (P.options.__c = function (e, t) {
        t.some(function (e) {
          try {
            e.__h.forEach(g),
              (e.__h = e.__h.filter(function (e) {
                return !e.__ || v(e);
              }));
          } catch (n) {
            t.some(function (e) {
              e.__h && (e.__h = []);
            }),
              (t = []),
              P.options.__e(n, e.__v);
          }
        }),
          E && E(e, t);
      }),
      (P.options.unmount = function (e) {
        T && T(e);
        var t = e.__c;
        if (t && t.__H)
          try {
            t.__H.__.forEach(g);
          } catch (e) {
            P.options.__e(e, t.__v);
          }
      });
    var C = 'function' == typeof requestAnimationFrame;
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = n(3),
      o = r(n(4)),
      a = r(n(186)),
      s = r(n(187)),
      c = r(n(188)),
      u = n(1),
      l = n(5),
      f = n(189),
      h = (0, u.createDocumentationMessageGenerator)({ name: 'hits' }),
      d = (0, l.component)('Hits'),
      p = (0, f.withInsightsListener)(s.default),
      m = function (e) {
        var t = e.renderState,
          n = e.cssClasses,
          r = e.containerNode,
          o = e.templates;
        return function (e, a) {
          var s = e.hits,
            l = e.results,
            f = e.instantSearchInstance,
            h = e.insights,
            d = e.bindEvent;
          if (a)
            return void (t.templateProps = (0, u.prepareTemplateProps)({
              defaultTemplates: c.default,
              templatesConfig: f.templatesConfig,
              templates: o,
            }));
          (0, i.render)(
            (0, i.h)(p, {
              cssClasses: n,
              hits: s,
              results: l,
              templateProps: t.templateProps,
              insights: h,
              sendEvent: function (e) {
                f.sendEventToInsights(e);
              },
              bindEvent: d,
            }),
            r
          );
        };
      },
      g = function (e) {
        var t = e || {},
          n = t.container,
          r = t.escapeHTML,
          s = t.transformItems,
          l = t.templates,
          p = void 0 === l ? c.default : l,
          g = t.cssClasses,
          v = void 0 === g ? {} : g;
        if (!n) throw new Error(h('The `container` option is required.'));
        var y = (0, u.getContainerNode)(n),
          b = {
            root: (0, o.default)(d(), v.root),
            emptyRoot: (0, o.default)(d({ modifierName: 'empty' }), v.emptyRoot),
            list: (0, o.default)(d({ descendantName: 'list' }), v.list),
            item: (0, o.default)(d({ descendantName: 'item' }), v.item),
          },
          w = m({ containerNode: y, cssClasses: b, renderState: {}, templates: p });
        return (0, f.withInsights)(a.default)(w, function () {
          return (0, i.render)(null, y);
        })({ escapeHTML: r, transformItems: s });
      },
      v = g;
    t.default = v;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var a = n(12);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var s = a(n(14)),
      c = n(1),
      u = (0, c.createDocumentationMessageGenerator)({ name: 'hits', connector: !0 }),
      l = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.noop;
        return (
          (0, c.checkRendering)(e, u()),
          function (n) {
            var r,
              a,
              u = n || {},
              l = u.escapeHTML,
              f = void 0 === l || l,
              h = u.transformItems,
              d =
                void 0 === h
                  ? function (e) {
                      return e;
                    }
                  : h;
            return {
              $$type: 'ais.hits',
              init: function (t) {
                var i = t.instantSearchInstance,
                  o = t.helper;
                (r = (0, c.createSendEventForHits)({
                  instantSearchInstance: i,
                  index: o.getIndex(),
                  widgetType: this.$$type,
                })),
                  (a = (0, c.createBindEventForHits)({ index: o.getIndex(), widgetType: this.$$type })),
                  e(
                    {
                      hits: [],
                      results: void 0,
                      sendEvent: r,
                      bindEvent: a,
                      instantSearchInstance: i,
                      widgetParams: n,
                    },
                    !0
                  );
              },
              render: function (t) {
                var i = t.results,
                  o = t.instantSearchInstance;
                f && i.hits.length > 0 && (i.hits = (0, s.default)(i.hits));
                var u = i.hits.__escaped;
                (i.hits = (0, c.addAbsolutePosition)(i.hits, i.page, i.hitsPerPage)),
                  (i.hits = (0, c.addQueryID)(i.hits, i.queryID)),
                  (i.hits = d(i.hits)),
                  (i.hits.__escaped = u),
                  r('view', i.hits),
                  e(
                    { hits: i.hits, results: i, sendEvent: r, bindEvent: a, instantSearchInstance: o, widgetParams: n },
                    !1
                  );
              },
              dispose: function (e) {
                var n = e.state;
                return (
                  t(),
                  f
                    ? n.setQueryParameters(
                        Object.keys(s.TAG_PLACEHOLDER).reduce(function (e, t) {
                          return i({}, e, o({}, t, void 0));
                        }, {})
                      )
                    : n
                );
              },
              getWidgetSearchParameters: function (e) {
                return f ? e.setQueryParameters(s.TAG_PLACEHOLDER) : e;
              },
            };
          }
        );
      },
      f = l;
    t.default = f;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a() {
      return (
        (a =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }),
        a.apply(this, arguments)
      );
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var c = n(3),
      u = s(n(4)),
      l = s(n(8)),
      f = function (e) {
        var t = e.results,
          n = e.hits,
          r = e.bindEvent,
          o = e.cssClasses,
          s = e.templateProps;
        return 0 === t.hits.length
          ? (0, c.h)(
              l.default,
              a({}, s, { templateKey: 'empty', rootProps: { className: (0, u.default)(o.root, o.emptyRoot) }, data: t })
            )
          : (0, c.h)(
              'div',
              { className: o.root },
              (0, c.h)(
                'ol',
                { className: o.list },
                n.map(function (e, t) {
                  return (0,
                  c.h)(l.default, a({}, s, { templateKey: 'item', rootTagName: 'li', rootProps: { className: o.item }, key: e.objectID, data: i({}, e, { __hitIndex: t }), bindEvent: r }));
                })
              )
            );
      };
    f.defaultProps = { results: { hits: [] }, hits: [] };
    var h = f;
    t.default = h;
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = {
      empty: 'No results',
      item: function (e) {
        return JSON.stringify(e, null, 2);
      },
    };
    t.default = r;
  },
  function (e, t, n) {
    'use strict';
    var r = n(0),
      i = n(12);
    Object.defineProperty(t, '__esModule', { value: !0 }),
      Object.defineProperty(t, 'withInsights', {
        enumerable: !0,
        get: function () {
          return o.default;
        },
      }),
      Object.defineProperty(t, 'inferInsightsPayload', {
        enumerable: !0,
        get: function () {
          return o.inferPayload;
        },
      }),
      Object.defineProperty(t, 'withInsightsListener', {
        enumerable: !0,
        get: function () {
          return a.default;
        },
      });
    var o = i(n(190)),
      a = r(n(191));
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      var t = function (e) {
        return function (t, n) {
          var r = t.results,
            o = t.hits,
            a = t.instantSearchInstance;
          if (r && o && a) {
            var s = h(a.insightsClient, r, o);
            return e(i({}, t, { insights: s }), n);
          }
          return e(t, n);
        };
      };
      return function (n, r) {
        return e(t(n), r);
      };
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a), (t.inferPayload = void 0);
    var s = n(1),
      c = function (e, t) {
        return t.map(function (t) {
          var n = (0, s.find)(e, function (e) {
            return e.objectID === t;
          });
          if (void 0 === n)
            throw new Error(
              'Could not find objectID "'.concat(
                t,
                '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'
              )
            );
          return n;
        });
      },
      u = function (e) {
        var t = (0, s.uniq)(
          e.map(function (e) {
            return e.__queryID;
          })
        );
        if (t.length > 1)
          throw new Error(
            'Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.'
          );
        var n = t[0];
        if ('string' != typeof n)
          throw new Error(
            'Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7'
          );
        return n;
      },
      l = function (e) {
        return e.map(function (e) {
          return e.__position;
        });
      },
      f = function (e) {
        var t = e.method,
          n = e.results,
          r = e.hits,
          i = e.objectIDs,
          o = n.index,
          a = c(r, i),
          s = u(a);
        switch (t) {
          case 'clickedObjectIDsAfterSearch':
            return { index: o, queryID: s, objectIDs: i, positions: l(a) };
          case 'convertedObjectIDsAfterSearch':
            return { index: o, queryID: s, objectIDs: i };
          default:
            throw new Error('Unsupported method passed to insights: "'.concat(t, '".'));
        }
      };
    t.inferPayload = f;
    var h = function (e, t, n) {
      return function (r, o) {
        if (!e) {
          var a = (0, s.createDocumentationMessageGenerator)({ name: 'instantsearch' });
          throw new Error(a('The `insightsClient` option has not been provided to `instantsearch`.'));
        }
        if (!Array.isArray(o.objectIDs)) throw new TypeError('Expected `objectIDs` to be an array.');
        var c = f({ method: r, results: t, hits: n, objectIDs: o.objectIDs });
        e(r, i({}, c, {}, o));
      };
    };
  },
  function (e, t, n) {
    'use strict';
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var r = n(3),
      i = n(48),
      o = function (e, t, n) {
        for (var r = e; r && !n(r); ) {
          if (r === t) return null;
          r = r.parentElement;
        }
        return r;
      },
      a = function (e) {
        var t = e.getAttribute('data-insights-event');
        if ('string' != typeof t)
          throw new Error('The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.');
        try {
          return JSON.parse(atob(t));
        } catch (e) {
          throw new Error('The insights middleware was unable to parse `data-insights-event`.');
        }
      },
      s = function (e) {
        function t(t) {
          var n = function (e) {
            if (t.sendEvent) {
              var n = o(e.target, e.currentTarget, function (e) {
                return e.hasAttribute('data-insights-event');
              });
              if (n) {
                var r = a(n);
                t.sendEvent(r);
              }
            } else {
              var s = o(e.target, e.currentTarget, function (e) {
                return (0, i.hasDataAttributes)(e);
              });
              if (s) {
                var c = (0, i.readDataAttributes)(s),
                  u = c.method,
                  l = c.payload;
                t.insights(u, l);
              }
            }
          };
          return (0, r.h)('div', { onClick: n }, (0, r.h)(e, t));
        }
        return t;
      },
      c = s;
    t.default = c;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.container,
        n = e.templates,
        r = void 0 === n ? {} : n,
        o = e.cssClasses,
        a = void 0 === o ? {} : o,
        s = e.totalPages,
        l = e.padding,
        d = e.showFirst,
        y = void 0 === d || d,
        b = e.showLast,
        w = void 0 === b || b,
        _ = e.showPrevious,
        O = void 0 === _ || _,
        P = e.showNext,
        j = void 0 === P || P,
        S = e.scrollTo,
        x = void 0 === S ? 'body' : S;
      if (!t) throw new Error(p('The `container` option is required.'));
      var R = (0, h.getContainerNode)(t),
        E = !0 === x ? 'body' : x,
        T = !1 !== E && (0, h.getContainerNode)(E),
        C = {
          root: (0, u.default)(m(), a.root),
          noRefinementRoot: (0, u.default)(m({ modifierName: 'noRefinement' }), a.noRefinementRoot),
          list: (0, u.default)(m({ descendantName: 'list' }), a.list),
          item: (0, u.default)(m({ descendantName: 'item' }), a.item),
          firstPageItem: (0, u.default)(m({ descendantName: 'item', modifierName: 'firstPage' }), a.firstPageItem),
          lastPageItem: (0, u.default)(m({ descendantName: 'item', modifierName: 'lastPage' }), a.lastPageItem),
          previousPageItem: (0, u.default)(
            m({ descendantName: 'item', modifierName: 'previousPage' }),
            a.previousPageItem
          ),
          nextPageItem: (0, u.default)(m({ descendantName: 'item', modifierName: 'nextPage' }), a.nextPageItem),
          pageItem: (0, u.default)(m({ descendantName: 'item', modifierName: 'page' }), a.pageItem),
          selectedItem: (0, u.default)(m({ descendantName: 'item', modifierName: 'selected' }), a.selectedItem),
          disabledItem: (0, u.default)(m({ descendantName: 'item', modifierName: 'disabled' }), a.disabledItem),
          link: (0, u.default)(m({ descendantName: 'link' }), a.link),
        },
        N = i({}, g, {}, r),
        k = v({
          containerNode: R,
          cssClasses: C,
          templates: N,
          showFirst: y,
          showLast: w,
          showPrevious: O,
          showNext: j,
          padding: l,
          scrollToNode: T,
        });
      return (0, f.default)(k, function () {
        return (0, c.render)(null, R);
      })({ totalPages: s, padding: l });
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var c = n(3),
      u = s(n(4)),
      l = s(n(193)),
      f = s(n(195)),
      h = n(1),
      d = n(5),
      p = (0, h.createDocumentationMessageGenerator)({ name: 'pagination' }),
      m = (0, d.component)('Pagination'),
      g = { previous: '‹', next: '›', first: '«', last: '»' },
      v = function (e) {
        var t = e.containerNode,
          n = e.cssClasses,
          r = e.templates,
          i = e.totalPages,
          o = e.showFirst,
          a = e.showLast,
          s = e.showPrevious,
          u = e.showNext,
          f = e.scrollToNode;
        return function (e, h) {
          var d = e.createURL,
            p = e.currentRefinement,
            m = e.nbHits,
            g = e.nbPages,
            v = e.pages,
            y = e.isFirstPage,
            b = e.isLastPage,
            w = e.refine;
          if (!h) {
            var _ = function (e) {
              w(e), !1 !== f && f.scrollIntoView();
            };
            (0, c.render)(
              (0, c.h)(l.default, {
                createURL: d,
                cssClasses: n,
                currentPage: p,
                templates: r,
                nbHits: m,
                nbPages: g,
                pages: v,
                totalPages: i,
                isFirstPage: y,
                isLastPage: b,
                setCurrentPage: _,
                showFirst: o,
                showLast: a,
                showPrevious: s,
                showNext: u,
              }),
              t
            );
          }
        };
      };
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return (r =
        'function' == typeof Symbol && 'symbol' === (0, p.default)(Symbol.iterator)
          ? function (e) {
              return (0, p.default)(e);
            }
          : function (e) {
              return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                ? 'symbol'
                : (0, p.default)(e);
            })(e);
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function a(e, t, n) {
      return t && o(e.prototype, t), n && o(e, n), e;
    }
    function s(e, t) {
      return !t || ('object' !== r(t) && 'function' != typeof t) ? u(e) : t;
    }
    function c(e) {
      return (c = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
    }
    function u(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function l(e, t) {
      if ('function' != typeof t && null !== t)
        throw new TypeError('Super expression must either be null or a function');
      (e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } })),
        t && f(e, t);
    }
    function f(e, t) {
      return (f =
        Object.setPrototypeOf ||
        function (e, t) {
          return (e.__proto__ = t), e;
        })(e, t);
    }
    function h(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    var d = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var p = d(n(2)),
      m = n(3),
      g = d(n(4)),
      v = d(n(194)),
      y = n(1),
      b = (function (e) {
        function t() {
          var e, n;
          i(this, t);
          for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
          return (
            (n = s(this, (e = c(t)).call.apply(e, [this].concat(o)))),
            h(u(n), 'handleClick', function (e, t) {
              (0, y.isSpecialClick)(t) || (t.preventDefault(), n.props.setCurrentPage(e));
            }),
            n
          );
        }
        return (
          l(t, e),
          a(t, [
            {
              key: 'pageLink',
              value: function (e) {
                var t = e.label,
                  n = e.ariaLabel,
                  r = e.pageNumber,
                  i = e.additionalClassName,
                  o = void 0 === i ? null : i,
                  a = e.isDisabled,
                  s = void 0 !== a && a,
                  c = e.isSelected,
                  u = void 0 !== c && c,
                  l = e.createURL,
                  f = { item: (0, g.default)(this.props.cssClasses.item, o), link: this.props.cssClasses.link };
                s
                  ? (f.item = (0, g.default)(f.item, this.props.cssClasses.disabledItem))
                  : u && (f.item = (0, g.default)(f.item, this.props.cssClasses.selectedItem));
                var h = l && !s ? l(r) : '#';
                return (0, m.h)(v.default, {
                  ariaLabel: n,
                  cssClasses: f,
                  handleClick: this.handleClick,
                  isDisabled: s,
                  key: t + r + n,
                  label: t,
                  pageNumber: r,
                  url: h,
                });
              },
            },
            {
              key: 'previousPageLink',
              value: function (e) {
                var t = e.isFirstPage,
                  n = e.currentPage,
                  r = e.createURL;
                return this.pageLink({
                  ariaLabel: 'Previous',
                  additionalClassName: this.props.cssClasses.previousPageItem,
                  isDisabled: t,
                  label: this.props.templates.previous,
                  pageNumber: n - 1,
                  createURL: r,
                });
              },
            },
            {
              key: 'nextPageLink',
              value: function (e) {
                var t = e.isLastPage,
                  n = e.currentPage,
                  r = e.createURL;
                return this.pageLink({
                  ariaLabel: 'Next',
                  additionalClassName: this.props.cssClasses.nextPageItem,
                  isDisabled: t,
                  label: this.props.templates.next,
                  pageNumber: n + 1,
                  createURL: r,
                });
              },
            },
            {
              key: 'firstPageLink',
              value: function (e) {
                var t = e.isFirstPage,
                  n = e.createURL;
                return this.pageLink({
                  ariaLabel: 'First',
                  additionalClassName: this.props.cssClasses.firstPageItem,
                  isDisabled: t,
                  label: this.props.templates.first,
                  pageNumber: 0,
                  createURL: n,
                });
              },
            },
            {
              key: 'lastPageLink',
              value: function (e) {
                var t = e.isLastPage,
                  n = e.nbPages,
                  r = e.createURL;
                return this.pageLink({
                  ariaLabel: 'Last',
                  additionalClassName: this.props.cssClasses.lastPageItem,
                  isDisabled: t,
                  label: this.props.templates.last,
                  pageNumber: n - 1,
                  createURL: r,
                });
              },
            },
            {
              key: 'pages',
              value: function (e) {
                var t = this,
                  n = e.currentPage,
                  r = e.pages,
                  i = e.createURL;
                return r.map(function (e) {
                  return t.pageLink({
                    ariaLabel: e + 1,
                    additionalClassName: t.props.cssClasses.pageItem,
                    isSelected: e === n,
                    label: e + 1,
                    pageNumber: e,
                    createURL: i,
                  });
                });
              },
            },
            {
              key: 'render',
              value: function () {
                return (0, m.h)(
                  'div',
                  {
                    className: (0, g.default)(
                      this.props.cssClasses.root,
                      h({}, this.props.cssClasses.noRefinementRoot, this.props.nbPages <= 1)
                    ),
                  },
                  (0, m.h)(
                    'ul',
                    { className: this.props.cssClasses.list },
                    this.props.showFirst && this.firstPageLink(this.props),
                    this.props.showPrevious && this.previousPageLink(this.props),
                    this.pages(this.props),
                    this.props.showNext && this.nextPageLink(this.props),
                    this.props.showLast && this.lastPageLink(this.props)
                  )
                );
              },
            },
          ]),
          t
        );
      })(m.Component);
    b.defaultProps = { nbHits: 0, currentPage: 0, nbPages: 0 };
    var w = b;
    t.default = w;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      var t = e.cssClasses,
        n = e.label,
        r = e.ariaLabel,
        o = e.url,
        a = e.isDisabled,
        s = e.handleClick,
        c = e.pageNumber;
      return a
        ? (0, i.h)(
            'li',
            { className: t.item },
            (0, i.h)('span', { className: t.link, dangerouslySetInnerHTML: { __html: n } })
          )
        : (0, i.h)(
            'li',
            { className: t.item },
            (0, i.h)('a', {
              className: t.link,
              'aria-label': r,
              href: o,
              onClick: function (e) {
                return s(c, e);
              },
              dangerouslySetInnerHTML: { __html: n },
            })
          );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = n(3),
      o = r;
    t.default = o;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : c.noop;
      return (
        (0, c.checkRendering)(e, l()),
        function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.totalPages,
            o = n.padding,
            a = void 0 === o ? 3 : o,
            s = new u.default({ currentPage: 0, total: 0, padding: a });
          return {
            $$type: 'ais.pagination',
            init: function (t) {
              var r = t.helper,
                i = t.createURL,
                o = t.instantSearchInstance;
              (this.refine = function (e) {
                r.setPage(e), r.search();
              }),
                (this.createURL = function (e) {
                  return function (t) {
                    return i(e.setPage(t));
                  };
                }),
                e(
                  {
                    createURL: this.createURL(r.state),
                    currentRefinement: r.state.page || 0,
                    nbHits: 0,
                    nbPages: 0,
                    pages: [],
                    isFirstPage: !0,
                    isLastPage: !0,
                    refine: this.refine,
                    widgetParams: n,
                    instantSearchInstance: o,
                  },
                  !0
                );
            },
            getMaxPage: function (e) {
              var t = e.nbPages;
              return void 0 !== r ? Math.min(r, t) : t;
            },
            render: function (t) {
              var r = t.results,
                i = t.state,
                o = t.instantSearchInstance,
                a = i.page || 0,
                c = this.getMaxPage(r);
              (s.currentPage = a),
                (s.total = c),
                e(
                  {
                    createURL: this.createURL(i),
                    currentRefinement: a,
                    refine: this.refine,
                    nbHits: r.nbHits,
                    nbPages: c,
                    pages: s.pages(),
                    isFirstPage: s.isFirstPage(),
                    isLastPage: s.isLastPage(),
                    widgetParams: n,
                    instantSearchInstance: o,
                  },
                  !1
                );
            },
            dispose: function (e) {
              var n = e.state;
              return t(), n.setQueryParameter('page', void 0);
            },
            getWidgetState: function (e, t) {
              var n = t.searchParameters,
                r = n.page || 0;
              return r ? i({}, e, { page: r + 1 }) : e;
            },
            getWidgetSearchParameters: function (e, t) {
              var n = t.uiState,
                r = n.page ? n.page - 1 : 0;
              return e.setQueryParameter('page', r);
            },
          };
        }
      );
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
    var c = n(1),
      u = s(n(196)),
      l = (0, c.createDocumentationMessageGenerator)({ name: 'pagination', connector: !0 });
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
    }
    function i(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        (r.enumerable = r.enumerable || !1),
          (r.configurable = !0),
          'value' in r && (r.writable = !0),
          Object.defineProperty(e, r.key, r);
      }
    }
    function o(e, t, n) {
      return t && i(e.prototype, t), n && i(e, n), e;
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var a = n(1),
      s = (function () {
        function e(t) {
          r(this, e), (this.currentPage = t.currentPage), (this.total = t.total), (this.padding = t.padding);
        }
        return (
          o(e, [
            {
              key: 'pages',
              value: function () {
                var e = this.total,
                  t = this.currentPage,
                  n = this.padding;
                if (0 === e) return [0];
                var r = this.nbPagesDisplayed(n, e);
                if (r === e) return (0, a.range)({ end: e });
                var i = this.calculatePaddingLeft(t, n, e, r),
                  o = r - i,
                  s = t - i,
                  c = t + o;
                return (0, a.range)({ start: s, end: c });
              },
            },
            {
              key: 'nbPagesDisplayed',
              value: function (e, t) {
                return Math.min(2 * e + 1, t);
              },
            },
            {
              key: 'calculatePaddingLeft',
              value: function (e, t, n, r) {
                return e <= t ? e : e >= n - t ? r - (n - e) : t;
              },
            },
            {
              key: 'isLastPage',
              value: function () {
                return this.currentPage === this.total - 1 || 0 === this.total;
              },
            },
            {
              key: 'isFirstPage',
              value: function () {
                return 0 === this.currentPage;
              },
            },
          ]),
          e
        );
      })(),
      c = s;
    t.default = c;
  },
  function (e, t, n) {
    'use strict';
    var r = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var i = r(n(198)),
      o = n(1),
      a = function (e) {
        return (0, i.default)(o.noop)({ searchParameters: e });
      },
      s = a;
    t.default = s;
  },
  function (e, t, n) {
    'use strict';
    function r(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t &&
          (r = r.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          n.push.apply(n, r);
      }
      return n;
    }
    function i(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? r(Object(n), !0).forEach(function (t) {
              o(e, t, n[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
          : r(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
      }
      return e;
    }
    function o(e, t, n) {
      return (
        t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = n),
        e
      );
    }
    function a(e, t) {
      return e.setQueryParameters(
        Object.keys(t.searchParameters).reduce(function (e, t) {
          return i({}, e, o({}, t, void 0));
        }, {})
      );
    }
    var s = n(0);
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var c = s(n(19)),
      u = n(1),
      l = (0, u.createDocumentationMessageGenerator)({ name: 'configure', connector: !0 }),
      f = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : u.noop,
          t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u.noop;
        return function (n) {
          function r(e) {
            return function (t) {
              var r = a(e.state, n),
                i = (0, u.mergeSearchParameters)(r, new c.default.SearchParameters(t));
              e.setState(i).search(), (n.searchParameters = t);
            };
          }
          if (!n || !(0, u.isPlainObject)(n.searchParameters))
            throw new Error(l('The `searchParameters` option expects an object.'));
          var o = {};
          return {
            $$type: 'ais.configure',
            init: function (t) {
              var i = t.instantSearchInstance,
                a = t.helper;
              (o.refine = r(a)), e({ refine: o.refine, instantSearchInstance: i, widgetParams: n }, !0);
            },
            render: function (t) {
              var r = t.instantSearchInstance;
              e({ refine: o.refine, instantSearchInstance: r, widgetParams: n }, !1);
            },
            dispose: function (e) {
              var r = e.state;
              return t(), a(r, n);
            },
            getWidgetSearchParameters: function (e, t) {
              var r = t.uiState;
              return (0, u.mergeSearchParameters)(
                e,
                new c.default.SearchParameters(i({}, r.configure, {}, n.searchParameters))
              );
            },
            getWidgetState: function (e) {
              return i({}, e, { configure: i({}, e.configure, {}, n.searchParameters) });
            },
          };
        };
      },
      h = f;
    t.default = h;
  },
  function (e, t, n) {
    'use strict';
    function r(e) {
      return a(e) || o(e) || i();
    }
    function i() {
      throw new TypeError('Invalid attempt to spread non-iterable instance');
    }
    function o(e) {
      if (Symbol.iterator in Object(e) || '[object Arguments]' === Object.prototype.toString.call(e))
        return Array.from(e);
    }
    function a(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = new Array(e.length); t < e.length; t++) n[t] = e[t];
        return n;
      }
    }
    function s(e) {
      var t = e.results,
        n = e.helper,
        i = e.includedAttributes,
        o = e.excludedAttributes,
        a = -1 !== (i || []).indexOf('query') || -1 === (o || []).indexOf('query'),
        s = i
          ? function (e) {
              return -1 !== i.indexOf(e.attribute);
            }
          : function (e) {
              return -1 === o.indexOf(e.attribute);
            },
        c = (0, h.getRefinements)(t, n.state, a).map(f).filter(s);
      return c.reduce(function (e, t) {
        return [].concat(
          r(
            e.filter(function (e) {
              return e.attribute !== t.attribute;
            })
          ),
          [
            {
              indexName: n.state.index,
              attribute: t.attribute,
              label: t.attribute,
              refinements: c
                .filter(function (e) {
                  return e.attribute === t.attribute;
                })
                .sort(function (e, t) {
                  return 'numeric' === e.type ? e.value - t.value : 0;
                }),
              refine: function (e) {
                return u(n, e);
              },
            },
          ]
        );
      }, []);
    }
    function c(e, t) {
      switch (t.type) {
        case 'facet':
          return e.removeFacetRefinement(t.attribute, String(t.value));
        case 'disjunctive':
          return e.removeDisjunctiveFacetRefinement(t.attribute, String(t.value));
        case 'hierarchical':
          return e.removeHierarchicalFacetRefinement(t.attribute);
        case 'exclude':
          return e.removeExcludeRefinement(t.attribute, String(t.value));
        case 'numeric':
          return e.removeNumericRefinement(t.attribute, t.operator, String(t.value));
        case 'tag':
          return e.removeTagRefinement(String(t.value));
        case 'query':
          return e.setQueryParameter('query', '');
        default:
          return e;
      }
    }
    function u(e, t) {
      e.setState(c(e.state, t)).search();
    }
    function l(e) {
      switch (e) {
        case '>=':
          return '≥';
        case '<=':
          return '≤';
        default:
          return e;
      }
    }
    function f(e) {
      var t = 'numeric' === e.type ? Number(e.name) : e.name,
        n = e.operator ? ''.concat(l(e.operator), ' ').concat(e.name) : e.name,
        r = { attribute: e.attribute, type: e.type, value: t, label: n };
      return (
        void 0 !== e.operator && (r.operator = e.operator),
        void 0 !== e.count && (r.count = e.count),
        void 0 !== e.exhaustive && (r.exhaustive = e.exhaustive),
        r
      );
    }
    Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
    var h = n(1),
      d = (0, h.createDocumentationMessageGenerator)({ name: 'current-refinements', connector: !0 }),
      p = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : h.noop;
        return (
          (0, h.checkRendering)(e, d()),
          function (n) {
            if ((n || {}).includedAttributes && (n || {}).excludedAttributes)
              throw new Error(d('The options `includedAttributes` and `excludedAttributes` cannot be used together.'));
            var r = n || {},
              i = r.includedAttributes,
              o = r.excludedAttributes,
              a = void 0 === o ? ['query'] : o,
              l = r.transformItems,
              f =
                void 0 === l
                  ? function (e) {
                      return e;
                    }
                  : l;
            return {
              $$type: 'ais.currentRefinements',
              init: function (t) {
                var r = t.helper,
                  o = t.createURL,
                  l = t.instantSearchInstance,
                  h = f(s({ results: {}, helper: r, includedAttributes: i, excludedAttributes: a }));
                e(
                  {
                    items: h,
                    refine: function (e) {
                      return u(r, e);
                    },
                    createURL: function (e) {
                      return o(c(r.state, e));
                    },
                    instantSearchInstance: l,
                    widgetParams: n,
                  },
                  !0
                );
              },
              render: function (t) {
                var r = t.scopedResults,
                  o = t.helper,
                  l = t.createURL,
                  h = t.instantSearchInstance,
                  d = r.reduce(function (e, t) {
                    return e.concat(
                      f(s({ results: t.results, helper: t.helper, includedAttributes: i, excludedAttributes: a }))
                    );
                  }, []);
                e(
                  {
                    items: d,
                    refine: function (e) {
                      return u(o, e);
                    },
                    createURL: function (e) {
                      return l(c(o.state, e));
                    },
                    instantSearchInstance: h,
                    widgetParams: n,
                  },
                  !1
                );
              },
              dispose: function () {
                t();
              },
            };
          }
        );
      },
      m = p;
    t.default = m;
  },
]);
